import './style.css';
import vi, { useRef as zo, useState as Yo, useMemo as $o, useEffect as En } from "react";
function Zo(r, e) {
  for (var t = 0; t < e.length; t++) {
    const n = e[t];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in r)) {
          const o = Object.getOwnPropertyDescriptor(n, i);
          o && Object.defineProperty(r, i, o.get ? o : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }));
}
function Ko(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Mr = { exports: {} }, Ot = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wn;
function qo() {
  if (wn)
    return Ot;
  wn = 1;
  var r = vi, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, f, u) {
    var c, l = {}, d = null, h = null;
    u !== void 0 && (d = "" + u), f.key !== void 0 && (d = "" + f.key), f.ref !== void 0 && (h = f.ref);
    for (c in f)
      n.call(f, c) && !o.hasOwnProperty(c) && (l[c] = f[c]);
    if (s && s.defaultProps)
      for (c in f = s.defaultProps, f)
        l[c] === void 0 && (l[c] = f[c]);
    return { $$typeof: e, type: s, key: d, ref: h, props: l, _owner: i.current };
  }
  return Ot.Fragment = t, Ot.jsx = a, Ot.jsxs = a, Ot;
}
var Rt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sn;
function Qo() {
  return Sn || (Sn = 1, process.env.NODE_ENV !== "production" && function() {
    var r = vi, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, v = "@@iterator";
    function y(m) {
      if (m === null || typeof m != "object")
        return null;
      var b = p && m[p] || m[v];
      return typeof b == "function" ? b : null;
    }
    var _ = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(m) {
      {
        for (var b = arguments.length, D = new Array(b > 1 ? b - 1 : 0), k = 1; k < b; k++)
          D[k - 1] = arguments[k];
        C("error", m, D);
      }
    }
    function C(m, b, D) {
      {
        var k = _.ReactDebugCurrentFrame, $ = k.getStackAddendum();
        $ !== "" && (b += "%s", D = D.concat([$]));
        var re = D.map(function(W) {
          return String(W);
        });
        re.unshift("Warning: " + b), Function.prototype.apply.call(console[m], console, re);
      }
    }
    var E = !1, S = !1, I = !1, T = !1, R = !1, B;
    B = Symbol.for("react.module.reference");
    function M(m) {
      return !!(typeof m == "string" || typeof m == "function" || m === n || m === o || R || m === i || m === u || m === c || T || m === h || E || S || I || typeof m == "object" && m !== null && (m.$$typeof === d || m.$$typeof === l || m.$$typeof === a || m.$$typeof === s || m.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      m.$$typeof === B || m.getModuleId !== void 0));
    }
    function te(m, b, D) {
      var k = m.displayName;
      if (k)
        return k;
      var $ = b.displayName || b.name || "";
      return $ !== "" ? D + "(" + $ + ")" : D;
    }
    function N(m) {
      return m.displayName || "Context";
    }
    function H(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case s:
            var b = m;
            return N(b) + ".Consumer";
          case a:
            var D = m;
            return N(D._context) + ".Provider";
          case f:
            return te(m, m.render, "ForwardRef");
          case l:
            var k = m.displayName || null;
            return k !== null ? k : H(m.type) || "Memo";
          case d: {
            var $ = m, re = $._payload, W = $._init;
            try {
              return H(W(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ie = Object.assign, we = 0, Ge, $e, Xe, qe, bt, Qe, at;
    function fn() {
    }
    fn.__reactDisabledLog = !0;
    function Co() {
      {
        if (we === 0) {
          Ge = console.log, $e = console.info, Xe = console.warn, qe = console.error, bt = console.group, Qe = console.groupCollapsed, at = console.groupEnd;
          var m = {
            configurable: !0,
            enumerable: !0,
            value: fn,
            writable: !0
          };
          Object.defineProperties(console, {
            info: m,
            log: m,
            warn: m,
            error: m,
            group: m,
            groupCollapsed: m,
            groupEnd: m
          });
        }
        we++;
      }
    }
    function Ao() {
      {
        if (we--, we === 0) {
          var m = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ie({}, m, {
              value: Ge
            }),
            info: ie({}, m, {
              value: $e
            }),
            warn: ie({}, m, {
              value: Xe
            }),
            error: ie({}, m, {
              value: qe
            }),
            group: ie({}, m, {
              value: bt
            }),
            groupCollapsed: ie({}, m, {
              value: Qe
            }),
            groupEnd: ie({}, m, {
              value: at
            })
          });
        }
        we < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var gr = _.ReactCurrentDispatcher, xr;
    function Gt(m, b, D) {
      {
        if (xr === void 0)
          try {
            throw Error();
          } catch ($) {
            var k = $.stack.trim().match(/\n( *(at )?)/);
            xr = k && k[1] || "";
          }
        return `
` + xr + m;
      }
    }
    var yr = !1, Ht;
    {
      var Eo = typeof WeakMap == "function" ? WeakMap : Map;
      Ht = new Eo();
    }
    function un(m, b) {
      if (!m || yr)
        return "";
      {
        var D = Ht.get(m);
        if (D !== void 0)
          return D;
      }
      var k;
      yr = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = gr.current, gr.current = null, Co();
      try {
        if (b) {
          var W = function() {
            throw Error();
          };
          if (Object.defineProperty(W.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(W, []);
            } catch (Ze) {
              k = Ze;
            }
            Reflect.construct(m, [], W);
          } else {
            try {
              W.call();
            } catch (Ze) {
              k = Ze;
            }
            m.call(W.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ze) {
            k = Ze;
          }
          m();
        }
      } catch (Ze) {
        if (Ze && k && typeof Ze.stack == "string") {
          for (var j = Ze.stack.split(`
`), Re = k.stack.split(`
`), le = j.length - 1, he = Re.length - 1; le >= 1 && he >= 0 && j[le] !== Re[he]; )
            he--;
          for (; le >= 1 && he >= 0; le--, he--)
            if (j[le] !== Re[he]) {
              if (le !== 1 || he !== 1)
                do
                  if (le--, he--, he < 0 || j[le] !== Re[he]) {
                    var Fe = `
` + j[le].replace(" at new ", " at ");
                    return m.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", m.displayName)), typeof m == "function" && Ht.set(m, Fe), Fe;
                  }
                while (le >= 1 && he >= 0);
              break;
            }
        }
      } finally {
        yr = !1, gr.current = re, Ao(), Error.prepareStackTrace = $;
      }
      var gt = m ? m.displayName || m.name : "", An = gt ? Gt(gt) : "";
      return typeof m == "function" && Ht.set(m, An), An;
    }
    function wo(m, b, D) {
      return un(m, !1);
    }
    function So(m) {
      var b = m.prototype;
      return !!(b && b.isReactComponent);
    }
    function jt(m, b, D) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return un(m, So(m));
      if (typeof m == "string")
        return Gt(m);
      switch (m) {
        case u:
          return Gt("Suspense");
        case c:
          return Gt("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case f:
            return wo(m.render);
          case l:
            return jt(m.type, b, D);
          case d: {
            var k = m, $ = k._payload, re = k._init;
            try {
              return jt(re($), b, D);
            } catch {
            }
          }
        }
      return "";
    }
    var Wt = Object.prototype.hasOwnProperty, cn = {}, ln = _.ReactDebugCurrentFrame;
    function Xt(m) {
      if (m) {
        var b = m._owner, D = jt(m.type, m._source, b ? b.type : null);
        ln.setExtraStackFrame(D);
      } else
        ln.setExtraStackFrame(null);
    }
    function Io(m, b, D, k, $) {
      {
        var re = Function.call.bind(Wt);
        for (var W in m)
          if (re(m, W)) {
            var j = void 0;
            try {
              if (typeof m[W] != "function") {
                var Re = Error((k || "React class") + ": " + D + " type `" + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[W] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Re.name = "Invariant Violation", Re;
              }
              j = m[W](b, W, k, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (le) {
              j = le;
            }
            j && !(j instanceof Error) && (Xt($), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", D, W, typeof j), Xt(null)), j instanceof Error && !(j.message in cn) && (cn[j.message] = !0, Xt($), x("Failed %s type: %s", D, j.message), Xt(null));
          }
      }
    }
    var bo = Array.isArray;
    function mr(m) {
      return bo(m);
    }
    function To(m) {
      {
        var b = typeof Symbol == "function" && Symbol.toStringTag, D = b && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return D;
      }
    }
    function Oo(m) {
      try {
        return dn(m), !1;
      } catch {
        return !0;
      }
    }
    function dn(m) {
      return "" + m;
    }
    function hn(m) {
      if (Oo(m))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", To(m)), dn(m);
    }
    var Tt = _.ReactCurrentOwner, Ro = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pn, vn, _r;
    _r = {};
    function Do(m) {
      if (Wt.call(m, "ref")) {
        var b = Object.getOwnPropertyDescriptor(m, "ref").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return m.ref !== void 0;
    }
    function Po(m) {
      if (Wt.call(m, "key")) {
        var b = Object.getOwnPropertyDescriptor(m, "key").get;
        if (b && b.isReactWarning)
          return !1;
      }
      return m.key !== void 0;
    }
    function No(m, b) {
      if (typeof m.ref == "string" && Tt.current && b && Tt.current.stateNode !== b) {
        var D = H(Tt.current.type);
        _r[D] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(Tt.current.type), m.ref), _r[D] = !0);
      }
    }
    function Mo(m, b) {
      {
        var D = function() {
          pn || (pn = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        D.isReactWarning = !0, Object.defineProperty(m, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function Bo(m, b) {
      {
        var D = function() {
          vn || (vn = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", b));
        };
        D.isReactWarning = !0, Object.defineProperty(m, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Lo = function(m, b, D, k, $, re, W) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: m,
        key: b,
        ref: D,
        props: W,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function Fo(m, b, D, k, $) {
      {
        var re, W = {}, j = null, Re = null;
        D !== void 0 && (hn(D), j = "" + D), Po(b) && (hn(b.key), j = "" + b.key), Do(b) && (Re = b.ref, No(b, $));
        for (re in b)
          Wt.call(b, re) && !Ro.hasOwnProperty(re) && (W[re] = b[re]);
        if (m && m.defaultProps) {
          var le = m.defaultProps;
          for (re in le)
            W[re] === void 0 && (W[re] = le[re]);
        }
        if (j || Re) {
          var he = typeof m == "function" ? m.displayName || m.name || "Unknown" : m;
          j && Mo(W, he), Re && Bo(W, he);
        }
        return Lo(m, j, Re, $, k, Tt.current, W);
      }
    }
    var Cr = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function vt(m) {
      if (m) {
        var b = m._owner, D = jt(m.type, m._source, b ? b.type : null);
        gn.setExtraStackFrame(D);
      } else
        gn.setExtraStackFrame(null);
    }
    var Ar;
    Ar = !1;
    function Er(m) {
      return typeof m == "object" && m !== null && m.$$typeof === e;
    }
    function xn() {
      {
        if (Cr.current) {
          var m = H(Cr.current.type);
          if (m)
            return `

Check the render method of \`` + m + "`.";
        }
        return "";
      }
    }
    function ko(m) {
      {
        if (m !== void 0) {
          var b = m.fileName.replace(/^.*[\\\/]/, ""), D = m.lineNumber;
          return `

Check your code at ` + b + ":" + D + ".";
        }
        return "";
      }
    }
    var yn = {};
    function Uo(m) {
      {
        var b = xn();
        if (!b) {
          var D = typeof m == "string" ? m : m.displayName || m.name;
          D && (b = `

Check the top-level render call using <` + D + ">.");
        }
        return b;
      }
    }
    function mn(m, b) {
      {
        if (!m._store || m._store.validated || m.key != null)
          return;
        m._store.validated = !0;
        var D = Uo(b);
        if (yn[D])
          return;
        yn[D] = !0;
        var k = "";
        m && m._owner && m._owner !== Cr.current && (k = " It was passed a child from " + H(m._owner.type) + "."), vt(m), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, k), vt(null);
      }
    }
    function _n(m, b) {
      {
        if (typeof m != "object")
          return;
        if (mr(m))
          for (var D = 0; D < m.length; D++) {
            var k = m[D];
            Er(k) && mn(k, b);
          }
        else if (Er(m))
          m._store && (m._store.validated = !0);
        else if (m) {
          var $ = y(m);
          if (typeof $ == "function" && $ !== m.entries)
            for (var re = $.call(m), W; !(W = re.next()).done; )
              Er(W.value) && mn(W.value, b);
        }
      }
    }
    function Vo(m) {
      {
        var b = m.type;
        if (b == null || typeof b == "string")
          return;
        var D;
        if (typeof b == "function")
          D = b.propTypes;
        else if (typeof b == "object" && (b.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        b.$$typeof === l))
          D = b.propTypes;
        else
          return;
        if (D) {
          var k = H(b);
          Io(D, m.props, "prop", k, m);
        } else if (b.PropTypes !== void 0 && !Ar) {
          Ar = !0;
          var $ = H(b);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof b.getDefaultProps == "function" && !b.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Go(m) {
      {
        for (var b = Object.keys(m.props), D = 0; D < b.length; D++) {
          var k = b[D];
          if (k !== "children" && k !== "key") {
            vt(m), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), vt(null);
            break;
          }
        }
        m.ref !== null && (vt(m), x("Invalid attribute `ref` supplied to `React.Fragment`."), vt(null));
      }
    }
    function Cn(m, b, D, k, $, re) {
      {
        var W = M(m);
        if (!W) {
          var j = "";
          (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Re = ko($);
          Re ? j += Re : j += xn();
          var le;
          m === null ? le = "null" : mr(m) ? le = "array" : m !== void 0 && m.$$typeof === e ? (le = "<" + (H(m.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : le = typeof m, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", le, j);
        }
        var he = Fo(m, b, D, $, re);
        if (he == null)
          return he;
        if (W) {
          var Fe = b.children;
          if (Fe !== void 0)
            if (k)
              if (mr(Fe)) {
                for (var gt = 0; gt < Fe.length; gt++)
                  _n(Fe[gt], m);
                Object.freeze && Object.freeze(Fe);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _n(Fe, m);
        }
        return m === n ? Go(he) : Vo(he), he;
      }
    }
    function Ho(m, b, D) {
      return Cn(m, b, D, !0);
    }
    function jo(m, b, D) {
      return Cn(m, b, D, !1);
    }
    var Wo = jo, Xo = Ho;
    Rt.Fragment = n, Rt.jsx = Wo, Rt.jsxs = Xo;
  }()), Rt;
}
process.env.NODE_ENV === "production" ? Mr.exports = qo() : Mr.exports = Qo();
var ct = Mr.exports;
function Jo(r, e) {
  var t = Object.setPrototypeOf;
  t ? t(r, e) : r.__proto__ = e;
}
function ea(r, e) {
  e === void 0 && (e = r.constructor);
  var t = Error.captureStackTrace;
  t && t(r, e);
}
var ta = /* @__PURE__ */ function() {
  var r = function(t, n) {
    return r = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (i[a] = o[a]);
    }, r(t, n);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ra = function(r) {
  ta(e, r);
  function e(t, n) {
    var i = this.constructor, o = r.call(this, t, n) || this;
    return Object.defineProperty(o, "name", {
      value: i.name,
      enumerable: !1,
      configurable: !0
    }), Jo(o, i.prototype), ea(o), o;
  }
  return e;
}(Error), na = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Le = (
  /** @class */
  function(r) {
    na(e, r);
    function e(t) {
      t === void 0 && (t = void 0);
      var n = r.call(this, t) || this;
      return n.message = t, n;
    }
    return e.prototype.getKind = function() {
      var t = this.constructor;
      return t.kind;
    }, e.kind = "Exception", e;
  }(ra)
), ia = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), de = (
  /** @class */
  function(r) {
    ia(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "ArgumentException", e;
  }(Le)
), oa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), F = (
  /** @class */
  function(r) {
    oa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "IllegalArgumentException", e;
  }(Le)
), gi = (
  /** @class */
  function() {
    function r(e) {
      if (this.binarizer = e, e === null)
        throw new F("Binarizer must be non-null.");
    }
    return r.prototype.getWidth = function() {
      return this.binarizer.getWidth();
    }, r.prototype.getHeight = function() {
      return this.binarizer.getHeight();
    }, r.prototype.getBlackRow = function(e, t) {
      return this.binarizer.getBlackRow(e, t);
    }, r.prototype.getBlackMatrix = function() {
      return (this.matrix === null || this.matrix === void 0) && (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, r.prototype.isCropSupported = function() {
      return this.binarizer.getLuminanceSource().isCropSupported();
    }, r.prototype.crop = function(e, t, n, i) {
      var o = this.binarizer.getLuminanceSource().crop(e, t, n, i);
      return new r(this.binarizer.createBinarizer(o));
    }, r.prototype.isRotateSupported = function() {
      return this.binarizer.getLuminanceSource().isRotateSupported();
    }, r.prototype.rotateCounterClockwise = function() {
      var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
      return new r(this.binarizer.createBinarizer(e));
    }, r.prototype.rotateCounterClockwise45 = function() {
      var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
      return new r(this.binarizer.createBinarizer(e));
    }, r.prototype.toString = function() {
      try {
        return this.getBlackMatrix().toString();
      } catch {
        return "";
      }
    }, r;
  }()
), aa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), pe = (
  /** @class */
  function(r) {
    aa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.getChecksumInstance = function() {
      return new e();
    }, e.kind = "ChecksumException", e;
  }(Le)
), sa = (
  /** @class */
  function() {
    function r(e) {
      this.source = e;
    }
    return r.prototype.getLuminanceSource = function() {
      return this.source;
    }, r.prototype.getWidth = function() {
      return this.source.getWidth();
    }, r.prototype.getHeight = function() {
      return this.source.getHeight();
    }, r;
  }()
), ne = (
  /** @class */
  function() {
    function r() {
    }
    return r.arraycopy = function(e, t, n, i, o) {
      for (; o--; )
        n[i++] = e[t++];
    }, r.currentTimeMillis = function() {
      return Date.now();
    }, r;
  }()
), fa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Qr = (
  /** @class */
  function(r) {
    fa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "IndexOutOfBoundsException", e;
  }(Le)
), ua = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), In = (
  /** @class */
  function(r) {
    ua(e, r);
    function e(t, n) {
      t === void 0 && (t = void 0), n === void 0 && (n = void 0);
      var i = r.call(this, n) || this;
      return i.index = t, i.message = n, i;
    }
    return e.kind = "ArrayIndexOutOfBoundsException", e;
  }(Qr)
), ca = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, me = (
  /** @class */
  function() {
    function r() {
    }
    return r.fill = function(e, t) {
      for (var n = 0, i = e.length; n < i; n++)
        e[n] = t;
    }, r.fillWithin = function(e, t, n, i) {
      r.rangeCheck(e.length, t, n);
      for (var o = t; o < n; o++)
        e[o] = i;
    }, r.rangeCheck = function(e, t, n) {
      if (t > n)
        throw new F("fromIndex(" + t + ") > toIndex(" + n + ")");
      if (t < 0)
        throw new In(t);
      if (n > e)
        throw new In(n);
    }, r.asList = function() {
      for (var e = [], t = 0; t < arguments.length; t++)
        e[t] = arguments[t];
      return e;
    }, r.create = function(e, t, n) {
      var i = Array.from({ length: e });
      return i.map(function(o) {
        return Array.from({ length: t }).fill(n);
      });
    }, r.createInt32Array = function(e, t, n) {
      var i = Array.from({ length: e });
      return i.map(function(o) {
        return Int32Array.from({ length: t }).fill(n);
      });
    }, r.equals = function(e, t) {
      if (!e || !t || !e.length || !t.length || e.length !== t.length)
        return !1;
      for (var n = 0, i = e.length; n < i; n++)
        if (e[n] !== t[n])
          return !1;
      return !0;
    }, r.hashCode = function(e) {
      var t, n;
      if (e === null)
        return 0;
      var i = 1;
      try {
        for (var o = ca(e), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          i = 31 * i + s;
        }
      } catch (f) {
        t = { error: f };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return i;
    }, r.fillUint8Array = function(e, t) {
      for (var n = 0; n !== e.length; n++)
        e[n] = t;
    }, r.copyOf = function(e, t) {
      return e.slice(0, t);
    }, r.copyOfUint8Array = function(e, t) {
      if (e.length <= t) {
        var n = new Uint8Array(t);
        return n.set(e), n;
      }
      return e.slice(0, t);
    }, r.copyOfRange = function(e, t, n) {
      var i = n - t, o = new Int32Array(i);
      return ne.arraycopy(e, t, o, 0, i), o;
    }, r.binarySearch = function(e, t, n) {
      n === void 0 && (n = r.numberComparator);
      for (var i = 0, o = e.length - 1; i <= o; ) {
        var a = o + i >> 1, s = n(t, e[a]);
        if (s > 0)
          i = a + 1;
        else if (s < 0)
          o = a - 1;
        else
          return a;
      }
      return -i - 1;
    }, r.numberComparator = function(e, t) {
      return e - t;
    }, r;
  }()
), G = (
  /** @class */
  function() {
    function r() {
    }
    return r.numberOfTrailingZeros = function(e) {
      var t;
      if (e === 0)
        return 32;
      var n = 31;
      return t = e << 16, t !== 0 && (n -= 16, e = t), t = e << 8, t !== 0 && (n -= 8, e = t), t = e << 4, t !== 0 && (n -= 4, e = t), t = e << 2, t !== 0 && (n -= 2, e = t), n - (e << 1 >>> 31);
    }, r.numberOfLeadingZeros = function(e) {
      if (e === 0)
        return 32;
      var t = 1;
      return e >>> 16 || (t += 16, e <<= 16), e >>> 24 || (t += 8, e <<= 8), e >>> 28 || (t += 4, e <<= 4), e >>> 30 || (t += 2, e <<= 2), t -= e >>> 31, t;
    }, r.toHexString = function(e) {
      return e.toString(16);
    }, r.toBinaryString = function(e) {
      return String(parseInt(String(e), 2));
    }, r.bitCount = function(e) {
      return e = e - (e >>> 1 & 1431655765), e = (e & 858993459) + (e >>> 2 & 858993459), e = e + (e >>> 4) & 252645135, e = e + (e >>> 8), e = e + (e >>> 16), e & 63;
    }, r.truncDivision = function(e, t) {
      return Math.trunc(e / t);
    }, r.parseInt = function(e, t) {
      return t === void 0 && (t = void 0), parseInt(e, t);
    }, r.MIN_VALUE_32_BITS = -2147483648, r.MAX_VALUE = Number.MAX_SAFE_INTEGER, r;
  }()
), Ee = (
  /** @class */
  function() {
    function r(e, t) {
      e === void 0 ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, t == null ? this.bits = r.makeArray(e) : this.bits = t);
    }
    return r.prototype.getSize = function() {
      return this.size;
    }, r.prototype.getSizeInBytes = function() {
      return Math.floor((this.size + 7) / 8);
    }, r.prototype.ensureCapacity = function(e) {
      if (e > this.bits.length * 32) {
        var t = r.makeArray(e);
        ne.arraycopy(this.bits, 0, t, 0, this.bits.length), this.bits = t;
      }
    }, r.prototype.get = function(e) {
      return (this.bits[Math.floor(e / 32)] & 1 << (e & 31)) !== 0;
    }, r.prototype.set = function(e) {
      this.bits[Math.floor(e / 32)] |= 1 << (e & 31);
    }, r.prototype.flip = function(e) {
      this.bits[Math.floor(e / 32)] ^= 1 << (e & 31);
    }, r.prototype.getNextSet = function(e) {
      var t = this.size;
      if (e >= t)
        return t;
      var n = this.bits, i = Math.floor(e / 32), o = n[i];
      o &= ~((1 << (e & 31)) - 1);
      for (var a = n.length; o === 0; ) {
        if (++i === a)
          return t;
        o = n[i];
      }
      var s = i * 32 + G.numberOfTrailingZeros(o);
      return s > t ? t : s;
    }, r.prototype.getNextUnset = function(e) {
      var t = this.size;
      if (e >= t)
        return t;
      var n = this.bits, i = Math.floor(e / 32), o = ~n[i];
      o &= ~((1 << (e & 31)) - 1);
      for (var a = n.length; o === 0; ) {
        if (++i === a)
          return t;
        o = ~n[i];
      }
      var s = i * 32 + G.numberOfTrailingZeros(o);
      return s > t ? t : s;
    }, r.prototype.setBulk = function(e, t) {
      this.bits[Math.floor(e / 32)] = t;
    }, r.prototype.setRange = function(e, t) {
      if (t < e || e < 0 || t > this.size)
        throw new F();
      if (t !== e) {
        t--;
        for (var n = Math.floor(e / 32), i = Math.floor(t / 32), o = this.bits, a = n; a <= i; a++) {
          var s = a > n ? 0 : e & 31, f = a < i ? 31 : t & 31, u = (2 << f) - (1 << s);
          o[a] |= u;
        }
      }
    }, r.prototype.clear = function() {
      for (var e = this.bits.length, t = this.bits, n = 0; n < e; n++)
        t[n] = 0;
    }, r.prototype.isRange = function(e, t, n) {
      if (t < e || e < 0 || t > this.size)
        throw new F();
      if (t === e)
        return !0;
      t--;
      for (var i = Math.floor(e / 32), o = Math.floor(t / 32), a = this.bits, s = i; s <= o; s++) {
        var f = s > i ? 0 : e & 31, u = s < o ? 31 : t & 31, c = (2 << u) - (1 << f) & 4294967295;
        if ((a[s] & c) !== (n ? c : 0))
          return !1;
      }
      return !0;
    }, r.prototype.appendBit = function(e) {
      this.ensureCapacity(this.size + 1), e && (this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 31)), this.size++;
    }, r.prototype.appendBits = function(e, t) {
      if (t < 0 || t > 32)
        throw new F("Num bits must be between 0 and 32");
      this.ensureCapacity(this.size + t);
      for (var n = t; n > 0; n--)
        this.appendBit((e >> n - 1 & 1) === 1);
    }, r.prototype.appendBitArray = function(e) {
      var t = e.size;
      this.ensureCapacity(this.size + t);
      for (var n = 0; n < t; n++)
        this.appendBit(e.get(n));
    }, r.prototype.xor = function(e) {
      if (this.size !== e.size)
        throw new F("Sizes don't match");
      for (var t = this.bits, n = 0, i = t.length; n < i; n++)
        t[n] ^= e.bits[n];
    }, r.prototype.toBytes = function(e, t, n, i) {
      for (var o = 0; o < i; o++) {
        for (var a = 0, s = 0; s < 8; s++)
          this.get(e) && (a |= 1 << 7 - s), e++;
        t[n + o] = /*(byte)*/
        a;
      }
    }, r.prototype.getBitArray = function() {
      return this.bits;
    }, r.prototype.reverse = function() {
      for (var e = new Int32Array(this.bits.length), t = Math.floor((this.size - 1) / 32), n = t + 1, i = this.bits, o = 0; o < n; o++) {
        var a = i[o];
        a = a >> 1 & 1431655765 | (a & 1431655765) << 1, a = a >> 2 & 858993459 | (a & 858993459) << 2, a = a >> 4 & 252645135 | (a & 252645135) << 4, a = a >> 8 & 16711935 | (a & 16711935) << 8, a = a >> 16 & 65535 | (a & 65535) << 16, e[t - o] = /*(int)*/
        a;
      }
      if (this.size !== n * 32) {
        for (var s = n * 32 - this.size, f = e[0] >>> s, o = 1; o < n; o++) {
          var u = e[o];
          f |= u << 32 - s, e[o - 1] = f, f = u >>> s;
        }
        e[n - 1] = f;
      }
      this.bits = e;
    }, r.makeArray = function(e) {
      return new Int32Array(Math.floor((e + 31) / 32));
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.size === t.size && me.equals(this.bits, t.bits);
    }, r.prototype.hashCode = function() {
      return 31 * this.size + me.hashCode(this.bits);
    }, r.prototype.toString = function() {
      for (var e = "", t = 0, n = this.size; t < n; t++)
        t & 7 || (e += " "), e += this.get(t) ? "X" : ".";
      return e;
    }, r.prototype.clone = function() {
      return new r(this.size, this.bits.slice());
    }, r.prototype.toArray = function() {
      for (var e = [], t = 0, n = this.size; t < n; t++)
        e.push(this.get(t));
      return e;
    }, r;
  }()
), Br;
(function(r) {
  r[r.OTHER = 0] = "OTHER", r[r.PURE_BARCODE = 1] = "PURE_BARCODE", r[r.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", r[r.TRY_HARDER = 3] = "TRY_HARDER", r[r.CHARACTER_SET = 4] = "CHARACTER_SET", r[r.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", r[r.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", r[r.ASSUME_GS1 = 7] = "ASSUME_GS1", r[r.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", r[r.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", r[r.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
})(Br || (Br = {}));
const fe = Br;
var la = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), O = (
  /** @class */
  function(r) {
    la(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.getFormatInstance = function() {
      return new e();
    }, e.kind = "FormatException", e;
  }(Le)
), da = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Q;
(function(r) {
  r[r.Cp437 = 0] = "Cp437", r[r.ISO8859_1 = 1] = "ISO8859_1", r[r.ISO8859_2 = 2] = "ISO8859_2", r[r.ISO8859_3 = 3] = "ISO8859_3", r[r.ISO8859_4 = 4] = "ISO8859_4", r[r.ISO8859_5 = 5] = "ISO8859_5", r[r.ISO8859_6 = 6] = "ISO8859_6", r[r.ISO8859_7 = 7] = "ISO8859_7", r[r.ISO8859_8 = 8] = "ISO8859_8", r[r.ISO8859_9 = 9] = "ISO8859_9", r[r.ISO8859_10 = 10] = "ISO8859_10", r[r.ISO8859_11 = 11] = "ISO8859_11", r[r.ISO8859_13 = 12] = "ISO8859_13", r[r.ISO8859_14 = 13] = "ISO8859_14", r[r.ISO8859_15 = 14] = "ISO8859_15", r[r.ISO8859_16 = 15] = "ISO8859_16", r[r.SJIS = 16] = "SJIS", r[r.Cp1250 = 17] = "Cp1250", r[r.Cp1251 = 18] = "Cp1251", r[r.Cp1252 = 19] = "Cp1252", r[r.Cp1256 = 20] = "Cp1256", r[r.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", r[r.UTF8 = 22] = "UTF8", r[r.ASCII = 23] = "ASCII", r[r.Big5 = 24] = "Big5", r[r.GB18030 = 25] = "GB18030", r[r.EUC_KR = 26] = "EUC_KR";
})(Q || (Q = {}));
var ye = (
  /** @class */
  function() {
    function r(e, t, n) {
      for (var i, o, a = [], s = 3; s < arguments.length; s++)
        a[s - 3] = arguments[s];
      this.valueIdentifier = e, this.name = n, typeof t == "number" ? this.values = Int32Array.from([t]) : this.values = t, this.otherEncodingNames = a, r.VALUE_IDENTIFIER_TO_ECI.set(e, this), r.NAME_TO_ECI.set(n, this);
      for (var f = this.values, u = 0, c = f.length; u !== c; u++) {
        var l = f[u];
        r.VALUES_TO_ECI.set(l, this);
      }
      try {
        for (var d = da(a), h = d.next(); !h.done; h = d.next()) {
          var p = h.value;
          r.NAME_TO_ECI.set(p, this);
        }
      } catch (v) {
        i = { error: v };
      } finally {
        try {
          h && !h.done && (o = d.return) && o.call(d);
        } finally {
          if (i)
            throw i.error;
        }
      }
    }
    return r.prototype.getValueIdentifier = function() {
      return this.valueIdentifier;
    }, r.prototype.getName = function() {
      return this.name;
    }, r.prototype.getValue = function() {
      return this.values[0];
    }, r.getCharacterSetECIByValue = function(e) {
      if (e < 0 || e >= 900)
        throw new O("incorect value");
      var t = r.VALUES_TO_ECI.get(e);
      if (t === void 0)
        throw new O("incorect value");
      return t;
    }, r.getCharacterSetECIByName = function(e) {
      var t = r.NAME_TO_ECI.get(e);
      if (t === void 0)
        throw new O("incorect value");
      return t;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.getName() === t.getName();
    }, r.VALUE_IDENTIFIER_TO_ECI = /* @__PURE__ */ new Map(), r.VALUES_TO_ECI = /* @__PURE__ */ new Map(), r.NAME_TO_ECI = /* @__PURE__ */ new Map(), r.Cp437 = new r(Q.Cp437, Int32Array.from([0, 2]), "Cp437"), r.ISO8859_1 = new r(Q.ISO8859_1, Int32Array.from([1, 3]), "ISO-8859-1", "ISO88591", "ISO8859_1"), r.ISO8859_2 = new r(Q.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), r.ISO8859_3 = new r(Q.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), r.ISO8859_4 = new r(Q.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), r.ISO8859_5 = new r(Q.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), r.ISO8859_6 = new r(Q.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), r.ISO8859_7 = new r(Q.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), r.ISO8859_8 = new r(Q.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), r.ISO8859_9 = new r(Q.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), r.ISO8859_10 = new r(Q.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), r.ISO8859_11 = new r(Q.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), r.ISO8859_13 = new r(Q.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), r.ISO8859_14 = new r(Q.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), r.ISO8859_15 = new r(Q.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), r.ISO8859_16 = new r(Q.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), r.SJIS = new r(Q.SJIS, 20, "SJIS", "Shift_JIS"), r.Cp1250 = new r(Q.Cp1250, 21, "Cp1250", "windows-1250"), r.Cp1251 = new r(Q.Cp1251, 22, "Cp1251", "windows-1251"), r.Cp1252 = new r(Q.Cp1252, 23, "Cp1252", "windows-1252"), r.Cp1256 = new r(Q.Cp1256, 24, "Cp1256", "windows-1256"), r.UnicodeBigUnmarked = new r(Q.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), r.UTF8 = new r(Q.UTF8, 26, "UTF8", "UTF-8"), r.ASCII = new r(Q.ASCII, Int32Array.from([27, 170]), "ASCII", "US-ASCII"), r.Big5 = new r(Q.Big5, 28, "Big5"), r.GB18030 = new r(Q.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), r.EUC_KR = new r(Q.EUC_KR, 30, "EUC_KR", "EUC-KR"), r;
  }()
), ha = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Qt = (
  /** @class */
  function(r) {
    ha(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "UnsupportedOperationException", e;
  }(Le)
), Ve = (
  /** @class */
  function() {
    function r() {
    }
    return r.decode = function(e, t) {
      var n = this.encodingName(t);
      return this.customDecoder ? this.customDecoder(e, n) : typeof TextDecoder > "u" || this.shouldDecodeOnFallback(n) ? this.decodeFallback(e, n) : new TextDecoder(n).decode(e);
    }, r.shouldDecodeOnFallback = function(e) {
      return !r.isBrowser() && e === "ISO-8859-1";
    }, r.encode = function(e, t) {
      var n = this.encodingName(t);
      return this.customEncoder ? this.customEncoder(e, n) : typeof TextEncoder > "u" ? this.encodeFallback(e) : new TextEncoder().encode(e);
    }, r.isBrowser = function() {
      return typeof window < "u" && {}.toString.call(window) === "[object Window]";
    }, r.encodingName = function(e) {
      return typeof e == "string" ? e : e.getName();
    }, r.encodingCharacterSet = function(e) {
      return e instanceof ye ? e : ye.getCharacterSetECIByName(e);
    }, r.decodeFallback = function(e, t) {
      var n = this.encodingCharacterSet(t);
      if (r.isDecodeFallbackSupported(n)) {
        for (var i = "", o = 0, a = e.length; o < a; o++) {
          var s = e[o].toString(16);
          s.length < 2 && (s = "0" + s), i += "%" + s;
        }
        return decodeURIComponent(i);
      }
      if (n.equals(ye.UnicodeBigUnmarked))
        return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
      throw new Qt("Encoding " + this.encodingName(t) + " not supported by fallback.");
    }, r.isDecodeFallbackSupported = function(e) {
      return e.equals(ye.UTF8) || e.equals(ye.ISO8859_1) || e.equals(ye.ASCII);
    }, r.encodeFallback = function(e) {
      for (var t = btoa(unescape(encodeURIComponent(e))), n = t.split(""), i = [], o = 0; o < n.length; o++)
        i.push(n[o].charCodeAt(0));
      return new Uint8Array(i);
    }, r;
  }()
), X = (
  /** @class */
  function() {
    function r() {
    }
    return r.castAsNonUtf8Char = function(e, t) {
      t === void 0 && (t = null);
      var n = t ? t.getName() : this.ISO88591;
      return Ve.decode(new Uint8Array([e]), n);
    }, r.guessEncoding = function(e, t) {
      if (t != null && t.get(fe.CHARACTER_SET) !== void 0)
        return t.get(fe.CHARACTER_SET).toString();
      for (var n = e.length, i = !0, o = !0, a = !0, s = 0, f = 0, u = 0, c = 0, l = 0, d = 0, h = 0, p = 0, v = 0, y = 0, _ = 0, x = e.length > 3 && e[0] === /*(byte) */
      239 && e[1] === /*(byte) */
      187 && e[2] === /*(byte) */
      191, C = 0; C < n && (i || o || a); C++) {
        var E = e[C] & 255;
        a && (s > 0 ? E & 128 ? s-- : a = !1 : E & 128 && (E & 64 ? (s++, E & 32 ? (s++, E & 16 ? (s++, E & 8 ? a = !1 : c++) : u++) : f++) : a = !1)), i && (E > 127 && E < 160 ? i = !1 : E > 159 && (E < 192 || E === 215 || E === 247) && _++), o && (l > 0 ? E < 64 || E === 127 || E > 252 ? o = !1 : l-- : E === 128 || E === 160 || E > 239 ? o = !1 : E > 160 && E < 224 ? (d++, p = 0, h++, h > v && (v = h)) : E > 127 ? (l++, h = 0, p++, p > y && (y = p)) : (h = 0, p = 0));
      }
      return a && s > 0 && (a = !1), o && l > 0 && (o = !1), a && (x || f + u + c > 0) ? r.UTF8 : o && (r.ASSUME_SHIFT_JIS || v >= 3 || y >= 3) ? r.SHIFT_JIS : i && o ? v === 2 && d === 2 || _ * 10 >= n ? r.SHIFT_JIS : r.ISO88591 : i ? r.ISO88591 : o ? r.SHIFT_JIS : a ? r.UTF8 : r.PLATFORM_DEFAULT_ENCODING;
    }, r.format = function(e) {
      for (var t = [], n = 1; n < arguments.length; n++)
        t[n - 1] = arguments[n];
      var i = -1;
      function o(s, f, u, c, l, d) {
        if (s === "%%")
          return "%";
        if (t[++i] !== void 0) {
          s = c ? parseInt(c.substr(1)) : void 0;
          var h = l ? parseInt(l.substr(1)) : void 0, p;
          switch (d) {
            case "s":
              p = t[i];
              break;
            case "c":
              p = t[i][0];
              break;
            case "f":
              p = parseFloat(t[i]).toFixed(s);
              break;
            case "p":
              p = parseFloat(t[i]).toPrecision(s);
              break;
            case "e":
              p = parseFloat(t[i]).toExponential(s);
              break;
            case "x":
              p = parseInt(t[i]).toString(h || 16);
              break;
            case "d":
              p = parseFloat(parseInt(t[i], h || 10).toPrecision(s)).toFixed(0);
              break;
          }
          p = typeof p == "object" ? JSON.stringify(p) : (+p).toString(h);
          for (var v = parseInt(u), y = u && u[0] + "" == "0" ? "0" : " "; p.length < v; )
            p = f !== void 0 ? p + y : y + p;
          return p;
        }
      }
      var a = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return e.replace(a, o);
    }, r.getBytes = function(e, t) {
      return Ve.encode(e, t);
    }, r.getCharCode = function(e, t) {
      return t === void 0 && (t = 0), e.charCodeAt(t);
    }, r.getCharAt = function(e) {
      return String.fromCharCode(e);
    }, r.SHIFT_JIS = ye.SJIS.getName(), r.GB2312 = "GB2312", r.ISO88591 = ye.ISO8859_1.getName(), r.EUC_JP = "EUC_JP", r.UTF8 = ye.UTF8.getName(), r.PLATFORM_DEFAULT_ENCODING = r.UTF8, r.ASSUME_SHIFT_JIS = !1, r;
  }()
), V = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = ""), this.value = e;
    }
    return r.prototype.enableDecoding = function(e) {
      return this.encoding = e, this;
    }, r.prototype.append = function(e) {
      return typeof e == "string" ? this.value += e.toString() : this.encoding ? this.value += X.castAsNonUtf8Char(e, this.encoding) : this.value += String.fromCharCode(e), this;
    }, r.prototype.appendChars = function(e, t, n) {
      for (var i = t; t < t + n; i++)
        this.append(e[i]);
      return this;
    }, r.prototype.length = function() {
      return this.value.length;
    }, r.prototype.charAt = function(e) {
      return this.value.charAt(e);
    }, r.prototype.deleteCharAt = function(e) {
      this.value = this.value.substr(0, e) + this.value.substring(e + 1);
    }, r.prototype.setCharAt = function(e, t) {
      this.value = this.value.substr(0, e) + t + this.value.substr(e + 1);
    }, r.prototype.substring = function(e, t) {
      return this.value.substring(e, t);
    }, r.prototype.setLengthToZero = function() {
      this.value = "";
    }, r.prototype.toString = function() {
      return this.value;
    }, r.prototype.insert = function(e, t) {
      this.value = this.value.substring(0, e) + t + this.value.substring(e);
    }, r;
  }()
), Ye = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      if (this.width = e, this.height = t, this.rowSize = n, this.bits = i, t == null && (t = e), this.height = t, e < 1 || t < 1)
        throw new F("Both dimensions must be greater than 0");
      n == null && (n = Math.floor((e + 31) / 32)), this.rowSize = n, i == null && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return r.parseFromBooleanArray = function(e) {
      for (var t = e.length, n = e[0].length, i = new r(n, t), o = 0; o < t; o++)
        for (var a = e[o], s = 0; s < n; s++)
          a[s] && i.set(s, o);
      return i;
    }, r.parseFromString = function(e, t, n) {
      if (e === null)
        throw new F("stringRepresentation cannot be null");
      for (var i = new Array(e.length), o = 0, a = 0, s = -1, f = 0, u = 0; u < e.length; )
        if (e.charAt(u) === `
` || e.charAt(u) === "\r") {
          if (o > a) {
            if (s === -1)
              s = o - a;
            else if (o - a !== s)
              throw new F("row lengths do not match");
            a = o, f++;
          }
          u++;
        } else if (e.substring(u, u + t.length) === t)
          u += t.length, i[o] = !0, o++;
        else if (e.substring(u, u + n.length) === n)
          u += n.length, i[o] = !1, o++;
        else
          throw new F("illegal character encountered: " + e.substring(u));
      if (o > a) {
        if (s === -1)
          s = o - a;
        else if (o - a !== s)
          throw new F("row lengths do not match");
        f++;
      }
      for (var c = new r(s, f), l = 0; l < o; l++)
        i[l] && c.set(Math.floor(l % s), Math.floor(l / s));
      return c;
    }, r.prototype.get = function(e, t) {
      var n = t * this.rowSize + Math.floor(e / 32);
      return (this.bits[n] >>> (e & 31) & 1) !== 0;
    }, r.prototype.set = function(e, t) {
      var n = t * this.rowSize + Math.floor(e / 32);
      this.bits[n] |= 1 << (e & 31) & 4294967295;
    }, r.prototype.unset = function(e, t) {
      var n = t * this.rowSize + Math.floor(e / 32);
      this.bits[n] &= ~(1 << (e & 31) & 4294967295);
    }, r.prototype.flip = function(e, t) {
      var n = t * this.rowSize + Math.floor(e / 32);
      this.bits[n] ^= 1 << (e & 31) & 4294967295;
    }, r.prototype.xor = function(e) {
      if (this.width !== e.getWidth() || this.height !== e.getHeight() || this.rowSize !== e.getRowSize())
        throw new F("input matrix dimensions do not match");
      for (var t = new Ee(Math.floor(this.width / 32) + 1), n = this.rowSize, i = this.bits, o = 0, a = this.height; o < a; o++)
        for (var s = o * n, f = e.getRow(o, t).getBitArray(), u = 0; u < n; u++)
          i[s + u] ^= f[u];
    }, r.prototype.clear = function() {
      for (var e = this.bits, t = e.length, n = 0; n < t; n++)
        e[n] = 0;
    }, r.prototype.setRegion = function(e, t, n, i) {
      if (t < 0 || e < 0)
        throw new F("Left and top must be nonnegative");
      if (i < 1 || n < 1)
        throw new F("Height and width must be at least 1");
      var o = e + n, a = t + i;
      if (a > this.height || o > this.width)
        throw new F("The region must fit inside the matrix");
      for (var s = this.rowSize, f = this.bits, u = t; u < a; u++)
        for (var c = u * s, l = e; l < o; l++)
          f[c + Math.floor(l / 32)] |= 1 << (l & 31) & 4294967295;
    }, r.prototype.getRow = function(e, t) {
      t == null || t.getSize() < this.width ? t = new Ee(this.width) : t.clear();
      for (var n = this.rowSize, i = this.bits, o = e * n, a = 0; a < n; a++)
        t.setBulk(a * 32, i[o + a]);
      return t;
    }, r.prototype.setRow = function(e, t) {
      ne.arraycopy(t.getBitArray(), 0, this.bits, e * this.rowSize, this.rowSize);
    }, r.prototype.rotate180 = function() {
      for (var e = this.getWidth(), t = this.getHeight(), n = new Ee(e), i = new Ee(e), o = 0, a = Math.floor((t + 1) / 2); o < a; o++)
        n = this.getRow(o, n), i = this.getRow(t - 1 - o, i), n.reverse(), i.reverse(), this.setRow(o, i), this.setRow(t - 1 - o, n);
    }, r.prototype.getEnclosingRectangle = function() {
      for (var e = this.width, t = this.height, n = this.rowSize, i = this.bits, o = e, a = t, s = -1, f = -1, u = 0; u < t; u++)
        for (var c = 0; c < n; c++) {
          var l = i[u * n + c];
          if (l !== 0) {
            if (u < a && (a = u), u > f && (f = u), c * 32 < o) {
              for (var d = 0; !(l << 31 - d & 4294967295); )
                d++;
              c * 32 + d < o && (o = c * 32 + d);
            }
            if (c * 32 + 31 > s) {
              for (var d = 31; !(l >>> d); )
                d--;
              c * 32 + d > s && (s = c * 32 + d);
            }
          }
        }
      return s < o || f < a ? null : Int32Array.from([o, a, s - o + 1, f - a + 1]);
    }, r.prototype.getTopLeftOnBit = function() {
      for (var e = this.rowSize, t = this.bits, n = 0; n < t.length && t[n] === 0; )
        n++;
      if (n === t.length)
        return null;
      for (var i = n / e, o = n % e * 32, a = t[n], s = 0; !(a << 31 - s & 4294967295); )
        s++;
      return o += s, Int32Array.from([o, i]);
    }, r.prototype.getBottomRightOnBit = function() {
      for (var e = this.rowSize, t = this.bits, n = t.length - 1; n >= 0 && t[n] === 0; )
        n--;
      if (n < 0)
        return null;
      for (var i = Math.floor(n / e), o = Math.floor(n % e) * 32, a = t[n], s = 31; !(a >>> s); )
        s--;
      return o += s, Int32Array.from([o, i]);
    }, r.prototype.getWidth = function() {
      return this.width;
    }, r.prototype.getHeight = function() {
      return this.height;
    }, r.prototype.getRowSize = function() {
      return this.rowSize;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.width === t.width && this.height === t.height && this.rowSize === t.rowSize && me.equals(this.bits, t.bits);
    }, r.prototype.hashCode = function() {
      var e = this.width;
      return e = 31 * e + this.width, e = 31 * e + this.height, e = 31 * e + this.rowSize, e = 31 * e + me.hashCode(this.bits), e;
    }, r.prototype.toString = function(e, t, n) {
      return e === void 0 && (e = "X "), t === void 0 && (t = "  "), n === void 0 && (n = `
`), this.buildToString(e, t, n);
    }, r.prototype.buildToString = function(e, t, n) {
      for (var i = new V(), o = 0, a = this.height; o < a; o++) {
        for (var s = 0, f = this.width; s < f; s++)
          i.append(this.get(s, o) ? e : t);
        i.append(n);
      }
      return i.toString();
    }, r.prototype.clone = function() {
      return new r(this.width, this.height, this.rowSize, this.bits.slice());
    }, r;
  }()
), pa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), w = (
  /** @class */
  function(r) {
    pa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.getNotFoundInstance = function() {
      return new e();
    }, e.kind = "NotFoundException", e;
  }(Le)
), va = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ga = (
  /** @class */
  function(r) {
    va(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return e.prototype.getBlackRow = function(t, n) {
      var i = this.getLuminanceSource(), o = i.getWidth();
      n == null || n.getSize() < o ? n = new Ee(o) : n.clear(), this.initArrays(o);
      for (var a = i.getRow(t, this.luminances), s = this.buckets, f = 0; f < o; f++)
        s[(a[f] & 255) >> e.LUMINANCE_SHIFT]++;
      var u = e.estimateBlackPoint(s);
      if (o < 3)
        for (var f = 0; f < o; f++)
          (a[f] & 255) < u && n.set(f);
      else
        for (var c = a[0] & 255, l = a[1] & 255, f = 1; f < o - 1; f++) {
          var d = a[f + 1] & 255;
          (l * 4 - c - d) / 2 < u && n.set(f), c = l, l = d;
        }
      return n;
    }, e.prototype.getBlackMatrix = function() {
      var t = this.getLuminanceSource(), n = t.getWidth(), i = t.getHeight(), o = new Ye(n, i);
      this.initArrays(n);
      for (var a = this.buckets, s = 1; s < 5; s++)
        for (var f = Math.floor(i * s / 5), u = t.getRow(f, this.luminances), c = Math.floor(n * 4 / 5), l = Math.floor(n / 5); l < c; l++) {
          var d = u[l] & 255;
          a[d >> e.LUMINANCE_SHIFT]++;
        }
      for (var h = e.estimateBlackPoint(a), p = t.getMatrix(), s = 0; s < i; s++)
        for (var v = s * n, l = 0; l < n; l++) {
          var d = p[v + l] & 255;
          d < h && o.set(l, s);
        }
      return o;
    }, e.prototype.createBinarizer = function(t) {
      return new e(t);
    }, e.prototype.initArrays = function(t) {
      this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
      for (var n = this.buckets, i = 0; i < e.LUMINANCE_BUCKETS; i++)
        n[i] = 0;
    }, e.estimateBlackPoint = function(t) {
      for (var n = t.length, i = 0, o = 0, a = 0, s = 0; s < n; s++)
        t[s] > a && (o = s, a = t[s]), t[s] > i && (i = t[s]);
      for (var f = 0, u = 0, s = 0; s < n; s++) {
        var c = s - o, l = t[s] * c * c;
        l > u && (f = s, u = l);
      }
      if (o > f) {
        var d = o;
        o = f, f = d;
      }
      if (f - o <= n / 16)
        throw new w();
      for (var h = f - 1, p = -1, s = f - 1; s > o; s--) {
        var v = s - o, l = v * v * (f - s) * (i - t[s]);
        l > p && (h = s, p = l);
      }
      return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([0]), e;
  }(sa)
), xa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xi = (
  /** @class */
  function(r) {
    xa(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return n.matrix = null, n;
    }
    return e.prototype.getBlackMatrix = function() {
      if (this.matrix !== null)
        return this.matrix;
      var t = this.getLuminanceSource(), n = t.getWidth(), i = t.getHeight();
      if (n >= e.MINIMUM_DIMENSION && i >= e.MINIMUM_DIMENSION) {
        var o = t.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
        n & e.BLOCK_SIZE_MASK && a++;
        var s = i >> e.BLOCK_SIZE_POWER;
        i & e.BLOCK_SIZE_MASK && s++;
        var f = e.calculateBlackPoints(o, a, s, n, i), u = new Ye(n, i);
        e.calculateThresholdForBlock(o, a, s, n, i, f, u), this.matrix = u;
      } else
        this.matrix = r.prototype.getBlackMatrix.call(this);
      return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
      return new e(t);
    }, e.calculateThresholdForBlock = function(t, n, i, o, a, s, f) {
      for (var u = a - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, l = 0; l < i; l++) {
        var d = l << e.BLOCK_SIZE_POWER;
        d > u && (d = u);
        for (var h = e.cap(l, 2, i - 3), p = 0; p < n; p++) {
          var v = p << e.BLOCK_SIZE_POWER;
          v > c && (v = c);
          for (var y = e.cap(p, 2, n - 3), _ = 0, x = -2; x <= 2; x++) {
            var C = s[h + x];
            _ += C[y - 2] + C[y - 1] + C[y] + C[y + 1] + C[y + 2];
          }
          var E = _ / 25;
          e.thresholdBlock(t, v, d, E, o, f);
        }
      }
    }, e.cap = function(t, n, i) {
      return t < n ? n : t > i ? i : t;
    }, e.thresholdBlock = function(t, n, i, o, a, s) {
      for (var f = 0, u = i * a + n; f < e.BLOCK_SIZE; f++, u += a)
        for (var c = 0; c < e.BLOCK_SIZE; c++)
          (t[u + c] & 255) <= o && s.set(n + c, i + f);
    }, e.calculateBlackPoints = function(t, n, i, o, a) {
      for (var s = a - e.BLOCK_SIZE, f = o - e.BLOCK_SIZE, u = new Array(i), c = 0; c < i; c++) {
        u[c] = new Int32Array(n);
        var l = c << e.BLOCK_SIZE_POWER;
        l > s && (l = s);
        for (var d = 0; d < n; d++) {
          var h = d << e.BLOCK_SIZE_POWER;
          h > f && (h = f);
          for (var p = 0, v = 255, y = 0, _ = 0, x = l * o + h; _ < e.BLOCK_SIZE; _++, x += o) {
            for (var C = 0; C < e.BLOCK_SIZE; C++) {
              var E = t[x + C] & 255;
              p += E, E < v && (v = E), E > y && (y = E);
            }
            if (y - v > e.MIN_DYNAMIC_RANGE)
              for (_++, x += o; _ < e.BLOCK_SIZE; _++, x += o)
                for (var C = 0; C < e.BLOCK_SIZE; C++)
                  p += t[x + C] & 255;
          }
          var S = p >> e.BLOCK_SIZE_POWER * 2;
          if (y - v <= e.MIN_DYNAMIC_RANGE && (S = v / 2, c > 0 && d > 0)) {
            var I = (u[c - 1][d] + 2 * u[c][d - 1] + u[c - 1][d - 1]) / 4;
            v < I && (S = I);
          }
          u[c][d] = S;
        }
      }
      return u;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = e.BLOCK_SIZE * 5, e.MIN_DYNAMIC_RANGE = 24, e;
  }(ga)
), Ut = (
  /** @class */
  function() {
    function r(e, t) {
      this.width = e, this.height = t;
    }
    return r.prototype.getWidth = function() {
      return this.width;
    }, r.prototype.getHeight = function() {
      return this.height;
    }, r.prototype.isCropSupported = function() {
      return !1;
    }, r.prototype.crop = function(e, t, n, i) {
      throw new Qt("This luminance source does not support cropping.");
    }, r.prototype.isRotateSupported = function() {
      return !1;
    }, r.prototype.rotateCounterClockwise = function() {
      throw new Qt("This luminance source does not support rotation by 90 degrees.");
    }, r.prototype.rotateCounterClockwise45 = function() {
      throw new Qt("This luminance source does not support rotation by 45 degrees.");
    }, r.prototype.toString = function() {
      for (var e = new Uint8ClampedArray(this.width), t = new V(), n = 0; n < this.height; n++) {
        for (var i = this.getRow(n, e), o = 0; o < this.width; o++) {
          var a = i[o] & 255, s = void 0;
          a < 64 ? s = "#" : a < 128 ? s = "+" : a < 192 ? s = "." : s = " ", t.append(s);
        }
        t.append(`
`);
      }
      return t.toString();
    }, r;
  }()
), ya = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), hr = (
  /** @class */
  function(r) {
    ya(e, r);
    function e(t) {
      var n = r.call(this, t.getWidth(), t.getHeight()) || this;
      return n.delegate = t, n;
    }
    return e.prototype.getRow = function(t, n) {
      for (var i = this.delegate.getRow(t, n), o = this.getWidth(), a = 0; a < o; a++)
        i[a] = /*(byte)*/
        255 - (i[a] & 255);
      return i;
    }, e.prototype.getMatrix = function() {
      for (var t = this.delegate.getMatrix(), n = this.getWidth() * this.getHeight(), i = new Uint8ClampedArray(n), o = 0; o < n; o++)
        i[o] = /*(byte)*/
        255 - (t[o] & 255);
      return i;
    }, e.prototype.isCropSupported = function() {
      return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, n, i, o) {
      return new e(this.delegate.crop(t, n, i, o));
    }, e.prototype.isRotateSupported = function() {
      return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
      return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
      return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
      return new e(this.delegate.rotateCounterClockwise45());
    }, e;
  }(Ut)
), ma = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), _a = (
  /** @class */
  function(r) {
    ma(e, r);
    function e(t) {
      var n = r.call(this, t.width, t.height) || this;
      return n.canvas = t, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(t), n;
    }
    return e.makeBufferFromCanvasImageData = function(t) {
      var n = t.getContext("2d").getImageData(0, 0, t.width, t.height);
      return e.toGrayscaleBuffer(n.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, n, i) {
      var o = new Uint8ClampedArray(n * i);
      if (e.FRAME_INDEX = !e.FRAME_INDEX, e.FRAME_INDEX)
        for (var a = 0, s = 0, f = t.length; a < f; a += 4, s++) {
          var u = void 0, c = t[a + 3];
          if (c === 0)
            u = 255;
          else {
            var l = t[a], d = t[a + 1], h = t[a + 2];
            u = 306 * l + 601 * d + 117 * h + 512 >> 10;
          }
          o[s] = u;
        }
      else
        for (var a = 0, s = 0, p = t.length; a < p; a += 4, s++) {
          var u = void 0, c = t[a + 3];
          if (c === 0)
            u = 255;
          else {
            var l = t[a], d = t[a + 1], h = t[a + 2];
            u = 306 * l + 601 * d + 117 * h + 512 >> 10;
          }
          o[s] = 255 - u;
        }
      return o;
    }, e.prototype.getRow = function(t, n) {
      if (t < 0 || t >= this.getHeight())
        throw new F("Requested row is outside the image: " + t);
      var i = this.getWidth(), o = t * i;
      return n === null ? n = this.buffer.slice(o, o + i) : (n.length < i && (n = new Uint8ClampedArray(i)), n.set(this.buffer.slice(o, o + i))), n;
    }, e.prototype.getMatrix = function() {
      return this.buffer;
    }, e.prototype.isCropSupported = function() {
      return !0;
    }, e.prototype.crop = function(t, n, i, o) {
      return r.prototype.crop.call(this, t, n, i, o), this;
    }, e.prototype.isRotateSupported = function() {
      return !0;
    }, e.prototype.rotateCounterClockwise = function() {
      return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
      return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
      if (this.tempCanvasElement === null) {
        var t = this.canvas.ownerDocument.createElement("canvas");
        t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
      }
      return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
      var n = this.getTempCanvasElement(), i = n.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, a = this.canvas.width, s = this.canvas.height, f = Math.ceil(Math.abs(Math.cos(o)) * a + Math.abs(Math.sin(o)) * s), u = Math.ceil(Math.abs(Math.sin(o)) * a + Math.abs(Math.cos(o)) * s);
      return n.width = f, n.height = u, i.translate(f / 2, u / 2), i.rotate(o), i.drawImage(this.canvas, a / -2, s / -2), this.buffer = e.makeBufferFromCanvasImageData(n), this;
    }, e.prototype.invert = function() {
      return new hr(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e.FRAME_INDEX = !0, e;
  }(Ut)
), Ca = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.deviceId = e, this.label = t, this.kind = "videoinput", this.groupId = n || void 0;
    }
    return r.prototype.toJSON = function() {
      return {
        kind: this.kind,
        groupId: this.groupId,
        deviceId: this.deviceId,
        label: this.label
      };
    }, r;
  }()
), De = function(r, e, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function s(c) {
      try {
        u(n.next(c));
      } catch (l) {
        a(l);
      }
    }
    function f(c) {
      try {
        u(n.throw(c));
      } catch (l) {
        a(l);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, f);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, Pe = function(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return f([u, c]);
    };
  }
  function f(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = u;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(u);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (c) {
        u = [6, c], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Aa = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, wt = (
  /** @class */
  function() {
    function r(e, t, n) {
      t === void 0 && (t = 500), this.reader = e, this.timeBetweenScansMillis = t, this._hints = n, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(r.prototype, "hasNavigator", {
      /**
       * If navigator is present.
       */
      get: function() {
        return typeof navigator < "u";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isMediaDevicesSuported", {
      /**
       * If mediaDevices under navigator is supported.
       */
      get: function() {
        return this.hasNavigator && !!navigator.mediaDevices;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "canEnumerateDevices", {
      /**
       * If enumerateDevices under navigator is supported.
       */
      get: function() {
        return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "timeBetweenDecodingAttempts", {
      /** Time between two decoding tries in milli seconds. */
      get: function() {
        return this._timeBetweenDecodingAttempts;
      },
      /**
       * Change the time span the decoder waits between two decoding tries.
       *
       * @param {number} millis Time between two decoding tries in milli seconds.
       */
      set: function(e) {
        this._timeBetweenDecodingAttempts = e < 0 ? 0 : e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "hints", {
      /**
       * Sets the hints.
       */
      get: function() {
        return this._hints;
      },
      /**
       * Sets the hints.
       */
      set: function(e) {
        this._hints = e || null;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.listVideoInputDevices = function() {
      return De(this, void 0, void 0, function() {
        var e, t, n, i, o, a, s, f, u, c, l, d;
        return Pe(this, function(h) {
          switch (h.label) {
            case 0:
              if (!this.hasNavigator)
                throw new Error("Can't enumerate devices, navigator is not present.");
              if (!this.canEnumerateDevices)
                throw new Error("Can't enumerate devices, method not supported.");
              return [4, navigator.mediaDevices.enumerateDevices()];
            case 1:
              e = h.sent(), t = [];
              try {
                for (n = Aa(e), i = n.next(); !i.done; i = n.next())
                  o = i.value, a = o.kind === "video" ? "videoinput" : o.kind, a === "videoinput" && (s = o.deviceId || o.id, f = o.label || "Video device " + (t.length + 1), u = o.groupId, c = { deviceId: s, label: f, kind: a, groupId: u }, t.push(c));
              } catch (p) {
                l = { error: p };
              } finally {
                try {
                  i && !i.done && (d = n.return) && d.call(n);
                } finally {
                  if (l)
                    throw l.error;
                }
              }
              return [2, t];
          }
        });
      });
    }, r.prototype.getVideoInputDevices = function() {
      return De(this, void 0, void 0, function() {
        var e;
        return Pe(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return e = t.sent(), [2, e.map(function(n) {
                return new Ca(n.deviceId, n.label);
              })];
          }
        });
      });
    }, r.prototype.findDeviceById = function(e) {
      return De(this, void 0, void 0, function() {
        var t;
        return Pe(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.listVideoInputDevices()];
            case 1:
              return t = n.sent(), t ? [2, t.find(function(i) {
                return i.deviceId === e;
              })] : [2, null];
          }
        });
      });
    }, r.prototype.decodeFromInputVideoDevice = function(e, t) {
      return De(this, void 0, void 0, function() {
        return Pe(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.decodeOnceFromVideoDevice(e, t)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromVideoDevice = function(e, t) {
      return De(this, void 0, void 0, function() {
        var n, i;
        return Pe(this, function(o) {
          switch (o.label) {
            case 0:
              return this.reset(), e ? n = { deviceId: { exact: e } } : n = { facingMode: "environment" }, i = { video: n }, [4, this.decodeOnceFromConstraints(i, t)];
            case 1:
              return [2, o.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromConstraints = function(e, t) {
      return De(this, void 0, void 0, function() {
        var n;
        return Pe(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(e)];
            case 1:
              return n = i.sent(), [4, this.decodeOnceFromStream(n, t)];
            case 2:
              return [2, i.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromStream = function(e, t) {
      return De(this, void 0, void 0, function() {
        var n, i;
        return Pe(this, function(o) {
          switch (o.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(e, t)];
            case 1:
              return n = o.sent(), [4, this.decodeOnce(n)];
            case 2:
              return i = o.sent(), [2, i];
          }
        });
      });
    }, r.prototype.decodeFromInputVideoDeviceContinuously = function(e, t, n) {
      return De(this, void 0, void 0, function() {
        return Pe(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.decodeFromVideoDevice(e, t, n)];
            case 1:
              return [2, i.sent()];
          }
        });
      });
    }, r.prototype.decodeFromVideoDevice = function(e, t, n) {
      return De(this, void 0, void 0, function() {
        var i, o;
        return Pe(this, function(a) {
          switch (a.label) {
            case 0:
              return e ? i = { deviceId: { exact: e } } : i = { facingMode: "environment" }, o = { video: i }, [4, this.decodeFromConstraints(o, t, n)];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, r.prototype.decodeFromConstraints = function(e, t, n) {
      return De(this, void 0, void 0, function() {
        var i;
        return Pe(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(e)];
            case 1:
              return i = o.sent(), [4, this.decodeFromStream(i, t, n)];
            case 2:
              return [2, o.sent()];
          }
        });
      });
    }, r.prototype.decodeFromStream = function(e, t, n) {
      return De(this, void 0, void 0, function() {
        var i;
        return Pe(this, function(o) {
          switch (o.label) {
            case 0:
              return this.reset(), [4, this.attachStreamToVideo(e, t)];
            case 1:
              return i = o.sent(), [4, this.decodeContinuously(i, n)];
            case 2:
              return [2, o.sent()];
          }
        });
      });
    }, r.prototype.stopAsyncDecode = function() {
      this._stopAsyncDecode = !0;
    }, r.prototype.stopContinuousDecode = function() {
      this._stopContinuousDecode = !0;
    }, r.prototype.attachStreamToVideo = function(e, t) {
      return De(this, void 0, void 0, function() {
        var n;
        return Pe(this, function(i) {
          switch (i.label) {
            case 0:
              return n = this.prepareVideoElement(t), this.addVideoSource(n, e), this.videoElement = n, this.stream = e, [4, this.playVideoOnLoadAsync(n)];
            case 1:
              return i.sent(), [2, n];
          }
        });
      });
    }, r.prototype.playVideoOnLoadAsync = function(e) {
      var t = this;
      return new Promise(function(n, i) {
        return t.playVideoOnLoad(e, function() {
          return n();
        });
      });
    }, r.prototype.playVideoOnLoad = function(e, t) {
      var n = this;
      this.videoEndedListener = function() {
        return n.stopStreams();
      }, this.videoCanPlayListener = function() {
        return n.tryPlayVideo(e);
      }, e.addEventListener("ended", this.videoEndedListener), e.addEventListener("canplay", this.videoCanPlayListener), e.addEventListener("playing", t), this.tryPlayVideo(e);
    }, r.prototype.isVideoPlaying = function(e) {
      return e.currentTime > 0 && !e.paused && !e.ended && e.readyState > 2;
    }, r.prototype.tryPlayVideo = function(e) {
      return De(this, void 0, void 0, function() {
        return Pe(this, function(t) {
          switch (t.label) {
            case 0:
              if (this.isVideoPlaying(e))
                return console.warn("Trying to play video that is already playing."), [
                  2
                  /*return*/
                ];
              t.label = 1;
            case 1:
              return t.trys.push([1, 3, , 4]), [4, e.play()];
            case 2:
              return t.sent(), [3, 4];
            case 3:
              return t.sent(), console.warn("It was not possible to play the video."), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.getMediaElement = function(e, t) {
      var n = document.getElementById(e);
      if (!n)
        throw new de("element with id '" + e + "' not found");
      if (n.nodeName.toLowerCase() !== t.toLowerCase())
        throw new de("element with id '" + e + "' must be an " + t + " element");
      return n;
    }, r.prototype.decodeFromImage = function(e, t) {
      if (!e && !t)
        throw new de("either imageElement with a src set or an url must be provided");
      return t && !e ? this.decodeFromImageUrl(t) : this.decodeFromImageElement(e);
    }, r.prototype.decodeFromVideo = function(e, t) {
      if (!e && !t)
        throw new de("Either an element with a src set or an URL must be provided");
      return t && !e ? this.decodeFromVideoUrl(t) : this.decodeFromVideoElement(e);
    }, r.prototype.decodeFromVideoContinuously = function(e, t, n) {
      if (e === void 0 && t === void 0)
        throw new de("Either an element with a src set or an URL must be provided");
      return t && !e ? this.decodeFromVideoUrlContinuously(t, n) : this.decodeFromVideoElementContinuously(e, n);
    }, r.prototype.decodeFromImageElement = function(e) {
      if (!e)
        throw new de("An image element must be provided.");
      this.reset();
      var t = this.prepareImageElement(e);
      this.imageElement = t;
      var n;
      return this.isImageLoaded(t) ? n = this.decodeOnce(t, !1, !0) : n = this._decodeOnLoadImage(t), n;
    }, r.prototype.decodeFromVideoElement = function(e) {
      var t = this._decodeFromVideoElementSetup(e);
      return this._decodeOnLoadVideo(t);
    }, r.prototype.decodeFromVideoElementContinuously = function(e, t) {
      var n = this._decodeFromVideoElementSetup(e);
      return this._decodeOnLoadVideoContinuously(n, t);
    }, r.prototype._decodeFromVideoElementSetup = function(e) {
      if (!e)
        throw new de("A video element must be provided.");
      this.reset();
      var t = this.prepareVideoElement(e);
      return this.videoElement = t, t;
    }, r.prototype.decodeFromImageUrl = function(e) {
      if (!e)
        throw new de("An URL must be provided.");
      this.reset();
      var t = this.prepareImageElement();
      this.imageElement = t;
      var n = this._decodeOnLoadImage(t);
      return t.src = e, n;
    }, r.prototype.decodeFromVideoUrl = function(e) {
      if (!e)
        throw new de("An URL must be provided.");
      this.reset();
      var t = this.prepareVideoElement(), n = this.decodeFromVideoElement(t);
      return t.src = e, n;
    }, r.prototype.decodeFromVideoUrlContinuously = function(e, t) {
      if (!e)
        throw new de("An URL must be provided.");
      this.reset();
      var n = this.prepareVideoElement(), i = this.decodeFromVideoElementContinuously(n, t);
      return n.src = e, i;
    }, r.prototype._decodeOnLoadImage = function(e) {
      var t = this;
      return new Promise(function(n, i) {
        t.imageLoadedListener = function() {
          return t.decodeOnce(e, !1, !0).then(n, i);
        }, e.addEventListener("load", t.imageLoadedListener);
      });
    }, r.prototype._decodeOnLoadVideo = function(e) {
      return De(this, void 0, void 0, function() {
        return Pe(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(e)];
            case 1:
              return t.sent(), [4, this.decodeOnce(e)];
            case 2:
              return [2, t.sent()];
          }
        });
      });
    }, r.prototype._decodeOnLoadVideoContinuously = function(e, t) {
      return De(this, void 0, void 0, function() {
        return Pe(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.playVideoOnLoadAsync(e)];
            case 1:
              return n.sent(), this.decodeContinuously(e, t), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.isImageLoaded = function(e) {
      return !(!e.complete || e.naturalWidth === 0);
    }, r.prototype.prepareImageElement = function(e) {
      var t;
      return typeof e > "u" && (t = document.createElement("img"), t.width = 200, t.height = 200), typeof e == "string" && (t = this.getMediaElement(e, "img")), e instanceof HTMLImageElement && (t = e), t;
    }, r.prototype.prepareVideoElement = function(e) {
      var t;
      return !e && typeof document < "u" && (t = document.createElement("video"), t.width = 200, t.height = 200), typeof e == "string" && (t = this.getMediaElement(e, "video")), e instanceof HTMLVideoElement && (t = e), t.setAttribute("autoplay", "true"), t.setAttribute("muted", "true"), t.setAttribute("playsinline", "true"), t;
    }, r.prototype.decodeOnce = function(e, t, n) {
      var i = this;
      t === void 0 && (t = !0), n === void 0 && (n = !0), this._stopAsyncDecode = !1;
      var o = function(a, s) {
        if (i._stopAsyncDecode) {
          s(new w("Video stream has ended before any code could be detected.")), i._stopAsyncDecode = void 0;
          return;
        }
        try {
          var f = i.decode(e);
          a(f);
        } catch (d) {
          var u = t && d instanceof w, c = d instanceof pe || d instanceof O, l = c && n;
          if (u || l)
            return setTimeout(o, i._timeBetweenDecodingAttempts, a, s);
          s(d);
        }
      };
      return new Promise(function(a, s) {
        return o(a, s);
      });
    }, r.prototype.decodeContinuously = function(e, t) {
      var n = this;
      this._stopContinuousDecode = !1;
      var i = function() {
        if (n._stopContinuousDecode) {
          n._stopContinuousDecode = void 0;
          return;
        }
        try {
          var o = n.decode(e);
          t(o, null), setTimeout(i, n.timeBetweenScansMillis);
        } catch (f) {
          t(null, f);
          var a = f instanceof pe || f instanceof O, s = f instanceof w;
          (a || s) && setTimeout(i, n._timeBetweenDecodingAttempts);
        }
      };
      i();
    }, r.prototype.decode = function(e) {
      var t = this.createBinaryBitmap(e);
      return this.decodeBitmap(t);
    }, r.prototype.createBinaryBitmap = function(e) {
      this.getCaptureCanvasContext(e), e instanceof HTMLVideoElement ? this.drawFrameOnCanvas(e) : this.drawImageOnCanvas(e);
      var t = this.getCaptureCanvas(e), n = new _a(t), i = new xi(n);
      return new gi(i);
    }, r.prototype.getCaptureCanvasContext = function(e) {
      if (!this.captureCanvasContext) {
        var t = this.getCaptureCanvas(e), n = void 0;
        try {
          n = t.getContext("2d", { willReadFrequently: !0 });
        } catch {
          n = t.getContext("2d");
        }
        this.captureCanvasContext = n;
      }
      return this.captureCanvasContext;
    }, r.prototype.getCaptureCanvas = function(e) {
      if (!this.captureCanvas) {
        var t = this.createCaptureCanvas(e);
        this.captureCanvas = t;
      }
      return this.captureCanvas;
    }, r.prototype.drawFrameOnCanvas = function(e, t, n) {
      t === void 0 && (t = {
        sx: 0,
        sy: 0,
        sWidth: e.videoWidth,
        sHeight: e.videoHeight,
        dx: 0,
        dy: 0,
        dWidth: e.videoWidth,
        dHeight: e.videoHeight
      }), n === void 0 && (n = this.captureCanvasContext), n.drawImage(e, t.sx, t.sy, t.sWidth, t.sHeight, t.dx, t.dy, t.dWidth, t.dHeight);
    }, r.prototype.drawImageOnCanvas = function(e, t, n) {
      t === void 0 && (t = {
        sx: 0,
        sy: 0,
        sWidth: e.naturalWidth,
        sHeight: e.naturalHeight,
        dx: 0,
        dy: 0,
        dWidth: e.naturalWidth,
        dHeight: e.naturalHeight
      }), n === void 0 && (n = this.captureCanvasContext), n.drawImage(e, t.sx, t.sy, t.sWidth, t.sHeight, t.dx, t.dy, t.dWidth, t.dHeight);
    }, r.prototype.decodeBitmap = function(e) {
      return this.reader.decode(e, this._hints);
    }, r.prototype.createCaptureCanvas = function(e) {
      if (typeof document > "u")
        return this._destroyCaptureCanvas(), null;
      var t = document.createElement("canvas"), n, i;
      return typeof e < "u" && (e instanceof HTMLVideoElement ? (n = e.videoWidth, i = e.videoHeight) : e instanceof HTMLImageElement && (n = e.naturalWidth || e.width, i = e.naturalHeight || e.height)), t.style.width = n + "px", t.style.height = i + "px", t.width = n, t.height = i, t;
    }, r.prototype.stopStreams = function() {
      this.stream && (this.stream.getVideoTracks().forEach(function(e) {
        return e.stop();
      }), this.stream = void 0), this._stopAsyncDecode === !1 && this.stopAsyncDecode(), this._stopContinuousDecode === !1 && this.stopContinuousDecode();
    }, r.prototype.reset = function() {
      this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, r.prototype._destroyVideoElement = function() {
      this.videoElement && (typeof this.videoEndedListener < "u" && this.videoElement.removeEventListener("ended", this.videoEndedListener), typeof this.videoPlayingEventListener < "u" && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), typeof this.videoCanPlayListener < "u" && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, r.prototype._destroyImageElement = function() {
      this.imageElement && (this.imageLoadedListener !== void 0 && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, r.prototype._destroyCaptureCanvas = function() {
      this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, r.prototype.addVideoSource = function(e, t) {
      try {
        e.srcObject = t;
      } catch {
        e.src = URL.createObjectURL(t);
      }
    }, r.prototype.cleanVideoSource = function(e) {
      try {
        e.srcObject = null;
      } catch {
        e.src = "";
      }
      this.videoElement.removeAttribute("src");
    }, r;
  }()
), Oe = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a) {
      n === void 0 && (n = t == null ? 0 : 8 * t.length), a === void 0 && (a = ne.currentTimeMillis()), this.text = e, this.rawBytes = t, this.numBits = n, this.resultPoints = i, this.format = o, this.timestamp = a, this.text = e, this.rawBytes = t, n == null ? this.numBits = t == null ? 0 : 8 * t.length : this.numBits = n, this.resultPoints = i, this.format = o, this.resultMetadata = null, a == null ? this.timestamp = ne.currentTimeMillis() : this.timestamp = a;
    }
    return r.prototype.getText = function() {
      return this.text;
    }, r.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, r.prototype.getNumBits = function() {
      return this.numBits;
    }, r.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, r.prototype.getBarcodeFormat = function() {
      return this.format;
    }, r.prototype.getResultMetadata = function() {
      return this.resultMetadata;
    }, r.prototype.putMetadata = function(e, t) {
      this.resultMetadata === null && (this.resultMetadata = /* @__PURE__ */ new Map()), this.resultMetadata.set(e, t);
    }, r.prototype.putAllMetadata = function(e) {
      e !== null && (this.resultMetadata === null ? this.resultMetadata = e : this.resultMetadata = new Map(e));
    }, r.prototype.addResultPoints = function(e) {
      var t = this.resultPoints;
      if (t === null)
        this.resultPoints = e;
      else if (e !== null && e.length > 0) {
        var n = new Array(t.length + e.length);
        ne.arraycopy(t, 0, n, 0, t.length), ne.arraycopy(e, 0, n, t.length, e.length), this.resultPoints = n;
      }
    }, r.prototype.getTimestamp = function() {
      return this.timestamp;
    }, r.prototype.toString = function() {
      return this.text;
    }, r;
  }()
), Lr;
(function(r) {
  r[r.AZTEC = 0] = "AZTEC", r[r.CODABAR = 1] = "CODABAR", r[r.CODE_39 = 2] = "CODE_39", r[r.CODE_93 = 3] = "CODE_93", r[r.CODE_128 = 4] = "CODE_128", r[r.DATA_MATRIX = 5] = "DATA_MATRIX", r[r.EAN_8 = 6] = "EAN_8", r[r.EAN_13 = 7] = "EAN_13", r[r.ITF = 8] = "ITF", r[r.MAXICODE = 9] = "MAXICODE", r[r.PDF_417 = 10] = "PDF_417", r[r.QR_CODE = 11] = "QR_CODE", r[r.RSS_14 = 12] = "RSS_14", r[r.RSS_EXPANDED = 13] = "RSS_EXPANDED", r[r.UPC_A = 14] = "UPC_A", r[r.UPC_E = 15] = "UPC_E", r[r.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
})(Lr || (Lr = {}));
const L = Lr;
var Fr;
(function(r) {
  r[r.OTHER = 0] = "OTHER", r[r.ORIENTATION = 1] = "ORIENTATION", r[r.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", r[r.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", r[r.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", r[r.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", r[r.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", r[r.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", r[r.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", r[r.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", r[r.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
})(Fr || (Fr = {}));
const be = Fr;
var pr = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a) {
      o === void 0 && (o = -1), a === void 0 && (a = -1), this.rawBytes = e, this.text = t, this.byteSegments = n, this.ecLevel = i, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = a, this.numBits = e == null ? 0 : 8 * e.length;
    }
    return r.prototype.getRawBytes = function() {
      return this.rawBytes;
    }, r.prototype.getNumBits = function() {
      return this.numBits;
    }, r.prototype.setNumBits = function(e) {
      this.numBits = e;
    }, r.prototype.getText = function() {
      return this.text;
    }, r.prototype.getByteSegments = function() {
      return this.byteSegments;
    }, r.prototype.getECLevel = function() {
      return this.ecLevel;
    }, r.prototype.getErrorsCorrected = function() {
      return this.errorsCorrected;
    }, r.prototype.setErrorsCorrected = function(e) {
      this.errorsCorrected = e;
    }, r.prototype.getErasures = function() {
      return this.erasures;
    }, r.prototype.setErasures = function(e) {
      this.erasures = e;
    }, r.prototype.getOther = function() {
      return this.other;
    }, r.prototype.setOther = function(e) {
      this.other = e;
    }, r.prototype.hasStructuredAppend = function() {
      return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, r.prototype.getStructuredAppendParity = function() {
      return this.structuredAppendParity;
    }, r.prototype.getStructuredAppendSequenceNumber = function() {
      return this.structuredAppendSequenceNumber;
    }, r;
  }()
), Lt = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.exp = function(e) {
      return this.expTable[e];
    }, r.prototype.log = function(e) {
      if (e === 0)
        throw new F();
      return this.logTable[e];
    }, r.addOrSubtract = function(e, t) {
      return e ^ t;
    }, r;
  }()
), it = (
  /** @class */
  function() {
    function r(e, t) {
      if (t.length === 0)
        throw new F();
      this.field = e;
      var n = t.length;
      if (n > 1 && t[0] === 0) {
        for (var i = 1; i < n && t[i] === 0; )
          i++;
        i === n ? this.coefficients = Int32Array.from([0]) : (this.coefficients = new Int32Array(n - i), ne.arraycopy(t, i, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = t;
    }
    return r.prototype.getCoefficients = function() {
      return this.coefficients;
    }, r.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, r.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, r.prototype.getCoefficient = function(e) {
      return this.coefficients[this.coefficients.length - 1 - e];
    }, r.prototype.evaluateAt = function(e) {
      if (e === 0)
        return this.getCoefficient(0);
      var t = this.coefficients, n;
      if (e === 1) {
        n = 0;
        for (var i = 0, o = t.length; i !== o; i++) {
          var a = t[i];
          n = Lt.addOrSubtract(n, a);
        }
        return n;
      }
      n = t[0];
      for (var s = t.length, f = this.field, i = 1; i < s; i++)
        n = Lt.addOrSubtract(f.multiply(e, n), t[i]);
      return n;
    }, r.prototype.addOrSubtract = function(e) {
      if (!this.field.equals(e.field))
        throw new F("GenericGFPolys do not have same GenericGF field");
      if (this.isZero())
        return e;
      if (e.isZero())
        return this;
      var t = this.coefficients, n = e.coefficients;
      if (t.length > n.length) {
        var i = t;
        t = n, n = i;
      }
      var o = new Int32Array(n.length), a = n.length - t.length;
      ne.arraycopy(n, 0, o, 0, a);
      for (var s = a; s < n.length; s++)
        o[s] = Lt.addOrSubtract(t[s - a], n[s]);
      return new r(this.field, o);
    }, r.prototype.multiply = function(e) {
      if (!this.field.equals(e.field))
        throw new F("GenericGFPolys do not have same GenericGF field");
      if (this.isZero() || e.isZero())
        return this.field.getZero();
      for (var t = this.coefficients, n = t.length, i = e.coefficients, o = i.length, a = new Int32Array(n + o - 1), s = this.field, f = 0; f < n; f++)
        for (var u = t[f], c = 0; c < o; c++)
          a[f + c] = Lt.addOrSubtract(a[f + c], s.multiply(u, i[c]));
      return new r(s, a);
    }, r.prototype.multiplyScalar = function(e) {
      if (e === 0)
        return this.field.getZero();
      if (e === 1)
        return this;
      for (var t = this.coefficients.length, n = this.field, i = new Int32Array(t), o = this.coefficients, a = 0; a < t; a++)
        i[a] = n.multiply(o[a], e);
      return new r(n, i);
    }, r.prototype.multiplyByMonomial = function(e, t) {
      if (e < 0)
        throw new F();
      if (t === 0)
        return this.field.getZero();
      for (var n = this.coefficients, i = n.length, o = new Int32Array(i + e), a = this.field, s = 0; s < i; s++)
        o[s] = a.multiply(n[s], t);
      return new r(a, o);
    }, r.prototype.divide = function(e) {
      if (!this.field.equals(e.field))
        throw new F("GenericGFPolys do not have same GenericGF field");
      if (e.isZero())
        throw new F("Divide by 0");
      for (var t = this.field, n = t.getZero(), i = this, o = e.getCoefficient(e.getDegree()), a = t.inverse(o); i.getDegree() >= e.getDegree() && !i.isZero(); ) {
        var s = i.getDegree() - e.getDegree(), f = t.multiply(i.getCoefficient(i.getDegree()), a), u = e.multiplyByMonomial(s, f), c = t.buildMonomial(s, f);
        n = n.addOrSubtract(c), i = i.addOrSubtract(u);
      }
      return [n, i];
    }, r.prototype.toString = function() {
      for (var e = "", t = this.getDegree(); t >= 0; t--) {
        var n = this.getCoefficient(t);
        if (n !== 0) {
          if (n < 0 ? (e += " - ", n = -n) : e.length > 0 && (e += " + "), t === 0 || n !== 1) {
            var i = this.field.log(n);
            i === 0 ? e += "1" : i === 1 ? e += "a" : (e += "a^", e += i);
          }
          t !== 0 && (t === 1 ? e += "x" : (e += "x^", e += t));
        }
      }
      return e;
    }, r;
  }()
), Ea = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), yi = (
  /** @class */
  function(r) {
    Ea(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "ArithmeticException", e;
  }(Le)
), wa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Be = (
  /** @class */
  function(r) {
    wa(e, r);
    function e(t, n, i) {
      var o = r.call(this) || this;
      o.primitive = t, o.size = n, o.generatorBase = i;
      for (var a = new Int32Array(n), s = 1, f = 0; f < n; f++)
        a[f] = s, s *= 2, s >= n && (s ^= t, s &= n - 1);
      o.expTable = a;
      for (var u = new Int32Array(n), f = 0; f < n - 1; f++)
        u[a[f]] = f;
      return o.logTable = u, o.zero = new it(o, Int32Array.from([0])), o.one = new it(o, Int32Array.from([1])), o;
    }
    return e.prototype.getZero = function() {
      return this.zero;
    }, e.prototype.getOne = function() {
      return this.one;
    }, e.prototype.buildMonomial = function(t, n) {
      if (t < 0)
        throw new F();
      if (n === 0)
        return this.zero;
      var i = new Int32Array(t + 1);
      return i[0] = n, new it(this, i);
    }, e.prototype.inverse = function(t) {
      if (t === 0)
        throw new yi();
      return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, n) {
      return t === 0 || n === 0 ? 0 : this.expTable[(this.logTable[t] + this.logTable[n]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
      return this.size;
    }, e.prototype.getGeneratorBase = function() {
      return this.generatorBase;
    }, e.prototype.toString = function() {
      return "GF(0x" + G.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
      return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
  }(Lt)
), Sa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), zt = (
  /** @class */
  function(r) {
    Sa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "ReedSolomonException", e;
  }(Le)
), Ia = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Vt = (
  /** @class */
  function(r) {
    Ia(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "IllegalStateException", e;
  }(Le)
), vr = (
  /** @class */
  function() {
    function r(e) {
      this.field = e;
    }
    return r.prototype.decode = function(e, t) {
      for (var n = this.field, i = new it(n, e), o = new Int32Array(t), a = !0, s = 0; s < t; s++) {
        var f = i.evaluateAt(n.exp(s + n.getGeneratorBase()));
        o[o.length - 1 - s] = f, f !== 0 && (a = !1);
      }
      if (!a)
        for (var u = new it(n, o), c = this.runEuclideanAlgorithm(n.buildMonomial(t, 1), u, t), l = c[0], d = c[1], h = this.findErrorLocations(l), p = this.findErrorMagnitudes(d, h), s = 0; s < h.length; s++) {
          var v = e.length - 1 - n.log(h[s]);
          if (v < 0)
            throw new zt("Bad error location");
          e[v] = Be.addOrSubtract(e[v], p[s]);
        }
    }, r.prototype.runEuclideanAlgorithm = function(e, t, n) {
      if (e.getDegree() < t.getDegree()) {
        var i = e;
        e = t, t = i;
      }
      for (var o = this.field, a = e, s = t, f = o.getZero(), u = o.getOne(); s.getDegree() >= (n / 2 | 0); ) {
        var c = a, l = f;
        if (a = s, f = u, a.isZero())
          throw new zt("r_{i-1} was zero");
        s = c;
        for (var d = o.getZero(), h = a.getCoefficient(a.getDegree()), p = o.inverse(h); s.getDegree() >= a.getDegree() && !s.isZero(); ) {
          var v = s.getDegree() - a.getDegree(), y = o.multiply(s.getCoefficient(s.getDegree()), p);
          d = d.addOrSubtract(o.buildMonomial(v, y)), s = s.addOrSubtract(a.multiplyByMonomial(v, y));
        }
        if (u = d.multiply(f).addOrSubtract(l), s.getDegree() >= a.getDegree())
          throw new Vt("Division algorithm failed to reduce polynomial?");
      }
      var _ = u.getCoefficient(0);
      if (_ === 0)
        throw new zt("sigmaTilde(0) was zero");
      var x = o.inverse(_), C = u.multiplyScalar(x), E = s.multiplyScalar(x);
      return [C, E];
    }, r.prototype.findErrorLocations = function(e) {
      var t = e.getDegree();
      if (t === 1)
        return Int32Array.from([e.getCoefficient(1)]);
      for (var n = new Int32Array(t), i = 0, o = this.field, a = 1; a < o.getSize() && i < t; a++)
        e.evaluateAt(a) === 0 && (n[i] = o.inverse(a), i++);
      if (i !== t)
        throw new zt("Error locator degree does not match number of roots");
      return n;
    }, r.prototype.findErrorMagnitudes = function(e, t) {
      for (var n = t.length, i = new Int32Array(n), o = this.field, a = 0; a < n; a++) {
        for (var s = o.inverse(t[a]), f = 1, u = 0; u < n; u++)
          if (a !== u) {
            var c = o.multiply(t[u], s), l = c & 1 ? c & -2 : c | 1;
            f = o.multiply(f, l);
          }
        i[a] = o.multiply(e.evaluateAt(s), o.inverse(f)), o.getGeneratorBase() !== 0 && (i[a] = o.multiply(i[a], s));
      }
      return i;
    }, r;
  }()
), Se;
(function(r) {
  r[r.UPPER = 0] = "UPPER", r[r.LOWER = 1] = "LOWER", r[r.MIXED = 2] = "MIXED", r[r.DIGIT = 3] = "DIGIT", r[r.PUNCT = 4] = "PUNCT", r[r.BINARY = 5] = "BINARY";
})(Se || (Se = {}));
var bn = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.decode = function(e) {
      this.ddata = e;
      var t = e.getBits(), n = this.extractBits(t), i = this.correctBits(n), o = r.convertBoolArrayToByteArray(i), a = r.getEncodedData(i), s = new pr(o, a, null, null);
      return s.setNumBits(i.length), s;
    }, r.highLevelDecode = function(e) {
      return this.getEncodedData(e);
    }, r.getEncodedData = function(e) {
      for (var t = e.length, n = Se.UPPER, i = Se.UPPER, o = "", a = 0; a < t; )
        if (i === Se.BINARY) {
          if (t - a < 5)
            break;
          var s = r.readCode(e, a, 5);
          if (a += 5, s === 0) {
            if (t - a < 11)
              break;
            s = r.readCode(e, a, 11) + 31, a += 11;
          }
          for (var f = 0; f < s; f++) {
            if (t - a < 8) {
              a = t;
              break;
            }
            var u = r.readCode(e, a, 8);
            o += /*(char)*/
            X.castAsNonUtf8Char(u), a += 8;
          }
          i = n;
        } else {
          var c = i === Se.DIGIT ? 4 : 5;
          if (t - a < c)
            break;
          var u = r.readCode(e, a, c);
          a += c;
          var l = r.getCharacter(i, u);
          l.startsWith("CTRL_") ? (n = i, i = r.getTable(l.charAt(5)), l.charAt(6) === "L" && (n = i)) : (o += l, i = n);
        }
      return o;
    }, r.getTable = function(e) {
      switch (e) {
        case "L":
          return Se.LOWER;
        case "P":
          return Se.PUNCT;
        case "M":
          return Se.MIXED;
        case "D":
          return Se.DIGIT;
        case "B":
          return Se.BINARY;
        case "U":
        default:
          return Se.UPPER;
      }
    }, r.getCharacter = function(e, t) {
      switch (e) {
        case Se.UPPER:
          return r.UPPER_TABLE[t];
        case Se.LOWER:
          return r.LOWER_TABLE[t];
        case Se.MIXED:
          return r.MIXED_TABLE[t];
        case Se.PUNCT:
          return r.PUNCT_TABLE[t];
        case Se.DIGIT:
          return r.DIGIT_TABLE[t];
        default:
          throw new Vt("Bad table");
      }
    }, r.prototype.correctBits = function(e) {
      var t, n;
      this.ddata.getNbLayers() <= 2 ? (n = 6, t = Be.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, t = Be.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, t = Be.AZTEC_DATA_10) : (n = 12, t = Be.AZTEC_DATA_12);
      var i = this.ddata.getNbDatablocks(), o = e.length / n;
      if (o < i)
        throw new O();
      for (var a = e.length % n, s = new Int32Array(o), f = 0; f < o; f++, a += n)
        s[f] = r.readCode(e, a, n);
      try {
        var u = new vr(t);
        u.decode(s, o - i);
      } catch (y) {
        throw new O(y);
      }
      for (var c = (1 << n) - 1, l = 0, f = 0; f < i; f++) {
        var d = s[f];
        if (d === 0 || d === c)
          throw new O();
        (d === 1 || d === c - 1) && l++;
      }
      for (var h = new Array(i * n - l), p = 0, f = 0; f < i; f++) {
        var d = s[f];
        if (d === 1 || d === c - 1)
          h.fill(d > 1, p, p + n - 1), p += n - 1;
        else
          for (var v = n - 1; v >= 0; --v)
            h[p++] = (d & 1 << v) !== 0;
      }
      return h;
    }, r.prototype.extractBits = function(e) {
      var t = this.ddata.isCompact(), n = this.ddata.getNbLayers(), i = (t ? 11 : 14) + n * 4, o = new Int32Array(i), a = new Array(this.totalBitsInLayer(n, t));
      if (t)
        for (var s = 0; s < o.length; s++)
          o[s] = s;
      else
        for (var f = i + 1 + 2 * G.truncDivision(G.truncDivision(i, 2) - 1, 15), u = i / 2, c = G.truncDivision(f, 2), s = 0; s < u; s++) {
          var l = s + G.truncDivision(s, 15);
          o[u - s - 1] = c - l - 1, o[u + s] = c + l + 1;
        }
      for (var s = 0, d = 0; s < n; s++) {
        for (var h = (n - s) * 4 + (t ? 9 : 12), p = s * 2, v = i - 1 - p, y = 0; y < h; y++)
          for (var _ = y * 2, x = 0; x < 2; x++)
            a[d + _ + x] = e.get(o[p + x], o[p + y]), a[d + 2 * h + _ + x] = e.get(o[p + y], o[v - x]), a[d + 4 * h + _ + x] = e.get(o[v - x], o[v - y]), a[d + 6 * h + _ + x] = e.get(o[v - y], o[p + x]);
        d += h * 8;
      }
      return a;
    }, r.readCode = function(e, t, n) {
      for (var i = 0, o = t; o < t + n; o++)
        i <<= 1, e[o] && (i |= 1);
      return i;
    }, r.readByte = function(e, t) {
      var n = e.length - t;
      return n >= 8 ? r.readCode(e, t, 8) : r.readCode(e, t, n) << 8 - n;
    }, r.convertBoolArrayToByteArray = function(e) {
      for (var t = new Uint8Array((e.length + 7) / 8), n = 0; n < t.length; n++)
        t[n] = r.readByte(e, 8 * n);
      return t;
    }, r.prototype.totalBitsInLayer = function(e, t) {
      return ((t ? 88 : 112) + 16 * e) * e;
    }, r.UPPER_TABLE = [
      "CTRL_PS",
      " ",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "CTRL_LL",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], r.LOWER_TABLE = [
      "CTRL_PS",
      " ",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
      "CTRL_US",
      "CTRL_ML",
      "CTRL_DL",
      "CTRL_BS"
    ], r.MIXED_TABLE = [
      // Module parse failed: Octal literal in strict mode (50:29)
      // so number string were scaped
      "CTRL_PS",
      " ",
      "\\1",
      "\\2",
      "\\3",
      "\\4",
      "\\5",
      "\\6",
      "\\7",
      "\b",
      "	",
      `
`,
      "\\13",
      "\f",
      "\r",
      "\\33",
      "\\34",
      "\\35",
      "\\36",
      "\\37",
      "@",
      "\\",
      "^",
      "_",
      "`",
      "|",
      "~",
      "\\177",
      "CTRL_LL",
      "CTRL_UL",
      "CTRL_PL",
      "CTRL_BS"
    ], r.PUNCT_TABLE = [
      "",
      "\r",
      `\r
`,
      ". ",
      ", ",
      ": ",
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "[",
      "]",
      "{",
      "}",
      "CTRL_UL"
    ], r.DIGIT_TABLE = [
      "CTRL_PS",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      ",",
      ".",
      "CTRL_UL",
      "CTRL_US"
    ], r;
  }()
), Y = (
  /** @class */
  function() {
    function r() {
    }
    return r.round = function(e) {
      return isNaN(e) ? 0 : e <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : e >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : (
        /*(int) */
        e + (e < 0 ? -0.5 : 0.5) | 0
      );
    }, r.distance = function(e, t, n, i) {
      var o = e - n, a = t - i;
      return (
        /*(float) */
        Math.sqrt(o * o + a * a)
      );
    }, r.sum = function(e) {
      for (var t = 0, n = 0, i = e.length; n !== i; n++) {
        var o = e[n];
        t += o;
      }
      return t;
    }, r;
  }()
), kr = (
  /** @class */
  function() {
    function r() {
    }
    return r.floatToIntBits = function(e) {
      return e;
    }, r.MAX_VALUE = Number.MAX_SAFE_INTEGER, r;
  }()
), P = (
  /** @class */
  function() {
    function r(e, t) {
      this.x = e, this.y = t;
    }
    return r.prototype.getX = function() {
      return this.x;
    }, r.prototype.getY = function() {
      return this.y;
    }, r.prototype.equals = function(e) {
      if (e instanceof r) {
        var t = e;
        return this.x === t.x && this.y === t.y;
      }
      return !1;
    }, r.prototype.hashCode = function() {
      return 31 * kr.floatToIntBits(this.x) + kr.floatToIntBits(this.y);
    }, r.prototype.toString = function() {
      return "(" + this.x + "," + this.y + ")";
    }, r.orderBestPatterns = function(e) {
      var t = this.distance(e[0], e[1]), n = this.distance(e[1], e[2]), i = this.distance(e[0], e[2]), o, a, s;
      if (n >= t && n >= i ? (a = e[0], o = e[1], s = e[2]) : i >= n && i >= t ? (a = e[1], o = e[0], s = e[2]) : (a = e[2], o = e[0], s = e[1]), this.crossProductZ(o, a, s) < 0) {
        var f = o;
        o = s, s = f;
      }
      e[0] = o, e[1] = a, e[2] = s;
    }, r.distance = function(e, t) {
      return Y.distance(e.x, e.y, t.x, t.y);
    }, r.crossProductZ = function(e, t, n) {
      var i = t.x, o = t.y;
      return (n.x - i) * (e.y - o) - (n.y - o) * (e.x - i);
    }, r;
  }()
), Jr = (
  /** @class */
  function() {
    function r(e, t) {
      this.bits = e, this.points = t;
    }
    return r.prototype.getBits = function() {
      return this.bits;
    }, r.prototype.getPoints = function() {
      return this.points;
    }, r;
  }()
), ba = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ta = (
  /** @class */
  function(r) {
    ba(e, r);
    function e(t, n, i, o, a) {
      var s = r.call(this, t, n) || this;
      return s.compact = i, s.nbDatablocks = o, s.nbLayers = a, s;
    }
    return e.prototype.getNbLayers = function() {
      return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
      return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
      return this.compact;
    }, e;
  }(Jr)
), Ur = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), t == null && (t = r.INIT_SIZE), n == null && (n = e.getWidth() / 2 | 0), i == null && (i = e.getHeight() / 2 | 0);
      var o = t / 2 | 0;
      if (this.leftInit = n - o, this.rightInit = n + o, this.upInit = i - o, this.downInit = i + o, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width)
        throw new w();
    }
    return r.prototype.detect = function() {
      for (var e = this.leftInit, t = this.rightInit, n = this.upInit, i = this.downInit, o = !1, a = !0, s = !1, f = !1, u = !1, c = !1, l = !1, d = this.width, h = this.height; a; ) {
        a = !1;
        for (var p = !0; (p || !f) && t < d; )
          p = this.containsBlackPoint(n, i, t, !1), p ? (t++, a = !0, f = !0) : f || t++;
        if (t >= d) {
          o = !0;
          break;
        }
        for (var v = !0; (v || !u) && i < h; )
          v = this.containsBlackPoint(e, t, i, !0), v ? (i++, a = !0, u = !0) : u || i++;
        if (i >= h) {
          o = !0;
          break;
        }
        for (var y = !0; (y || !c) && e >= 0; )
          y = this.containsBlackPoint(n, i, e, !1), y ? (e--, a = !0, c = !0) : c || e--;
        if (e < 0) {
          o = !0;
          break;
        }
        for (var _ = !0; (_ || !l) && n >= 0; )
          _ = this.containsBlackPoint(e, t, n, !0), _ ? (n--, a = !0, l = !0) : l || n--;
        if (n < 0) {
          o = !0;
          break;
        }
        a && (s = !0);
      }
      if (!o && s) {
        for (var x = t - e, C = null, E = 1; C === null && E < x; E++)
          C = this.getBlackPointOnSegment(e, i - E, e + E, i);
        if (C == null)
          throw new w();
        for (var S = null, E = 1; S === null && E < x; E++)
          S = this.getBlackPointOnSegment(e, n + E, e + E, n);
        if (S == null)
          throw new w();
        for (var I = null, E = 1; I === null && E < x; E++)
          I = this.getBlackPointOnSegment(t, n + E, t - E, n);
        if (I == null)
          throw new w();
        for (var T = null, E = 1; T === null && E < x; E++)
          T = this.getBlackPointOnSegment(t, i - E, t - E, i);
        if (T == null)
          throw new w();
        return this.centerEdges(T, C, I, S);
      } else
        throw new w();
    }, r.prototype.getBlackPointOnSegment = function(e, t, n, i) {
      for (var o = Y.round(Y.distance(e, t, n, i)), a = (n - e) / o, s = (i - t) / o, f = this.image, u = 0; u < o; u++) {
        var c = Y.round(e + u * a), l = Y.round(t + u * s);
        if (f.get(c, l))
          return new P(c, l);
      }
      return null;
    }, r.prototype.centerEdges = function(e, t, n, i) {
      var o = e.getX(), a = e.getY(), s = t.getX(), f = t.getY(), u = n.getX(), c = n.getY(), l = i.getX(), d = i.getY(), h = r.CORR;
      return o < this.width / 2 ? [
        new P(l - h, d + h),
        new P(s + h, f + h),
        new P(u - h, c - h),
        new P(o + h, a - h)
      ] : [
        new P(l + h, d + h),
        new P(s + h, f - h),
        new P(u - h, c + h),
        new P(o - h, a - h)
      ];
    }, r.prototype.containsBlackPoint = function(e, t, n, i) {
      var o = this.image;
      if (i) {
        for (var a = e; a <= t; a++)
          if (o.get(a, n))
            return !0;
      } else
        for (var s = e; s <= t; s++)
          if (o.get(n, s))
            return !0;
      return !1;
    }, r.INIT_SIZE = 10, r.CORR = 1, r;
  }()
), Tn = (
  /** @class */
  function() {
    function r() {
    }
    return r.checkAndNudgePoints = function(e, t) {
      for (var n = e.getWidth(), i = e.getHeight(), o = !0, a = 0; a < t.length && o; a += 2) {
        var s = Math.floor(t[a]), f = Math.floor(t[a + 1]);
        if (s < -1 || s > n || f < -1 || f > i)
          throw new w();
        o = !1, s === -1 ? (t[a] = 0, o = !0) : s === n && (t[a] = n - 1, o = !0), f === -1 ? (t[a + 1] = 0, o = !0) : f === i && (t[a + 1] = i - 1, o = !0);
      }
      o = !0;
      for (var a = t.length - 2; a >= 0 && o; a -= 2) {
        var s = Math.floor(t[a]), f = Math.floor(t[a + 1]);
        if (s < -1 || s > n || f < -1 || f > i)
          throw new w();
        o = !1, s === -1 ? (t[a] = 0, o = !0) : s === n && (t[a] = n - 1, o = !0), f === -1 ? (t[a + 1] = 0, o = !0) : f === i && (t[a + 1] = i - 1, o = !0);
      }
    }, r;
  }()
), mi = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a, s, f, u) {
      this.a11 = e, this.a21 = t, this.a31 = n, this.a12 = i, this.a22 = o, this.a32 = a, this.a13 = s, this.a23 = f, this.a33 = u;
    }
    return r.quadrilateralToQuadrilateral = function(e, t, n, i, o, a, s, f, u, c, l, d, h, p, v, y) {
      var _ = r.quadrilateralToSquare(e, t, n, i, o, a, s, f), x = r.squareToQuadrilateral(u, c, l, d, h, p, v, y);
      return x.times(_);
    }, r.prototype.transformPoints = function(e) {
      for (var t = e.length, n = this.a11, i = this.a12, o = this.a13, a = this.a21, s = this.a22, f = this.a23, u = this.a31, c = this.a32, l = this.a33, d = 0; d < t; d += 2) {
        var h = e[d], p = e[d + 1], v = o * h + f * p + l;
        e[d] = (n * h + a * p + u) / v, e[d + 1] = (i * h + s * p + c) / v;
      }
    }, r.prototype.transformPointsWithValues = function(e, t) {
      for (var n = this.a11, i = this.a12, o = this.a13, a = this.a21, s = this.a22, f = this.a23, u = this.a31, c = this.a32, l = this.a33, d = e.length, h = 0; h < d; h++) {
        var p = e[h], v = t[h], y = o * p + f * v + l;
        e[h] = (n * p + a * v + u) / y, t[h] = (i * p + s * v + c) / y;
      }
    }, r.squareToQuadrilateral = function(e, t, n, i, o, a, s, f) {
      var u = e - n + o - s, c = t - i + a - f;
      if (u === 0 && c === 0)
        return new r(n - e, o - n, e, i - t, a - i, t, 0, 0, 1);
      var l = n - o, d = s - o, h = i - a, p = f - a, v = l * p - d * h, y = (u * p - d * c) / v, _ = (l * c - u * h) / v;
      return new r(n - e + y * n, s - e + _ * s, e, i - t + y * i, f - t + _ * f, t, y, _, 1);
    }, r.quadrilateralToSquare = function(e, t, n, i, o, a, s, f) {
      return r.squareToQuadrilateral(e, t, n, i, o, a, s, f).buildAdjoint();
    }, r.prototype.buildAdjoint = function() {
      return new r(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, r.prototype.times = function(e) {
      return new r(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, r;
  }()
), Oa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ra = (
  /** @class */
  function(r) {
    Oa(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.sampleGrid = function(t, n, i, o, a, s, f, u, c, l, d, h, p, v, y, _, x, C, E) {
      var S = mi.quadrilateralToQuadrilateral(o, a, s, f, u, c, l, d, h, p, v, y, _, x, C, E);
      return this.sampleGridWithTransform(t, n, i, S);
    }, e.prototype.sampleGridWithTransform = function(t, n, i, o) {
      if (n <= 0 || i <= 0)
        throw new w();
      for (var a = new Ye(n, i), s = new Float32Array(2 * n), f = 0; f < i; f++) {
        for (var u = s.length, c = f + 0.5, l = 0; l < u; l += 2)
          s[l] = l / 2 + 0.5, s[l + 1] = c;
        o.transformPoints(s), Tn.checkAndNudgePoints(t, s);
        try {
          for (var l = 0; l < u; l += 2)
            t.get(Math.floor(s[l]), Math.floor(s[l + 1])) && a.set(l / 2, f);
        } catch {
          throw new w();
        }
      }
      return a;
    }, e;
  }(Tn)
), en = (
  /** @class */
  function() {
    function r() {
    }
    return r.setGridSampler = function(e) {
      r.gridSampler = e;
    }, r.getInstance = function() {
      return r.gridSampler;
    }, r.gridSampler = new Ra(), r;
  }()
), Me = (
  /** @class */
  function() {
    function r(e, t) {
      this.x = e, this.y = t;
    }
    return r.prototype.toResultPoint = function() {
      return new P(this.getX(), this.getY());
    }, r.prototype.getX = function() {
      return this.x;
    }, r.prototype.getY = function() {
      return this.y;
    }, r;
  }()
), Da = (
  /** @class */
  function() {
    function r(e) {
      this.EXPECTED_CORNER_BITS = new Int32Array([
        3808,
        476,
        2107,
        1799
      ]), this.image = e;
    }
    return r.prototype.detect = function() {
      return this.detectMirror(!1);
    }, r.prototype.detectMirror = function(e) {
      var t = this.getMatrixCenter(), n = this.getBullsEyeCorners(t);
      if (e) {
        var i = n[0];
        n[0] = n[2], n[2] = i;
      }
      this.extractParameters(n);
      var o = this.sampleGrid(this.image, n[this.shift % 4], n[(this.shift + 1) % 4], n[(this.shift + 2) % 4], n[(this.shift + 3) % 4]), a = this.getMatrixCornerPoints(n);
      return new Ta(o, a, this.compact, this.nbDataBlocks, this.nbLayers);
    }, r.prototype.extractParameters = function(e) {
      if (!this.isValidPoint(e[0]) || !this.isValidPoint(e[1]) || !this.isValidPoint(e[2]) || !this.isValidPoint(e[3]))
        throw new w();
      var t = 2 * this.nbCenterLayers, n = new Int32Array([
        this.sampleLine(e[0], e[1], t),
        this.sampleLine(e[1], e[2], t),
        this.sampleLine(e[2], e[3], t),
        this.sampleLine(e[3], e[0], t)
        // Top
      ]);
      this.shift = this.getRotation(n, t);
      for (var i = 0, o = 0; o < 4; o++) {
        var a = n[(this.shift + o) % 4];
        this.compact ? (i <<= 7, i += a >> 1 & 127) : (i <<= 10, i += (a >> 2 & 992) + (a >> 1 & 31));
      }
      var s = this.getCorrectedParameterData(i, this.compact);
      this.compact ? (this.nbLayers = (s >> 6) + 1, this.nbDataBlocks = (s & 63) + 1) : (this.nbLayers = (s >> 11) + 1, this.nbDataBlocks = (s & 2047) + 1);
    }, r.prototype.getRotation = function(e, t) {
      var n = 0;
      e.forEach(function(o, a, s) {
        var f = (o >> t - 2 << 1) + (o & 1);
        n = (n << 3) + f;
      }), n = ((n & 1) << 11) + (n >> 1);
      for (var i = 0; i < 4; i++)
        if (G.bitCount(n ^ this.EXPECTED_CORNER_BITS[i]) <= 2)
          return i;
      throw new w();
    }, r.prototype.getCorrectedParameterData = function(e, t) {
      var n, i;
      t ? (n = 7, i = 2) : (n = 10, i = 4);
      for (var o = n - i, a = new Int32Array(n), s = n - 1; s >= 0; --s)
        a[s] = e & 15, e >>= 4;
      try {
        var f = new vr(Be.AZTEC_PARAM);
        f.decode(a, o);
      } catch {
        throw new w();
      }
      for (var u = 0, s = 0; s < i; s++)
        u = (u << 4) + a[s];
      return u;
    }, r.prototype.getBullsEyeCorners = function(e) {
      var t = e, n = e, i = e, o = e, a = !0;
      for (this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++) {
        var s = this.getFirstDifferent(t, a, 1, -1), f = this.getFirstDifferent(n, a, 1, 1), u = this.getFirstDifferent(i, a, -1, 1), c = this.getFirstDifferent(o, a, -1, -1);
        if (this.nbCenterLayers > 2) {
          var l = this.distancePoint(c, s) * this.nbCenterLayers / (this.distancePoint(o, t) * (this.nbCenterLayers + 2));
          if (l < 0.75 || l > 1.25 || !this.isWhiteOrBlackRectangle(s, f, u, c))
            break;
        }
        t = s, n = f, i = u, o = c, a = !a;
      }
      if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7)
        throw new w();
      this.compact = this.nbCenterLayers === 5;
      var d = new P(t.getX() + 0.5, t.getY() - 0.5), h = new P(n.getX() + 0.5, n.getY() + 0.5), p = new P(i.getX() - 0.5, i.getY() + 0.5), v = new P(o.getX() - 0.5, o.getY() - 0.5);
      return this.expandSquare([d, h, p, v], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, r.prototype.getMatrixCenter = function() {
      var e, t, n, i;
      try {
        var o = new Ur(this.image).detect();
        e = o[0], t = o[1], n = o[2], i = o[3];
      } catch {
        var a = this.image.getWidth() / 2, s = this.image.getHeight() / 2;
        e = this.getFirstDifferent(new Me(a + 7, s - 7), !1, 1, -1).toResultPoint(), t = this.getFirstDifferent(new Me(a + 7, s + 7), !1, 1, 1).toResultPoint(), n = this.getFirstDifferent(new Me(a - 7, s + 7), !1, -1, 1).toResultPoint(), i = this.getFirstDifferent(new Me(a - 7, s - 7), !1, -1, -1).toResultPoint();
      }
      var f = Y.round((e.getX() + i.getX() + t.getX() + n.getX()) / 4), u = Y.round((e.getY() + i.getY() + t.getY() + n.getY()) / 4);
      try {
        var o = new Ur(this.image, 15, f, u).detect();
        e = o[0], t = o[1], n = o[2], i = o[3];
      } catch {
        e = this.getFirstDifferent(new Me(f + 7, u - 7), !1, 1, -1).toResultPoint(), t = this.getFirstDifferent(new Me(f + 7, u + 7), !1, 1, 1).toResultPoint(), n = this.getFirstDifferent(new Me(f - 7, u + 7), !1, -1, 1).toResultPoint(), i = this.getFirstDifferent(new Me(f - 7, u - 7), !1, -1, -1).toResultPoint();
      }
      return f = Y.round((e.getX() + i.getX() + t.getX() + n.getX()) / 4), u = Y.round((e.getY() + i.getY() + t.getY() + n.getY()) / 4), new Me(f, u);
    }, r.prototype.getMatrixCornerPoints = function(e) {
      return this.expandSquare(e, 2 * this.nbCenterLayers, this.getDimension());
    }, r.prototype.sampleGrid = function(e, t, n, i, o) {
      var a = en.getInstance(), s = this.getDimension(), f = s / 2 - this.nbCenterLayers, u = s / 2 + this.nbCenterLayers;
      return a.sampleGrid(
        e,
        s,
        s,
        f,
        f,
        // topleft
        u,
        f,
        // topright
        u,
        u,
        // bottomright
        f,
        u,
        // bottomleft
        t.getX(),
        t.getY(),
        n.getX(),
        n.getY(),
        i.getX(),
        i.getY(),
        o.getX(),
        o.getY()
      );
    }, r.prototype.sampleLine = function(e, t, n) {
      for (var i = 0, o = this.distanceResultPoint(e, t), a = o / n, s = e.getX(), f = e.getY(), u = a * (t.getX() - e.getX()) / o, c = a * (t.getY() - e.getY()) / o, l = 0; l < n; l++)
        this.image.get(Y.round(s + l * u), Y.round(f + l * c)) && (i |= 1 << n - l - 1);
      return i;
    }, r.prototype.isWhiteOrBlackRectangle = function(e, t, n, i) {
      var o = 3;
      e = new Me(e.getX() - o, e.getY() + o), t = new Me(t.getX() - o, t.getY() - o), n = new Me(n.getX() + o, n.getY() - o), i = new Me(i.getX() + o, i.getY() + o);
      var a = this.getColor(i, e);
      if (a === 0)
        return !1;
      var s = this.getColor(e, t);
      return s !== a || (s = this.getColor(t, n), s !== a) ? !1 : (s = this.getColor(n, i), s === a);
    }, r.prototype.getColor = function(e, t) {
      for (var n = this.distancePoint(e, t), i = (t.getX() - e.getX()) / n, o = (t.getY() - e.getY()) / n, a = 0, s = e.getX(), f = e.getY(), u = this.image.get(e.getX(), e.getY()), c = Math.ceil(n), l = 0; l < c; l++)
        s += i, f += o, this.image.get(Y.round(s), Y.round(f)) !== u && a++;
      var d = a / n;
      return d > 0.1 && d < 0.9 ? 0 : d <= 0.1 === u ? 1 : -1;
    }, r.prototype.getFirstDifferent = function(e, t, n, i) {
      for (var o = e.getX() + n, a = e.getY() + i; this.isValid(o, a) && this.image.get(o, a) === t; )
        o += n, a += i;
      for (o -= n, a -= i; this.isValid(o, a) && this.image.get(o, a) === t; )
        o += n;
      for (o -= n; this.isValid(o, a) && this.image.get(o, a) === t; )
        a += i;
      return a -= i, new Me(o, a);
    }, r.prototype.expandSquare = function(e, t, n) {
      var i = n / (2 * t), o = e[0].getX() - e[2].getX(), a = e[0].getY() - e[2].getY(), s = (e[0].getX() + e[2].getX()) / 2, f = (e[0].getY() + e[2].getY()) / 2, u = new P(s + i * o, f + i * a), c = new P(s - i * o, f - i * a);
      o = e[1].getX() - e[3].getX(), a = e[1].getY() - e[3].getY(), s = (e[1].getX() + e[3].getX()) / 2, f = (e[1].getY() + e[3].getY()) / 2;
      var l = new P(s + i * o, f + i * a), d = new P(s - i * o, f - i * a), h = [u, l, c, d];
      return h;
    }, r.prototype.isValid = function(e, t) {
      return e >= 0 && e < this.image.getWidth() && t > 0 && t < this.image.getHeight();
    }, r.prototype.isValidPoint = function(e) {
      var t = Y.round(e.getX()), n = Y.round(e.getY());
      return this.isValid(t, n);
    }, r.prototype.distancePoint = function(e, t) {
      return Y.distance(e.getX(), e.getY(), t.getX(), t.getY());
    }, r.prototype.distanceResultPoint = function(e, t) {
      return Y.distance(e.getX(), e.getY(), t.getX(), t.getY());
    }, r.prototype.getDimension = function() {
      return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * (G.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, r;
  }()
), sr = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.decode = function(e, t) {
      t === void 0 && (t = null);
      var n = null, i = new Da(e.getBlackMatrix()), o = null, a = null;
      try {
        var s = i.detectMirror(!1);
        o = s.getPoints(), this.reportFoundResultPoints(t, o), a = new bn().decode(s);
      } catch (l) {
        n = l;
      }
      if (a == null)
        try {
          var s = i.detectMirror(!0);
          o = s.getPoints(), this.reportFoundResultPoints(t, o), a = new bn().decode(s);
        } catch (l) {
          throw n ?? l;
        }
      var f = new Oe(a.getText(), a.getRawBytes(), a.getNumBits(), o, L.AZTEC, ne.currentTimeMillis()), u = a.getByteSegments();
      u != null && f.putMetadata(be.BYTE_SEGMENTS, u);
      var c = a.getECLevel();
      return c != null && f.putMetadata(be.ERROR_CORRECTION_LEVEL, c), f;
    }, r.prototype.reportFoundResultPoints = function(e, t) {
      if (e != null) {
        var n = e.get(fe.NEED_RESULT_POINT_CALLBACK);
        n != null && t.forEach(function(i, o, a) {
          n.foundPossibleResultPoint(i);
        });
      }
    }, r.prototype.reset = function() {
    }, r;
  }()
), Pa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Pa(e, r);
  function e(t) {
    return t === void 0 && (t = 500), r.call(this, new sr(), t) || this;
  }
  return e;
})(wt);
var _e = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.decode = function(e, t) {
      try {
        return this.doDecode(e, t);
      } catch {
        var n = t && t.get(fe.TRY_HARDER) === !0;
        if (n && e.isRotateSupported()) {
          var i = e.rotateCounterClockwise(), o = this.doDecode(i, t), a = o.getResultMetadata(), s = 270;
          a !== null && a.get(be.ORIENTATION) === !0 && (s = s + a.get(be.ORIENTATION) % 360), o.putMetadata(be.ORIENTATION, s);
          var f = o.getResultPoints();
          if (f !== null)
            for (var u = i.getHeight(), c = 0; c < f.length; c++)
              f[c] = new P(u - f[c].getY() - 1, f[c].getX());
          return o;
        } else
          throw new w();
      }
    }, r.prototype.reset = function() {
    }, r.prototype.doDecode = function(e, t) {
      var n = e.getWidth(), i = e.getHeight(), o = new Ee(n), a = t && t.get(fe.TRY_HARDER) === !0, s = Math.max(1, i >> (a ? 8 : 5)), f;
      a ? f = i : f = 15;
      for (var u = Math.trunc(i / 2), c = 0; c < f; c++) {
        var l = Math.trunc((c + 1) / 2), d = (c & 1) === 0, h = u + s * (d ? l : -l);
        if (h < 0 || h >= i)
          break;
        try {
          o = e.getBlackRow(h, o);
        } catch {
          continue;
        }
        for (var p = function(x) {
          if (x === 1 && (o.reverse(), t && t.get(fe.NEED_RESULT_POINT_CALLBACK) === !0)) {
            var C = /* @__PURE__ */ new Map();
            t.forEach(function(I, T) {
              return C.set(T, I);
            }), C.delete(fe.NEED_RESULT_POINT_CALLBACK), t = C;
          }
          try {
            var E = v.decodeRow(h, o, t);
            if (x === 1) {
              E.putMetadata(be.ORIENTATION, 180);
              var S = E.getResultPoints();
              S !== null && (S[0] = new P(n - S[0].getX() - 1, S[0].getY()), S[1] = new P(n - S[1].getX() - 1, S[1].getY()));
            }
            return { value: E };
          } catch {
          }
        }, v = this, y = 0; y < 2; y++) {
          var _ = p(y);
          if (typeof _ == "object")
            return _.value;
        }
      }
      throw new w();
    }, r.recordPattern = function(e, t, n) {
      for (var i = n.length, o = 0; o < i; o++)
        n[o] = 0;
      var a = e.getSize();
      if (t >= a)
        throw new w();
      for (var s = !e.get(t), f = 0, u = t; u < a; ) {
        if (e.get(u) !== s)
          n[f]++;
        else {
          if (++f === i)
            break;
          n[f] = 1, s = !s;
        }
        u++;
      }
      if (!(f === i || f === i - 1 && u === a))
        throw new w();
    }, r.recordPatternInReverse = function(e, t, n) {
      for (var i = n.length, o = e.get(t); t > 0 && i >= 0; )
        e.get(--t) !== o && (i--, o = !o);
      if (i >= 0)
        throw new w();
      r.recordPattern(e, t + 1, n);
    }, r.patternMatchVariance = function(e, t, n) {
      for (var i = e.length, o = 0, a = 0, s = 0; s < i; s++)
        o += e[s], a += t[s];
      if (o < a)
        return Number.POSITIVE_INFINITY;
      var f = o / a;
      n *= f;
      for (var u = 0, c = 0; c < i; c++) {
        var l = e[c], d = t[c] * f, h = l > d ? l - d : d - l;
        if (h > n)
          return Number.POSITIVE_INFINITY;
        u += h;
      }
      return u / o;
    }, r;
  }()
), Na = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), On = (
  /** @class */
  function(r) {
    Na(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.findStartPattern = function(t) {
      for (var n = t.getSize(), i = t.getNextSet(0), o = 0, a = Int32Array.from([0, 0, 0, 0, 0, 0]), s = i, f = !1, u = 6, c = i; c < n; c++)
        if (t.get(c) !== f)
          a[o]++;
        else {
          if (o === u - 1) {
            for (var l = e.MAX_AVG_VARIANCE, d = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++) {
              var p = _e.patternMatchVariance(a, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
              p < l && (l = p, d = h);
            }
            if (d >= 0 && t.isRange(Math.max(0, s - (c - s) / 2), s, !1))
              return Int32Array.from([s, c, d]);
            s += a[0] + a[1], a = a.slice(2, a.length - 1), a[o - 1] = 0, a[o] = 0, o--;
          } else
            o++;
          a[o] = 1, f = !f;
        }
      throw new w();
    }, e.decodeCode = function(t, n, i) {
      _e.recordPattern(t, i, n);
      for (var o = e.MAX_AVG_VARIANCE, a = -1, s = 0; s < e.CODE_PATTERNS.length; s++) {
        var f = e.CODE_PATTERNS[s], u = this.patternMatchVariance(n, f, e.MAX_INDIVIDUAL_VARIANCE);
        u < o && (o = u, a = s);
      }
      if (a >= 0)
        return a;
      throw new w();
    }, e.prototype.decodeRow = function(t, n, i) {
      var o = i && i.get(fe.ASSUME_GS1) === !0, a = e.findStartPattern(n), s = a[2], f = 0, u = new Uint8Array(20);
      u[f++] = s;
      var c;
      switch (s) {
        case e.CODE_START_A:
          c = e.CODE_CODE_A;
          break;
        case e.CODE_START_B:
          c = e.CODE_CODE_B;
          break;
        case e.CODE_START_C:
          c = e.CODE_CODE_C;
          break;
        default:
          throw new O();
      }
      for (var l = !1, d = !1, h = "", p = a[0], v = a[1], y = Int32Array.from([0, 0, 0, 0, 0, 0]), _ = 0, x = 0, C = s, E = 0, S = !0, I = !1, T = !1; !l; ) {
        var R = d;
        switch (d = !1, _ = x, x = e.decodeCode(n, y, v), u[f++] = x, x !== e.CODE_STOP && (S = !0), x !== e.CODE_STOP && (E++, C += E * x), p = v, v += y.reduce(function($e, Xe) {
          return $e + Xe;
        }, 0), x) {
          case e.CODE_START_A:
          case e.CODE_START_B:
          case e.CODE_START_C:
            throw new O();
        }
        switch (c) {
          case e.CODE_CODE_A:
            if (x < 64)
              T === I ? h += String.fromCharCode(32 + x) : h += String.fromCharCode(32 + x + 128), T = !1;
            else if (x < 96)
              T === I ? h += String.fromCharCode(x - 64) : h += String.fromCharCode(x + 64), T = !1;
            else
              switch (x !== e.CODE_STOP && (S = !1), x) {
                case e.CODE_FNC_1:
                  o && (h.length === 0 ? h += "]C1" : h += "");
                  break;
                case e.CODE_FNC_2:
                case e.CODE_FNC_3:
                  break;
                case e.CODE_FNC_4_A:
                  !I && T ? (I = !0, T = !1) : I && T ? (I = !1, T = !1) : T = !0;
                  break;
                case e.CODE_SHIFT:
                  d = !0, c = e.CODE_CODE_B;
                  break;
                case e.CODE_CODE_B:
                  c = e.CODE_CODE_B;
                  break;
                case e.CODE_CODE_C:
                  c = e.CODE_CODE_C;
                  break;
                case e.CODE_STOP:
                  l = !0;
                  break;
              }
            break;
          case e.CODE_CODE_B:
            if (x < 96)
              T === I ? h += String.fromCharCode(32 + x) : h += String.fromCharCode(32 + x + 128), T = !1;
            else
              switch (x !== e.CODE_STOP && (S = !1), x) {
                case e.CODE_FNC_1:
                  o && (h.length === 0 ? h += "]C1" : h += "");
                  break;
                case e.CODE_FNC_2:
                case e.CODE_FNC_3:
                  break;
                case e.CODE_FNC_4_B:
                  !I && T ? (I = !0, T = !1) : I && T ? (I = !1, T = !1) : T = !0;
                  break;
                case e.CODE_SHIFT:
                  d = !0, c = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_A:
                  c = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_C:
                  c = e.CODE_CODE_C;
                  break;
                case e.CODE_STOP:
                  l = !0;
                  break;
              }
            break;
          case e.CODE_CODE_C:
            if (x < 100)
              x < 10 && (h += "0"), h += x;
            else
              switch (x !== e.CODE_STOP && (S = !1), x) {
                case e.CODE_FNC_1:
                  o && (h.length === 0 ? h += "]C1" : h += "");
                  break;
                case e.CODE_CODE_A:
                  c = e.CODE_CODE_A;
                  break;
                case e.CODE_CODE_B:
                  c = e.CODE_CODE_B;
                  break;
                case e.CODE_STOP:
                  l = !0;
                  break;
              }
            break;
        }
        R && (c = c === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
      }
      var B = v - p;
      if (v = n.getNextUnset(v), !n.isRange(v, Math.min(n.getSize(), v + (v - p) / 2), !1))
        throw new w();
      if (C -= E * _, C % 103 !== _)
        throw new pe();
      var M = h.length;
      if (M === 0)
        throw new w();
      M > 0 && S && (c === e.CODE_CODE_C ? h = h.substring(0, M - 2) : h = h.substring(0, M - 1));
      for (var te = (a[1] + a[0]) / 2, N = p + B / 2, H = u.length, ie = new Uint8Array(H), we = 0; we < H; we++)
        ie[we] = u[we];
      var Ge = [new P(te, t), new P(N, t)];
      return new Oe(h, ie, 0, Ge, L.CODE_128, (/* @__PURE__ */ new Date()).getTime());
    }, e.CODE_PATTERNS = [
      Int32Array.from([2, 1, 2, 2, 2, 2]),
      Int32Array.from([2, 2, 2, 1, 2, 2]),
      Int32Array.from([2, 2, 2, 2, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 2, 3]),
      Int32Array.from([1, 2, 1, 3, 2, 2]),
      Int32Array.from([1, 3, 1, 2, 2, 2]),
      Int32Array.from([1, 2, 2, 2, 1, 3]),
      Int32Array.from([1, 2, 2, 3, 1, 2]),
      Int32Array.from([1, 3, 2, 2, 1, 2]),
      Int32Array.from([2, 2, 1, 2, 1, 3]),
      Int32Array.from([2, 2, 1, 3, 1, 2]),
      Int32Array.from([2, 3, 1, 2, 1, 2]),
      Int32Array.from([1, 1, 2, 2, 3, 2]),
      Int32Array.from([1, 2, 2, 1, 3, 2]),
      Int32Array.from([1, 2, 2, 2, 3, 1]),
      Int32Array.from([1, 1, 3, 2, 2, 2]),
      Int32Array.from([1, 2, 3, 1, 2, 2]),
      Int32Array.from([1, 2, 3, 2, 2, 1]),
      Int32Array.from([2, 2, 3, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 3, 2]),
      Int32Array.from([2, 2, 1, 2, 3, 1]),
      Int32Array.from([2, 1, 3, 2, 1, 2]),
      Int32Array.from([2, 2, 3, 1, 1, 2]),
      Int32Array.from([3, 1, 2, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 2, 2, 2]),
      Int32Array.from([3, 2, 1, 1, 2, 2]),
      Int32Array.from([3, 2, 1, 2, 2, 1]),
      Int32Array.from([3, 1, 2, 2, 1, 2]),
      Int32Array.from([3, 2, 2, 1, 1, 2]),
      Int32Array.from([3, 2, 2, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 2, 3]),
      Int32Array.from([2, 1, 2, 3, 2, 1]),
      Int32Array.from([2, 3, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 3, 2, 3]),
      Int32Array.from([1, 3, 1, 1, 2, 3]),
      Int32Array.from([1, 3, 1, 3, 2, 1]),
      Int32Array.from([1, 1, 2, 3, 1, 3]),
      Int32Array.from([1, 3, 2, 1, 1, 3]),
      Int32Array.from([1, 3, 2, 3, 1, 1]),
      Int32Array.from([2, 1, 1, 3, 1, 3]),
      Int32Array.from([2, 3, 1, 1, 1, 3]),
      Int32Array.from([2, 3, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 3, 3]),
      Int32Array.from([1, 1, 2, 3, 3, 1]),
      Int32Array.from([1, 3, 2, 1, 3, 1]),
      Int32Array.from([1, 1, 3, 1, 2, 3]),
      Int32Array.from([1, 1, 3, 3, 2, 1]),
      Int32Array.from([1, 3, 3, 1, 2, 1]),
      Int32Array.from([3, 1, 3, 1, 2, 1]),
      Int32Array.from([2, 1, 1, 3, 3, 1]),
      Int32Array.from([2, 3, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 3, 1, 1, 3]),
      Int32Array.from([2, 1, 3, 3, 1, 1]),
      Int32Array.from([2, 1, 3, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 2, 3]),
      Int32Array.from([3, 1, 1, 3, 2, 1]),
      Int32Array.from([3, 3, 1, 1, 2, 1]),
      Int32Array.from([3, 1, 2, 1, 1, 3]),
      Int32Array.from([3, 1, 2, 3, 1, 1]),
      Int32Array.from([3, 3, 2, 1, 1, 1]),
      Int32Array.from([3, 1, 4, 1, 1, 1]),
      Int32Array.from([2, 2, 1, 4, 1, 1]),
      Int32Array.from([4, 3, 1, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2, 4]),
      Int32Array.from([1, 1, 1, 4, 2, 2]),
      Int32Array.from([1, 2, 1, 1, 2, 4]),
      Int32Array.from([1, 2, 1, 4, 2, 1]),
      Int32Array.from([1, 4, 1, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 2, 2, 1]),
      Int32Array.from([1, 1, 2, 2, 1, 4]),
      Int32Array.from([1, 1, 2, 4, 1, 2]),
      Int32Array.from([1, 2, 2, 1, 1, 4]),
      Int32Array.from([1, 2, 2, 4, 1, 1]),
      Int32Array.from([1, 4, 2, 1, 1, 2]),
      Int32Array.from([1, 4, 2, 2, 1, 1]),
      Int32Array.from([2, 4, 1, 2, 1, 1]),
      Int32Array.from([2, 2, 1, 1, 1, 4]),
      Int32Array.from([4, 1, 3, 1, 1, 1]),
      Int32Array.from([2, 4, 1, 1, 1, 2]),
      Int32Array.from([1, 3, 4, 1, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 4, 2]),
      Int32Array.from([1, 2, 1, 1, 4, 2]),
      Int32Array.from([1, 2, 1, 2, 4, 1]),
      Int32Array.from([1, 1, 4, 2, 1, 2]),
      Int32Array.from([1, 2, 4, 1, 1, 2]),
      Int32Array.from([1, 2, 4, 2, 1, 1]),
      Int32Array.from([4, 1, 1, 2, 1, 2]),
      Int32Array.from([4, 2, 1, 1, 1, 2]),
      Int32Array.from([4, 2, 1, 2, 1, 1]),
      Int32Array.from([2, 1, 2, 1, 4, 1]),
      Int32Array.from([2, 1, 4, 1, 2, 1]),
      Int32Array.from([4, 1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 1, 1, 4, 3]),
      Int32Array.from([1, 1, 1, 3, 4, 1]),
      Int32Array.from([1, 3, 1, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 1, 3]),
      Int32Array.from([1, 1, 4, 3, 1, 1]),
      Int32Array.from([4, 1, 1, 1, 1, 3]),
      Int32Array.from([4, 1, 1, 3, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 4, 1]),
      Int32Array.from([1, 1, 4, 1, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 4, 1]),
      Int32Array.from([4, 1, 1, 1, 3, 1]),
      Int32Array.from([2, 1, 1, 4, 1, 2]),
      Int32Array.from([2, 1, 1, 2, 1, 4]),
      Int32Array.from([2, 1, 1, 2, 3, 2]),
      Int32Array.from([2, 3, 3, 1, 1, 1, 2])
    ], e.MAX_AVG_VARIANCE = 0.25, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
  }(_e)
), Ma = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), wr = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rn = (
  /** @class */
  function(r) {
    Ma(e, r);
    function e(t, n) {
      t === void 0 && (t = !1), n === void 0 && (n = !1);
      var i = r.call(this) || this;
      return i.usingCheckDigit = t, i.extendedMode = n, i.decodeRowResult = "", i.counters = new Int32Array(9), i;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o, a, s, f, u = this.counters;
      u.fill(0), this.decodeRowResult = "";
      var c = e.findAsteriskPattern(n, u), l = n.getNextSet(c[1]), d = n.getSize(), h, p;
      do {
        e.recordPattern(n, l, u);
        var v = e.toNarrowWidePattern(u);
        if (v < 0)
          throw new w();
        h = e.patternToChar(v), this.decodeRowResult += h, p = l;
        try {
          for (var y = (o = void 0, wr(u)), _ = y.next(); !_.done; _ = y.next()) {
            var x = _.value;
            l += x;
          }
        } catch (H) {
          o = { error: H };
        } finally {
          try {
            _ && !_.done && (a = y.return) && a.call(y);
          } finally {
            if (o)
              throw o.error;
          }
        }
        l = n.getNextSet(l);
      } while (h !== "*");
      this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
      var C = 0;
      try {
        for (var E = wr(u), S = E.next(); !S.done; S = E.next()) {
          var x = S.value;
          C += x;
        }
      } catch (H) {
        s = { error: H };
      } finally {
        try {
          S && !S.done && (f = E.return) && f.call(E);
        } finally {
          if (s)
            throw s.error;
        }
      }
      var I = l - p - C;
      if (l !== d && I * 2 < C)
        throw new w();
      if (this.usingCheckDigit) {
        for (var T = this.decodeRowResult.length - 1, R = 0, B = 0; B < T; B++)
          R += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(B));
        if (this.decodeRowResult.charAt(T) !== e.ALPHABET_STRING.charAt(R % 43))
          throw new pe();
        this.decodeRowResult = this.decodeRowResult.substring(0, T);
      }
      if (this.decodeRowResult.length === 0)
        throw new w();
      var M;
      this.extendedMode ? M = e.decodeExtended(this.decodeRowResult) : M = this.decodeRowResult;
      var te = (c[1] + c[0]) / 2, N = p + C / 2;
      return new Oe(M, null, 0, [new P(te, t), new P(N, t)], L.CODE_39, (/* @__PURE__ */ new Date()).getTime());
    }, e.findAsteriskPattern = function(t, n) {
      for (var i = t.getSize(), o = t.getNextSet(0), a = 0, s = o, f = !1, u = n.length, c = o; c < i; c++)
        if (t.get(c) !== f)
          n[a]++;
        else {
          if (a === u - 1) {
            if (this.toNarrowWidePattern(n) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, s - Math.floor((c - s) / 2)), s, !1))
              return [s, c];
            s += n[0] + n[1], n.copyWithin(0, 2, 2 + a - 1), n[a - 1] = 0, n[a] = 0, a--;
          } else
            a++;
          n[a] = 1, f = !f;
        }
      throw new w();
    }, e.toNarrowWidePattern = function(t) {
      var n, i, o = t.length, a = 0, s;
      do {
        var f = 2147483647;
        try {
          for (var u = (n = void 0, wr(t)), c = u.next(); !c.done; c = u.next()) {
            var l = c.value;
            l < f && l > a && (f = l);
          }
        } catch (v) {
          n = { error: v };
        } finally {
          try {
            c && !c.done && (i = u.return) && i.call(u);
          } finally {
            if (n)
              throw n.error;
          }
        }
        a = f, s = 0;
        for (var d = 0, h = 0, p = 0; p < o; p++) {
          var l = t[p];
          l > a && (h |= 1 << o - 1 - p, s++, d += l);
        }
        if (s === 3) {
          for (var p = 0; p < o && s > 0; p++) {
            var l = t[p];
            if (l > a && (s--, l * 2 >= d))
              return -1;
          }
          return h;
        }
      } while (s > 3);
      return -1;
    }, e.patternToChar = function(t) {
      for (var n = 0; n < e.CHARACTER_ENCODINGS.length; n++)
        if (e.CHARACTER_ENCODINGS[n] === t)
          return e.ALPHABET_STRING.charAt(n);
      if (t === e.ASTERISK_ENCODING)
        return "*";
      throw new w();
    }, e.decodeExtended = function(t) {
      for (var n = t.length, i = "", o = 0; o < n; o++) {
        var a = t.charAt(o);
        if (a === "+" || a === "$" || a === "%" || a === "/") {
          var s = t.charAt(o + 1), f = "\0";
          switch (a) {
            case "+":
              if (s >= "A" && s <= "Z")
                f = String.fromCharCode(s.charCodeAt(0) + 32);
              else
                throw new O();
              break;
            case "$":
              if (s >= "A" && s <= "Z")
                f = String.fromCharCode(s.charCodeAt(0) - 64);
              else
                throw new O();
              break;
            case "%":
              if (s >= "A" && s <= "E")
                f = String.fromCharCode(s.charCodeAt(0) - 38);
              else if (s >= "F" && s <= "J")
                f = String.fromCharCode(s.charCodeAt(0) - 11);
              else if (s >= "K" && s <= "O")
                f = String.fromCharCode(s.charCodeAt(0) + 16);
              else if (s >= "P" && s <= "T")
                f = String.fromCharCode(s.charCodeAt(0) + 43);
              else if (s === "U")
                f = "\0";
              else if (s === "V")
                f = "@";
              else if (s === "W")
                f = "`";
              else if (s === "X" || s === "Y" || s === "Z")
                f = "";
              else
                throw new O();
              break;
            case "/":
              if (s >= "A" && s <= "O")
                f = String.fromCharCode(s.charCodeAt(0) - 32);
              else if (s === "Z")
                f = ":";
              else
                throw new O();
              break;
          }
          i += f, o++;
        } else
          i += a;
      }
      return i;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
      52,
      289,
      97,
      352,
      49,
      304,
      112,
      37,
      292,
      100,
      265,
      73,
      328,
      25,
      280,
      88,
      13,
      268,
      76,
      28,
      259,
      67,
      322,
      19,
      274,
      82,
      7,
      262,
      70,
      22,
      385,
      193,
      448,
      145,
      400,
      208,
      133,
      388,
      196,
      168,
      162,
      138,
      42
      // /-%
    ], e.ASTERISK_ENCODING = 148, e;
  }(_e)
), Ba = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Sr = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Dn = (
  /** @class */
  function(r) {
    Ba(e, r);
    function e() {
      var t = r.call(this) || this;
      return t.decodeRowResult = "", t.counters = new Int32Array(6), t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o, a, s, f, u = this.findAsteriskPattern(n), c = n.getNextSet(u[1]), l = n.getSize(), d = this.counters;
      d.fill(0), this.decodeRowResult = "";
      var h, p;
      do {
        e.recordPattern(n, c, d);
        var v = this.toPattern(d);
        if (v < 0)
          throw new w();
        h = this.patternToChar(v), this.decodeRowResult += h, p = c;
        try {
          for (var y = (o = void 0, Sr(d)), _ = y.next(); !_.done; _ = y.next()) {
            var x = _.value;
            c += x;
          }
        } catch (B) {
          o = { error: B };
        } finally {
          try {
            _ && !_.done && (a = y.return) && a.call(y);
          } finally {
            if (o)
              throw o.error;
          }
        }
        c = n.getNextSet(c);
      } while (h !== "*");
      this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
      var C = 0;
      try {
        for (var E = Sr(d), S = E.next(); !S.done; S = E.next()) {
          var x = S.value;
          C += x;
        }
      } catch (B) {
        s = { error: B };
      } finally {
        try {
          S && !S.done && (f = E.return) && f.call(E);
        } finally {
          if (s)
            throw s.error;
        }
      }
      if (c === l || !n.get(c))
        throw new w();
      if (this.decodeRowResult.length < 2)
        throw new w();
      this.checkChecksums(this.decodeRowResult), this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
      var I = this.decodeExtended(this.decodeRowResult), T = (u[1] + u[0]) / 2, R = p + C / 2;
      return new Oe(I, null, 0, [new P(T, t), new P(R, t)], L.CODE_93, (/* @__PURE__ */ new Date()).getTime());
    }, e.prototype.findAsteriskPattern = function(t) {
      var n = t.getSize(), i = t.getNextSet(0);
      this.counters.fill(0);
      for (var o = this.counters, a = i, s = !1, f = o.length, u = 0, c = i; c < n; c++)
        if (t.get(c) !== s)
          o[u]++;
        else {
          if (u === f - 1) {
            if (this.toPattern(o) === e.ASTERISK_ENCODING)
              return new Int32Array([a, c]);
            a += o[0] + o[1], o.copyWithin(0, 2, 2 + u - 1), o[u - 1] = 0, o[u] = 0, u--;
          } else
            u++;
          o[u] = 1, s = !s;
        }
      throw new w();
    }, e.prototype.toPattern = function(t) {
      var n, i, o = 0;
      try {
        for (var a = Sr(t), s = a.next(); !s.done; s = a.next()) {
          var f = s.value;
          o += f;
        }
      } catch (p) {
        n = { error: p };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      for (var u = 0, c = t.length, l = 0; l < c; l++) {
        var d = Math.round(t[l] * 9 / o);
        if (d < 1 || d > 4)
          return -1;
        if (l & 1)
          u <<= d;
        else
          for (var h = 0; h < d; h++)
            u = u << 1 | 1;
      }
      return u;
    }, e.prototype.patternToChar = function(t) {
      for (var n = 0; n < e.CHARACTER_ENCODINGS.length; n++)
        if (e.CHARACTER_ENCODINGS[n] === t)
          return e.ALPHABET_STRING.charAt(n);
      throw new w();
    }, e.prototype.decodeExtended = function(t) {
      for (var n = t.length, i = "", o = 0; o < n; o++) {
        var a = t.charAt(o);
        if (a >= "a" && a <= "d") {
          if (o >= n - 1)
            throw new O();
          var s = t.charAt(o + 1), f = "\0";
          switch (a) {
            case "d":
              if (s >= "A" && s <= "Z")
                f = String.fromCharCode(s.charCodeAt(0) + 32);
              else
                throw new O();
              break;
            case "a":
              if (s >= "A" && s <= "Z")
                f = String.fromCharCode(s.charCodeAt(0) - 64);
              else
                throw new O();
              break;
            case "b":
              if (s >= "A" && s <= "E")
                f = String.fromCharCode(s.charCodeAt(0) - 38);
              else if (s >= "F" && s <= "J")
                f = String.fromCharCode(s.charCodeAt(0) - 11);
              else if (s >= "K" && s <= "O")
                f = String.fromCharCode(s.charCodeAt(0) + 16);
              else if (s >= "P" && s <= "T")
                f = String.fromCharCode(s.charCodeAt(0) + 43);
              else if (s === "U")
                f = "\0";
              else if (s === "V")
                f = "@";
              else if (s === "W")
                f = "`";
              else if (s >= "X" && s <= "Z")
                f = "";
              else
                throw new O();
              break;
            case "c":
              if (s >= "A" && s <= "O")
                f = String.fromCharCode(s.charCodeAt(0) - 32);
              else if (s === "Z")
                f = ":";
              else
                throw new O();
              break;
          }
          i += f, o++;
        } else
          i += a;
      }
      return i;
    }, e.prototype.checkChecksums = function(t) {
      var n = t.length;
      this.checkOneChecksum(t, n - 2, 20), this.checkOneChecksum(t, n - 1, 15);
    }, e.prototype.checkOneChecksum = function(t, n, i) {
      for (var o = 1, a = 0, s = n - 1; s >= 0; s--)
        a += o * e.ALPHABET_STRING.indexOf(t.charAt(s)), ++o > i && (o = 1);
      if (t.charAt(n) !== e.ALPHABET_STRING[a % 47])
        throw new pe();
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*", e.CHARACTER_ENCODINGS = [
      276,
      328,
      324,
      322,
      296,
      292,
      290,
      336,
      274,
      266,
      424,
      420,
      418,
      404,
      402,
      394,
      360,
      356,
      354,
      308,
      282,
      344,
      332,
      326,
      300,
      278,
      436,
      434,
      428,
      422,
      406,
      410,
      364,
      358,
      310,
      314,
      302,
      468,
      466,
      458,
      366,
      374,
      430,
      294,
      474,
      470,
      306,
      350
    ], e.ASTERISK_ENCODING = e.CHARACTER_ENCODINGS[47], e;
  }(_e)
), La = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Fa = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pn = (
  /** @class */
  function(r) {
    La(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.narrowLineWidth = -1, t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o, a, s = this.decodeStart(n), f = this.decodeEnd(n), u = new V();
      e.decodeMiddle(n, s[1], f[0], u);
      var c = u.toString(), l = null;
      i != null && (l = i.get(fe.ALLOWED_LENGTHS)), l == null && (l = e.DEFAULT_ALLOWED_LENGTHS);
      var d = c.length, h = !1, p = 0;
      try {
        for (var v = Fa(l), y = v.next(); !y.done; y = v.next()) {
          var _ = y.value;
          if (d === _) {
            h = !0;
            break;
          }
          _ > p && (p = _);
        }
      } catch (E) {
        o = { error: E };
      } finally {
        try {
          y && !y.done && (a = v.return) && a.call(v);
        } finally {
          if (o)
            throw o.error;
        }
      }
      if (!h && d > p && (h = !0), !h)
        throw new O();
      var x = [new P(s[1], t), new P(f[0], t)], C = new Oe(
        c,
        null,
        // no natural byte representation for these barcodes
        0,
        x,
        L.ITF,
        (/* @__PURE__ */ new Date()).getTime()
      );
      return C;
    }, e.decodeMiddle = function(t, n, i, o) {
      var a = new Int32Array(10), s = new Int32Array(5), f = new Int32Array(5);
      for (a.fill(0), s.fill(0), f.fill(0); n < i; ) {
        _e.recordPattern(t, n, a);
        for (var u = 0; u < 5; u++) {
          var c = 2 * u;
          s[u] = a[c], f[u] = a[c + 1];
        }
        var l = e.decodeDigit(s);
        o.append(l.toString()), l = this.decodeDigit(f), o.append(l.toString()), a.forEach(function(d) {
          n += d;
        });
      }
    }, e.prototype.decodeStart = function(t) {
      var n = e.skipWhiteSpace(t), i = e.findGuardPattern(t, n, e.START_PATTERN);
      return this.narrowLineWidth = (i[1] - i[0]) / 4, this.validateQuietZone(t, i[0]), i;
    }, e.prototype.validateQuietZone = function(t, n) {
      var i = this.narrowLineWidth * 10;
      i = i < n ? i : n;
      for (var o = n - 1; i > 0 && o >= 0 && !t.get(o); o--)
        i--;
      if (i !== 0)
        throw new w();
    }, e.skipWhiteSpace = function(t) {
      var n = t.getSize(), i = t.getNextSet(0);
      if (i === n)
        throw new w();
      return i;
    }, e.prototype.decodeEnd = function(t) {
      t.reverse();
      try {
        var n = e.skipWhiteSpace(t), i = void 0;
        try {
          i = e.findGuardPattern(t, n, e.END_PATTERN_REVERSED[0]);
        } catch (a) {
          a instanceof w && (i = e.findGuardPattern(t, n, e.END_PATTERN_REVERSED[1]));
        }
        this.validateQuietZone(t, i[0]);
        var o = i[0];
        return i[0] = t.getSize() - i[1], i[1] = t.getSize() - o, i;
      } finally {
        t.reverse();
      }
    }, e.findGuardPattern = function(t, n, i) {
      var o = i.length, a = new Int32Array(o), s = t.getSize(), f = !1, u = 0, c = n;
      a.fill(0);
      for (var l = n; l < s; l++)
        if (t.get(l) !== f)
          a[u]++;
        else {
          if (u === o - 1) {
            if (_e.patternMatchVariance(a, i, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
              return [c, l];
            c += a[0] + a[1], ne.arraycopy(a, 2, a, 0, u - 1), a[u - 1] = 0, a[u] = 0, u--;
          } else
            u++;
          a[u] = 1, f = !f;
        }
      throw new w();
    }, e.decodeDigit = function(t) {
      for (var n = e.MAX_AVG_VARIANCE, i = -1, o = e.PATTERNS.length, a = 0; a < o; a++) {
        var s = e.PATTERNS[a], f = _e.patternMatchVariance(t, s, e.MAX_INDIVIDUAL_VARIANCE);
        f < n ? (n = f, i = a) : f === n && (i = -1);
      }
      if (i >= 0)
        return i % 10;
      throw new w();
    }, e.PATTERNS = [
      Int32Array.from([1, 1, 2, 2, 1]),
      Int32Array.from([2, 1, 1, 1, 2]),
      Int32Array.from([1, 2, 1, 1, 2]),
      Int32Array.from([2, 2, 1, 1, 1]),
      Int32Array.from([1, 1, 2, 1, 2]),
      Int32Array.from([2, 1, 2, 1, 1]),
      Int32Array.from([1, 2, 2, 1, 1]),
      Int32Array.from([1, 1, 1, 2, 2]),
      Int32Array.from([2, 1, 1, 2, 1]),
      Int32Array.from([1, 2, 1, 2, 1]),
      Int32Array.from([1, 1, 3, 3, 1]),
      Int32Array.from([3, 1, 1, 1, 3]),
      Int32Array.from([1, 3, 1, 1, 3]),
      Int32Array.from([3, 3, 1, 1, 1]),
      Int32Array.from([1, 1, 3, 1, 3]),
      Int32Array.from([3, 1, 3, 1, 1]),
      Int32Array.from([1, 3, 3, 1, 1]),
      Int32Array.from([1, 1, 1, 3, 3]),
      Int32Array.from([3, 1, 1, 3, 1]),
      Int32Array.from([1, 3, 1, 3, 1])
      // 9
    ], e.MAX_AVG_VARIANCE = 0.38, e.MAX_INDIVIDUAL_VARIANCE = 0.5, e.DEFAULT_ALLOWED_LENGTHS = [6, 8, 10, 12, 14], e.START_PATTERN = Int32Array.from([1, 1, 1, 1]), e.END_PATTERN_REVERSED = [
      Int32Array.from([1, 1, 2]),
      Int32Array.from([1, 1, 3])
      // 3x
    ], e;
  }(_e)
), ka = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Et = (
  /** @class */
  function(r) {
    ka(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.decodeRowStringBuffer = "", t;
    }
    return e.findStartGuardPattern = function(t) {
      for (var n = !1, i, o = 0, a = Int32Array.from([0, 0, 0]); !n; ) {
        a = Int32Array.from([0, 0, 0]), i = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, a);
        var s = i[0];
        o = i[1];
        var f = s - (o - s);
        f >= 0 && (n = t.isRange(f, s, !1));
      }
      return i;
    }, e.checkChecksum = function(t) {
      return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
      var n = t.length;
      if (n === 0)
        return !1;
      var i = parseInt(t.charAt(n - 1), 10);
      return e.getStandardUPCEANChecksum(t.substring(0, n - 1)) === i;
    }, e.getStandardUPCEANChecksum = function(t) {
      for (var n = t.length, i = 0, o = n - 1; o >= 0; o -= 2) {
        var a = t.charAt(o).charCodeAt(0) - 48;
        if (a < 0 || a > 9)
          throw new O();
        i += a;
      }
      i *= 3;
      for (var o = n - 2; o >= 0; o -= 2) {
        var a = t.charAt(o).charCodeAt(0) - 48;
        if (a < 0 || a > 9)
          throw new O();
        i += a;
      }
      return (1e3 - i) % 10;
    }, e.decodeEnd = function(t, n) {
      return e.findGuardPattern(t, n, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, n, i, o) {
      return this.findGuardPattern(t, n, i, o, new Int32Array(o.length));
    }, e.findGuardPattern = function(t, n, i, o, a) {
      var s = t.getSize();
      n = i ? t.getNextUnset(n) : t.getNextSet(n);
      for (var f = 0, u = n, c = o.length, l = i, d = n; d < s; d++)
        if (t.get(d) !== l)
          a[f]++;
        else {
          if (f === c - 1) {
            if (_e.patternMatchVariance(a, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
              return Int32Array.from([u, d]);
            u += a[0] + a[1];
            for (var h = a.slice(2, a.length), p = 0; p < f - 1; p++)
              a[p] = h[p];
            a[f - 1] = 0, a[f] = 0, f--;
          } else
            f++;
          a[f] = 1, l = !l;
        }
      throw new w();
    }, e.decodeDigit = function(t, n, i, o) {
      this.recordPattern(t, i, n);
      for (var a = this.MAX_AVG_VARIANCE, s = -1, f = o.length, u = 0; u < f; u++) {
        var c = o[u], l = _e.patternMatchVariance(n, c, e.MAX_INDIVIDUAL_VARIANCE);
        l < a && (a = l, s = u);
      }
      if (s >= 0)
        return s;
      throw new w();
    }, e.MAX_AVG_VARIANCE = 0.48, e.MAX_INDIVIDUAL_VARIANCE = 0.7, e.START_END_PATTERN = Int32Array.from([1, 1, 1]), e.MIDDLE_PATTERN = Int32Array.from([1, 1, 1, 1, 1]), e.END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), e.L_PATTERNS = [
      Int32Array.from([3, 2, 1, 1]),
      Int32Array.from([2, 2, 2, 1]),
      Int32Array.from([2, 1, 2, 2]),
      Int32Array.from([1, 4, 1, 1]),
      Int32Array.from([1, 1, 3, 2]),
      Int32Array.from([1, 2, 3, 1]),
      Int32Array.from([1, 1, 1, 4]),
      Int32Array.from([1, 3, 1, 2]),
      Int32Array.from([1, 2, 1, 3]),
      Int32Array.from([3, 1, 1, 2])
    ], e;
  }(_e)
), Ua = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Va = (
  /** @class */
  function() {
    function r() {
      this.CHECK_DIGIT_ENCODINGS = [24, 20, 18, 17, 12, 6, 3, 10, 9, 5], this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return r.prototype.decodeRow = function(e, t, n) {
      var i = this.decodeRowStringBuffer, o = this.decodeMiddle(t, n, i), a = i.toString(), s = r.parseExtensionString(a), f = [
        new P((n[0] + n[1]) / 2, e),
        new P(o, e)
      ], u = new Oe(a, null, 0, f, L.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return s != null && u.putAllMetadata(s), u;
    }, r.prototype.decodeMiddle = function(e, t, n) {
      var i, o, a = this.decodeMiddleCounters;
      a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
      for (var s = e.getSize(), f = t[1], u = 0, c = 0; c < 5 && f < s; c++) {
        var l = Et.decodeDigit(e, a, f, Et.L_AND_G_PATTERNS);
        n += String.fromCharCode(48 + l % 10);
        try {
          for (var d = (i = void 0, Ua(a)), h = d.next(); !h.done; h = d.next()) {
            var p = h.value;
            f += p;
          }
        } catch (y) {
          i = { error: y };
        } finally {
          try {
            h && !h.done && (o = d.return) && o.call(d);
          } finally {
            if (i)
              throw i.error;
          }
        }
        l >= 10 && (u |= 1 << 4 - c), c !== 4 && (f = e.getNextSet(f), f = e.getNextUnset(f));
      }
      if (n.length !== 5)
        throw new w();
      var v = this.determineCheckDigit(u);
      if (r.extensionChecksum(n.toString()) !== v)
        throw new w();
      return f;
    }, r.extensionChecksum = function(e) {
      for (var t = e.length, n = 0, i = t - 2; i >= 0; i -= 2)
        n += e.charAt(i).charCodeAt(0) - 48;
      n *= 3;
      for (var i = t - 1; i >= 0; i -= 2)
        n += e.charAt(i).charCodeAt(0) - 48;
      return n *= 3, n % 10;
    }, r.prototype.determineCheckDigit = function(e) {
      for (var t = 0; t < 10; t++)
        if (e === this.CHECK_DIGIT_ENCODINGS[t])
          return t;
      throw new w();
    }, r.parseExtensionString = function(e) {
      if (e.length !== 5)
        return null;
      var t = r.parseExtension5String(e);
      return t == null ? null : /* @__PURE__ */ new Map([[be.SUGGESTED_PRICE, t]]);
    }, r.parseExtension5String = function(e) {
      var t;
      switch (e.charAt(0)) {
        case "0":
          t = "£";
          break;
        case "5":
          t = "$";
          break;
        case "9":
          switch (e) {
            case "90000":
              return null;
            case "99991":
              return "0.00";
            case "99990":
              return "Used";
          }
          t = "";
          break;
        default:
          t = "";
          break;
      }
      var n = parseInt(e.substring(1)), i = (n / 100).toString(), o = n % 100, a = o < 10 ? "0" + o : o.toString();
      return t + i + "." + a;
    }, r;
  }()
), Ga = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ha = (
  /** @class */
  function() {
    function r() {
      this.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), this.decodeRowStringBuffer = "";
    }
    return r.prototype.decodeRow = function(e, t, n) {
      var i = this.decodeRowStringBuffer, o = this.decodeMiddle(t, n, i), a = i.toString(), s = r.parseExtensionString(a), f = [
        new P((n[0] + n[1]) / 2, e),
        new P(o, e)
      ], u = new Oe(a, null, 0, f, L.UPC_EAN_EXTENSION, (/* @__PURE__ */ new Date()).getTime());
      return s != null && u.putAllMetadata(s), u;
    }, r.prototype.decodeMiddle = function(e, t, n) {
      var i, o, a = this.decodeMiddleCounters;
      a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
      for (var s = e.getSize(), f = t[1], u = 0, c = 0; c < 2 && f < s; c++) {
        var l = Et.decodeDigit(e, a, f, Et.L_AND_G_PATTERNS);
        n += String.fromCharCode(48 + l % 10);
        try {
          for (var d = (i = void 0, Ga(a)), h = d.next(); !h.done; h = d.next()) {
            var p = h.value;
            f += p;
          }
        } catch (v) {
          i = { error: v };
        } finally {
          try {
            h && !h.done && (o = d.return) && o.call(d);
          } finally {
            if (i)
              throw i.error;
          }
        }
        l >= 10 && (u |= 1 << 1 - c), c !== 1 && (f = e.getNextSet(f), f = e.getNextUnset(f));
      }
      if (n.length !== 2)
        throw new w();
      if (parseInt(n.toString()) % 4 !== u)
        throw new w();
      return f;
    }, r.parseExtensionString = function(e) {
      return e.length !== 2 ? null : /* @__PURE__ */ new Map([[be.ISSUE_NUMBER, parseInt(e)]]);
    }, r;
  }()
), ja = (
  /** @class */
  function() {
    function r() {
    }
    return r.decodeRow = function(e, t, n) {
      var i = Et.findGuardPattern(t, n, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
      try {
        var o = new Va();
        return o.decodeRow(e, t, i);
      } catch {
        var a = new Ha();
        return a.decodeRow(e, t, i);
      }
    }, r.EXTENSION_START_PATTERN = Int32Array.from([1, 1, 2]), r;
  }()
), Wa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xe = (
  /** @class */
  function(r) {
    Wa(e, r);
    function e() {
      var t = r.call(this) || this;
      t.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(s) {
        return Int32Array.from(s);
      });
      for (var n = 10; n < 20; n++) {
        for (var i = e.L_PATTERNS[n - 10], o = new Int32Array(i.length), a = 0; a < i.length; a++)
          o[a] = i[i.length - a - 1];
        e.L_AND_G_PATTERNS[n] = o;
      }
      return t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o = e.findStartGuardPattern(n), a = i == null ? null : i.get(fe.NEED_RESULT_POINT_CALLBACK);
      if (a != null) {
        var s = new P((o[0] + o[1]) / 2, t);
        a.foundPossibleResultPoint(s);
      }
      var f = this.decodeMiddle(n, o, this.decodeRowStringBuffer), u = f.rowOffset, c = f.resultString;
      if (a != null) {
        var l = new P(u, t);
        a.foundPossibleResultPoint(l);
      }
      var d = e.decodeEnd(n, u);
      if (a != null) {
        var h = new P((d[0] + d[1]) / 2, t);
        a.foundPossibleResultPoint(h);
      }
      var p = d[1], v = p + (p - d[0]);
      if (v >= n.getSize() || !n.isRange(p, v, !1))
        throw new w();
      var y = c.toString();
      if (y.length < 8)
        throw new O();
      if (!e.checkChecksum(y))
        throw new pe();
      var _ = (o[1] + o[0]) / 2, x = (d[1] + d[0]) / 2, C = this.getBarcodeFormat(), E = [new P(_, t), new P(x, t)], S = new Oe(y, null, 0, E, C, (/* @__PURE__ */ new Date()).getTime()), I = 0;
      try {
        var T = ja.decodeRow(t, n, d[1]);
        S.putMetadata(be.UPC_EAN_EXTENSION, T.getText()), S.putAllMetadata(T.getResultMetadata()), S.addResultPoints(T.getResultPoints()), I = T.getText().length;
      } catch {
      }
      var R = i == null ? null : i.get(fe.ALLOWED_EAN_EXTENSIONS);
      if (R != null) {
        var B = !1;
        for (var M in R)
          if (I.toString() === M) {
            B = !0;
            break;
          }
        if (!B)
          throw new w();
      }
      return C === L.EAN_13 || L.UPC_A, S;
    }, e.checkChecksum = function(t) {
      return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
      var n = t.length;
      if (n === 0)
        return !1;
      var i = parseInt(t.charAt(n - 1), 10);
      return e.getStandardUPCEANChecksum(t.substring(0, n - 1)) === i;
    }, e.getStandardUPCEANChecksum = function(t) {
      for (var n = t.length, i = 0, o = n - 1; o >= 0; o -= 2) {
        var a = t.charAt(o).charCodeAt(0) - 48;
        if (a < 0 || a > 9)
          throw new O();
        i += a;
      }
      i *= 3;
      for (var o = n - 2; o >= 0; o -= 2) {
        var a = t.charAt(o).charCodeAt(0) - 48;
        if (a < 0 || a > 9)
          throw new O();
        i += a;
      }
      return (1e3 - i) % 10;
    }, e.decodeEnd = function(t, n) {
      return e.findGuardPattern(t, n, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
  }(Et)
), Xa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Nn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vr = (
  /** @class */
  function(r) {
    Xa(e, r);
    function e() {
      var t = r.call(this) || this;
      return t.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), t;
    }
    return e.prototype.decodeMiddle = function(t, n, i) {
      var o, a, s, f, u = this.decodeMiddleCounters;
      u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
      for (var c = t.getSize(), l = n[1], d = 0, h = 0; h < 6 && l < c; h++) {
        var p = xe.decodeDigit(t, u, l, xe.L_AND_G_PATTERNS);
        i += String.fromCharCode(48 + p % 10);
        try {
          for (var v = (o = void 0, Nn(u)), y = v.next(); !y.done; y = v.next()) {
            var _ = y.value;
            l += _;
          }
        } catch (S) {
          o = { error: S };
        } finally {
          try {
            y && !y.done && (a = v.return) && a.call(v);
          } finally {
            if (o)
              throw o.error;
          }
        }
        p >= 10 && (d |= 1 << 5 - h);
      }
      i = e.determineFirstDigit(i, d);
      var x = xe.findGuardPattern(t, l, !0, xe.MIDDLE_PATTERN, new Int32Array(xe.MIDDLE_PATTERN.length).fill(0));
      l = x[1];
      for (var h = 0; h < 6 && l < c; h++) {
        var p = xe.decodeDigit(t, u, l, xe.L_PATTERNS);
        i += String.fromCharCode(48 + p);
        try {
          for (var C = (s = void 0, Nn(u)), E = C.next(); !E.done; E = C.next()) {
            var _ = E.value;
            l += _;
          }
        } catch (T) {
          s = { error: T };
        } finally {
          try {
            E && !E.done && (f = C.return) && f.call(C);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      return { rowOffset: l, resultString: i };
    }, e.prototype.getBarcodeFormat = function() {
      return L.EAN_13;
    }, e.determineFirstDigit = function(t, n) {
      for (var i = 0; i < 10; i++)
        if (n === this.FIRST_DIGIT_ENCODINGS[i])
          return t = String.fromCharCode(48 + i) + t, t;
      throw new w();
    }, e.FIRST_DIGIT_ENCODINGS = [0, 11, 13, 14, 19, 25, 28, 21, 22, 26], e;
  }(xe)
), za = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Mn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Bn = (
  /** @class */
  function(r) {
    za(e, r);
    function e() {
      var t = r.call(this) || this;
      return t.decodeMiddleCounters = Int32Array.from([0, 0, 0, 0]), t;
    }
    return e.prototype.decodeMiddle = function(t, n, i) {
      var o, a, s, f, u = this.decodeMiddleCounters;
      u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
      for (var c = t.getSize(), l = n[1], d = 0; d < 4 && l < c; d++) {
        var h = xe.decodeDigit(t, u, l, xe.L_PATTERNS);
        i += String.fromCharCode(48 + h);
        try {
          for (var p = (o = void 0, Mn(u)), v = p.next(); !v.done; v = p.next()) {
            var y = v.value;
            l += y;
          }
        } catch (E) {
          o = { error: E };
        } finally {
          try {
            v && !v.done && (a = p.return) && a.call(p);
          } finally {
            if (o)
              throw o.error;
          }
        }
      }
      var _ = xe.findGuardPattern(t, l, !0, xe.MIDDLE_PATTERN, new Int32Array(xe.MIDDLE_PATTERN.length).fill(0));
      l = _[1];
      for (var d = 0; d < 4 && l < c; d++) {
        var h = xe.decodeDigit(t, u, l, xe.L_PATTERNS);
        i += String.fromCharCode(48 + h);
        try {
          for (var x = (s = void 0, Mn(u)), C = x.next(); !C.done; C = x.next()) {
            var y = C.value;
            l += y;
          }
        } catch (I) {
          s = { error: I };
        } finally {
          try {
            C && !C.done && (f = x.return) && f.call(x);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      return { rowOffset: l, resultString: i };
    }, e.prototype.getBarcodeFormat = function() {
      return L.EAN_8;
    }, e;
  }(xe)
), Ya = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ln = (
  /** @class */
  function(r) {
    Ya(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.ean13Reader = new Vr(), t;
    }
    return e.prototype.getBarcodeFormat = function() {
      return L.UPC_A;
    }, e.prototype.decode = function(t, n) {
      return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, n, i) {
      return this.maybeReturnResult(this.ean13Reader.decodeRow(t, n, i));
    }, e.prototype.decodeMiddle = function(t, n, i) {
      return this.ean13Reader.decodeMiddle(t, n, i);
    }, e.prototype.maybeReturnResult = function(t) {
      var n = t.getText();
      if (n.charAt(0) === "0") {
        var i = new Oe(n.substring(1), null, null, t.getResultPoints(), L.UPC_A);
        return t.getResultMetadata() != null && i.putAllMetadata(t.getResultMetadata()), i;
      } else
        throw new w();
    }, e.prototype.reset = function() {
      this.ean13Reader.reset();
    }, e;
  }(xe)
), $a = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Za = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fn = (
  /** @class */
  function(r) {
    $a(e, r);
    function e() {
      var t = r.call(this) || this;
      return t.decodeMiddleCounters = new Int32Array(4), t;
    }
    return e.prototype.decodeMiddle = function(t, n, i) {
      var o, a, s = this.decodeMiddleCounters.map(function(y) {
        return y;
      });
      s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
      for (var f = t.getSize(), u = n[1], c = 0, l = 0; l < 6 && u < f; l++) {
        var d = e.decodeDigit(t, s, u, e.L_AND_G_PATTERNS);
        i += String.fromCharCode(48 + d % 10);
        try {
          for (var h = (o = void 0, Za(s)), p = h.next(); !p.done; p = h.next()) {
            var v = p.value;
            u += v;
          }
        } catch (y) {
          o = { error: y };
        } finally {
          try {
            p && !p.done && (a = h.return) && a.call(h);
          } finally {
            if (o)
              throw o.error;
          }
        }
        d >= 10 && (c |= 1 << 5 - l);
      }
      return e.determineNumSysAndCheckDigit(new V(i), c), u;
    }, e.prototype.decodeEnd = function(t, n) {
      return e.findGuardPatternWithoutCounters(t, n, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
      return xe.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, n) {
      for (var i = 0; i <= 1; i++)
        for (var o = 0; o < 10; o++)
          if (n === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[i][o]) {
            t.insert(
              0,
              /*(char)*/
              "0" + i
            ), t.append(
              /*(char)*/
              "0" + o
            );
            return;
          }
      throw w.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
      return L.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
      var n = t.slice(1, 7).split("").map(function(a) {
        return a.charCodeAt(0);
      }), i = new V(
        /*12*/
      );
      i.append(t.charAt(0));
      var o = n[5];
      switch (o) {
        case 0:
        case 1:
        case 2:
          i.appendChars(n, 0, 2), i.append(o), i.append("0000"), i.appendChars(n, 2, 3);
          break;
        case 3:
          i.appendChars(n, 0, 3), i.append("00000"), i.appendChars(n, 3, 2);
          break;
        case 4:
          i.appendChars(n, 0, 4), i.append("00000"), i.append(n[4]);
          break;
        default:
          i.appendChars(n, 0, 5), i.append("0000"), i.append(o);
          break;
      }
      return t.length >= 8 && i.append(t.charAt(7)), i.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([1, 1, 1, 1, 1, 1]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
      Int32Array.from([56, 52, 50, 49, 44, 38, 35, 42, 41, 37]),
      Int32Array.from([7, 11, 13, 14, 19, 25, 28, 21, 22, 1])
    ], e;
  }(xe)
), Ka = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), kn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ir = (
  /** @class */
  function(r) {
    Ka(e, r);
    function e(t) {
      var n = r.call(this) || this, i = t == null ? null : t.get(fe.POSSIBLE_FORMATS), o = [];
      return i != null && (i.indexOf(L.EAN_13) > -1 && o.push(new Vr()), i.indexOf(L.UPC_A) > -1 && o.push(new Ln()), i.indexOf(L.EAN_8) > -1 && o.push(new Bn()), i.indexOf(L.UPC_E) > -1 && o.push(new Fn())), o.length === 0 && (o.push(new Vr()), o.push(new Ln()), o.push(new Bn()), o.push(new Fn())), n.readers = o, n;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o, a;
      try {
        for (var s = kn(this.readers), f = s.next(); !f.done; f = s.next()) {
          var u = f.value;
          try {
            var c = u.decodeRow(t, n, i), l = c.getBarcodeFormat() === L.EAN_13 && c.getText().charAt(0) === "0", d = i == null ? null : i.get(fe.POSSIBLE_FORMATS), h = d == null || d.includes(L.UPC_A);
            if (l && h) {
              var p = c.getRawBytes(), v = new Oe(c.getText().substring(1), p, p ? p.length : null, c.getResultPoints(), L.UPC_A);
              return v.putAllMetadata(c.getResultMetadata()), v;
            }
            return c;
          } catch {
          }
        }
      } catch (y) {
        o = { error: y };
      } finally {
        try {
          f && !f.done && (a = s.return) && a.call(s);
        } finally {
          if (o)
            throw o.error;
        }
      }
      throw new w();
    }, e.prototype.reset = function() {
      var t, n;
      try {
        for (var i = kn(this.readers), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.reset();
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
    }, e;
  }(_e)
), qa = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Qa = (
  /** @class */
  function(r) {
    qa(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.CODA_BAR_CHAR_SET = {
        nnnnnww: "0",
        nnnnwwn: "1",
        nnnwnnw: "2",
        wwnnnnn: "3",
        nnwnnwn: "4",
        wnnnnwn: "5",
        nwnnnnw: "6",
        nwnnwnn: "7",
        nwwnnnn: "8",
        wnnwnnn: "9",
        nnnwwnn: "-",
        nnwwnnn: "$",
        wnnnwnw: ":",
        wnwnnnw: "/",
        wnwnwnn: ".",
        nnwwwww: "+",
        nnwwnwn: "A",
        nwnwnnw: "B",
        nnnwnww: "C",
        nnnwwwn: "D"
      }, t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o = this.getValidRowData(n);
      if (!o)
        throw new w();
      var a = this.codaBarDecodeRow(o.row);
      if (!a)
        throw new w();
      return new Oe(a, null, 0, [new P(o.left, t), new P(o.right, t)], L.CODABAR, (/* @__PURE__ */ new Date()).getTime());
    }, e.prototype.getValidRowData = function(t) {
      var n = t.toArray(), i = n.indexOf(!0);
      if (i === -1)
        return null;
      var o = n.lastIndexOf(!0);
      if (o <= i)
        return null;
      n = n.slice(i, o + 1);
      for (var a = [], s = n[0], f = 1, u = 1; u < n.length; u++)
        n[u] === s ? f++ : (s = n[u], a.push(f), f = 1);
      return a.push(f), a.length < 23 && (a.length + 1) % 8 !== 0 ? null : { row: a, left: i, right: o };
    }, e.prototype.codaBarDecodeRow = function(t) {
      for (var n = [], i = Math.ceil(t.reduce(function(f, u) {
        return (f + u) / 2;
      }, 0)); t.length > 0; ) {
        var o = t.splice(0, 8).splice(0, 7), a = o.map(function(f) {
          return f < i ? "n" : "w";
        }).join("");
        if (this.CODA_BAR_CHAR_SET[a] === void 0)
          return null;
        n.push(this.CODA_BAR_CHAR_SET[a]);
      }
      var s = n.join("");
      return this.validCodaBarString(s) ? s : null;
    }, e.prototype.validCodaBarString = function(t) {
      var n = /^[A-D].{1,}[A-D]$/;
      return n.test(t);
    }, e;
  }(_e)
), Ja = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), es = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ut = (
  /** @class */
  function(r) {
    Ja(e, r);
    function e() {
      var t = r.call(this) || this;
      return t.decodeFinderCounters = new Int32Array(4), t.dataCharacterCounters = new Int32Array(8), t.oddRoundingErrors = new Array(4), t.evenRoundingErrors = new Array(4), t.oddCounts = new Array(t.dataCharacterCounters.length / 2), t.evenCounts = new Array(t.dataCharacterCounters.length / 2), t;
    }
    return e.prototype.getDecodeFinderCounters = function() {
      return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
      return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
      return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
      return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
      return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
      return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, n) {
      for (var i = 0; i < n.length; i++)
        if (_e.patternMatchVariance(t, n[i], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE)
          return i;
      throw new w();
    }, e.count = function(t) {
      return Y.sum(new Int32Array(t));
    }, e.increment = function(t, n) {
      for (var i = 0, o = n[0], a = 1; a < t.length; a++)
        n[a] > o && (o = n[a], i = a);
      t[i]++;
    }, e.decrement = function(t, n) {
      for (var i = 0, o = n[0], a = 1; a < t.length; a++)
        n[a] < o && (o = n[a], i = a);
      t[i]--;
    }, e.isFinderPattern = function(t) {
      var n, i, o = t[0] + t[1], a = o + t[2] + t[3], s = o / a;
      if (s >= e.MIN_FINDER_PATTERN_RATIO && s <= e.MAX_FINDER_PATTERN_RATIO) {
        var f = Number.MAX_SAFE_INTEGER, u = Number.MIN_SAFE_INTEGER;
        try {
          for (var c = es(t), l = c.next(); !l.done; l = c.next()) {
            var d = l.value;
            d > u && (u = d), d < f && (f = d);
          }
        } catch (h) {
          n = { error: h };
        } finally {
          try {
            l && !l.done && (i = c.return) && i.call(c);
          } finally {
            if (n)
              throw n.error;
          }
        }
        return u < 10 * f;
      }
      return !1;
    }, e.MAX_AVG_VARIANCE = 0.2, e.MAX_INDIVIDUAL_VARIANCE = 0.45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
  }(_e)
), fr = (
  /** @class */
  function() {
    function r(e, t) {
      this.value = e, this.checksumPortion = t;
    }
    return r.prototype.getValue = function() {
      return this.value;
    }, r.prototype.getChecksumPortion = function() {
      return this.checksumPortion;
    }, r.prototype.toString = function() {
      return this.value + "(" + this.checksumPortion + ")";
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.value === t.value && this.checksumPortion === t.checksumPortion;
    }, r.prototype.hashCode = function() {
      return this.value ^ this.checksumPortion;
    }, r;
  }()
), _i = (
  /** @class */
  function() {
    function r(e, t, n, i, o) {
      this.value = e, this.startEnd = t, this.value = e, this.startEnd = t, this.resultPoints = new Array(), this.resultPoints.push(new P(n, o)), this.resultPoints.push(new P(i, o));
    }
    return r.prototype.getValue = function() {
      return this.value;
    }, r.prototype.getStartEnd = function() {
      return this.startEnd;
    }, r.prototype.getResultPoints = function() {
      return this.resultPoints;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.value === t.value;
    }, r.prototype.hashCode = function() {
      return this.value;
    }, r;
  }()
), ts = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, yt = (
  /** @class */
  function() {
    function r() {
    }
    return r.getRSSvalue = function(e, t, n) {
      var i, o, a = 0;
      try {
        for (var s = ts(e), f = s.next(); !f.done; f = s.next()) {
          var u = f.value;
          a += u;
        }
      } catch (x) {
        i = { error: x };
      } finally {
        try {
          f && !f.done && (o = s.return) && o.call(s);
        } finally {
          if (i)
            throw i.error;
        }
      }
      for (var c = 0, l = 0, d = e.length, h = 0; h < d - 1; h++) {
        var p = void 0;
        for (p = 1, l |= 1 << h; p < e[h]; p++, l &= ~(1 << h)) {
          var v = r.combins(a - p - 1, d - h - 2);
          if (n && l === 0 && a - p - (d - h - 1) >= d - h - 1 && (v -= r.combins(a - p - (d - h), d - h - 2)), d - h - 1 > 1) {
            for (var y = 0, _ = a - p - (d - h - 2); _ > t; _--)
              y += r.combins(a - p - _ - 1, d - h - 3);
            v -= y * (d - 1 - h);
          } else
            a - p > t && v--;
          c += v;
        }
        a -= p;
      }
      return c;
    }, r.combins = function(e, t) {
      var n, i;
      e - t > t ? (i = t, n = e - t) : (i = e - t, n = t);
      for (var o = 1, a = 1, s = e; s > n; s--)
        o *= s, a <= i && (o /= a, a++);
      for (; a <= i; )
        o /= a, a++;
      return o;
    }, r;
  }()
), rs = (
  /** @class */
  function() {
    function r() {
    }
    return r.buildBitArray = function(e) {
      var t = e.length * 2 - 1;
      e[e.length - 1].getRightChar() == null && (t -= 1);
      for (var n = 12 * t, i = new Ee(n), o = 0, a = e[0], s = a.getRightChar().getValue(), f = 11; f >= 0; --f)
        s & 1 << f && i.set(o), o++;
      for (var f = 1; f < e.length; ++f) {
        for (var u = e[f], c = u.getLeftChar().getValue(), l = 11; l >= 0; --l)
          c & 1 << l && i.set(o), o++;
        if (u.getRightChar() !== null)
          for (var d = u.getRightChar().getValue(), l = 11; l >= 0; --l)
            d & 1 << l && i.set(o), o++;
      }
      return i;
    }, r;
  }()
), st = (
  /** @class */
  function() {
    function r(e, t) {
      t ? this.decodedInformation = null : (this.finished = e, this.decodedInformation = t);
    }
    return r.prototype.getDecodedInformation = function() {
      return this.decodedInformation;
    }, r.prototype.isFinished = function() {
      return this.finished;
    }, r;
  }()
), tn = (
  /** @class */
  function() {
    function r(e) {
      this.newPosition = e;
    }
    return r.prototype.getNewPosition = function() {
      return this.newPosition;
    }, r;
  }()
), ns = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), He = (
  /** @class */
  function(r) {
    ns(e, r);
    function e(t, n) {
      var i = r.call(this, t) || this;
      return i.value = n, i;
    }
    return e.prototype.getValue = function() {
      return this.value;
    }, e.prototype.isFNC1 = function() {
      return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
  }(tn)
), is = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ft = (
  /** @class */
  function(r) {
    is(e, r);
    function e(t, n, i) {
      var o = r.call(this, t) || this;
      return i ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = n, o;
    }
    return e.prototype.getNewString = function() {
      return this.newString;
    }, e.prototype.isRemaining = function() {
      return this.remaining;
    }, e.prototype.getRemainingValue = function() {
      return this.remainingValue;
    }, e;
  }(tn)
), os = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xt = (
  /** @class */
  function(r) {
    os(e, r);
    function e(t, n, i) {
      var o = r.call(this, t) || this;
      if (n < 0 || n > 10 || i < 0 || i > 10)
        throw new O();
      return o.firstDigit = n, o.secondDigit = i, o;
    }
    return e.prototype.getFirstDigit = function() {
      return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
      return this.secondDigit;
    }, e.prototype.getValue = function() {
      return this.firstDigit * 10 + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
      return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
      return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
      return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
  }(tn)
), Yt = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, as = (
  /** @class */
  function() {
    function r() {
    }
    return r.parseFieldsInGeneralPurpose = function(e) {
      var t, n, i, o, a, s, f, u;
      if (!e)
        return null;
      if (e.length < 2)
        throw new w();
      var c = e.substring(0, 2);
      try {
        for (var l = Yt(r.TWO_DIGIT_DATA_LENGTH), d = l.next(); !d.done; d = l.next()) {
          var h = d.value;
          if (h[0] === c)
            return h[1] === r.VARIABLE_LENGTH ? r.processVariableAI(2, h[2], e) : r.processFixedAI(2, h[1], e);
        }
      } catch (I) {
        t = { error: I };
      } finally {
        try {
          d && !d.done && (n = l.return) && n.call(l);
        } finally {
          if (t)
            throw t.error;
        }
      }
      if (e.length < 3)
        throw new w();
      var p = e.substring(0, 3);
      try {
        for (var v = Yt(r.THREE_DIGIT_DATA_LENGTH), y = v.next(); !y.done; y = v.next()) {
          var h = y.value;
          if (h[0] === p)
            return h[1] === r.VARIABLE_LENGTH ? r.processVariableAI(3, h[2], e) : r.processFixedAI(3, h[1], e);
        }
      } catch (I) {
        i = { error: I };
      } finally {
        try {
          y && !y.done && (o = v.return) && o.call(v);
        } finally {
          if (i)
            throw i.error;
        }
      }
      try {
        for (var _ = Yt(r.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), x = _.next(); !x.done; x = _.next()) {
          var h = x.value;
          if (h[0] === p)
            return h[1] === r.VARIABLE_LENGTH ? r.processVariableAI(4, h[2], e) : r.processFixedAI(4, h[1], e);
        }
      } catch (I) {
        a = { error: I };
      } finally {
        try {
          x && !x.done && (s = _.return) && s.call(_);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (e.length < 4)
        throw new w();
      var C = e.substring(0, 4);
      try {
        for (var E = Yt(r.FOUR_DIGIT_DATA_LENGTH), S = E.next(); !S.done; S = E.next()) {
          var h = S.value;
          if (h[0] === C)
            return h[1] === r.VARIABLE_LENGTH ? r.processVariableAI(4, h[2], e) : r.processFixedAI(4, h[1], e);
        }
      } catch (I) {
        f = { error: I };
      } finally {
        try {
          S && !S.done && (u = E.return) && u.call(E);
        } finally {
          if (f)
            throw f.error;
        }
      }
      throw new w();
    }, r.processFixedAI = function(e, t, n) {
      if (n.length < e)
        throw new w();
      var i = n.substring(0, e);
      if (n.length < e + t)
        throw new w();
      var o = n.substring(e, e + t), a = n.substring(e + t), s = "(" + i + ")" + o, f = r.parseFieldsInGeneralPurpose(a);
      return f == null ? s : s + f;
    }, r.processVariableAI = function(e, t, n) {
      var i = n.substring(0, e), o;
      n.length < e + t ? o = n.length : o = e + t;
      var a = n.substring(e, o), s = n.substring(o), f = "(" + i + ")" + a, u = r.parseFieldsInGeneralPurpose(s);
      return u == null ? f : f + u;
    }, r.VARIABLE_LENGTH = [], r.TWO_DIGIT_DATA_LENGTH = [
      ["00", 18],
      ["01", 14],
      ["02", 14],
      ["10", r.VARIABLE_LENGTH, 20],
      ["11", 6],
      ["12", 6],
      ["13", 6],
      ["15", 6],
      ["17", 6],
      ["20", 2],
      ["21", r.VARIABLE_LENGTH, 20],
      ["22", r.VARIABLE_LENGTH, 29],
      ["30", r.VARIABLE_LENGTH, 8],
      ["37", r.VARIABLE_LENGTH, 8],
      // internal company codes
      ["90", r.VARIABLE_LENGTH, 30],
      ["91", r.VARIABLE_LENGTH, 30],
      ["92", r.VARIABLE_LENGTH, 30],
      ["93", r.VARIABLE_LENGTH, 30],
      ["94", r.VARIABLE_LENGTH, 30],
      ["95", r.VARIABLE_LENGTH, 30],
      ["96", r.VARIABLE_LENGTH, 30],
      ["97", r.VARIABLE_LENGTH, 3],
      ["98", r.VARIABLE_LENGTH, 30],
      ["99", r.VARIABLE_LENGTH, 30]
    ], r.THREE_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["240", r.VARIABLE_LENGTH, 30],
      ["241", r.VARIABLE_LENGTH, 30],
      ["242", r.VARIABLE_LENGTH, 6],
      ["250", r.VARIABLE_LENGTH, 30],
      ["251", r.VARIABLE_LENGTH, 30],
      ["253", r.VARIABLE_LENGTH, 17],
      ["254", r.VARIABLE_LENGTH, 20],
      ["400", r.VARIABLE_LENGTH, 30],
      ["401", r.VARIABLE_LENGTH, 30],
      ["402", 17],
      ["403", r.VARIABLE_LENGTH, 30],
      ["410", 13],
      ["411", 13],
      ["412", 13],
      ["413", 13],
      ["414", 13],
      ["420", r.VARIABLE_LENGTH, 20],
      ["421", r.VARIABLE_LENGTH, 15],
      ["422", 3],
      ["423", r.VARIABLE_LENGTH, 15],
      ["424", 3],
      ["425", 3],
      ["426", 3]
    ], r.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["310", 6],
      ["311", 6],
      ["312", 6],
      ["313", 6],
      ["314", 6],
      ["315", 6],
      ["316", 6],
      ["320", 6],
      ["321", 6],
      ["322", 6],
      ["323", 6],
      ["324", 6],
      ["325", 6],
      ["326", 6],
      ["327", 6],
      ["328", 6],
      ["329", 6],
      ["330", 6],
      ["331", 6],
      ["332", 6],
      ["333", 6],
      ["334", 6],
      ["335", 6],
      ["336", 6],
      ["340", 6],
      ["341", 6],
      ["342", 6],
      ["343", 6],
      ["344", 6],
      ["345", 6],
      ["346", 6],
      ["347", 6],
      ["348", 6],
      ["349", 6],
      ["350", 6],
      ["351", 6],
      ["352", 6],
      ["353", 6],
      ["354", 6],
      ["355", 6],
      ["356", 6],
      ["357", 6],
      ["360", 6],
      ["361", 6],
      ["362", 6],
      ["363", 6],
      ["364", 6],
      ["365", 6],
      ["366", 6],
      ["367", 6],
      ["368", 6],
      ["369", 6],
      ["390", r.VARIABLE_LENGTH, 15],
      ["391", r.VARIABLE_LENGTH, 18],
      ["392", r.VARIABLE_LENGTH, 15],
      ["393", r.VARIABLE_LENGTH, 18],
      ["703", r.VARIABLE_LENGTH, 30]
    ], r.FOUR_DIGIT_DATA_LENGTH = [
      // Same format as above
      ["7001", 13],
      ["7002", r.VARIABLE_LENGTH, 30],
      ["7003", 10],
      ["8001", 14],
      ["8002", r.VARIABLE_LENGTH, 20],
      ["8003", r.VARIABLE_LENGTH, 30],
      ["8004", r.VARIABLE_LENGTH, 30],
      ["8005", 6],
      ["8006", 18],
      ["8007", r.VARIABLE_LENGTH, 30],
      ["8008", r.VARIABLE_LENGTH, 12],
      ["8018", 18],
      ["8020", r.VARIABLE_LENGTH, 25],
      ["8100", 6],
      ["8101", 10],
      ["8102", 2],
      ["8110", r.VARIABLE_LENGTH, 70],
      ["8200", r.VARIABLE_LENGTH, 70]
    ], r;
  }()
), Jt = (
  /** @class */
  function() {
    function r(e) {
      this.buffer = new V(), this.information = e;
    }
    return r.prototype.decodeAllCodes = function(e, t) {
      var n = t, i = null;
      do {
        var o = this.decodeGeneralPurposeField(n, i), a = as.parseFieldsInGeneralPurpose(o.getNewString());
        if (a != null && e.append(a), o.isRemaining() ? i = "" + o.getRemainingValue() : i = null, n === o.getNewPosition())
          break;
        n = o.getNewPosition();
      } while (!0);
      return e.toString();
    }, r.prototype.isStillNumeric = function(e) {
      if (e + 7 > this.information.getSize())
        return e + 4 <= this.information.getSize();
      for (var t = e; t < e + 3; ++t)
        if (this.information.get(t))
          return !0;
      return this.information.get(e + 3);
    }, r.prototype.decodeNumeric = function(e) {
      if (e + 7 > this.information.getSize()) {
        var t = this.extractNumericValueFromBitArray(e, 4);
        return t === 0 ? new xt(this.information.getSize(), xt.FNC1, xt.FNC1) : new xt(this.information.getSize(), t - 1, xt.FNC1);
      }
      var n = this.extractNumericValueFromBitArray(e, 7), i = (n - 8) / 11, o = (n - 8) % 11;
      return new xt(e + 7, i, o);
    }, r.prototype.extractNumericValueFromBitArray = function(e, t) {
      return r.extractNumericValueFromBitArray(this.information, e, t);
    }, r.extractNumericValueFromBitArray = function(e, t, n) {
      for (var i = 0, o = 0; o < n; ++o)
        e.get(t + o) && (i |= 1 << n - o - 1);
      return i;
    }, r.prototype.decodeGeneralPurposeField = function(e, t) {
      this.buffer.setLengthToZero(), t != null && this.buffer.append(t), this.current.setPosition(e);
      var n = this.parseBlocks();
      return n != null && n.isRemaining() ? new ft(this.current.getPosition(), this.buffer.toString(), n.getRemainingValue()) : new ft(this.current.getPosition(), this.buffer.toString());
    }, r.prototype.parseBlocks = function() {
      var e, t;
      do {
        var n = this.current.getPosition();
        this.current.isAlpha() ? (t = this.parseAlphaBlock(), e = t.isFinished()) : this.current.isIsoIec646() ? (t = this.parseIsoIec646Block(), e = t.isFinished()) : (t = this.parseNumericBlock(), e = t.isFinished());
        var i = n !== this.current.getPosition();
        if (!i && !e)
          break;
      } while (!e);
      return t.getDecodedInformation();
    }, r.prototype.parseNumericBlock = function() {
      for (; this.isStillNumeric(this.current.getPosition()); ) {
        var e = this.decodeNumeric(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFirstDigitFNC1()) {
          var t = void 0;
          return e.isSecondDigitFNC1() ? t = new ft(this.current.getPosition(), this.buffer.toString()) : t = new ft(this.current.getPosition(), this.buffer.toString(), e.getSecondDigit()), new st(!0, t);
        }
        if (this.buffer.append(e.getFirstDigit()), e.isSecondDigitFNC1()) {
          var t = new ft(this.current.getPosition(), this.buffer.toString());
          return new st(!0, t);
        }
        this.buffer.append(e.getSecondDigit());
      }
      return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new st(!1);
    }, r.prototype.parseIsoIec646Block = function() {
      for (; this.isStillIsoIec646(this.current.getPosition()); ) {
        var e = this.decodeIsoIec646(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFNC1()) {
          var t = new ft(this.current.getPosition(), this.buffer.toString());
          return new st(!0, t);
        }
        this.buffer.append(e.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new st(!1);
    }, r.prototype.parseAlphaBlock = function() {
      for (; this.isStillAlpha(this.current.getPosition()); ) {
        var e = this.decodeAlphanumeric(this.current.getPosition());
        if (this.current.setPosition(e.getNewPosition()), e.isFNC1()) {
          var t = new ft(this.current.getPosition(), this.buffer.toString());
          return new st(!0, t);
        }
        this.buffer.append(e.getValue());
      }
      return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new st(!1);
    }, r.prototype.isStillIsoIec646 = function(e) {
      if (e + 5 > this.information.getSize())
        return !1;
      var t = this.extractNumericValueFromBitArray(e, 5);
      if (t >= 5 && t < 16)
        return !0;
      if (e + 7 > this.information.getSize())
        return !1;
      var n = this.extractNumericValueFromBitArray(e, 7);
      if (n >= 64 && n < 116)
        return !0;
      if (e + 8 > this.information.getSize())
        return !1;
      var i = this.extractNumericValueFromBitArray(e, 8);
      return i >= 232 && i < 253;
    }, r.prototype.decodeIsoIec646 = function(e) {
      var t = this.extractNumericValueFromBitArray(e, 5);
      if (t === 15)
        return new He(e + 5, He.FNC1);
      if (t >= 5 && t < 15)
        return new He(e + 5, "0" + (t - 5));
      var n = this.extractNumericValueFromBitArray(e, 7);
      if (n >= 64 && n < 90)
        return new He(e + 7, "" + (n + 1));
      if (n >= 90 && n < 116)
        return new He(e + 7, "" + (n + 7));
      var i = this.extractNumericValueFromBitArray(e, 8), o;
      switch (i) {
        case 232:
          o = "!";
          break;
        case 233:
          o = '"';
          break;
        case 234:
          o = "%";
          break;
        case 235:
          o = "&";
          break;
        case 236:
          o = "'";
          break;
        case 237:
          o = "(";
          break;
        case 238:
          o = ")";
          break;
        case 239:
          o = "*";
          break;
        case 240:
          o = "+";
          break;
        case 241:
          o = ",";
          break;
        case 242:
          o = "-";
          break;
        case 243:
          o = ".";
          break;
        case 244:
          o = "/";
          break;
        case 245:
          o = ":";
          break;
        case 246:
          o = ";";
          break;
        case 247:
          o = "<";
          break;
        case 248:
          o = "=";
          break;
        case 249:
          o = ">";
          break;
        case 250:
          o = "?";
          break;
        case 251:
          o = "_";
          break;
        case 252:
          o = " ";
          break;
        default:
          throw new O();
      }
      return new He(e + 8, o);
    }, r.prototype.isStillAlpha = function(e) {
      if (e + 5 > this.information.getSize())
        return !1;
      var t = this.extractNumericValueFromBitArray(e, 5);
      if (t >= 5 && t < 16)
        return !0;
      if (e + 6 > this.information.getSize())
        return !1;
      var n = this.extractNumericValueFromBitArray(e, 6);
      return n >= 16 && n < 63;
    }, r.prototype.decodeAlphanumeric = function(e) {
      var t = this.extractNumericValueFromBitArray(e, 5);
      if (t === 15)
        return new He(e + 5, He.FNC1);
      if (t >= 5 && t < 15)
        return new He(e + 5, "0" + (t - 5));
      var n = this.extractNumericValueFromBitArray(e, 6);
      if (n >= 32 && n < 58)
        return new He(e + 6, "" + (n + 33));
      var i;
      switch (n) {
        case 58:
          i = "*";
          break;
        case 59:
          i = ",";
          break;
        case 60:
          i = "-";
          break;
        case 61:
          i = ".";
          break;
        case 62:
          i = "/";
          break;
        default:
          throw new Vt("Decoding invalid alphanumeric value: " + n);
      }
      return new He(e + 6, i);
    }, r.prototype.isAlphaTo646ToAlphaLatch = function(e) {
      if (e + 1 > this.information.getSize())
        return !1;
      for (var t = 0; t < 5 && t + e < this.information.getSize(); ++t)
        if (t === 2) {
          if (!this.information.get(e + 2))
            return !1;
        } else if (this.information.get(e + t))
          return !1;
      return !0;
    }, r.prototype.isAlphaOr646ToNumericLatch = function(e) {
      if (e + 3 > this.information.getSize())
        return !1;
      for (var t = e; t < e + 3; ++t)
        if (this.information.get(t))
          return !1;
      return !0;
    }, r.prototype.isNumericToAlphaNumericLatch = function(e) {
      if (e + 1 > this.information.getSize())
        return !1;
      for (var t = 0; t < 4 && t + e < this.information.getSize(); ++t)
        if (this.information.get(e + t))
          return !1;
      return !0;
    }, r;
  }()
), Ci = (
  /** @class */
  function() {
    function r(e) {
      this.information = e, this.generalDecoder = new Jt(e);
    }
    return r.prototype.getInformation = function() {
      return this.information;
    }, r.prototype.getGeneralDecoder = function() {
      return this.generalDecoder;
    }, r;
  }()
), ss = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), je = (
  /** @class */
  function(r) {
    ss(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.encodeCompressedGtin = function(t, n) {
      t.append("(01)");
      var i = t.length();
      t.append("9"), this.encodeCompressedGtinWithoutAI(t, n, i);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, n, i) {
      for (var o = 0; o < 4; ++o) {
        var a = this.getGeneralDecoder().extractNumericValueFromBitArray(n + 10 * o, 10);
        a / 100 === 0 && t.append("0"), a / 10 === 0 && t.append("0"), t.append(a);
      }
      e.appendCheckDigit(t, i);
    }, e.appendCheckDigit = function(t, n) {
      for (var i = 0, o = 0; o < 13; o++) {
        var a = t.charAt(o + n).charCodeAt(0) - 48;
        i += o & 1 ? a : 3 * a;
      }
      i = 10 - i % 10, i === 10 && (i = 0), t.append(i);
    }, e.GTIN_SIZE = 40, e;
  }(Ci)
), fs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), us = (
  /** @class */
  function(r) {
    fs(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.parseInformation = function() {
      var t = new V();
      t.append("(01)");
      var n = t.length(), i = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
      return t.append(i), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, n), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
  }(je)
), cs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ls = (
  /** @class */
  function(r) {
    cs(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.parseInformation = function() {
      var t = new V();
      return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
  }(Ci)
), ds = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), er = (
  /** @class */
  function(r) {
    ds(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.encodeCompressedWeight = function(t, n, i) {
      var o = this.getGeneralDecoder().extractNumericValueFromBitArray(n, i);
      this.addWeightCode(t, o);
      for (var a = this.checkWeight(o), s = 1e5, f = 0; f < 5; ++f)
        a / s === 0 && t.append("0"), s /= 10;
      t.append(a);
    }, e;
  }(je)
), hs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ai = (
  /** @class */
  function(r) {
    hs(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() !== e.HEADER_SIZE + er.GTIN_SIZE + e.WEIGHT_SIZE)
        throw new w();
      var t = new V();
      return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + er.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
  }(er)
), ps = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), vs = (
  /** @class */
  function(r) {
    ps(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.addWeightCode = function(t, n) {
      t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
      return t;
    }, e;
  }(Ai)
), gs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xs = (
  /** @class */
  function(r) {
    gs(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.addWeightCode = function(t, n) {
      n < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
      return t < 1e4 ? t : t - 1e4;
    }, e;
  }(Ai)
), ys = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ms = (
  /** @class */
  function(r) {
    ys(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < e.HEADER_SIZE + je.GTIN_SIZE)
        throw new w();
      var t = new V();
      this.encodeCompressedGtin(t, e.HEADER_SIZE);
      var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + je.GTIN_SIZE, e.LAST_DIGIT_SIZE);
      t.append("(392"), t.append(n), t.append(")");
      var i = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + je.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
      return t.append(i.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
  }(je)
), _s = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Cs = (
  /** @class */
  function(r) {
    _s(e, r);
    function e(t) {
      return r.call(this, t) || this;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() < e.HEADER_SIZE + je.GTIN_SIZE)
        throw new w();
      var t = new V();
      this.encodeCompressedGtin(t, e.HEADER_SIZE);
      var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + je.GTIN_SIZE, e.LAST_DIGIT_SIZE);
      t.append("(393"), t.append(n), t.append(")");
      var i = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + je.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
      i / 100 === 0 && t.append("0"), i / 10 === 0 && t.append("0"), t.append(i);
      var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + je.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
      return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
  }(je)
), As = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Je = (
  /** @class */
  function(r) {
    As(e, r);
    function e(t, n, i) {
      var o = r.call(this, t) || this;
      return o.dateCode = i, o.firstAIdigits = n, o;
    }
    return e.prototype.parseInformation = function() {
      if (this.getInformation().getSize() !== e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE)
        throw new w();
      var t = new V();
      return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, n) {
      var i = this.getGeneralDecoder().extractNumericValueFromBitArray(n, e.DATE_SIZE);
      if (i !== 38400) {
        t.append("("), t.append(this.dateCode), t.append(")");
        var o = i % 32;
        i /= 32;
        var a = i % 12 + 1;
        i /= 12;
        var s = i;
        s / 10 === 0 && t.append("0"), t.append(s), a / 10 === 0 && t.append("0"), t.append(a), o / 10 === 0 && t.append("0"), t.append(o);
      }
    }, e.prototype.addWeightCode = function(t, n) {
      t.append("("), t.append(this.firstAIdigits), t.append(n / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
      return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
  }(er)
);
function Es(r) {
  try {
    if (r.get(1))
      return new us(r);
    if (!r.get(2))
      return new ls(r);
    var e = Jt.extractNumericValueFromBitArray(r, 1, 4);
    switch (e) {
      case 4:
        return new vs(r);
      case 5:
        return new xs(r);
    }
    var t = Jt.extractNumericValueFromBitArray(r, 1, 5);
    switch (t) {
      case 12:
        return new ms(r);
      case 13:
        return new Cs(r);
    }
    var n = Jt.extractNumericValueFromBitArray(r, 1, 7);
    switch (n) {
      case 56:
        return new Je(r, "310", "11");
      case 57:
        return new Je(r, "320", "11");
      case 58:
        return new Je(r, "310", "13");
      case 59:
        return new Je(r, "320", "13");
      case 60:
        return new Je(r, "310", "15");
      case 61:
        return new Je(r, "320", "15");
      case 62:
        return new Je(r, "310", "17");
      case 63:
        return new Je(r, "320", "17");
    }
  } catch (i) {
    throw console.log(i), new Vt("unknown decoder: " + r);
  }
}
var Un = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.leftchar = e, this.rightchar = t, this.finderpattern = n, this.maybeLast = i;
    }
    return r.prototype.mayBeLast = function() {
      return this.maybeLast;
    }, r.prototype.getLeftChar = function() {
      return this.leftchar;
    }, r.prototype.getRightChar = function() {
      return this.rightchar;
    }, r.prototype.getFinderPattern = function() {
      return this.finderpattern;
    }, r.prototype.mustBeLast = function() {
      return this.rightchar == null;
    }, r.prototype.toString = function() {
      return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
    }, r.equals = function(e, t) {
      return e instanceof r ? r.equalsOrNull(e.leftchar, t.leftchar) && r.equalsOrNull(e.rightchar, t.rightchar) && r.equalsOrNull(e.finderpattern, t.finderpattern) : !1;
    }, r.equalsOrNull = function(e, t) {
      return e === null ? t === null : r.equals(e, t);
    }, r.prototype.hashCode = function() {
      var e = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
      return e;
    }, r;
  }()
), ws = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.pairs = e, this.rowNumber = t, this.wasReversed = n;
    }
    return r.prototype.getPairs = function() {
      return this.pairs;
    }, r.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, r.prototype.isReversed = function() {
      return this.wasReversed;
    }, r.prototype.isEquivalent = function(e) {
      return this.checkEqualitity(this, e);
    }, r.prototype.toString = function() {
      return "{ " + this.pairs + " }";
    }, r.prototype.equals = function(e, t) {
      return e instanceof r ? this.checkEqualitity(e, t) && e.wasReversed === t.wasReversed : !1;
    }, r.prototype.checkEqualitity = function(e, t) {
      if (!(!e || !t)) {
        var n;
        return e.forEach(function(i, o) {
          t.forEach(function(a) {
            i.getLeftChar().getValue() === a.getLeftChar().getValue() && i.getRightChar().getValue() === a.getRightChar().getValue() && i.getFinderPatter().getValue() === a.getFinderPatter().getValue() && (n = !0);
          });
        }), n;
      }
    }, r;
  }()
), Ss = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), et = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Is = (
  /** @class */
  function(r) {
    Ss(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.pairs = new Array(e.MAX_PAIRS), t.rows = new Array(), t.startEnd = [2], t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      this.pairs.length = 0, this.startFromEven = !1;
      try {
        return e.constructResult(this.decodeRow2pairs(t, n));
      } catch {
      }
      return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, n));
    }, e.prototype.reset = function() {
      this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, n) {
      for (var i = !1; !i; )
        try {
          this.pairs.push(this.retrieveNextPair(n, this.pairs, t));
        } catch (s) {
          if (s instanceof w) {
            if (!this.pairs.length)
              throw new w();
            i = !0;
          }
        }
      if (this.checkChecksum())
        return this.pairs;
      var o;
      if (this.rows.length ? o = !0 : o = !1, this.storeRow(t, !1), o) {
        var a = this.checkRowsBoolean(!1);
        if (a != null || (a = this.checkRowsBoolean(!0), a != null))
          return a;
      }
      throw new w();
    }, e.prototype.checkRowsBoolean = function(t) {
      if (this.rows.length > 25)
        return this.rows.length = 0, null;
      this.pairs.length = 0, t && (this.rows = this.rows.reverse());
      var n = null;
      try {
        n = this.checkRows(new Array(), 0);
      } catch (i) {
        console.log(i);
      }
      return t && (this.rows = this.rows.reverse()), n;
    }, e.prototype.checkRows = function(t, n) {
      for (var i, o, a = n; a < this.rows.length; a++) {
        var s = this.rows[a];
        this.pairs.length = 0;
        try {
          for (var f = (i = void 0, et(t)), u = f.next(); !u.done; u = f.next()) {
            var c = u.value;
            this.pairs.push(c.getPairs());
          }
        } catch (d) {
          i = { error: d };
        } finally {
          try {
            u && !u.done && (o = f.return) && o.call(f);
          } finally {
            if (i)
              throw i.error;
          }
        }
        if (this.pairs.push(s.getPairs()), !!e.isValidSequence(this.pairs)) {
          if (this.checkChecksum())
            return this.pairs;
          var l = new Array(t);
          l.push(s);
          try {
            return this.checkRows(l, a + 1);
          } catch (d) {
            console.log(d);
          }
        }
      }
      throw new w();
    }, e.isValidSequence = function(t) {
      var n, i;
      try {
        for (var o = et(e.FINDER_PATTERN_SEQUENCES), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          if (!(t.length > s.length)) {
            for (var f = !0, u = 0; u < t.length; u++)
              if (t[u].getFinderPattern().getValue() !== s[u]) {
                f = !1;
                break;
              }
            if (f)
              return !0;
          }
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return !1;
    }, e.prototype.storeRow = function(t, n) {
      for (var i = 0, o = !1, a = !1; i < this.rows.length; ) {
        var s = this.rows[i];
        if (s.getRowNumber() > t) {
          a = s.isEquivalent(this.pairs);
          break;
        }
        o = s.isEquivalent(this.pairs), i++;
      }
      a || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(i, new ws(this.pairs, t, n)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, n) {
      var i, o, a, s, f, u;
      try {
        for (var c = et(n), l = c.next(); !l.done; l = c.next()) {
          var d = l.value;
          if (d.getPairs().length !== t.length) {
            var h = !0;
            try {
              for (var p = (a = void 0, et(d.getPairs())), v = p.next(); !v.done; v = p.next()) {
                var y = v.value, _ = !1;
                try {
                  for (var x = (f = void 0, et(t)), C = x.next(); !C.done; C = x.next()) {
                    var E = C.value;
                    if (Un.equals(y, E)) {
                      _ = !0;
                      break;
                    }
                  }
                } catch (S) {
                  f = { error: S };
                } finally {
                  try {
                    C && !C.done && (u = x.return) && u.call(x);
                  } finally {
                    if (f)
                      throw f.error;
                  }
                }
                _ || (h = !1);
              }
            } catch (S) {
              a = { error: S };
            } finally {
              try {
                v && !v.done && (s = p.return) && s.call(p);
              } finally {
                if (a)
                  throw a.error;
              }
            }
          }
        }
      } catch (S) {
        i = { error: S };
      } finally {
        try {
          l && !l.done && (o = c.return) && o.call(c);
        } finally {
          if (i)
            throw i.error;
        }
      }
    }, e.isPartialRow = function(t, n) {
      var i, o, a, s, f, u;
      try {
        for (var c = et(n), l = c.next(); !l.done; l = c.next()) {
          var d = l.value, h = !0;
          try {
            for (var p = (a = void 0, et(t)), v = p.next(); !v.done; v = p.next()) {
              var y = v.value, _ = !1;
              try {
                for (var x = (f = void 0, et(d.getPairs())), C = x.next(); !C.done; C = x.next()) {
                  var E = C.value;
                  if (y.equals(E)) {
                    _ = !0;
                    break;
                  }
                }
              } catch (S) {
                f = { error: S };
              } finally {
                try {
                  C && !C.done && (u = x.return) && u.call(x);
                } finally {
                  if (f)
                    throw f.error;
                }
              }
              if (!_) {
                h = !1;
                break;
              }
            }
          } catch (S) {
            a = { error: S };
          } finally {
            try {
              v && !v.done && (s = p.return) && s.call(p);
            } finally {
              if (a)
                throw a.error;
            }
          }
          if (h)
            return !0;
        }
      } catch (S) {
        i = { error: S };
      } finally {
        try {
          l && !l.done && (o = c.return) && o.call(c);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return !1;
    }, e.prototype.getRows = function() {
      return this.rows;
    }, e.constructResult = function(t) {
      var n = rs.buildBitArray(t), i = Es(n), o = i.parseInformation(), a = t[0].getFinderPattern().getResultPoints(), s = t[t.length - 1].getFinderPattern().getResultPoints(), f = [a[0], a[1], s[0], s[1]];
      return new Oe(o, null, null, f, L.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
      var t = this.pairs.get(0), n = t.getLeftChar(), i = t.getRightChar();
      if (i === null)
        return !1;
      for (var o = i.getChecksumPortion(), a = 2, s = 1; s < this.pairs.size(); ++s) {
        var f = this.pairs.get(s);
        o += f.getLeftChar().getChecksumPortion(), a++;
        var u = f.getRightChar();
        u != null && (o += u.getChecksumPortion(), a++);
      }
      o %= 211;
      var c = 211 * (a - 4) + o;
      return c === n.getValue();
    }, e.getNextSecondBar = function(t, n) {
      var i;
      return t.get(n) ? (i = t.getNextUnset(n), i = t.getNextSet(i)) : (i = t.getNextSet(n), i = t.getNextUnset(i)), i;
    }, e.prototype.retrieveNextPair = function(t, n, i) {
      var o = n.length % 2 === 0;
      this.startFromEven && (o = !o);
      var a, s = !0, f = -1;
      do
        this.findNextPair(t, n, f), a = this.parseFoundFinderPattern(t, i, o), a === null ? f = e.getNextSecondBar(t, this.startEnd[0]) : s = !1;
      while (s);
      var u = this.decodeDataCharacter(t, a, o, !0);
      if (!this.isEmptyPair(n) && n[n.length - 1].mustBeLast())
        throw new w();
      var c;
      try {
        c = this.decodeDataCharacter(t, a, o, !1);
      } catch (l) {
        c = null, console.log(l);
      }
      return new Un(u, c, a, !0);
    }, e.prototype.isEmptyPair = function(t) {
      return t.length === 0;
    }, e.prototype.findNextPair = function(t, n, i) {
      var o = this.getDecodeFinderCounters();
      o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
      var a = t.getSize(), s;
      if (i >= 0)
        s = i;
      else if (this.isEmptyPair(n))
        s = 0;
      else {
        var f = n[n.length - 1];
        s = f.getFinderPattern().getStartEnd()[1];
      }
      var u = n.length % 2 !== 0;
      this.startFromEven && (u = !u);
      for (var c = !1; s < a && (c = !t.get(s), !!c); )
        s++;
      for (var l = 0, d = s, h = s; h < a; h++)
        if (t.get(h) !== c)
          o[l]++;
        else {
          if (l === 3) {
            if (u && e.reverseCounters(o), e.isFinderPattern(o)) {
              this.startEnd[0] = d, this.startEnd[1] = h;
              return;
            }
            u && e.reverseCounters(o), d += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, l--;
          } else
            l++;
          o[l] = 1, c = !c;
        }
      throw new w();
    }, e.reverseCounters = function(t) {
      for (var n = t.length, i = 0; i < n / 2; ++i) {
        var o = t[i];
        t[i] = t[n - i - 1], t[n - i - 1] = o;
      }
    }, e.prototype.parseFoundFinderPattern = function(t, n, i) {
      var o, a, s;
      if (i) {
        for (var f = this.startEnd[0] - 1; f >= 0 && !t.get(f); )
          f--;
        f++, o = this.startEnd[0] - f, a = f, s = this.startEnd[1];
      } else
        a = this.startEnd[0], s = t.getNextUnset(this.startEnd[1] + 1), o = s - this.startEnd[1];
      var u = this.getDecodeFinderCounters();
      ne.arraycopy(u, 0, u, 1, u.length - 1), u[0] = o;
      var c;
      try {
        c = this.parseFinderValue(u, e.FINDER_PATTERNS);
      } catch {
        return null;
      }
      return new _i(c, [a, s], a, s, n);
    }, e.prototype.decodeDataCharacter = function(t, n, i, o) {
      for (var a = this.getDataCharacterCounters(), s = 0; s < a.length; s++)
        a[s] = 0;
      if (o)
        e.recordPatternInReverse(t, n.getStartEnd()[0], a);
      else {
        e.recordPattern(t, n.getStartEnd()[1], a);
        for (var f = 0, u = a.length - 1; f < u; f++, u--) {
          var c = a[f];
          a[f] = a[u], a[u] = c;
        }
      }
      var l = 17, d = Y.sum(new Int32Array(a)) / l, h = (n.getStartEnd()[1] - n.getStartEnd()[0]) / 15;
      if (Math.abs(d - h) / h > 0.3)
        throw new w();
      for (var p = this.getOddCounts(), v = this.getEvenCounts(), y = this.getOddRoundingErrors(), _ = this.getEvenRoundingErrors(), f = 0; f < a.length; f++) {
        var x = 1 * a[f] / d, C = x + 0.5;
        if (C < 1) {
          if (x < 0.3)
            throw new w();
          C = 1;
        } else if (C > 8) {
          if (x > 8.7)
            throw new w();
          C = 8;
        }
        var E = f / 2;
        f & 1 ? (v[E] = C, _[E] = x - C) : (p[E] = C, y[E] = x - C);
      }
      this.adjustOddEvenCounts(l);
      for (var S = 4 * n.getValue() + (i ? 0 : 2) + (o ? 0 : 1) - 1, I = 0, T = 0, f = p.length - 1; f >= 0; f--) {
        if (e.isNotA1left(n, i, o)) {
          var R = e.WEIGHTS[S][2 * f];
          T += p[f] * R;
        }
        I += p[f];
      }
      for (var B = 0, f = v.length - 1; f >= 0; f--)
        if (e.isNotA1left(n, i, o)) {
          var R = e.WEIGHTS[S][2 * f + 1];
          B += v[f] * R;
        }
      var M = T + B;
      if (I & 1 || I > 13 || I < 4)
        throw new w();
      var te = (13 - I) / 2, N = e.SYMBOL_WIDEST[te], H = 9 - N, ie = yt.getRSSvalue(p, N, !0), we = yt.getRSSvalue(v, H, !1), Ge = e.EVEN_TOTAL_SUBSET[te], $e = e.GSUM[te], Xe = ie * Ge + we + $e;
      return new fr(Xe, M);
    }, e.isNotA1left = function(t, n, i) {
      return !(t.getValue() === 0 && n && i);
    }, e.prototype.adjustOddEvenCounts = function(t) {
      var n = Y.sum(new Int32Array(this.getOddCounts())), i = Y.sum(new Int32Array(this.getEvenCounts())), o = !1, a = !1;
      n > 13 ? a = !0 : n < 4 && (o = !0);
      var s = !1, f = !1;
      i > 13 ? f = !0 : i < 4 && (s = !0);
      var u = n + i - t, c = (n & 1) === 1, l = (i & 1) === 0;
      if (u === 1)
        if (c) {
          if (l)
            throw new w();
          a = !0;
        } else {
          if (!l)
            throw new w();
          f = !0;
        }
      else if (u === -1)
        if (c) {
          if (l)
            throw new w();
          o = !0;
        } else {
          if (!l)
            throw new w();
          s = !0;
        }
      else if (u === 0) {
        if (c) {
          if (!l)
            throw new w();
          n < i ? (o = !0, f = !0) : (a = !0, s = !0);
        } else if (l)
          throw new w();
      } else
        throw new w();
      if (o) {
        if (a)
          throw new w();
        e.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (a && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), s) {
        if (f)
          throw new w();
        e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      f && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [7, 5, 4, 3, 1], e.EVEN_TOTAL_SUBSET = [4, 20, 52, 104, 204], e.GSUM = [0, 348, 1388, 2948, 3988], e.FINDER_PATTERNS = [
      Int32Array.from([1, 8, 4, 1]),
      Int32Array.from([3, 6, 4, 1]),
      Int32Array.from([3, 4, 6, 1]),
      Int32Array.from([3, 2, 8, 1]),
      Int32Array.from([2, 6, 5, 1]),
      Int32Array.from([2, 2, 9, 1])
    ], e.WEIGHTS = [
      [1, 3, 9, 27, 81, 32, 96, 77],
      [20, 60, 180, 118, 143, 7, 21, 63],
      [189, 145, 13, 39, 117, 140, 209, 205],
      [193, 157, 49, 147, 19, 57, 171, 91],
      [62, 186, 136, 197, 169, 85, 44, 132],
      [185, 133, 188, 142, 4, 12, 36, 108],
      [113, 128, 173, 97, 80, 29, 87, 50],
      [150, 28, 84, 41, 123, 158, 52, 156],
      [46, 138, 203, 187, 139, 206, 196, 166],
      [76, 17, 51, 153, 37, 111, 122, 155],
      [43, 129, 176, 106, 107, 110, 119, 146],
      [16, 48, 144, 10, 30, 90, 59, 177],
      [109, 116, 137, 200, 178, 112, 125, 164],
      [70, 210, 208, 202, 184, 130, 179, 115],
      [134, 191, 151, 31, 93, 68, 204, 190],
      [148, 22, 66, 198, 172, 94, 71, 2],
      [6, 18, 54, 162, 64, 192, 154, 40],
      [120, 149, 25, 75, 14, 42, 126, 167],
      [79, 26, 78, 23, 69, 207, 199, 175],
      [103, 98, 83, 38, 114, 131, 182, 124],
      [161, 61, 183, 127, 170, 88, 53, 159],
      [55, 165, 73, 8, 24, 72, 5, 15],
      [45, 135, 194, 160, 58, 174, 100, 89]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
      [e.FINDER_PAT_A, e.FINDER_PAT_A],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_C,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_C
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_E,
        e.FINDER_PAT_B,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_E
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ],
      [
        e.FINDER_PAT_A,
        e.FINDER_PAT_A,
        e.FINDER_PAT_B,
        e.FINDER_PAT_B,
        e.FINDER_PAT_C,
        e.FINDER_PAT_D,
        e.FINDER_PAT_D,
        e.FINDER_PAT_E,
        e.FINDER_PAT_E,
        e.FINDER_PAT_F,
        e.FINDER_PAT_F
      ]
    ], e.MAX_PAIRS = 11, e;
  }(ut)
), bs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ts = (
  /** @class */
  function(r) {
    bs(e, r);
    function e(t, n, i) {
      var o = r.call(this, t, n) || this;
      return o.count = 0, o.finderPattern = i, o;
    }
    return e.prototype.getFinderPattern = function() {
      return this.finderPattern;
    }, e.prototype.getCount = function() {
      return this.count;
    }, e.prototype.incrementCount = function() {
      this.count++;
    }, e;
  }(fr)
), Os = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), br = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vn = (
  /** @class */
  function(r) {
    Os(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.possibleLeftPairs = [], t.possibleRightPairs = [], t;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      var o, a, s, f, u = this.decodePair(n, !1, t, i);
      e.addOrTally(this.possibleLeftPairs, u), n.reverse();
      var c = this.decodePair(n, !0, t, i);
      e.addOrTally(this.possibleRightPairs, c), n.reverse();
      try {
        for (var l = br(this.possibleLeftPairs), d = l.next(); !d.done; d = l.next()) {
          var h = d.value;
          if (h.getCount() > 1)
            try {
              for (var p = (s = void 0, br(this.possibleRightPairs)), v = p.next(); !v.done; v = p.next()) {
                var y = v.value;
                if (y.getCount() > 1 && e.checkChecksum(h, y))
                  return e.constructResult(h, y);
              }
            } catch (_) {
              s = { error: _ };
            } finally {
              try {
                v && !v.done && (f = p.return) && f.call(p);
              } finally {
                if (s)
                  throw s.error;
              }
            }
        }
      } catch (_) {
        o = { error: _ };
      } finally {
        try {
          d && !d.done && (a = l.return) && a.call(l);
        } finally {
          if (o)
            throw o.error;
        }
      }
      throw new w();
    }, e.addOrTally = function(t, n) {
      var i, o;
      if (n != null) {
        var a = !1;
        try {
          for (var s = br(t), f = s.next(); !f.done; f = s.next()) {
            var u = f.value;
            if (u.getValue() === n.getValue()) {
              u.incrementCount(), a = !0;
              break;
            }
          }
        } catch (c) {
          i = { error: c };
        } finally {
          try {
            f && !f.done && (o = s.return) && o.call(s);
          } finally {
            if (i)
              throw i.error;
          }
        }
        a || t.push(n);
      }
    }, e.prototype.reset = function() {
      this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, n) {
      for (var i = 4537077 * t.getValue() + n.getValue(), o = new String(i).toString(), a = new V(), s = 13 - o.length; s > 0; s--)
        a.append("0");
      a.append(o);
      for (var f = 0, s = 0; s < 13; s++) {
        var u = a.charAt(s).charCodeAt(0) - 48;
        f += s & 1 ? u : 3 * u;
      }
      f = 10 - f % 10, f === 10 && (f = 0), a.append(f.toString());
      var c = t.getFinderPattern().getResultPoints(), l = n.getFinderPattern().getResultPoints();
      return new Oe(a.toString(), null, 0, [c[0], c[1], l[0], l[1]], L.RSS_14, (/* @__PURE__ */ new Date()).getTime());
    }, e.checkChecksum = function(t, n) {
      var i = (t.getChecksumPortion() + 16 * n.getChecksumPortion()) % 79, o = 9 * t.getFinderPattern().getValue() + n.getFinderPattern().getValue();
      return o > 72 && o--, o > 8 && o--, i === o;
    }, e.prototype.decodePair = function(t, n, i, o) {
      try {
        var a = this.findFinderPattern(t, n), s = this.parseFoundFinderPattern(t, i, n, a), f = o == null ? null : o.get(fe.NEED_RESULT_POINT_CALLBACK);
        if (f != null) {
          var u = (a[0] + a[1]) / 2;
          n && (u = t.getSize() - 1 - u), f.foundPossibleResultPoint(new P(u, i));
        }
        var c = this.decodeDataCharacter(t, s, !0), l = this.decodeDataCharacter(t, s, !1);
        return new Ts(1597 * c.getValue() + l.getValue(), c.getChecksumPortion() + 4 * l.getChecksumPortion(), s);
      } catch {
        return null;
      }
    }, e.prototype.decodeDataCharacter = function(t, n, i) {
      for (var o = this.getDataCharacterCounters(), a = 0; a < o.length; a++)
        o[a] = 0;
      if (i)
        _e.recordPatternInReverse(t, n.getStartEnd()[0], o);
      else {
        _e.recordPattern(t, n.getStartEnd()[1] + 1, o);
        for (var s = 0, f = o.length - 1; s < f; s++, f--) {
          var u = o[s];
          o[s] = o[f], o[f] = u;
        }
      }
      for (var c = i ? 16 : 15, l = Y.sum(new Int32Array(o)) / c, d = this.getOddCounts(), h = this.getEvenCounts(), p = this.getOddRoundingErrors(), v = this.getEvenRoundingErrors(), s = 0; s < o.length; s++) {
        var y = o[s] / l, _ = Math.floor(y + 0.5);
        _ < 1 ? _ = 1 : _ > 8 && (_ = 8);
        var x = Math.floor(s / 2);
        s & 1 ? (h[x] = _, v[x] = y - _) : (d[x] = _, p[x] = y - _);
      }
      this.adjustOddEvenCounts(i, c);
      for (var C = 0, E = 0, s = d.length - 1; s >= 0; s--)
        E *= 9, E += d[s], C += d[s];
      for (var S = 0, I = 0, s = h.length - 1; s >= 0; s--)
        S *= 9, S += h[s], I += h[s];
      var T = E + 3 * S;
      if (i) {
        if (C & 1 || C > 12 || C < 4)
          throw new w();
        var R = (12 - C) / 2, B = e.OUTSIDE_ODD_WIDEST[R], M = 9 - B, te = yt.getRSSvalue(d, B, !1), N = yt.getRSSvalue(h, M, !0), H = e.OUTSIDE_EVEN_TOTAL_SUBSET[R], ie = e.OUTSIDE_GSUM[R];
        return new fr(te * H + N + ie, T);
      } else {
        if (I & 1 || I > 10 || I < 4)
          throw new w();
        var R = (10 - I) / 2, B = e.INSIDE_ODD_WIDEST[R], M = 9 - B, te = yt.getRSSvalue(d, B, !0), N = yt.getRSSvalue(h, M, !1), we = e.INSIDE_ODD_TOTAL_SUBSET[R], ie = e.INSIDE_GSUM[R];
        return new fr(N * we + te + ie, T);
      }
    }, e.prototype.findFinderPattern = function(t, n) {
      var i = this.getDecodeFinderCounters();
      i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
      for (var o = t.getSize(), a = !1, s = 0; s < o && (a = !t.get(s), n !== a); )
        s++;
      for (var f = 0, u = s, c = s; c < o; c++)
        if (t.get(c) !== a)
          i[f]++;
        else {
          if (f === 3) {
            if (ut.isFinderPattern(i))
              return [u, c];
            u += i[0] + i[1], i[0] = i[2], i[1] = i[3], i[2] = 0, i[3] = 0, f--;
          } else
            f++;
          i[f] = 1, a = !a;
        }
      throw new w();
    }, e.prototype.parseFoundFinderPattern = function(t, n, i, o) {
      for (var a = t.get(o[0]), s = o[0] - 1; s >= 0 && a !== t.get(s); )
        s--;
      s++;
      var f = o[0] - s, u = this.getDecodeFinderCounters(), c = new Int32Array(u.length);
      ne.arraycopy(u, 0, c, 1, u.length - 1), c[0] = f;
      var l = this.parseFinderValue(c, e.FINDER_PATTERNS), d = s, h = o[1];
      return i && (d = t.getSize() - 1 - d, h = t.getSize() - 1 - h), new _i(l, [s, o[1]], d, h, n);
    }, e.prototype.adjustOddEvenCounts = function(t, n) {
      var i = Y.sum(new Int32Array(this.getOddCounts())), o = Y.sum(new Int32Array(this.getEvenCounts())), a = !1, s = !1, f = !1, u = !1;
      t ? (i > 12 ? s = !0 : i < 4 && (a = !0), o > 12 ? u = !0 : o < 4 && (f = !0)) : (i > 11 ? s = !0 : i < 5 && (a = !0), o > 10 ? u = !0 : o < 4 && (f = !0));
      var c = i + o - n, l = (i & 1) === (t ? 1 : 0), d = (o & 1) === 1;
      if (c === 1)
        if (l) {
          if (d)
            throw new w();
          s = !0;
        } else {
          if (!d)
            throw new w();
          u = !0;
        }
      else if (c === -1)
        if (l) {
          if (d)
            throw new w();
          a = !0;
        } else {
          if (!d)
            throw new w();
          f = !0;
        }
      else if (c === 0) {
        if (l) {
          if (!d)
            throw new w();
          i < o ? (a = !0, u = !0) : (s = !0, f = !0);
        } else if (d)
          throw new w();
      } else
        throw new w();
      if (a) {
        if (s)
          throw new w();
        ut.increment(this.getOddCounts(), this.getOddRoundingErrors());
      }
      if (s && ut.decrement(this.getOddCounts(), this.getOddRoundingErrors()), f) {
        if (u)
          throw new w();
        ut.increment(this.getEvenCounts(), this.getOddRoundingErrors());
      }
      u && ut.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [1, 10, 34, 70, 126], e.INSIDE_ODD_TOTAL_SUBSET = [4, 20, 48, 81], e.OUTSIDE_GSUM = [0, 161, 961, 2015, 2715], e.INSIDE_GSUM = [0, 336, 1036, 1516], e.OUTSIDE_ODD_WIDEST = [8, 6, 4, 3, 1], e.INSIDE_ODD_WIDEST = [2, 4, 6, 8], e.FINDER_PATTERNS = [
      Int32Array.from([3, 8, 2, 1]),
      Int32Array.from([3, 5, 5, 1]),
      Int32Array.from([3, 3, 7, 1]),
      Int32Array.from([3, 1, 9, 1]),
      Int32Array.from([2, 7, 4, 1]),
      Int32Array.from([2, 5, 6, 1]),
      Int32Array.from([2, 3, 8, 1]),
      Int32Array.from([1, 5, 7, 1]),
      Int32Array.from([1, 3, 9, 1])
    ], e;
  }(ut)
), Rs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), mt = (
  /** @class */
  function(r) {
    Rs(e, r);
    function e(t) {
      var n = r.call(this) || this;
      n.readers = [];
      var i = t ? t.get(fe.POSSIBLE_FORMATS) : null, o = t && t.get(fe.ASSUME_CODE_39_CHECK_DIGIT) !== void 0;
      return i && ((i.includes(L.EAN_13) || i.includes(L.UPC_A) || i.includes(L.EAN_8) || i.includes(L.UPC_E)) && n.readers.push(new Ir(t)), i.includes(L.CODE_39) && n.readers.push(new Rn(o)), i.includes(L.CODE_93) && n.readers.push(new Dn()), i.includes(L.CODE_128) && n.readers.push(new On()), i.includes(L.ITF) && n.readers.push(new Pn()), i.includes(L.CODABAR) && n.readers.push(new Qa()), i.includes(L.RSS_14) && n.readers.push(new Vn()), i.includes(L.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), n.readers.push(new Is()))), n.readers.length === 0 && (n.readers.push(new Ir(t)), n.readers.push(new Rn()), n.readers.push(new Dn()), n.readers.push(new Ir(t)), n.readers.push(new On()), n.readers.push(new Pn()), n.readers.push(new Vn())), n;
    }
    return e.prototype.decodeRow = function(t, n, i) {
      for (var o = 0; o < this.readers.length; o++)
        try {
          return this.readers[o].decodeRow(t, n, i);
        } catch {
        }
      throw new w();
    }, e.prototype.reset = function() {
      this.readers.forEach(function(t) {
        return t.reset();
      });
    }, e;
  }(_e)
), Ds = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Ds(e, r);
  function e(t, n) {
    return t === void 0 && (t = 500), r.call(this, new mt(n), t, n) || this;
  }
  return e;
})(wt);
var Gn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, q = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.ecCodewords = e, this.ecBlocks = [t], n && this.ecBlocks.push(n);
    }
    return r.prototype.getECCodewords = function() {
      return this.ecCodewords;
    }, r.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, r;
  }()
), Z = (
  /** @class */
  function() {
    function r(e, t) {
      this.count = e, this.dataCodewords = t;
    }
    return r.prototype.getCount = function() {
      return this.count;
    }, r.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, r;
  }()
), Ps = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a) {
      var s, f;
      this.versionNumber = e, this.symbolSizeRows = t, this.symbolSizeColumns = n, this.dataRegionSizeRows = i, this.dataRegionSizeColumns = o, this.ecBlocks = a;
      var u = 0, c = a.getECCodewords(), l = a.getECBlocks();
      try {
        for (var d = Gn(l), h = d.next(); !h.done; h = d.next()) {
          var p = h.value;
          u += p.getCount() * (p.getDataCodewords() + c);
        }
      } catch (v) {
        s = { error: v };
      } finally {
        try {
          h && !h.done && (f = d.return) && f.call(d);
        } finally {
          if (s)
            throw s.error;
        }
      }
      this.totalCodewords = u;
    }
    return r.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, r.prototype.getSymbolSizeRows = function() {
      return this.symbolSizeRows;
    }, r.prototype.getSymbolSizeColumns = function() {
      return this.symbolSizeColumns;
    }, r.prototype.getDataRegionSizeRows = function() {
      return this.dataRegionSizeRows;
    }, r.prototype.getDataRegionSizeColumns = function() {
      return this.dataRegionSizeColumns;
    }, r.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, r.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, r.getVersionForDimensions = function(e, t) {
      var n, i;
      if (e & 1 || t & 1)
        throw new O();
      try {
        for (var o = Gn(r.VERSIONS), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          if (s.symbolSizeRows === e && s.symbolSizeColumns === t)
            return s;
        }
      } catch (f) {
        n = { error: f };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n)
            throw n.error;
        }
      }
      throw new O();
    }, r.prototype.toString = function() {
      return "" + this.versionNumber;
    }, r.buildVersions = function() {
      return [
        new r(1, 10, 10, 8, 8, new q(5, new Z(1, 3))),
        new r(2, 12, 12, 10, 10, new q(7, new Z(1, 5))),
        new r(3, 14, 14, 12, 12, new q(10, new Z(1, 8))),
        new r(4, 16, 16, 14, 14, new q(12, new Z(1, 12))),
        new r(5, 18, 18, 16, 16, new q(14, new Z(1, 18))),
        new r(6, 20, 20, 18, 18, new q(18, new Z(1, 22))),
        new r(7, 22, 22, 20, 20, new q(20, new Z(1, 30))),
        new r(8, 24, 24, 22, 22, new q(24, new Z(1, 36))),
        new r(9, 26, 26, 24, 24, new q(28, new Z(1, 44))),
        new r(10, 32, 32, 14, 14, new q(36, new Z(1, 62))),
        new r(11, 36, 36, 16, 16, new q(42, new Z(1, 86))),
        new r(12, 40, 40, 18, 18, new q(48, new Z(1, 114))),
        new r(13, 44, 44, 20, 20, new q(56, new Z(1, 144))),
        new r(14, 48, 48, 22, 22, new q(68, new Z(1, 174))),
        new r(15, 52, 52, 24, 24, new q(42, new Z(2, 102))),
        new r(16, 64, 64, 14, 14, new q(56, new Z(2, 140))),
        new r(17, 72, 72, 16, 16, new q(36, new Z(4, 92))),
        new r(18, 80, 80, 18, 18, new q(48, new Z(4, 114))),
        new r(19, 88, 88, 20, 20, new q(56, new Z(4, 144))),
        new r(20, 96, 96, 22, 22, new q(68, new Z(4, 174))),
        new r(21, 104, 104, 24, 24, new q(56, new Z(6, 136))),
        new r(22, 120, 120, 18, 18, new q(68, new Z(6, 175))),
        new r(23, 132, 132, 20, 20, new q(62, new Z(8, 163))),
        new r(24, 144, 144, 22, 22, new q(62, new Z(8, 156), new Z(2, 155))),
        new r(25, 8, 18, 6, 16, new q(7, new Z(1, 5))),
        new r(26, 8, 32, 6, 14, new q(11, new Z(1, 10))),
        new r(27, 12, 26, 10, 24, new q(14, new Z(1, 16))),
        new r(28, 12, 36, 10, 16, new q(18, new Z(1, 22))),
        new r(29, 16, 36, 14, 16, new q(24, new Z(1, 32))),
        new r(30, 16, 48, 14, 22, new q(28, new Z(1, 49)))
      ];
    }, r.VERSIONS = r.buildVersions(), r;
  }()
), Ns = (
  /** @class */
  function() {
    function r(e) {
      var t = e.getHeight();
      if (t < 8 || t > 144 || t & 1)
        throw new O();
      this.version = r.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new Ye(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return r.prototype.getVersion = function() {
      return this.version;
    }, r.readVersion = function(e) {
      var t = e.getHeight(), n = e.getWidth();
      return Ps.getVersionForDimensions(t, n);
    }, r.prototype.readCodewords = function() {
      var e = new Int8Array(this.version.getTotalCodewords()), t = 0, n = 4, i = 0, o = this.mappingBitMatrix.getHeight(), a = this.mappingBitMatrix.getWidth(), s = !1, f = !1, u = !1, c = !1;
      do
        if (n === o && i === 0 && !s)
          e[t++] = this.readCorner1(o, a) & 255, n -= 2, i += 2, s = !0;
        else if (n === o - 2 && i === 0 && a & 3 && !f)
          e[t++] = this.readCorner2(o, a) & 255, n -= 2, i += 2, f = !0;
        else if (n === o + 4 && i === 2 && !(a & 7) && !u)
          e[t++] = this.readCorner3(o, a) & 255, n -= 2, i += 2, u = !0;
        else if (n === o - 2 && i === 0 && (a & 7) === 4 && !c)
          e[t++] = this.readCorner4(o, a) & 255, n -= 2, i += 2, c = !0;
        else {
          do
            n < o && i >= 0 && !this.readMappingMatrix.get(i, n) && (e[t++] = this.readUtah(n, i, o, a) & 255), n -= 2, i += 2;
          while (n >= 0 && i < a);
          n += 1, i += 3;
          do
            n >= 0 && i < a && !this.readMappingMatrix.get(i, n) && (e[t++] = this.readUtah(n, i, o, a) & 255), n += 2, i -= 2;
          while (n < o && i >= 0);
          n += 3, i += 1;
        }
      while (n < o || i < a);
      if (t !== this.version.getTotalCodewords())
        throw new O();
      return e;
    }, r.prototype.readModule = function(e, t, n, i) {
      return e < 0 && (e += n, t += 4 - (n + 4 & 7)), t < 0 && (t += i, e += 4 - (i + 4 & 7)), this.readMappingMatrix.set(t, e), this.mappingBitMatrix.get(t, e);
    }, r.prototype.readUtah = function(e, t, n, i) {
      var o = 0;
      return this.readModule(e - 2, t - 2, n, i) && (o |= 1), o <<= 1, this.readModule(e - 2, t - 1, n, i) && (o |= 1), o <<= 1, this.readModule(e - 1, t - 2, n, i) && (o |= 1), o <<= 1, this.readModule(e - 1, t - 1, n, i) && (o |= 1), o <<= 1, this.readModule(e - 1, t, n, i) && (o |= 1), o <<= 1, this.readModule(e, t - 2, n, i) && (o |= 1), o <<= 1, this.readModule(e, t - 1, n, i) && (o |= 1), o <<= 1, this.readModule(e, t, n, i) && (o |= 1), o;
    }, r.prototype.readCorner1 = function(e, t) {
      var n = 0;
      return this.readModule(e - 1, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 1, 1, e, t) && (n |= 1), n <<= 1, this.readModule(e - 1, 2, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 2, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(2, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(3, t - 1, e, t) && (n |= 1), n;
    }, r.prototype.readCorner2 = function(e, t) {
      var n = 0;
      return this.readModule(e - 3, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 2, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 1, 0, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 4, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 3, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 2, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 1, e, t) && (n |= 1), n;
    }, r.prototype.readCorner3 = function(e, t) {
      var n = 0;
      return this.readModule(e - 1, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 1, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 3, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 2, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 3, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 2, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 1, e, t) && (n |= 1), n;
    }, r.prototype.readCorner4 = function(e, t) {
      var n = 0;
      return this.readModule(e - 3, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 2, 0, e, t) && (n |= 1), n <<= 1, this.readModule(e - 1, 0, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 2, e, t) && (n |= 1), n <<= 1, this.readModule(0, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(1, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(2, t - 1, e, t) && (n |= 1), n <<= 1, this.readModule(3, t - 1, e, t) && (n |= 1), n;
    }, r.prototype.extractDataRegion = function(e) {
      var t = this.version.getSymbolSizeRows(), n = this.version.getSymbolSizeColumns();
      if (e.getHeight() !== t)
        throw new F("Dimension of bitMatrix must match the version size");
      for (var i = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), a = t / i | 0, s = n / o | 0, f = a * i, u = s * o, c = new Ye(u, f), l = 0; l < a; ++l)
        for (var d = l * i, h = 0; h < s; ++h)
          for (var p = h * o, v = 0; v < i; ++v)
            for (var y = l * (i + 2) + 1 + v, _ = d + v, x = 0; x < o; ++x) {
              var C = h * (o + 2) + 1 + x;
              if (e.get(C, y)) {
                var E = p + x;
                c.set(E, _);
              }
            }
      return c;
    }, r;
  }()
), Hn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ms = (
  /** @class */
  function() {
    function r(e, t) {
      this.numDataCodewords = e, this.codewords = t;
    }
    return r.getDataBlocks = function(e, t) {
      var n, i, o, a, s = t.getECBlocks(), f = 0, u = s.getECBlocks();
      try {
        for (var c = Hn(u), l = c.next(); !l.done; l = c.next()) {
          var d = l.value;
          f += d.getCount();
        }
      } catch (ie) {
        n = { error: ie };
      } finally {
        try {
          l && !l.done && (i = c.return) && i.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      var h = new Array(f), p = 0;
      try {
        for (var v = Hn(u), y = v.next(); !y.done; y = v.next())
          for (var d = y.value, _ = 0; _ < d.getCount(); _++) {
            var x = d.getDataCodewords(), C = s.getECCodewords() + x;
            h[p++] = new r(x, new Uint8Array(C));
          }
      } catch (ie) {
        o = { error: ie };
      } finally {
        try {
          y && !y.done && (a = v.return) && a.call(v);
        } finally {
          if (o)
            throw o.error;
        }
      }
      for (var E = h[0].codewords.length, S = E - s.getECCodewords(), I = S - 1, T = 0, _ = 0; _ < I; _++)
        for (var R = 0; R < p; R++)
          h[R].codewords[_] = e[T++];
      for (var B = t.getVersionNumber() === 24, M = B ? 8 : p, R = 0; R < M; R++)
        h[R].codewords[S - 1] = e[T++];
      for (var te = h[0].codewords.length, _ = S; _ < te; _++)
        for (var R = 0; R < p; R++) {
          var N = B ? (R + 8) % p : R, H = B && N > 7 ? _ - 1 : _;
          h[N].codewords[H] = e[T++];
        }
      if (T !== e.length)
        throw new F();
      return h;
    }, r.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, r.prototype.getCodewords = function() {
      return this.codewords;
    }, r;
  }()
), Ei = (
  /** @class */
  function() {
    function r(e) {
      this.bytes = e, this.byteOffset = 0, this.bitOffset = 0;
    }
    return r.prototype.getBitOffset = function() {
      return this.bitOffset;
    }, r.prototype.getByteOffset = function() {
      return this.byteOffset;
    }, r.prototype.readBits = function(e) {
      if (e < 1 || e > 32 || e > this.available())
        throw new F("" + e);
      var t = 0, n = this.bitOffset, i = this.byteOffset, o = this.bytes;
      if (n > 0) {
        var a = 8 - n, s = e < a ? e : a, f = a - s, u = 255 >> 8 - s << f;
        t = (o[i] & u) >> f, e -= s, n += s, n === 8 && (n = 0, i++);
      }
      if (e > 0) {
        for (; e >= 8; )
          t = t << 8 | o[i] & 255, i++, e -= 8;
        if (e > 0) {
          var f = 8 - e, u = 255 >> f << f;
          t = t << e | (o[i] & u) >> f, n += e;
        }
      }
      return this.bitOffset = n, this.byteOffset = i, t;
    }, r.prototype.available = function() {
      return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, r;
  }()
), ve;
(function(r) {
  r[r.PAD_ENCODE = 0] = "PAD_ENCODE", r[r.ASCII_ENCODE = 1] = "ASCII_ENCODE", r[r.C40_ENCODE = 2] = "C40_ENCODE", r[r.TEXT_ENCODE = 3] = "TEXT_ENCODE", r[r.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", r[r.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", r[r.BASE256_ENCODE = 6] = "BASE256_ENCODE";
})(ve || (ve = {}));
var Bs = (
  /** @class */
  function() {
    function r() {
    }
    return r.decode = function(e) {
      var t = new Ei(e), n = new V(), i = new V(), o = new Array(), a = ve.ASCII_ENCODE;
      do
        if (a === ve.ASCII_ENCODE)
          a = this.decodeAsciiSegment(t, n, i);
        else {
          switch (a) {
            case ve.C40_ENCODE:
              this.decodeC40Segment(t, n);
              break;
            case ve.TEXT_ENCODE:
              this.decodeTextSegment(t, n);
              break;
            case ve.ANSIX12_ENCODE:
              this.decodeAnsiX12Segment(t, n);
              break;
            case ve.EDIFACT_ENCODE:
              this.decodeEdifactSegment(t, n);
              break;
            case ve.BASE256_ENCODE:
              this.decodeBase256Segment(t, n, o);
              break;
            default:
              throw new O();
          }
          a = ve.ASCII_ENCODE;
        }
      while (a !== ve.PAD_ENCODE && t.available() > 0);
      return i.length() > 0 && n.append(i.toString()), new pr(e, n.toString(), o.length === 0 ? null : o, null);
    }, r.decodeAsciiSegment = function(e, t, n) {
      var i = !1;
      do {
        var o = e.readBits(8);
        if (o === 0)
          throw new O();
        if (o <= 128)
          return i && (o += 128), t.append(String.fromCharCode(o - 1)), ve.ASCII_ENCODE;
        if (o === 129)
          return ve.PAD_ENCODE;
        if (o <= 229) {
          var a = o - 130;
          a < 10 && t.append("0"), t.append("" + a);
        } else
          switch (o) {
            case 230:
              return ve.C40_ENCODE;
            case 231:
              return ve.BASE256_ENCODE;
            case 232:
              t.append("");
              break;
            case 233:
            case 234:
              break;
            case 235:
              i = !0;
              break;
            case 236:
              t.append("[)>05"), n.insert(0, "");
              break;
            case 237:
              t.append("[)>06"), n.insert(0, "");
              break;
            case 238:
              return ve.ANSIX12_ENCODE;
            case 239:
              return ve.TEXT_ENCODE;
            case 240:
              return ve.EDIFACT_ENCODE;
            case 241:
              break;
            default:
              if (o !== 254 || e.available() !== 0)
                throw new O();
              break;
          }
      } while (e.available() > 0);
      return ve.ASCII_ENCODE;
    }, r.decodeC40Segment = function(e, t) {
      var n = !1, i = [], o = 0;
      do {
        if (e.available() === 8)
          return;
        var a = e.readBits(8);
        if (a === 254)
          return;
        this.parseTwoBytes(a, e.readBits(8), i);
        for (var s = 0; s < 3; s++) {
          var f = i[s];
          switch (o) {
            case 0:
              if (f < 3)
                o = f + 1;
              else if (f < this.C40_BASIC_SET_CHARS.length) {
                var u = this.C40_BASIC_SET_CHARS[f];
                n ? (t.append(String.fromCharCode(u.charCodeAt(0) + 128)), n = !1) : t.append(u);
              } else
                throw new O();
              break;
            case 1:
              n ? (t.append(String.fromCharCode(f + 128)), n = !1) : t.append(String.fromCharCode(f)), o = 0;
              break;
            case 2:
              if (f < this.C40_SHIFT2_SET_CHARS.length) {
                var u = this.C40_SHIFT2_SET_CHARS[f];
                n ? (t.append(String.fromCharCode(u.charCodeAt(0) + 128)), n = !1) : t.append(u);
              } else
                switch (f) {
                  case 27:
                    t.append("");
                    break;
                  case 30:
                    n = !0;
                    break;
                  default:
                    throw new O();
                }
              o = 0;
              break;
            case 3:
              n ? (t.append(String.fromCharCode(f + 224)), n = !1) : t.append(String.fromCharCode(f + 96)), o = 0;
              break;
            default:
              throw new O();
          }
        }
      } while (e.available() > 0);
    }, r.decodeTextSegment = function(e, t) {
      var n = !1, i = [], o = 0;
      do {
        if (e.available() === 8)
          return;
        var a = e.readBits(8);
        if (a === 254)
          return;
        this.parseTwoBytes(a, e.readBits(8), i);
        for (var s = 0; s < 3; s++) {
          var f = i[s];
          switch (o) {
            case 0:
              if (f < 3)
                o = f + 1;
              else if (f < this.TEXT_BASIC_SET_CHARS.length) {
                var u = this.TEXT_BASIC_SET_CHARS[f];
                n ? (t.append(String.fromCharCode(u.charCodeAt(0) + 128)), n = !1) : t.append(u);
              } else
                throw new O();
              break;
            case 1:
              n ? (t.append(String.fromCharCode(f + 128)), n = !1) : t.append(String.fromCharCode(f)), o = 0;
              break;
            case 2:
              if (f < this.TEXT_SHIFT2_SET_CHARS.length) {
                var u = this.TEXT_SHIFT2_SET_CHARS[f];
                n ? (t.append(String.fromCharCode(u.charCodeAt(0) + 128)), n = !1) : t.append(u);
              } else
                switch (f) {
                  case 27:
                    t.append("");
                    break;
                  case 30:
                    n = !0;
                    break;
                  default:
                    throw new O();
                }
              o = 0;
              break;
            case 3:
              if (f < this.TEXT_SHIFT3_SET_CHARS.length) {
                var u = this.TEXT_SHIFT3_SET_CHARS[f];
                n ? (t.append(String.fromCharCode(u.charCodeAt(0) + 128)), n = !1) : t.append(u), o = 0;
              } else
                throw new O();
              break;
            default:
              throw new O();
          }
        }
      } while (e.available() > 0);
    }, r.decodeAnsiX12Segment = function(e, t) {
      var n = [];
      do {
        if (e.available() === 8)
          return;
        var i = e.readBits(8);
        if (i === 254)
          return;
        this.parseTwoBytes(i, e.readBits(8), n);
        for (var o = 0; o < 3; o++) {
          var a = n[o];
          switch (a) {
            case 0:
              t.append("\r");
              break;
            case 1:
              t.append("*");
              break;
            case 2:
              t.append(">");
              break;
            case 3:
              t.append(" ");
              break;
            default:
              if (a < 14)
                t.append(String.fromCharCode(a + 44));
              else if (a < 40)
                t.append(String.fromCharCode(a + 51));
              else
                throw new O();
              break;
          }
        }
      } while (e.available() > 0);
    }, r.parseTwoBytes = function(e, t, n) {
      var i = (e << 8) + t - 1, o = Math.floor(i / 1600);
      n[0] = o, i -= o * 1600, o = Math.floor(i / 40), n[1] = o, n[2] = i - o * 40;
    }, r.decodeEdifactSegment = function(e, t) {
      do {
        if (e.available() <= 16)
          return;
        for (var n = 0; n < 4; n++) {
          var i = e.readBits(6);
          if (i === 31) {
            var o = 8 - e.getBitOffset();
            o !== 8 && e.readBits(o);
            return;
          }
          i & 32 || (i |= 64), t.append(String.fromCharCode(i));
        }
      } while (e.available() > 0);
    }, r.decodeBase256Segment = function(e, t, n) {
      var i = 1 + e.getByteOffset(), o = this.unrandomize255State(e.readBits(8), i++), a;
      if (o === 0 ? a = e.available() / 8 | 0 : o < 250 ? a = o : a = 250 * (o - 249) + this.unrandomize255State(e.readBits(8), i++), a < 0)
        throw new O();
      for (var s = new Uint8Array(a), f = 0; f < a; f++) {
        if (e.available() < 8)
          throw new O();
        s[f] = this.unrandomize255State(e.readBits(8), i++);
      }
      n.push(s);
      try {
        t.append(Ve.decode(s, X.ISO88591));
      } catch (u) {
        throw new Vt("Platform does not support required encoding: " + u.message);
      }
    }, r.unrandomize255State = function(e, t) {
      var n = 149 * t % 255 + 1, i = e - n;
      return i >= 0 ? i : i + 256;
    }, r.C40_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ], r.C40_SHIFT2_SET_CHARS = [
      "!",
      '"',
      "#",
      "$",
      "%",
      "&",
      "'",
      "(",
      ")",
      "*",
      "+",
      ",",
      "-",
      ".",
      "/",
      ":",
      ";",
      "<",
      "=",
      ">",
      "?",
      "@",
      "[",
      "\\",
      "]",
      "^",
      "_"
    ], r.TEXT_BASIC_SET_CHARS = [
      "*",
      "*",
      "*",
      " ",
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ], r.TEXT_SHIFT2_SET_CHARS = r.C40_SHIFT2_SET_CHARS, r.TEXT_SHIFT3_SET_CHARS = [
      "`",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "{",
      "|",
      "}",
      "~",
      ""
    ], r;
  }()
), Ls = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fs = (
  /** @class */
  function() {
    function r() {
      this.rsDecoder = new vr(Be.DATA_MATRIX_FIELD_256);
    }
    return r.prototype.decode = function(e) {
      var t, n, i = new Ns(e), o = i.getVersion(), a = i.readCodewords(), s = Ms.getDataBlocks(a, o), f = 0;
      try {
        for (var u = Ls(s), c = u.next(); !c.done; c = u.next()) {
          var l = c.value;
          f += l.getNumDataCodewords();
        }
      } catch (C) {
        t = { error: C };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (t)
            throw t.error;
        }
      }
      for (var d = new Uint8Array(f), h = s.length, p = 0; p < h; p++) {
        var v = s[p], y = v.getCodewords(), _ = v.getNumDataCodewords();
        this.correctErrors(y, _);
        for (var x = 0; x < _; x++)
          d[x * h + p] = y[x];
      }
      return Bs.decode(d);
    }, r.prototype.correctErrors = function(e, t) {
      var n = new Int32Array(e);
      try {
        this.rsDecoder.decode(n, e.length - t);
      } catch {
        throw new pe();
      }
      for (var i = 0; i < t; i++)
        e[i] = n[i];
    }, r;
  }()
), ks = (
  /** @class */
  function() {
    function r(e) {
      this.image = e, this.rectangleDetector = new Ur(this.image);
    }
    return r.prototype.detect = function() {
      var e = this.rectangleDetector.detect(), t = this.detectSolid1(e);
      if (t = this.detectSolid2(t), t[3] = this.correctTopRight(t), !t[3])
        throw new w();
      t = this.shiftToModuleCenter(t);
      var n = t[0], i = t[1], o = t[2], a = t[3], s = this.transitionsBetween(n, a) + 1, f = this.transitionsBetween(o, a) + 1;
      (s & 1) === 1 && (s += 1), (f & 1) === 1 && (f += 1), 4 * s < 7 * f && 4 * f < 7 * s && (s = f = Math.max(s, f));
      var u = r.sampleGrid(this.image, n, i, o, a, s, f);
      return new Jr(u, [n, i, o, a]);
    }, r.shiftPoint = function(e, t, n) {
      var i = (t.getX() - e.getX()) / (n + 1), o = (t.getY() - e.getY()) / (n + 1);
      return new P(e.getX() + i, e.getY() + o);
    }, r.moveAway = function(e, t, n) {
      var i = e.getX(), o = e.getY();
      return i < t ? i -= 1 : i += 1, o < n ? o -= 1 : o += 1, new P(i, o);
    }, r.prototype.detectSolid1 = function(e) {
      var t = e[0], n = e[1], i = e[3], o = e[2], a = this.transitionsBetween(t, n), s = this.transitionsBetween(n, i), f = this.transitionsBetween(i, o), u = this.transitionsBetween(o, t), c = a, l = [o, t, n, i];
      return c > s && (c = s, l[0] = t, l[1] = n, l[2] = i, l[3] = o), c > f && (c = f, l[0] = n, l[1] = i, l[2] = o, l[3] = t), c > u && (l[0] = i, l[1] = o, l[2] = t, l[3] = n), l;
    }, r.prototype.detectSolid2 = function(e) {
      var t = e[0], n = e[1], i = e[2], o = e[3], a = this.transitionsBetween(t, o), s = r.shiftPoint(n, i, (a + 1) * 4), f = r.shiftPoint(i, n, (a + 1) * 4), u = this.transitionsBetween(s, t), c = this.transitionsBetween(f, o);
      return u < c ? (e[0] = t, e[1] = n, e[2] = i, e[3] = o) : (e[0] = n, e[1] = i, e[2] = o, e[3] = t), e;
    }, r.prototype.correctTopRight = function(e) {
      var t = e[0], n = e[1], i = e[2], o = e[3], a = this.transitionsBetween(t, o), s = this.transitionsBetween(n, o), f = r.shiftPoint(t, n, (s + 1) * 4), u = r.shiftPoint(i, n, (a + 1) * 4);
      a = this.transitionsBetween(f, o), s = this.transitionsBetween(u, o);
      var c = new P(o.getX() + (i.getX() - n.getX()) / (a + 1), o.getY() + (i.getY() - n.getY()) / (a + 1)), l = new P(o.getX() + (t.getX() - n.getX()) / (s + 1), o.getY() + (t.getY() - n.getY()) / (s + 1));
      if (!this.isValid(c))
        return this.isValid(l) ? l : null;
      if (!this.isValid(l))
        return c;
      var d = this.transitionsBetween(f, c) + this.transitionsBetween(u, c), h = this.transitionsBetween(f, l) + this.transitionsBetween(u, l);
      return d > h ? c : l;
    }, r.prototype.shiftToModuleCenter = function(e) {
      var t = e[0], n = e[1], i = e[2], o = e[3], a = this.transitionsBetween(t, o) + 1, s = this.transitionsBetween(i, o) + 1, f = r.shiftPoint(t, n, s * 4), u = r.shiftPoint(i, n, a * 4);
      a = this.transitionsBetween(f, o) + 1, s = this.transitionsBetween(u, o) + 1, (a & 1) === 1 && (a += 1), (s & 1) === 1 && (s += 1);
      var c = (t.getX() + n.getX() + i.getX() + o.getX()) / 4, l = (t.getY() + n.getY() + i.getY() + o.getY()) / 4;
      t = r.moveAway(t, c, l), n = r.moveAway(n, c, l), i = r.moveAway(i, c, l), o = r.moveAway(o, c, l);
      var d, h;
      return f = r.shiftPoint(t, n, s * 4), f = r.shiftPoint(f, o, a * 4), d = r.shiftPoint(n, t, s * 4), d = r.shiftPoint(d, i, a * 4), u = r.shiftPoint(i, o, s * 4), u = r.shiftPoint(u, n, a * 4), h = r.shiftPoint(o, i, s * 4), h = r.shiftPoint(h, t, a * 4), [f, d, u, h];
    }, r.prototype.isValid = function(e) {
      return e.getX() >= 0 && e.getX() < this.image.getWidth() && e.getY() > 0 && e.getY() < this.image.getHeight();
    }, r.sampleGrid = function(e, t, n, i, o, a, s) {
      var f = en.getInstance();
      return f.sampleGrid(e, a, s, 0.5, 0.5, a - 0.5, 0.5, a - 0.5, s - 0.5, 0.5, s - 0.5, t.getX(), t.getY(), o.getX(), o.getY(), i.getX(), i.getY(), n.getX(), n.getY());
    }, r.prototype.transitionsBetween = function(e, t) {
      var n = Math.trunc(e.getX()), i = Math.trunc(e.getY()), o = Math.trunc(t.getX()), a = Math.trunc(t.getY()), s = Math.abs(a - i) > Math.abs(o - n);
      if (s) {
        var f = n;
        n = i, i = f, f = o, o = a, a = f;
      }
      for (var u = Math.abs(o - n), c = Math.abs(a - i), l = -u / 2, d = i < a ? 1 : -1, h = n < o ? 1 : -1, p = 0, v = this.image.get(s ? i : n, s ? n : i), y = n, _ = i; y !== o; y += h) {
        var x = this.image.get(s ? _ : y, s ? y : _);
        if (x !== v && (p++, v = x), l += c, l > 0) {
          if (_ === a)
            break;
          _ += d, l -= u;
        }
      }
      return p;
    }, r;
  }()
), ur = (
  /** @class */
  function() {
    function r() {
      this.decoder = new Fs();
    }
    return r.prototype.decode = function(e, t) {
      t === void 0 && (t = null);
      var n, i;
      if (t != null && t.has(fe.PURE_BARCODE)) {
        var o = r.extractPureBits(e.getBlackMatrix());
        n = this.decoder.decode(o), i = r.NO_POINTS;
      } else {
        var a = new ks(e.getBlackMatrix()).detect();
        n = this.decoder.decode(a.getBits()), i = a.getPoints();
      }
      var s = n.getRawBytes(), f = new Oe(n.getText(), s, 8 * s.length, i, L.DATA_MATRIX, ne.currentTimeMillis()), u = n.getByteSegments();
      u != null && f.putMetadata(be.BYTE_SEGMENTS, u);
      var c = n.getECLevel();
      return c != null && f.putMetadata(be.ERROR_CORRECTION_LEVEL, c), f;
    }, r.prototype.reset = function() {
    }, r.extractPureBits = function(e) {
      var t = e.getTopLeftOnBit(), n = e.getBottomRightOnBit();
      if (t == null || n == null)
        throw new w();
      var i = this.moduleSize(t, e), o = t[1], a = n[1], s = t[0], f = n[0], u = (f - s + 1) / i, c = (a - o + 1) / i;
      if (u <= 0 || c <= 0)
        throw new w();
      var l = i / 2;
      o += l, s += l;
      for (var d = new Ye(u, c), h = 0; h < c; h++)
        for (var p = o + h * i, v = 0; v < u; v++)
          e.get(s + v * i, p) && d.set(v, h);
      return d;
    }, r.moduleSize = function(e, t) {
      for (var n = t.getWidth(), i = e[0], o = e[1]; i < n && t.get(i, o); )
        i++;
      if (i === n)
        throw new w();
      var a = i - e[0];
      if (a === 0)
        throw new w();
      return a;
    }, r.NO_POINTS = [], r;
  }()
), Us = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Us(e, r);
  function e(t) {
    return t === void 0 && (t = 500), r.call(this, new ur(), t) || this;
  }
  return e;
})(wt);
var _t;
(function(r) {
  r[r.L = 0] = "L", r[r.M = 1] = "M", r[r.Q = 2] = "Q", r[r.H = 3] = "H";
})(_t || (_t = {}));
var Vs = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.value = e, this.stringValue = t, this.bits = n, r.FOR_BITS.set(n, this), r.FOR_VALUE.set(e, this);
    }
    return r.prototype.getValue = function() {
      return this.value;
    }, r.prototype.getBits = function() {
      return this.bits;
    }, r.fromString = function(e) {
      switch (e) {
        case "L":
          return r.L;
        case "M":
          return r.M;
        case "Q":
          return r.Q;
        case "H":
          return r.H;
        default:
          throw new de(e + "not available");
      }
    }, r.prototype.toString = function() {
      return this.stringValue;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.value === t.value;
    }, r.forBits = function(e) {
      if (e < 0 || e >= r.FOR_BITS.size)
        throw new F();
      return r.FOR_BITS.get(e);
    }, r.FOR_BITS = /* @__PURE__ */ new Map(), r.FOR_VALUE = /* @__PURE__ */ new Map(), r.L = new r(_t.L, "L", 1), r.M = new r(_t.M, "M", 0), r.Q = new r(_t.Q, "Q", 3), r.H = new r(_t.H, "H", 2), r;
  }()
), Gs = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, wi = (
  /** @class */
  function() {
    function r(e) {
      this.errorCorrectionLevel = Vs.forBits(e >> 3 & 3), this.dataMask = /*(byte) */
      e & 7;
    }
    return r.numBitsDiffering = function(e, t) {
      return G.bitCount(e ^ t);
    }, r.decodeFormatInformation = function(e, t) {
      var n = r.doDecodeFormatInformation(e, t);
      return n !== null ? n : r.doDecodeFormatInformation(e ^ r.FORMAT_INFO_MASK_QR, t ^ r.FORMAT_INFO_MASK_QR);
    }, r.doDecodeFormatInformation = function(e, t) {
      var n, i, o = Number.MAX_SAFE_INTEGER, a = 0;
      try {
        for (var s = Gs(r.FORMAT_INFO_DECODE_LOOKUP), f = s.next(); !f.done; f = s.next()) {
          var u = f.value, c = u[0];
          if (c === e || c === t)
            return new r(u[1]);
          var l = r.numBitsDiffering(e, c);
          l < o && (a = u[1], o = l), e !== t && (l = r.numBitsDiffering(t, c), l < o && (a = u[1], o = l));
        }
      } catch (d) {
        n = { error: d };
      } finally {
        try {
          f && !f.done && (i = s.return) && i.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return o <= 3 ? new r(a) : null;
    }, r.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, r.prototype.getDataMask = function() {
      return this.dataMask;
    }, r.prototype.hashCode = function() {
      return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.errorCorrectionLevel === t.errorCorrectionLevel && this.dataMask === t.dataMask;
    }, r.FORMAT_INFO_MASK_QR = 21522, r.FORMAT_INFO_DECODE_LOOKUP = [
      Int32Array.from([21522, 0]),
      Int32Array.from([20773, 1]),
      Int32Array.from([24188, 2]),
      Int32Array.from([23371, 3]),
      Int32Array.from([17913, 4]),
      Int32Array.from([16590, 5]),
      Int32Array.from([20375, 6]),
      Int32Array.from([19104, 7]),
      Int32Array.from([30660, 8]),
      Int32Array.from([29427, 9]),
      Int32Array.from([32170, 10]),
      Int32Array.from([30877, 11]),
      Int32Array.from([26159, 12]),
      Int32Array.from([25368, 13]),
      Int32Array.from([27713, 14]),
      Int32Array.from([26998, 15]),
      Int32Array.from([5769, 16]),
      Int32Array.from([5054, 17]),
      Int32Array.from([7399, 18]),
      Int32Array.from([6608, 19]),
      Int32Array.from([1890, 20]),
      Int32Array.from([597, 21]),
      Int32Array.from([3340, 22]),
      Int32Array.from([2107, 23]),
      Int32Array.from([13663, 24]),
      Int32Array.from([12392, 25]),
      Int32Array.from([16177, 26]),
      Int32Array.from([14854, 27]),
      Int32Array.from([9396, 28]),
      Int32Array.from([8579, 29]),
      Int32Array.from([11994, 30]),
      Int32Array.from([11245, 31])
    ], r;
  }()
), Hs = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, A = (
  /** @class */
  function() {
    function r(e) {
      for (var t = [], n = 1; n < arguments.length; n++)
        t[n - 1] = arguments[n];
      this.ecCodewordsPerBlock = e, this.ecBlocks = t;
    }
    return r.prototype.getECCodewordsPerBlock = function() {
      return this.ecCodewordsPerBlock;
    }, r.prototype.getNumBlocks = function() {
      var e, t, n = 0, i = this.ecBlocks;
      try {
        for (var o = Hs(i), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          n += s.getCount();
        }
      } catch (f) {
        e = { error: f };
      } finally {
        try {
          a && !a.done && (t = o.return) && t.call(o);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return n;
    }, r.prototype.getTotalECCodewords = function() {
      return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, r.prototype.getECBlocks = function() {
      return this.ecBlocks;
    }, r;
  }()
), g = (
  /** @class */
  function() {
    function r(e, t) {
      this.count = e, this.dataCodewords = t;
    }
    return r.prototype.getCount = function() {
      return this.count;
    }, r.prototype.getDataCodewords = function() {
      return this.dataCodewords;
    }, r;
  }()
), js = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ht = (
  /** @class */
  function() {
    function r(e, t) {
      for (var n, i, o = [], a = 2; a < arguments.length; a++)
        o[a - 2] = arguments[a];
      this.versionNumber = e, this.alignmentPatternCenters = t, this.ecBlocks = o;
      var s = 0, f = o[0].getECCodewordsPerBlock(), u = o[0].getECBlocks();
      try {
        for (var c = js(u), l = c.next(); !l.done; l = c.next()) {
          var d = l.value;
          s += d.getCount() * (d.getDataCodewords() + f);
        }
      } catch (h) {
        n = { error: h };
      } finally {
        try {
          l && !l.done && (i = c.return) && i.call(c);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.totalCodewords = s;
    }
    return r.prototype.getVersionNumber = function() {
      return this.versionNumber;
    }, r.prototype.getAlignmentPatternCenters = function() {
      return this.alignmentPatternCenters;
    }, r.prototype.getTotalCodewords = function() {
      return this.totalCodewords;
    }, r.prototype.getDimensionForVersion = function() {
      return 17 + 4 * this.versionNumber;
    }, r.prototype.getECBlocksForLevel = function(e) {
      return this.ecBlocks[e.getValue()];
    }, r.getProvisionalVersionForDimension = function(e) {
      if (e % 4 !== 1)
        throw new O();
      try {
        return this.getVersionForNumber((e - 17) / 4);
      } catch {
        throw new O();
      }
    }, r.getVersionForNumber = function(e) {
      if (e < 1 || e > 40)
        throw new F();
      return r.VERSIONS[e - 1];
    }, r.decodeVersionInformation = function(e) {
      for (var t = Number.MAX_SAFE_INTEGER, n = 0, i = 0; i < r.VERSION_DECODE_INFO.length; i++) {
        var o = r.VERSION_DECODE_INFO[i];
        if (o === e)
          return r.getVersionForNumber(i + 7);
        var a = wi.numBitsDiffering(e, o);
        a < t && (n = i + 7, t = a);
      }
      return t <= 3 ? r.getVersionForNumber(n) : null;
    }, r.prototype.buildFunctionPattern = function() {
      var e = this.getDimensionForVersion(), t = new Ye(e);
      t.setRegion(0, 0, 9, 9), t.setRegion(e - 8, 0, 8, 9), t.setRegion(0, e - 8, 9, 8);
      for (var n = this.alignmentPatternCenters.length, i = 0; i < n; i++)
        for (var o = this.alignmentPatternCenters[i] - 2, a = 0; a < n; a++)
          i === 0 && (a === 0 || a === n - 1) || i === n - 1 && a === 0 || t.setRegion(this.alignmentPatternCenters[a] - 2, o, 5, 5);
      return t.setRegion(6, 9, 1, e - 17), t.setRegion(9, 6, e - 17, 1), this.versionNumber > 6 && (t.setRegion(e - 11, 0, 3, 6), t.setRegion(0, e - 11, 6, 3)), t;
    }, r.prototype.toString = function() {
      return "" + this.versionNumber;
    }, r.VERSION_DECODE_INFO = Int32Array.from([
      31892,
      34236,
      39577,
      42195,
      48118,
      51042,
      55367,
      58893,
      63784,
      68472,
      70749,
      76311,
      79154,
      84390,
      87683,
      92361,
      96236,
      102084,
      102881,
      110507,
      110734,
      117786,
      119615,
      126325,
      127568,
      133589,
      136944,
      141498,
      145311,
      150283,
      152622,
      158308,
      161089,
      167017
    ]), r.VERSIONS = [
      new r(1, new Int32Array(0), new A(7, new g(1, 19)), new A(10, new g(1, 16)), new A(13, new g(1, 13)), new A(17, new g(1, 9))),
      new r(2, Int32Array.from([6, 18]), new A(10, new g(1, 34)), new A(16, new g(1, 28)), new A(22, new g(1, 22)), new A(28, new g(1, 16))),
      new r(3, Int32Array.from([6, 22]), new A(15, new g(1, 55)), new A(26, new g(1, 44)), new A(18, new g(2, 17)), new A(22, new g(2, 13))),
      new r(4, Int32Array.from([6, 26]), new A(20, new g(1, 80)), new A(18, new g(2, 32)), new A(26, new g(2, 24)), new A(16, new g(4, 9))),
      new r(5, Int32Array.from([6, 30]), new A(26, new g(1, 108)), new A(24, new g(2, 43)), new A(18, new g(2, 15), new g(2, 16)), new A(22, new g(2, 11), new g(2, 12))),
      new r(6, Int32Array.from([6, 34]), new A(18, new g(2, 68)), new A(16, new g(4, 27)), new A(24, new g(4, 19)), new A(28, new g(4, 15))),
      new r(7, Int32Array.from([6, 22, 38]), new A(20, new g(2, 78)), new A(18, new g(4, 31)), new A(18, new g(2, 14), new g(4, 15)), new A(26, new g(4, 13), new g(1, 14))),
      new r(8, Int32Array.from([6, 24, 42]), new A(24, new g(2, 97)), new A(22, new g(2, 38), new g(2, 39)), new A(22, new g(4, 18), new g(2, 19)), new A(26, new g(4, 14), new g(2, 15))),
      new r(9, Int32Array.from([6, 26, 46]), new A(30, new g(2, 116)), new A(22, new g(3, 36), new g(2, 37)), new A(20, new g(4, 16), new g(4, 17)), new A(24, new g(4, 12), new g(4, 13))),
      new r(10, Int32Array.from([6, 28, 50]), new A(18, new g(2, 68), new g(2, 69)), new A(26, new g(4, 43), new g(1, 44)), new A(24, new g(6, 19), new g(2, 20)), new A(28, new g(6, 15), new g(2, 16))),
      new r(11, Int32Array.from([6, 30, 54]), new A(20, new g(4, 81)), new A(30, new g(1, 50), new g(4, 51)), new A(28, new g(4, 22), new g(4, 23)), new A(24, new g(3, 12), new g(8, 13))),
      new r(12, Int32Array.from([6, 32, 58]), new A(24, new g(2, 92), new g(2, 93)), new A(22, new g(6, 36), new g(2, 37)), new A(26, new g(4, 20), new g(6, 21)), new A(28, new g(7, 14), new g(4, 15))),
      new r(13, Int32Array.from([6, 34, 62]), new A(26, new g(4, 107)), new A(22, new g(8, 37), new g(1, 38)), new A(24, new g(8, 20), new g(4, 21)), new A(22, new g(12, 11), new g(4, 12))),
      new r(14, Int32Array.from([6, 26, 46, 66]), new A(30, new g(3, 115), new g(1, 116)), new A(24, new g(4, 40), new g(5, 41)), new A(20, new g(11, 16), new g(5, 17)), new A(24, new g(11, 12), new g(5, 13))),
      new r(15, Int32Array.from([6, 26, 48, 70]), new A(22, new g(5, 87), new g(1, 88)), new A(24, new g(5, 41), new g(5, 42)), new A(30, new g(5, 24), new g(7, 25)), new A(24, new g(11, 12), new g(7, 13))),
      new r(16, Int32Array.from([6, 26, 50, 74]), new A(24, new g(5, 98), new g(1, 99)), new A(28, new g(7, 45), new g(3, 46)), new A(24, new g(15, 19), new g(2, 20)), new A(30, new g(3, 15), new g(13, 16))),
      new r(17, Int32Array.from([6, 30, 54, 78]), new A(28, new g(1, 107), new g(5, 108)), new A(28, new g(10, 46), new g(1, 47)), new A(28, new g(1, 22), new g(15, 23)), new A(28, new g(2, 14), new g(17, 15))),
      new r(18, Int32Array.from([6, 30, 56, 82]), new A(30, new g(5, 120), new g(1, 121)), new A(26, new g(9, 43), new g(4, 44)), new A(28, new g(17, 22), new g(1, 23)), new A(28, new g(2, 14), new g(19, 15))),
      new r(19, Int32Array.from([6, 30, 58, 86]), new A(28, new g(3, 113), new g(4, 114)), new A(26, new g(3, 44), new g(11, 45)), new A(26, new g(17, 21), new g(4, 22)), new A(26, new g(9, 13), new g(16, 14))),
      new r(20, Int32Array.from([6, 34, 62, 90]), new A(28, new g(3, 107), new g(5, 108)), new A(26, new g(3, 41), new g(13, 42)), new A(30, new g(15, 24), new g(5, 25)), new A(28, new g(15, 15), new g(10, 16))),
      new r(21, Int32Array.from([6, 28, 50, 72, 94]), new A(28, new g(4, 116), new g(4, 117)), new A(26, new g(17, 42)), new A(28, new g(17, 22), new g(6, 23)), new A(30, new g(19, 16), new g(6, 17))),
      new r(22, Int32Array.from([6, 26, 50, 74, 98]), new A(28, new g(2, 111), new g(7, 112)), new A(28, new g(17, 46)), new A(30, new g(7, 24), new g(16, 25)), new A(24, new g(34, 13))),
      new r(23, Int32Array.from([6, 30, 54, 78, 102]), new A(30, new g(4, 121), new g(5, 122)), new A(28, new g(4, 47), new g(14, 48)), new A(30, new g(11, 24), new g(14, 25)), new A(30, new g(16, 15), new g(14, 16))),
      new r(24, Int32Array.from([6, 28, 54, 80, 106]), new A(30, new g(6, 117), new g(4, 118)), new A(28, new g(6, 45), new g(14, 46)), new A(30, new g(11, 24), new g(16, 25)), new A(30, new g(30, 16), new g(2, 17))),
      new r(25, Int32Array.from([6, 32, 58, 84, 110]), new A(26, new g(8, 106), new g(4, 107)), new A(28, new g(8, 47), new g(13, 48)), new A(30, new g(7, 24), new g(22, 25)), new A(30, new g(22, 15), new g(13, 16))),
      new r(26, Int32Array.from([6, 30, 58, 86, 114]), new A(28, new g(10, 114), new g(2, 115)), new A(28, new g(19, 46), new g(4, 47)), new A(28, new g(28, 22), new g(6, 23)), new A(30, new g(33, 16), new g(4, 17))),
      new r(27, Int32Array.from([6, 34, 62, 90, 118]), new A(30, new g(8, 122), new g(4, 123)), new A(28, new g(22, 45), new g(3, 46)), new A(30, new g(8, 23), new g(26, 24)), new A(30, new g(12, 15), new g(28, 16))),
      new r(28, Int32Array.from([6, 26, 50, 74, 98, 122]), new A(30, new g(3, 117), new g(10, 118)), new A(28, new g(3, 45), new g(23, 46)), new A(30, new g(4, 24), new g(31, 25)), new A(30, new g(11, 15), new g(31, 16))),
      new r(29, Int32Array.from([6, 30, 54, 78, 102, 126]), new A(30, new g(7, 116), new g(7, 117)), new A(28, new g(21, 45), new g(7, 46)), new A(30, new g(1, 23), new g(37, 24)), new A(30, new g(19, 15), new g(26, 16))),
      new r(30, Int32Array.from([6, 26, 52, 78, 104, 130]), new A(30, new g(5, 115), new g(10, 116)), new A(28, new g(19, 47), new g(10, 48)), new A(30, new g(15, 24), new g(25, 25)), new A(30, new g(23, 15), new g(25, 16))),
      new r(31, Int32Array.from([6, 30, 56, 82, 108, 134]), new A(30, new g(13, 115), new g(3, 116)), new A(28, new g(2, 46), new g(29, 47)), new A(30, new g(42, 24), new g(1, 25)), new A(30, new g(23, 15), new g(28, 16))),
      new r(32, Int32Array.from([6, 34, 60, 86, 112, 138]), new A(30, new g(17, 115)), new A(28, new g(10, 46), new g(23, 47)), new A(30, new g(10, 24), new g(35, 25)), new A(30, new g(19, 15), new g(35, 16))),
      new r(33, Int32Array.from([6, 30, 58, 86, 114, 142]), new A(30, new g(17, 115), new g(1, 116)), new A(28, new g(14, 46), new g(21, 47)), new A(30, new g(29, 24), new g(19, 25)), new A(30, new g(11, 15), new g(46, 16))),
      new r(34, Int32Array.from([6, 34, 62, 90, 118, 146]), new A(30, new g(13, 115), new g(6, 116)), new A(28, new g(14, 46), new g(23, 47)), new A(30, new g(44, 24), new g(7, 25)), new A(30, new g(59, 16), new g(1, 17))),
      new r(35, Int32Array.from([6, 30, 54, 78, 102, 126, 150]), new A(30, new g(12, 121), new g(7, 122)), new A(28, new g(12, 47), new g(26, 48)), new A(30, new g(39, 24), new g(14, 25)), new A(30, new g(22, 15), new g(41, 16))),
      new r(36, Int32Array.from([6, 24, 50, 76, 102, 128, 154]), new A(30, new g(6, 121), new g(14, 122)), new A(28, new g(6, 47), new g(34, 48)), new A(30, new g(46, 24), new g(10, 25)), new A(30, new g(2, 15), new g(64, 16))),
      new r(37, Int32Array.from([6, 28, 54, 80, 106, 132, 158]), new A(30, new g(17, 122), new g(4, 123)), new A(28, new g(29, 46), new g(14, 47)), new A(30, new g(49, 24), new g(10, 25)), new A(30, new g(24, 15), new g(46, 16))),
      new r(38, Int32Array.from([6, 32, 58, 84, 110, 136, 162]), new A(30, new g(4, 122), new g(18, 123)), new A(28, new g(13, 46), new g(32, 47)), new A(30, new g(48, 24), new g(14, 25)), new A(30, new g(42, 15), new g(32, 16))),
      new r(39, Int32Array.from([6, 26, 54, 82, 110, 138, 166]), new A(30, new g(20, 117), new g(4, 118)), new A(28, new g(40, 47), new g(7, 48)), new A(30, new g(43, 24), new g(22, 25)), new A(30, new g(10, 15), new g(67, 16))),
      new r(40, Int32Array.from([6, 30, 58, 86, 114, 142, 170]), new A(30, new g(19, 118), new g(6, 119)), new A(28, new g(18, 47), new g(31, 48)), new A(30, new g(34, 24), new g(34, 25)), new A(30, new g(20, 15), new g(61, 16)))
    ], r;
  }()
), Ce;
(function(r) {
  r[r.DATA_MASK_000 = 0] = "DATA_MASK_000", r[r.DATA_MASK_001 = 1] = "DATA_MASK_001", r[r.DATA_MASK_010 = 2] = "DATA_MASK_010", r[r.DATA_MASK_011 = 3] = "DATA_MASK_011", r[r.DATA_MASK_100 = 4] = "DATA_MASK_100", r[r.DATA_MASK_101 = 5] = "DATA_MASK_101", r[r.DATA_MASK_110 = 6] = "DATA_MASK_110", r[r.DATA_MASK_111 = 7] = "DATA_MASK_111";
})(Ce || (Ce = {}));
var jn = (
  /** @class */
  function() {
    function r(e, t) {
      this.value = e, this.isMasked = t;
    }
    return r.prototype.unmaskBitMatrix = function(e, t) {
      for (var n = 0; n < t; n++)
        for (var i = 0; i < t; i++)
          this.isMasked(n, i) && e.flip(i, n);
    }, r.values = /* @__PURE__ */ new Map([
      /**
       * 000: mask bits for which (x + y) mod 2 == 0
       */
      [Ce.DATA_MASK_000, new r(Ce.DATA_MASK_000, function(e, t) {
        return (e + t & 1) === 0;
      })],
      /**
       * 001: mask bits for which x mod 2 == 0
       */
      [Ce.DATA_MASK_001, new r(Ce.DATA_MASK_001, function(e, t) {
        return (e & 1) === 0;
      })],
      /**
       * 010: mask bits for which y mod 3 == 0
       */
      [Ce.DATA_MASK_010, new r(Ce.DATA_MASK_010, function(e, t) {
        return t % 3 === 0;
      })],
      /**
       * 011: mask bits for which (x + y) mod 3 == 0
       */
      [Ce.DATA_MASK_011, new r(Ce.DATA_MASK_011, function(e, t) {
        return (e + t) % 3 === 0;
      })],
      /**
       * 100: mask bits for which (x/2 + y/3) mod 2 == 0
       */
      [Ce.DATA_MASK_100, new r(Ce.DATA_MASK_100, function(e, t) {
        return (Math.floor(e / 2) + Math.floor(t / 3) & 1) === 0;
      })],
      /**
       * 101: mask bits for which xy mod 2 + xy mod 3 == 0
       * equivalently, such that xy mod 6 == 0
       */
      [Ce.DATA_MASK_101, new r(Ce.DATA_MASK_101, function(e, t) {
        return e * t % 6 === 0;
      })],
      /**
       * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that xy mod 6 < 3
       */
      [Ce.DATA_MASK_110, new r(Ce.DATA_MASK_110, function(e, t) {
        return e * t % 6 < 3;
      })],
      /**
       * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
       * equivalently, such that (x + y + xy mod 3) mod 2 == 0
       */
      [Ce.DATA_MASK_111, new r(Ce.DATA_MASK_111, function(e, t) {
        return (e + t + e * t % 3 & 1) === 0;
      })]
    ]), r;
  }()
), Ws = (
  /** @class */
  function() {
    function r(e) {
      var t = e.getHeight();
      if (t < 21 || (t & 3) !== 1)
        throw new O();
      this.bitMatrix = e;
    }
    return r.prototype.readFormatInformation = function() {
      if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== void 0)
        return this.parsedFormatInfo;
      for (var e = 0, t = 0; t < 6; t++)
        e = this.copyBit(t, 8, e);
      e = this.copyBit(7, 8, e), e = this.copyBit(8, 8, e), e = this.copyBit(8, 7, e);
      for (var n = 5; n >= 0; n--)
        e = this.copyBit(8, n, e);
      for (var i = this.bitMatrix.getHeight(), o = 0, a = i - 7, n = i - 1; n >= a; n--)
        o = this.copyBit(8, n, o);
      for (var t = i - 8; t < i; t++)
        o = this.copyBit(t, 8, o);
      if (this.parsedFormatInfo = wi.decodeFormatInformation(e, o), this.parsedFormatInfo !== null)
        return this.parsedFormatInfo;
      throw new O();
    }, r.prototype.readVersion = function() {
      if (this.parsedVersion !== null && this.parsedVersion !== void 0)
        return this.parsedVersion;
      var e = this.bitMatrix.getHeight(), t = Math.floor((e - 17) / 4);
      if (t <= 6)
        return ht.getVersionForNumber(t);
      for (var n = 0, i = e - 11, o = 5; o >= 0; o--)
        for (var a = e - 9; a >= i; a--)
          n = this.copyBit(a, o, n);
      var s = ht.decodeVersionInformation(n);
      if (s !== null && s.getDimensionForVersion() === e)
        return this.parsedVersion = s, s;
      n = 0;
      for (var a = 5; a >= 0; a--)
        for (var o = e - 9; o >= i; o--)
          n = this.copyBit(a, o, n);
      if (s = ht.decodeVersionInformation(n), s !== null && s.getDimensionForVersion() === e)
        return this.parsedVersion = s, s;
      throw new O();
    }, r.prototype.copyBit = function(e, t, n) {
      var i = this.isMirror ? this.bitMatrix.get(t, e) : this.bitMatrix.get(e, t);
      return i ? n << 1 | 1 : n << 1;
    }, r.prototype.readCodewords = function() {
      var e = this.readFormatInformation(), t = this.readVersion(), n = jn.values.get(e.getDataMask()), i = this.bitMatrix.getHeight();
      n.unmaskBitMatrix(this.bitMatrix, i);
      for (var o = t.buildFunctionPattern(), a = !0, s = new Uint8Array(t.getTotalCodewords()), f = 0, u = 0, c = 0, l = i - 1; l > 0; l -= 2) {
        l === 6 && l--;
        for (var d = 0; d < i; d++)
          for (var h = a ? i - 1 - d : d, p = 0; p < 2; p++)
            o.get(l - p, h) || (c++, u <<= 1, this.bitMatrix.get(l - p, h) && (u |= 1), c === 8 && (s[f++] = /*(byte) */
            u, c = 0, u = 0));
        a = !a;
      }
      if (f !== t.getTotalCodewords())
        throw new O();
      return s;
    }, r.prototype.remask = function() {
      if (this.parsedFormatInfo !== null) {
        var e = jn.values[this.parsedFormatInfo.getDataMask()], t = this.bitMatrix.getHeight();
        e.unmaskBitMatrix(this.bitMatrix, t);
      }
    }, r.prototype.setMirror = function(e) {
      this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = e;
    }, r.prototype.mirror = function() {
      for (var e = this.bitMatrix, t = 0, n = e.getWidth(); t < n; t++)
        for (var i = t + 1, o = e.getHeight(); i < o; i++)
          e.get(t, i) !== e.get(i, t) && (e.flip(i, t), e.flip(t, i));
    }, r;
  }()
), Wn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Xs = (
  /** @class */
  function() {
    function r(e, t) {
      this.numDataCodewords = e, this.codewords = t;
    }
    return r.getDataBlocks = function(e, t, n) {
      var i, o, a, s;
      if (e.length !== t.getTotalCodewords())
        throw new F();
      var f = t.getECBlocksForLevel(n), u = 0, c = f.getECBlocks();
      try {
        for (var l = Wn(c), d = l.next(); !d.done; d = l.next()) {
          var h = d.value;
          u += h.getCount();
        }
      } catch (H) {
        i = { error: H };
      } finally {
        try {
          d && !d.done && (o = l.return) && o.call(l);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var p = new Array(u), v = 0;
      try {
        for (var y = Wn(c), _ = y.next(); !_.done; _ = y.next())
          for (var h = _.value, x = 0; x < h.getCount(); x++) {
            var C = h.getDataCodewords(), E = f.getECCodewordsPerBlock() + C;
            p[v++] = new r(C, new Uint8Array(E));
          }
      } catch (H) {
        a = { error: H };
      } finally {
        try {
          _ && !_.done && (s = y.return) && s.call(y);
        } finally {
          if (a)
            throw a.error;
        }
      }
      for (var S = p[0].codewords.length, I = p.length - 1; I >= 0; ) {
        var T = p[I].codewords.length;
        if (T === S)
          break;
        I--;
      }
      I++;
      for (var R = S - f.getECCodewordsPerBlock(), B = 0, x = 0; x < R; x++)
        for (var M = 0; M < v; M++)
          p[M].codewords[x] = e[B++];
      for (var M = I; M < v; M++)
        p[M].codewords[R] = e[B++];
      for (var te = p[0].codewords.length, x = R; x < te; x++)
        for (var M = 0; M < v; M++) {
          var N = M < I ? x : x + 1;
          p[M].codewords[N] = e[B++];
        }
      return p;
    }, r.prototype.getNumDataCodewords = function() {
      return this.numDataCodewords;
    }, r.prototype.getCodewords = function() {
      return this.codewords;
    }, r;
  }()
), ke;
(function(r) {
  r[r.TERMINATOR = 0] = "TERMINATOR", r[r.NUMERIC = 1] = "NUMERIC", r[r.ALPHANUMERIC = 2] = "ALPHANUMERIC", r[r.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", r[r.BYTE = 4] = "BYTE", r[r.ECI = 5] = "ECI", r[r.KANJI = 6] = "KANJI", r[r.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", r[r.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", r[r.HANZI = 9] = "HANZI";
})(ke || (ke = {}));
var se = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.value = e, this.stringValue = t, this.characterCountBitsForVersions = n, this.bits = i, r.FOR_BITS.set(i, this), r.FOR_VALUE.set(e, this);
    }
    return r.forBits = function(e) {
      var t = r.FOR_BITS.get(e);
      if (t === void 0)
        throw new F();
      return t;
    }, r.prototype.getCharacterCountBits = function(e) {
      var t = e.getVersionNumber(), n;
      return t <= 9 ? n = 0 : t <= 26 ? n = 1 : n = 2, this.characterCountBitsForVersions[n];
    }, r.prototype.getValue = function() {
      return this.value;
    }, r.prototype.getBits = function() {
      return this.bits;
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      return this.value === t.value;
    }, r.prototype.toString = function() {
      return this.stringValue;
    }, r.FOR_BITS = /* @__PURE__ */ new Map(), r.FOR_VALUE = /* @__PURE__ */ new Map(), r.TERMINATOR = new r(ke.TERMINATOR, "TERMINATOR", Int32Array.from([0, 0, 0]), 0), r.NUMERIC = new r(ke.NUMERIC, "NUMERIC", Int32Array.from([10, 12, 14]), 1), r.ALPHANUMERIC = new r(ke.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([9, 11, 13]), 2), r.STRUCTURED_APPEND = new r(ke.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([0, 0, 0]), 3), r.BYTE = new r(ke.BYTE, "BYTE", Int32Array.from([8, 16, 16]), 4), r.ECI = new r(ke.ECI, "ECI", Int32Array.from([0, 0, 0]), 7), r.KANJI = new r(ke.KANJI, "KANJI", Int32Array.from([8, 10, 12]), 8), r.FNC1_FIRST_POSITION = new r(ke.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([0, 0, 0]), 5), r.FNC1_SECOND_POSITION = new r(ke.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([0, 0, 0]), 9), r.HANZI = new r(ke.HANZI, "HANZI", Int32Array.from([8, 10, 12]), 13), r;
  }()
), zs = (
  /** @class */
  function() {
    function r() {
    }
    return r.decode = function(e, t, n, i) {
      var o = new Ei(e), a = new V(), s = new Array(), f = -1, u = -1;
      try {
        var c = null, l = !1, d = void 0;
        do {
          if (o.available() < 4)
            d = se.TERMINATOR;
          else {
            var h = o.readBits(4);
            d = se.forBits(h);
          }
          switch (d) {
            case se.TERMINATOR:
              break;
            case se.FNC1_FIRST_POSITION:
            case se.FNC1_SECOND_POSITION:
              l = !0;
              break;
            case se.STRUCTURED_APPEND:
              if (o.available() < 16)
                throw new O();
              f = o.readBits(8), u = o.readBits(8);
              break;
            case se.ECI:
              var p = r.parseECIValue(o);
              if (c = ye.getCharacterSetECIByValue(p), c === null)
                throw new O();
              break;
            case se.HANZI:
              var v = o.readBits(4), y = o.readBits(d.getCharacterCountBits(t));
              v === r.GB2312_SUBSET && r.decodeHanziSegment(o, a, y);
              break;
            default:
              var _ = o.readBits(d.getCharacterCountBits(t));
              switch (d) {
                case se.NUMERIC:
                  r.decodeNumericSegment(o, a, _);
                  break;
                case se.ALPHANUMERIC:
                  r.decodeAlphanumericSegment(o, a, _, l);
                  break;
                case se.BYTE:
                  r.decodeByteSegment(o, a, _, c, s, i);
                  break;
                case se.KANJI:
                  r.decodeKanjiSegment(o, a, _);
                  break;
                default:
                  throw new O();
              }
              break;
          }
        } while (d !== se.TERMINATOR);
      } catch {
        throw new O();
      }
      return new pr(e, a.toString(), s.length === 0 ? null : s, n === null ? null : n.toString(), f, u);
    }, r.decodeHanziSegment = function(e, t, n) {
      if (n * 13 > e.available())
        throw new O();
      for (var i = new Uint8Array(2 * n), o = 0; n > 0; ) {
        var a = e.readBits(13), s = a / 96 << 8 & 4294967295 | a % 96;
        s < 959 ? s += 41377 : s += 42657, i[o] = /*(byte) */
        s >> 8 & 255, i[o + 1] = /*(byte) */
        s & 255, o += 2, n--;
      }
      try {
        t.append(Ve.decode(i, X.GB2312));
      } catch (f) {
        throw new O(f);
      }
    }, r.decodeKanjiSegment = function(e, t, n) {
      if (n * 13 > e.available())
        throw new O();
      for (var i = new Uint8Array(2 * n), o = 0; n > 0; ) {
        var a = e.readBits(13), s = a / 192 << 8 & 4294967295 | a % 192;
        s < 7936 ? s += 33088 : s += 49472, i[o] = /*(byte) */
        s >> 8, i[o + 1] = /*(byte) */
        s, o += 2, n--;
      }
      try {
        t.append(Ve.decode(i, X.SHIFT_JIS));
      } catch (f) {
        throw new O(f);
      }
    }, r.decodeByteSegment = function(e, t, n, i, o, a) {
      if (8 * n > e.available())
        throw new O();
      for (var s = new Uint8Array(n), f = 0; f < n; f++)
        s[f] = /*(byte) */
        e.readBits(8);
      var u;
      i === null ? u = X.guessEncoding(s, a) : u = i.getName();
      try {
        t.append(Ve.decode(s, u));
      } catch (c) {
        throw new O(c);
      }
      o.push(s);
    }, r.toAlphaNumericChar = function(e) {
      if (e >= r.ALPHANUMERIC_CHARS.length)
        throw new O();
      return r.ALPHANUMERIC_CHARS[e];
    }, r.decodeAlphanumericSegment = function(e, t, n, i) {
      for (var o = t.length(); n > 1; ) {
        if (e.available() < 11)
          throw new O();
        var a = e.readBits(11);
        t.append(r.toAlphaNumericChar(Math.floor(a / 45))), t.append(r.toAlphaNumericChar(a % 45)), n -= 2;
      }
      if (n === 1) {
        if (e.available() < 6)
          throw new O();
        t.append(r.toAlphaNumericChar(e.readBits(6)));
      }
      if (i)
        for (var s = o; s < t.length(); s++)
          t.charAt(s) === "%" && (s < t.length() - 1 && t.charAt(s + 1) === "%" ? t.deleteCharAt(s + 1) : t.setCharAt(s, ""));
    }, r.decodeNumericSegment = function(e, t, n) {
      for (; n >= 3; ) {
        if (e.available() < 10)
          throw new O();
        var i = e.readBits(10);
        if (i >= 1e3)
          throw new O();
        t.append(r.toAlphaNumericChar(Math.floor(i / 100))), t.append(r.toAlphaNumericChar(Math.floor(i / 10) % 10)), t.append(r.toAlphaNumericChar(i % 10)), n -= 3;
      }
      if (n === 2) {
        if (e.available() < 7)
          throw new O();
        var o = e.readBits(7);
        if (o >= 100)
          throw new O();
        t.append(r.toAlphaNumericChar(Math.floor(o / 10))), t.append(r.toAlphaNumericChar(o % 10));
      } else if (n === 1) {
        if (e.available() < 4)
          throw new O();
        var a = e.readBits(4);
        if (a >= 10)
          throw new O();
        t.append(r.toAlphaNumericChar(a));
      }
    }, r.parseECIValue = function(e) {
      var t = e.readBits(8);
      if (!(t & 128))
        return t & 127;
      if ((t & 192) === 128) {
        var n = e.readBits(8);
        return (t & 63) << 8 & 4294967295 | n;
      }
      if ((t & 224) === 192) {
        var i = e.readBits(16);
        return (t & 31) << 16 & 4294967295 | i;
      }
      throw new O();
    }, r.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", r.GB2312_SUBSET = 1, r;
  }()
), Si = (
  /** @class */
  function() {
    function r(e) {
      this.mirrored = e;
    }
    return r.prototype.isMirrored = function() {
      return this.mirrored;
    }, r.prototype.applyMirroredCorrection = function(e) {
      if (!(!this.mirrored || e === null || e.length < 3)) {
        var t = e[0];
        e[0] = e[2], e[2] = t;
      }
    }, r;
  }()
), Xn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ys = (
  /** @class */
  function() {
    function r() {
      this.rsDecoder = new vr(Be.QR_CODE_FIELD_256);
    }
    return r.prototype.decodeBooleanArray = function(e, t) {
      return this.decodeBitMatrix(Ye.parseFromBooleanArray(e), t);
    }, r.prototype.decodeBitMatrix = function(e, t) {
      var n = new Ws(e), i = null;
      try {
        return this.decodeBitMatrixParser(n, t);
      } catch (a) {
        i = a;
      }
      try {
        n.remask(), n.setMirror(!0), n.readVersion(), n.readFormatInformation(), n.mirror();
        var o = this.decodeBitMatrixParser(n, t);
        return o.setOther(new Si(!0)), o;
      } catch (a) {
        throw i !== null ? i : a;
      }
    }, r.prototype.decodeBitMatrixParser = function(e, t) {
      var n, i, o, a, s = e.readVersion(), f = e.readFormatInformation().getErrorCorrectionLevel(), u = e.readCodewords(), c = Xs.getDataBlocks(u, s, f), l = 0;
      try {
        for (var d = Xn(c), h = d.next(); !h.done; h = d.next()) {
          var p = h.value;
          l += p.getNumDataCodewords();
        }
      } catch (I) {
        n = { error: I };
      } finally {
        try {
          h && !h.done && (i = d.return) && i.call(d);
        } finally {
          if (n)
            throw n.error;
        }
      }
      var v = new Uint8Array(l), y = 0;
      try {
        for (var _ = Xn(c), x = _.next(); !x.done; x = _.next()) {
          var p = x.value, C = p.getCodewords(), E = p.getNumDataCodewords();
          this.correctErrors(C, E);
          for (var S = 0; S < E; S++)
            v[y++] = C[S];
        }
      } catch (I) {
        o = { error: I };
      } finally {
        try {
          x && !x.done && (a = _.return) && a.call(_);
        } finally {
          if (o)
            throw o.error;
        }
      }
      return zs.decode(v, s, f, t);
    }, r.prototype.correctErrors = function(e, t) {
      var n = new Int32Array(e);
      try {
        this.rsDecoder.decode(n, e.length - t);
      } catch {
        throw new pe();
      }
      for (var i = 0; i < t; i++)
        e[i] = /*(byte) */
        n[i];
    }, r;
  }()
), $s = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Zs = (
  /** @class */
  function(r) {
    $s(e, r);
    function e(t, n, i) {
      var o = r.call(this, t, n) || this;
      return o.estimatedModuleSize = i, o;
    }
    return e.prototype.aboutEquals = function(t, n, i) {
      if (Math.abs(n - this.getY()) <= t && Math.abs(i - this.getX()) <= t) {
        var o = Math.abs(t - this.estimatedModuleSize);
        return o <= 1 || o <= this.estimatedModuleSize;
      }
      return !1;
    }, e.prototype.combineEstimate = function(t, n, i) {
      var o = (this.getX() + n) / 2, a = (this.getY() + t) / 2, s = (this.estimatedModuleSize + i) / 2;
      return new e(o, a, s);
    }, e;
  }(P)
), Ks = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, qs = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a, s) {
      this.image = e, this.startX = t, this.startY = n, this.width = i, this.height = o, this.moduleSize = a, this.resultPointCallback = s, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return r.prototype.find = function() {
      for (var e = this.startX, t = this.height, n = this.width, i = e + n, o = this.startY + t / 2, a = new Int32Array(3), s = this.image, f = 0; f < t; f++) {
        var u = o + (f & 1 ? -Math.floor((f + 1) / 2) : Math.floor((f + 1) / 2));
        a[0] = 0, a[1] = 0, a[2] = 0;
        for (var c = e; c < i && !s.get(c, u); )
          c++;
        for (var l = 0; c < i; ) {
          if (s.get(c, u))
            if (l === 1)
              a[1]++;
            else if (l === 2) {
              if (this.foundPatternCross(a)) {
                var d = this.handlePossibleCenter(a, u, c);
                if (d !== null)
                  return d;
              }
              a[0] = a[2], a[1] = 1, a[2] = 0, l = 1;
            } else
              a[++l]++;
          else
            l === 1 && l++, a[l]++;
          c++;
        }
        if (this.foundPatternCross(a)) {
          var d = this.handlePossibleCenter(a, u, i);
          if (d !== null)
            return d;
        }
      }
      if (this.possibleCenters.length !== 0)
        return this.possibleCenters[0];
      throw new w();
    }, r.centerFromEnd = function(e, t) {
      return t - e[2] - e[1] / 2;
    }, r.prototype.foundPatternCross = function(e) {
      for (var t = this.moduleSize, n = t / 2, i = 0; i < 3; i++)
        if (Math.abs(t - e[i]) >= n)
          return !1;
      return !0;
    }, r.prototype.crossCheckVertical = function(e, t, n, i) {
      var o = this.image, a = o.getHeight(), s = this.crossCheckStateCount;
      s[0] = 0, s[1] = 0, s[2] = 0;
      for (var f = e; f >= 0 && o.get(t, f) && s[1] <= n; )
        s[1]++, f--;
      if (f < 0 || s[1] > n)
        return NaN;
      for (; f >= 0 && !o.get(t, f) && s[0] <= n; )
        s[0]++, f--;
      if (s[0] > n)
        return NaN;
      for (f = e + 1; f < a && o.get(t, f) && s[1] <= n; )
        s[1]++, f++;
      if (f === a || s[1] > n)
        return NaN;
      for (; f < a && !o.get(t, f) && s[2] <= n; )
        s[2]++, f++;
      if (s[2] > n)
        return NaN;
      var u = s[0] + s[1] + s[2];
      return 5 * Math.abs(u - i) >= 2 * i ? NaN : this.foundPatternCross(s) ? r.centerFromEnd(s, f) : NaN;
    }, r.prototype.handlePossibleCenter = function(e, t, n) {
      var i, o, a = e[0] + e[1] + e[2], s = r.centerFromEnd(e, n), f = this.crossCheckVertical(
        t,
        /*(int) */
        s,
        2 * e[1],
        a
      );
      if (!isNaN(f)) {
        var u = (e[0] + e[1] + e[2]) / 3;
        try {
          for (var c = Ks(this.possibleCenters), l = c.next(); !l.done; l = c.next()) {
            var d = l.value;
            if (d.aboutEquals(u, f, s))
              return d.combineEstimate(f, s, u);
          }
        } catch (p) {
          i = { error: p };
        } finally {
          try {
            l && !l.done && (o = c.return) && o.call(c);
          } finally {
            if (i)
              throw i.error;
          }
        }
        var h = new Zs(s, f, u);
        this.possibleCenters.push(h), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(h);
      }
      return null;
    }, r;
  }()
), Qs = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Js = (
  /** @class */
  function(r) {
    Qs(e, r);
    function e(t, n, i, o) {
      var a = r.call(this, t, n) || this;
      return a.estimatedModuleSize = i, a.count = o, o === void 0 && (a.count = 1), a;
    }
    return e.prototype.getEstimatedModuleSize = function() {
      return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
      return this.count;
    }, e.prototype.aboutEquals = function(t, n, i) {
      if (Math.abs(n - this.getY()) <= t && Math.abs(i - this.getX()) <= t) {
        var o = Math.abs(t - this.estimatedModuleSize);
        return o <= 1 || o <= this.estimatedModuleSize;
      }
      return !1;
    }, e.prototype.combineEstimate = function(t, n, i) {
      var o = this.count + 1, a = (this.count * this.getX() + n) / o, s = (this.count * this.getY() + t) / o, f = (this.count * this.estimatedModuleSize + i) / o;
      return new e(a, s, f, o);
    }, e;
  }(P)
), ef = (
  /** @class */
  function() {
    function r(e) {
      this.bottomLeft = e[0], this.topLeft = e[1], this.topRight = e[2];
    }
    return r.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, r.prototype.getTopLeft = function() {
      return this.topLeft;
    }, r.prototype.getTopRight = function() {
      return this.topRight;
    }, r;
  }()
), Dt = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, tf = (
  /** @class */
  function() {
    function r(e, t) {
      this.image = e, this.resultPointCallback = t, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = t;
    }
    return r.prototype.getImage = function() {
      return this.image;
    }, r.prototype.getPossibleCenters = function() {
      return this.possibleCenters;
    }, r.prototype.find = function(e) {
      var t = e != null && e.get(fe.TRY_HARDER) !== void 0, n = e != null && e.get(fe.PURE_BARCODE) !== void 0, i = this.image, o = i.getHeight(), a = i.getWidth(), s = Math.floor(3 * o / (4 * r.MAX_MODULES));
      (s < r.MIN_SKIP || t) && (s = r.MIN_SKIP);
      for (var f = !1, u = new Int32Array(5), c = s - 1; c < o && !f; c += s) {
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0;
        for (var l = 0, d = 0; d < a; d++)
          if (i.get(d, c))
            (l & 1) === 1 && l++, u[l]++;
          else if (l & 1)
            u[l]++;
          else if (l === 4)
            if (r.foundPatternCross(u)) {
              var h = this.handlePossibleCenter(u, c, d, n);
              if (h === !0)
                if (s = 2, this.hasSkipped === !0)
                  f = this.haveMultiplyConfirmedCenters();
                else {
                  var p = this.findRowSkip();
                  p > u[2] && (c += p - u[2] - s, d = a - 1);
                }
              else {
                u[0] = u[2], u[1] = u[3], u[2] = u[4], u[3] = 1, u[4] = 0, l = 3;
                continue;
              }
              l = 0, u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0;
            } else
              u[0] = u[2], u[1] = u[3], u[2] = u[4], u[3] = 1, u[4] = 0, l = 3;
          else
            u[++l]++;
        if (r.foundPatternCross(u)) {
          var h = this.handlePossibleCenter(u, c, a, n);
          h === !0 && (s = u[0], this.hasSkipped && (f = this.haveMultiplyConfirmedCenters()));
        }
      }
      var v = this.selectBestPatterns();
      return P.orderBestPatterns(v), new ef(v);
    }, r.centerFromEnd = function(e, t) {
      return t - e[4] - e[3] - e[2] / 2;
    }, r.foundPatternCross = function(e) {
      for (var t = 0, n = 0; n < 5; n++) {
        var i = e[n];
        if (i === 0)
          return !1;
        t += i;
      }
      if (t < 7)
        return !1;
      var o = t / 7, a = o / 2;
      return Math.abs(o - e[0]) < a && Math.abs(o - e[1]) < a && Math.abs(3 * o - e[2]) < 3 * a && Math.abs(o - e[3]) < a && Math.abs(o - e[4]) < a;
    }, r.prototype.getCrossCheckStateCount = function() {
      var e = this.crossCheckStateCount;
      return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e;
    }, r.prototype.crossCheckDiagonal = function(e, t, n, i) {
      for (var o = this.getCrossCheckStateCount(), a = 0, s = this.image; e >= a && t >= a && s.get(t - a, e - a); )
        o[2]++, a++;
      if (e < a || t < a)
        return !1;
      for (; e >= a && t >= a && !s.get(t - a, e - a) && o[1] <= n; )
        o[1]++, a++;
      if (e < a || t < a || o[1] > n)
        return !1;
      for (; e >= a && t >= a && s.get(t - a, e - a) && o[0] <= n; )
        o[0]++, a++;
      if (o[0] > n)
        return !1;
      var f = s.getHeight(), u = s.getWidth();
      for (a = 1; e + a < f && t + a < u && s.get(t + a, e + a); )
        o[2]++, a++;
      if (e + a >= f || t + a >= u)
        return !1;
      for (; e + a < f && t + a < u && !s.get(t + a, e + a) && o[3] < n; )
        o[3]++, a++;
      if (e + a >= f || t + a >= u || o[3] >= n)
        return !1;
      for (; e + a < f && t + a < u && s.get(t + a, e + a) && o[4] < n; )
        o[4]++, a++;
      if (o[4] >= n)
        return !1;
      var c = o[0] + o[1] + o[2] + o[3] + o[4];
      return Math.abs(c - i) < 2 * i && r.foundPatternCross(o);
    }, r.prototype.crossCheckVertical = function(e, t, n, i) {
      for (var o = this.image, a = o.getHeight(), s = this.getCrossCheckStateCount(), f = e; f >= 0 && o.get(t, f); )
        s[2]++, f--;
      if (f < 0)
        return NaN;
      for (; f >= 0 && !o.get(t, f) && s[1] <= n; )
        s[1]++, f--;
      if (f < 0 || s[1] > n)
        return NaN;
      for (; f >= 0 && o.get(t, f) && s[0] <= n; )
        s[0]++, f--;
      if (s[0] > n)
        return NaN;
      for (f = e + 1; f < a && o.get(t, f); )
        s[2]++, f++;
      if (f === a)
        return NaN;
      for (; f < a && !o.get(t, f) && s[3] < n; )
        s[3]++, f++;
      if (f === a || s[3] >= n)
        return NaN;
      for (; f < a && o.get(t, f) && s[4] < n; )
        s[4]++, f++;
      if (s[4] >= n)
        return NaN;
      var u = s[0] + s[1] + s[2] + s[3] + s[4];
      return 5 * Math.abs(u - i) >= 2 * i ? NaN : r.foundPatternCross(s) ? r.centerFromEnd(s, f) : NaN;
    }, r.prototype.crossCheckHorizontal = function(e, t, n, i) {
      for (var o = this.image, a = o.getWidth(), s = this.getCrossCheckStateCount(), f = e; f >= 0 && o.get(f, t); )
        s[2]++, f--;
      if (f < 0)
        return NaN;
      for (; f >= 0 && !o.get(f, t) && s[1] <= n; )
        s[1]++, f--;
      if (f < 0 || s[1] > n)
        return NaN;
      for (; f >= 0 && o.get(f, t) && s[0] <= n; )
        s[0]++, f--;
      if (s[0] > n)
        return NaN;
      for (f = e + 1; f < a && o.get(f, t); )
        s[2]++, f++;
      if (f === a)
        return NaN;
      for (; f < a && !o.get(f, t) && s[3] < n; )
        s[3]++, f++;
      if (f === a || s[3] >= n)
        return NaN;
      for (; f < a && o.get(f, t) && s[4] < n; )
        s[4]++, f++;
      if (s[4] >= n)
        return NaN;
      var u = s[0] + s[1] + s[2] + s[3] + s[4];
      return 5 * Math.abs(u - i) >= i ? NaN : r.foundPatternCross(s) ? r.centerFromEnd(s, f) : NaN;
    }, r.prototype.handlePossibleCenter = function(e, t, n, i) {
      var o = e[0] + e[1] + e[2] + e[3] + e[4], a = r.centerFromEnd(e, n), s = this.crossCheckVertical(
        t,
        /*(int) */
        Math.floor(a),
        e[2],
        o
      );
      if (!isNaN(s) && (a = this.crossCheckHorizontal(
        /*(int) */
        Math.floor(a),
        /*(int) */
        Math.floor(s),
        e[2],
        o
      ), !isNaN(a) && (!i || this.crossCheckDiagonal(
        /*(int) */
        Math.floor(s),
        /*(int) */
        Math.floor(a),
        e[2],
        o
      )))) {
        for (var f = o / 7, u = !1, c = this.possibleCenters, l = 0, d = c.length; l < d; l++) {
          var h = c[l];
          if (h.aboutEquals(f, s, a)) {
            c[l] = h.combineEstimate(s, a, f), u = !0;
            break;
          }
        }
        if (!u) {
          var p = new Js(a, s, f);
          c.push(p), this.resultPointCallback !== null && this.resultPointCallback !== void 0 && this.resultPointCallback.foundPossibleResultPoint(p);
        }
        return !0;
      }
      return !1;
    }, r.prototype.findRowSkip = function() {
      var e, t, n = this.possibleCenters.length;
      if (n <= 1)
        return 0;
      var i = null;
      try {
        for (var o = Dt(this.possibleCenters), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          if (s.getCount() >= r.CENTER_QUORUM)
            if (i == null)
              i = s;
            else
              return this.hasSkipped = !0, /*(int) */
              Math.floor((Math.abs(i.getX() - s.getX()) - Math.abs(i.getY() - s.getY())) / 2);
        }
      } catch (f) {
        e = { error: f };
      } finally {
        try {
          a && !a.done && (t = o.return) && t.call(o);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return 0;
    }, r.prototype.haveMultiplyConfirmedCenters = function() {
      var e, t, n, i, o = 0, a = 0, s = this.possibleCenters.length;
      try {
        for (var f = Dt(this.possibleCenters), u = f.next(); !u.done; u = f.next()) {
          var c = u.value;
          c.getCount() >= r.CENTER_QUORUM && (o++, a += c.getEstimatedModuleSize());
        }
      } catch (v) {
        e = { error: v };
      } finally {
        try {
          u && !u.done && (t = f.return) && t.call(f);
        } finally {
          if (e)
            throw e.error;
        }
      }
      if (o < 3)
        return !1;
      var l = a / s, d = 0;
      try {
        for (var h = Dt(this.possibleCenters), p = h.next(); !p.done; p = h.next()) {
          var c = p.value;
          d += Math.abs(c.getEstimatedModuleSize() - l);
        }
      } catch (v) {
        n = { error: v };
      } finally {
        try {
          p && !p.done && (i = h.return) && i.call(h);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return d <= 0.05 * a;
    }, r.prototype.selectBestPatterns = function() {
      var e, t, n, i, o = this.possibleCenters.length;
      if (o < 3)
        throw new w();
      var a = this.possibleCenters, s;
      if (o > 3) {
        var f = 0, u = 0;
        try {
          for (var c = Dt(this.possibleCenters), l = c.next(); !l.done; l = c.next()) {
            var d = l.value, h = d.getEstimatedModuleSize();
            f += h, u += h * h;
          }
        } catch (S) {
          e = { error: S };
        } finally {
          try {
            l && !l.done && (t = c.return) && t.call(c);
          } finally {
            if (e)
              throw e.error;
          }
        }
        s = f / o;
        var p = Math.sqrt(u / o - s * s);
        a.sort(
          /**
           * <p>Orders by furthest from average</p>
           */
          // FurthestFromAverageComparator implements Comparator<FinderPattern>
          function(S, I) {
            var T = Math.abs(I.getEstimatedModuleSize() - s), R = Math.abs(S.getEstimatedModuleSize() - s);
            return T < R ? -1 : T > R ? 1 : 0;
          }
        );
        for (var v = Math.max(0.2 * s, p), y = 0; y < a.length && a.length > 3; y++) {
          var _ = a[y];
          Math.abs(_.getEstimatedModuleSize() - s) > v && (a.splice(y, 1), y--);
        }
      }
      if (a.length > 3) {
        var f = 0;
        try {
          for (var x = Dt(a), C = x.next(); !C.done; C = x.next()) {
            var E = C.value;
            f += E.getEstimatedModuleSize();
          }
        } catch (I) {
          n = { error: I };
        } finally {
          try {
            C && !C.done && (i = x.return) && i.call(x);
          } finally {
            if (n)
              throw n.error;
          }
        }
        s = f / a.length, a.sort(
          /**
           * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
           */
          // CenterComparator implements Comparator<FinderPattern>
          function(I, T) {
            if (T.getCount() === I.getCount()) {
              var R = Math.abs(T.getEstimatedModuleSize() - s), B = Math.abs(I.getEstimatedModuleSize() - s);
              return R < B ? 1 : R > B ? -1 : 0;
            } else
              return T.getCount() - I.getCount();
          }
        ), a.splice(3);
      }
      return [
        a[0],
        a[1],
        a[2]
      ];
    }, r.CENTER_QUORUM = 2, r.MIN_SKIP = 3, r.MAX_MODULES = 57, r;
  }()
), rf = (
  /** @class */
  function() {
    function r(e) {
      this.image = e;
    }
    return r.prototype.getImage = function() {
      return this.image;
    }, r.prototype.getResultPointCallback = function() {
      return this.resultPointCallback;
    }, r.prototype.detect = function(e) {
      this.resultPointCallback = e == null ? null : (
        /*(ResultPointCallback) */
        e.get(fe.NEED_RESULT_POINT_CALLBACK)
      );
      var t = new tf(this.image, this.resultPointCallback), n = t.find(e);
      return this.processFinderPatternInfo(n);
    }, r.prototype.processFinderPatternInfo = function(e) {
      var t = e.getTopLeft(), n = e.getTopRight(), i = e.getBottomLeft(), o = this.calculateModuleSize(t, n, i);
      if (o < 1)
        throw new w("No pattern found in proccess finder.");
      var a = r.computeDimension(t, n, i, o), s = ht.getProvisionalVersionForDimension(a), f = s.getDimensionForVersion() - 7, u = null;
      if (s.getAlignmentPatternCenters().length > 0)
        for (var c = n.getX() - t.getX() + i.getX(), l = n.getY() - t.getY() + i.getY(), d = 1 - 3 / f, h = (
          /*(int) */
          Math.floor(t.getX() + d * (c - t.getX()))
        ), p = (
          /*(int) */
          Math.floor(t.getY() + d * (l - t.getY()))
        ), v = 4; v <= 16; v <<= 1)
          try {
            u = this.findAlignmentInRegion(o, h, p, v);
            break;
          } catch (C) {
            if (!(C instanceof w))
              throw C;
          }
      var y = r.createTransform(t, n, i, u, a), _ = r.sampleGrid(this.image, y, a), x;
      return u === null ? x = [i, t, n] : x = [i, t, n, u], new Jr(_, x);
    }, r.createTransform = function(e, t, n, i, o) {
      var a = o - 3.5, s, f, u, c;
      return i !== null ? (s = i.getX(), f = i.getY(), u = a - 3, c = u) : (s = t.getX() - e.getX() + n.getX(), f = t.getY() - e.getY() + n.getY(), u = a, c = a), mi.quadrilateralToQuadrilateral(3.5, 3.5, a, 3.5, u, c, 3.5, a, e.getX(), e.getY(), t.getX(), t.getY(), s, f, n.getX(), n.getY());
    }, r.sampleGrid = function(e, t, n) {
      var i = en.getInstance();
      return i.sampleGridWithTransform(e, n, n, t);
    }, r.computeDimension = function(e, t, n, i) {
      var o = Y.round(P.distance(e, t) / i), a = Y.round(P.distance(e, n) / i), s = Math.floor((o + a) / 2) + 7;
      switch (s & 3) {
        case 0:
          s++;
          break;
        case 2:
          s--;
          break;
        case 3:
          throw new w("Dimensions could be not found.");
      }
      return s;
    }, r.prototype.calculateModuleSize = function(e, t, n) {
      return (this.calculateModuleSizeOneWay(e, t) + this.calculateModuleSizeOneWay(e, n)) / 2;
    }, r.prototype.calculateModuleSizeOneWay = function(e, t) {
      var n = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(e.getX()),
        /*(int) */
        Math.floor(e.getY()),
        /*(int) */
        Math.floor(t.getX()),
        /*(int) */
        Math.floor(t.getY())
      ), i = this.sizeOfBlackWhiteBlackRunBothWays(
        /*(int) */
        Math.floor(t.getX()),
        /*(int) */
        Math.floor(t.getY()),
        /*(int) */
        Math.floor(e.getX()),
        /*(int) */
        Math.floor(e.getY())
      );
      return isNaN(n) ? i / 7 : isNaN(i) ? n / 7 : (n + i) / 14;
    }, r.prototype.sizeOfBlackWhiteBlackRunBothWays = function(e, t, n, i) {
      var o = this.sizeOfBlackWhiteBlackRun(e, t, n, i), a = 1, s = e - (n - e);
      s < 0 ? (a = e / /*(float) */
      (e - s), s = 0) : s >= this.image.getWidth() && (a = (this.image.getWidth() - 1 - e) / /*(float) */
      (s - e), s = this.image.getWidth() - 1);
      var f = (
        /*(int) */
        Math.floor(t - (i - t) * a)
      );
      return a = 1, f < 0 ? (a = t / /*(float) */
      (t - f), f = 0) : f >= this.image.getHeight() && (a = (this.image.getHeight() - 1 - t) / /*(float) */
      (f - t), f = this.image.getHeight() - 1), s = /*(int) */
      Math.floor(e + (s - e) * a), o += this.sizeOfBlackWhiteBlackRun(e, t, s, f), o - 1;
    }, r.prototype.sizeOfBlackWhiteBlackRun = function(e, t, n, i) {
      var o = Math.abs(i - t) > Math.abs(n - e);
      if (o) {
        var a = e;
        e = t, t = a, a = n, n = i, i = a;
      }
      for (var s = Math.abs(n - e), f = Math.abs(i - t), u = -s / 2, c = e < n ? 1 : -1, l = t < i ? 1 : -1, d = 0, h = n + c, p = e, v = t; p !== h; p += c) {
        var y = o ? v : p, _ = o ? p : v;
        if (d === 1 === this.image.get(y, _)) {
          if (d === 2)
            return Y.distance(p, v, e, t);
          d++;
        }
        if (u += f, u > 0) {
          if (v === i)
            break;
          v += l, u -= s;
        }
      }
      return d === 2 ? Y.distance(n + c, i, e, t) : NaN;
    }, r.prototype.findAlignmentInRegion = function(e, t, n, i) {
      var o = (
        /*(int) */
        Math.floor(i * e)
      ), a = Math.max(0, t - o), s = Math.min(this.image.getWidth() - 1, t + o);
      if (s - a < e * 3)
        throw new w("Alignment top exceeds estimated module size.");
      var f = Math.max(0, n - o), u = Math.min(this.image.getHeight() - 1, n + o);
      if (u - f < e * 3)
        throw new w("Alignment bottom exceeds estimated module size.");
      var c = new qs(this.image, a, f, s - a, u - f, e, this.resultPointCallback);
      return c.find();
    }, r;
  }()
), cr = (
  /** @class */
  function() {
    function r() {
      this.decoder = new Ys();
    }
    return r.prototype.getDecoder = function() {
      return this.decoder;
    }, r.prototype.decode = function(e, t) {
      var n, i;
      if (t != null && t.get(fe.PURE_BARCODE) !== void 0) {
        var o = r.extractPureBits(e.getBlackMatrix());
        n = this.decoder.decodeBitMatrix(o, t), i = r.NO_POINTS;
      } else {
        var a = new rf(e.getBlackMatrix()).detect(t);
        n = this.decoder.decodeBitMatrix(a.getBits(), t), i = a.getPoints();
      }
      n.getOther() instanceof Si && n.getOther().applyMirroredCorrection(i);
      var s = new Oe(n.getText(), n.getRawBytes(), void 0, i, L.QR_CODE, void 0), f = n.getByteSegments();
      f !== null && s.putMetadata(be.BYTE_SEGMENTS, f);
      var u = n.getECLevel();
      return u !== null && s.putMetadata(be.ERROR_CORRECTION_LEVEL, u), n.hasStructuredAppend() && (s.putMetadata(be.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), s.putMetadata(be.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), s;
    }, r.prototype.reset = function() {
    }, r.extractPureBits = function(e) {
      var t = e.getTopLeftOnBit(), n = e.getBottomRightOnBit();
      if (t === null || n === null)
        throw new w();
      var i = this.moduleSize(t, e), o = t[1], a = n[1], s = t[0], f = n[0];
      if (s >= f || o >= a)
        throw new w();
      if (a - o !== f - s && (f = s + (a - o), f >= e.getWidth()))
        throw new w();
      var u = Math.round((f - s + 1) / i), c = Math.round((a - o + 1) / i);
      if (u <= 0 || c <= 0)
        throw new w();
      if (c !== u)
        throw new w();
      var l = (
        /*(int) */
        Math.floor(i / 2)
      );
      o += l, s += l;
      var d = s + /*(int) */
      Math.floor((u - 1) * i) - f;
      if (d > 0) {
        if (d > l)
          throw new w();
        s -= d;
      }
      var h = o + /*(int) */
      Math.floor((c - 1) * i) - a;
      if (h > 0) {
        if (h > l)
          throw new w();
        o -= h;
      }
      for (var p = new Ye(u, c), v = 0; v < c; v++)
        for (var y = o + /*(int) */
        Math.floor(v * i), _ = 0; _ < u; _++)
          e.get(s + /*(int) */
          Math.floor(_ * i), y) && p.set(_, v);
      return p;
    }, r.moduleSize = function(e, t) {
      for (var n = t.getHeight(), i = t.getWidth(), o = e[0], a = e[1], s = !0, f = 0; o < i && a < n; ) {
        if (s !== t.get(o, a)) {
          if (++f === 5)
            break;
          s = !s;
        }
        o++, a++;
      }
      if (o === i || a === n)
        throw new w();
      return (o - e[0]) / 7;
    }, r.NO_POINTS = new Array(), r;
  }()
), nf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, z = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.PDF417Common = function() {
    }, r.getBitCountSum = function(e) {
      return Y.sum(e);
    }, r.toIntArray = function(e) {
      var t, n;
      if (e == null || !e.length)
        return r.EMPTY_INT_ARRAY;
      var i = new Int32Array(e.length), o = 0;
      try {
        for (var a = nf(e), s = a.next(); !s.done; s = a.next()) {
          var f = s.value;
          i[o++] = f;
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          s && !s.done && (n = a.return) && n.call(a);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return i;
    }, r.getCodeword = function(e) {
      var t = me.binarySearch(r.SYMBOL_TABLE, e & 262143);
      return t < 0 ? -1 : (r.CODEWORD_TABLE[t] - 1) % r.NUMBER_OF_CODEWORDS;
    }, r.NUMBER_OF_CODEWORDS = 929, r.MAX_CODEWORDS_IN_BARCODE = r.NUMBER_OF_CODEWORDS - 1, r.MIN_ROWS_IN_BARCODE = 3, r.MAX_ROWS_IN_BARCODE = 90, r.MODULES_IN_CODEWORD = 17, r.MODULES_IN_STOP_PATTERN = 18, r.BARS_IN_MODULE = 8, r.EMPTY_INT_ARRAY = new Int32Array([]), r.SYMBOL_TABLE = Int32Array.from([
      66142,
      66170,
      66206,
      66236,
      66290,
      66292,
      66350,
      66382,
      66396,
      66454,
      66470,
      66476,
      66594,
      66600,
      66614,
      66626,
      66628,
      66632,
      66640,
      66654,
      66662,
      66668,
      66682,
      66690,
      66718,
      66720,
      66748,
      66758,
      66776,
      66798,
      66802,
      66804,
      66820,
      66824,
      66832,
      66846,
      66848,
      66876,
      66880,
      66936,
      66950,
      66956,
      66968,
      66992,
      67006,
      67022,
      67036,
      67042,
      67044,
      67048,
      67062,
      67118,
      67150,
      67164,
      67214,
      67228,
      67256,
      67294,
      67322,
      67350,
      67366,
      67372,
      67398,
      67404,
      67416,
      67438,
      67474,
      67476,
      67490,
      67492,
      67496,
      67510,
      67618,
      67624,
      67650,
      67656,
      67664,
      67678,
      67686,
      67692,
      67706,
      67714,
      67716,
      67728,
      67742,
      67744,
      67772,
      67782,
      67788,
      67800,
      67822,
      67826,
      67828,
      67842,
      67848,
      67870,
      67872,
      67900,
      67904,
      67960,
      67974,
      67992,
      68016,
      68030,
      68046,
      68060,
      68066,
      68068,
      68072,
      68086,
      68104,
      68112,
      68126,
      68128,
      68156,
      68160,
      68216,
      68336,
      68358,
      68364,
      68376,
      68400,
      68414,
      68448,
      68476,
      68494,
      68508,
      68536,
      68546,
      68548,
      68552,
      68560,
      68574,
      68582,
      68588,
      68654,
      68686,
      68700,
      68706,
      68708,
      68712,
      68726,
      68750,
      68764,
      68792,
      68802,
      68804,
      68808,
      68816,
      68830,
      68838,
      68844,
      68858,
      68878,
      68892,
      68920,
      68976,
      68990,
      68994,
      68996,
      69e3,
      69008,
      69022,
      69024,
      69052,
      69062,
      69068,
      69080,
      69102,
      69106,
      69108,
      69142,
      69158,
      69164,
      69190,
      69208,
      69230,
      69254,
      69260,
      69272,
      69296,
      69310,
      69326,
      69340,
      69386,
      69394,
      69396,
      69410,
      69416,
      69430,
      69442,
      69444,
      69448,
      69456,
      69470,
      69478,
      69484,
      69554,
      69556,
      69666,
      69672,
      69698,
      69704,
      69712,
      69726,
      69754,
      69762,
      69764,
      69776,
      69790,
      69792,
      69820,
      69830,
      69836,
      69848,
      69870,
      69874,
      69876,
      69890,
      69918,
      69920,
      69948,
      69952,
      70008,
      70022,
      70040,
      70064,
      70078,
      70094,
      70108,
      70114,
      70116,
      70120,
      70134,
      70152,
      70174,
      70176,
      70264,
      70384,
      70412,
      70448,
      70462,
      70496,
      70524,
      70542,
      70556,
      70584,
      70594,
      70600,
      70608,
      70622,
      70630,
      70636,
      70664,
      70672,
      70686,
      70688,
      70716,
      70720,
      70776,
      70896,
      71136,
      71180,
      71192,
      71216,
      71230,
      71264,
      71292,
      71360,
      71416,
      71452,
      71480,
      71536,
      71550,
      71554,
      71556,
      71560,
      71568,
      71582,
      71584,
      71612,
      71622,
      71628,
      71640,
      71662,
      71726,
      71732,
      71758,
      71772,
      71778,
      71780,
      71784,
      71798,
      71822,
      71836,
      71864,
      71874,
      71880,
      71888,
      71902,
      71910,
      71916,
      71930,
      71950,
      71964,
      71992,
      72048,
      72062,
      72066,
      72068,
      72080,
      72094,
      72096,
      72124,
      72134,
      72140,
      72152,
      72174,
      72178,
      72180,
      72206,
      72220,
      72248,
      72304,
      72318,
      72416,
      72444,
      72456,
      72464,
      72478,
      72480,
      72508,
      72512,
      72568,
      72588,
      72600,
      72624,
      72638,
      72654,
      72668,
      72674,
      72676,
      72680,
      72694,
      72726,
      72742,
      72748,
      72774,
      72780,
      72792,
      72814,
      72838,
      72856,
      72880,
      72894,
      72910,
      72924,
      72930,
      72932,
      72936,
      72950,
      72966,
      72972,
      72984,
      73008,
      73022,
      73056,
      73084,
      73102,
      73116,
      73144,
      73156,
      73160,
      73168,
      73182,
      73190,
      73196,
      73210,
      73226,
      73234,
      73236,
      73250,
      73252,
      73256,
      73270,
      73282,
      73284,
      73296,
      73310,
      73318,
      73324,
      73346,
      73348,
      73352,
      73360,
      73374,
      73376,
      73404,
      73414,
      73420,
      73432,
      73454,
      73498,
      73518,
      73522,
      73524,
      73550,
      73564,
      73570,
      73572,
      73576,
      73590,
      73800,
      73822,
      73858,
      73860,
      73872,
      73886,
      73888,
      73916,
      73944,
      73970,
      73972,
      73992,
      74014,
      74016,
      74044,
      74048,
      74104,
      74118,
      74136,
      74160,
      74174,
      74210,
      74212,
      74216,
      74230,
      74244,
      74256,
      74270,
      74272,
      74360,
      74480,
      74502,
      74508,
      74544,
      74558,
      74592,
      74620,
      74638,
      74652,
      74680,
      74690,
      74696,
      74704,
      74726,
      74732,
      74782,
      74784,
      74812,
      74992,
      75232,
      75288,
      75326,
      75360,
      75388,
      75456,
      75512,
      75576,
      75632,
      75646,
      75650,
      75652,
      75664,
      75678,
      75680,
      75708,
      75718,
      75724,
      75736,
      75758,
      75808,
      75836,
      75840,
      75896,
      76016,
      76256,
      76736,
      76824,
      76848,
      76862,
      76896,
      76924,
      76992,
      77048,
      77296,
      77340,
      77368,
      77424,
      77438,
      77536,
      77564,
      77572,
      77576,
      77584,
      77600,
      77628,
      77632,
      77688,
      77702,
      77708,
      77720,
      77744,
      77758,
      77774,
      77788,
      77870,
      77902,
      77916,
      77922,
      77928,
      77966,
      77980,
      78008,
      78018,
      78024,
      78032,
      78046,
      78060,
      78074,
      78094,
      78136,
      78192,
      78206,
      78210,
      78212,
      78224,
      78238,
      78240,
      78268,
      78278,
      78284,
      78296,
      78322,
      78324,
      78350,
      78364,
      78448,
      78462,
      78560,
      78588,
      78600,
      78622,
      78624,
      78652,
      78656,
      78712,
      78726,
      78744,
      78768,
      78782,
      78798,
      78812,
      78818,
      78820,
      78824,
      78838,
      78862,
      78876,
      78904,
      78960,
      78974,
      79072,
      79100,
      79296,
      79352,
      79368,
      79376,
      79390,
      79392,
      79420,
      79424,
      79480,
      79600,
      79628,
      79640,
      79664,
      79678,
      79712,
      79740,
      79772,
      79800,
      79810,
      79812,
      79816,
      79824,
      79838,
      79846,
      79852,
      79894,
      79910,
      79916,
      79942,
      79948,
      79960,
      79982,
      79988,
      80006,
      80024,
      80048,
      80062,
      80078,
      80092,
      80098,
      80100,
      80104,
      80134,
      80140,
      80176,
      80190,
      80224,
      80252,
      80270,
      80284,
      80312,
      80328,
      80336,
      80350,
      80358,
      80364,
      80378,
      80390,
      80396,
      80408,
      80432,
      80446,
      80480,
      80508,
      80576,
      80632,
      80654,
      80668,
      80696,
      80752,
      80766,
      80776,
      80784,
      80798,
      80800,
      80828,
      80844,
      80856,
      80878,
      80882,
      80884,
      80914,
      80916,
      80930,
      80932,
      80936,
      80950,
      80962,
      80968,
      80976,
      80990,
      80998,
      81004,
      81026,
      81028,
      81040,
      81054,
      81056,
      81084,
      81094,
      81100,
      81112,
      81134,
      81154,
      81156,
      81160,
      81168,
      81182,
      81184,
      81212,
      81216,
      81272,
      81286,
      81292,
      81304,
      81328,
      81342,
      81358,
      81372,
      81380,
      81384,
      81398,
      81434,
      81454,
      81458,
      81460,
      81486,
      81500,
      81506,
      81508,
      81512,
      81526,
      81550,
      81564,
      81592,
      81602,
      81604,
      81608,
      81616,
      81630,
      81638,
      81644,
      81702,
      81708,
      81722,
      81734,
      81740,
      81752,
      81774,
      81778,
      81780,
      82050,
      82078,
      82080,
      82108,
      82180,
      82184,
      82192,
      82206,
      82208,
      82236,
      82240,
      82296,
      82316,
      82328,
      82352,
      82366,
      82402,
      82404,
      82408,
      82440,
      82448,
      82462,
      82464,
      82492,
      82496,
      82552,
      82672,
      82694,
      82700,
      82712,
      82736,
      82750,
      82784,
      82812,
      82830,
      82882,
      82884,
      82888,
      82896,
      82918,
      82924,
      82952,
      82960,
      82974,
      82976,
      83004,
      83008,
      83064,
      83184,
      83424,
      83468,
      83480,
      83504,
      83518,
      83552,
      83580,
      83648,
      83704,
      83740,
      83768,
      83824,
      83838,
      83842,
      83844,
      83848,
      83856,
      83872,
      83900,
      83910,
      83916,
      83928,
      83950,
      83984,
      84e3,
      84028,
      84032,
      84088,
      84208,
      84448,
      84928,
      85040,
      85054,
      85088,
      85116,
      85184,
      85240,
      85488,
      85560,
      85616,
      85630,
      85728,
      85756,
      85764,
      85768,
      85776,
      85790,
      85792,
      85820,
      85824,
      85880,
      85894,
      85900,
      85912,
      85936,
      85966,
      85980,
      86048,
      86080,
      86136,
      86256,
      86496,
      86976,
      88160,
      88188,
      88256,
      88312,
      88560,
      89056,
      89200,
      89214,
      89312,
      89340,
      89536,
      89592,
      89608,
      89616,
      89632,
      89664,
      89720,
      89840,
      89868,
      89880,
      89904,
      89952,
      89980,
      89998,
      90012,
      90040,
      90190,
      90204,
      90254,
      90268,
      90296,
      90306,
      90308,
      90312,
      90334,
      90382,
      90396,
      90424,
      90480,
      90494,
      90500,
      90504,
      90512,
      90526,
      90528,
      90556,
      90566,
      90572,
      90584,
      90610,
      90612,
      90638,
      90652,
      90680,
      90736,
      90750,
      90848,
      90876,
      90884,
      90888,
      90896,
      90910,
      90912,
      90940,
      90944,
      91e3,
      91014,
      91020,
      91032,
      91056,
      91070,
      91086,
      91100,
      91106,
      91108,
      91112,
      91126,
      91150,
      91164,
      91192,
      91248,
      91262,
      91360,
      91388,
      91584,
      91640,
      91664,
      91678,
      91680,
      91708,
      91712,
      91768,
      91888,
      91928,
      91952,
      91966,
      92e3,
      92028,
      92046,
      92060,
      92088,
      92098,
      92100,
      92104,
      92112,
      92126,
      92134,
      92140,
      92188,
      92216,
      92272,
      92384,
      92412,
      92608,
      92664,
      93168,
      93200,
      93214,
      93216,
      93244,
      93248,
      93304,
      93424,
      93664,
      93720,
      93744,
      93758,
      93792,
      93820,
      93888,
      93944,
      93980,
      94008,
      94064,
      94078,
      94084,
      94088,
      94096,
      94110,
      94112,
      94140,
      94150,
      94156,
      94168,
      94246,
      94252,
      94278,
      94284,
      94296,
      94318,
      94342,
      94348,
      94360,
      94384,
      94398,
      94414,
      94428,
      94440,
      94470,
      94476,
      94488,
      94512,
      94526,
      94560,
      94588,
      94606,
      94620,
      94648,
      94658,
      94660,
      94664,
      94672,
      94686,
      94694,
      94700,
      94714,
      94726,
      94732,
      94744,
      94768,
      94782,
      94816,
      94844,
      94912,
      94968,
      94990,
      95004,
      95032,
      95088,
      95102,
      95112,
      95120,
      95134,
      95136,
      95164,
      95180,
      95192,
      95214,
      95218,
      95220,
      95244,
      95256,
      95280,
      95294,
      95328,
      95356,
      95424,
      95480,
      95728,
      95758,
      95772,
      95800,
      95856,
      95870,
      95968,
      95996,
      96008,
      96016,
      96030,
      96032,
      96060,
      96064,
      96120,
      96152,
      96176,
      96190,
      96220,
      96226,
      96228,
      96232,
      96290,
      96292,
      96296,
      96310,
      96322,
      96324,
      96328,
      96336,
      96350,
      96358,
      96364,
      96386,
      96388,
      96392,
      96400,
      96414,
      96416,
      96444,
      96454,
      96460,
      96472,
      96494,
      96498,
      96500,
      96514,
      96516,
      96520,
      96528,
      96542,
      96544,
      96572,
      96576,
      96632,
      96646,
      96652,
      96664,
      96688,
      96702,
      96718,
      96732,
      96738,
      96740,
      96744,
      96758,
      96772,
      96776,
      96784,
      96798,
      96800,
      96828,
      96832,
      96888,
      97008,
      97030,
      97036,
      97048,
      97072,
      97086,
      97120,
      97148,
      97166,
      97180,
      97208,
      97220,
      97224,
      97232,
      97246,
      97254,
      97260,
      97326,
      97330,
      97332,
      97358,
      97372,
      97378,
      97380,
      97384,
      97398,
      97422,
      97436,
      97464,
      97474,
      97476,
      97480,
      97488,
      97502,
      97510,
      97516,
      97550,
      97564,
      97592,
      97648,
      97666,
      97668,
      97672,
      97680,
      97694,
      97696,
      97724,
      97734,
      97740,
      97752,
      97774,
      97830,
      97836,
      97850,
      97862,
      97868,
      97880,
      97902,
      97906,
      97908,
      97926,
      97932,
      97944,
      97968,
      97998,
      98012,
      98018,
      98020,
      98024,
      98038,
      98618,
      98674,
      98676,
      98838,
      98854,
      98874,
      98892,
      98904,
      98926,
      98930,
      98932,
      98968,
      99006,
      99042,
      99044,
      99048,
      99062,
      99166,
      99194,
      99246,
      99286,
      99350,
      99366,
      99372,
      99386,
      99398,
      99416,
      99438,
      99442,
      99444,
      99462,
      99504,
      99518,
      99534,
      99548,
      99554,
      99556,
      99560,
      99574,
      99590,
      99596,
      99608,
      99632,
      99646,
      99680,
      99708,
      99726,
      99740,
      99768,
      99778,
      99780,
      99784,
      99792,
      99806,
      99814,
      99820,
      99834,
      99858,
      99860,
      99874,
      99880,
      99894,
      99906,
      99920,
      99934,
      99962,
      99970,
      99972,
      99976,
      99984,
      99998,
      1e5,
      100028,
      100038,
      100044,
      100056,
      100078,
      100082,
      100084,
      100142,
      100174,
      100188,
      100246,
      100262,
      100268,
      100306,
      100308,
      100390,
      100396,
      100410,
      100422,
      100428,
      100440,
      100462,
      100466,
      100468,
      100486,
      100504,
      100528,
      100542,
      100558,
      100572,
      100578,
      100580,
      100584,
      100598,
      100620,
      100656,
      100670,
      100704,
      100732,
      100750,
      100792,
      100802,
      100808,
      100816,
      100830,
      100838,
      100844,
      100858,
      100888,
      100912,
      100926,
      100960,
      100988,
      101056,
      101112,
      101148,
      101176,
      101232,
      101246,
      101250,
      101252,
      101256,
      101264,
      101278,
      101280,
      101308,
      101318,
      101324,
      101336,
      101358,
      101362,
      101364,
      101410,
      101412,
      101416,
      101430,
      101442,
      101448,
      101456,
      101470,
      101478,
      101498,
      101506,
      101508,
      101520,
      101534,
      101536,
      101564,
      101580,
      101618,
      101620,
      101636,
      101640,
      101648,
      101662,
      101664,
      101692,
      101696,
      101752,
      101766,
      101784,
      101838,
      101858,
      101860,
      101864,
      101934,
      101938,
      101940,
      101966,
      101980,
      101986,
      101988,
      101992,
      102030,
      102044,
      102072,
      102082,
      102084,
      102088,
      102096,
      102138,
      102166,
      102182,
      102188,
      102214,
      102220,
      102232,
      102254,
      102282,
      102290,
      102292,
      102306,
      102308,
      102312,
      102326,
      102444,
      102458,
      102470,
      102476,
      102488,
      102514,
      102516,
      102534,
      102552,
      102576,
      102590,
      102606,
      102620,
      102626,
      102632,
      102646,
      102662,
      102668,
      102704,
      102718,
      102752,
      102780,
      102798,
      102812,
      102840,
      102850,
      102856,
      102864,
      102878,
      102886,
      102892,
      102906,
      102936,
      102974,
      103008,
      103036,
      103104,
      103160,
      103224,
      103280,
      103294,
      103298,
      103300,
      103312,
      103326,
      103328,
      103356,
      103366,
      103372,
      103384,
      103406,
      103410,
      103412,
      103472,
      103486,
      103520,
      103548,
      103616,
      103672,
      103920,
      103992,
      104048,
      104062,
      104160,
      104188,
      104194,
      104196,
      104200,
      104208,
      104224,
      104252,
      104256,
      104312,
      104326,
      104332,
      104344,
      104368,
      104382,
      104398,
      104412,
      104418,
      104420,
      104424,
      104482,
      104484,
      104514,
      104520,
      104528,
      104542,
      104550,
      104570,
      104578,
      104580,
      104592,
      104606,
      104608,
      104636,
      104652,
      104690,
      104692,
      104706,
      104712,
      104734,
      104736,
      104764,
      104768,
      104824,
      104838,
      104856,
      104910,
      104930,
      104932,
      104936,
      104968,
      104976,
      104990,
      104992,
      105020,
      105024,
      105080,
      105200,
      105240,
      105278,
      105312,
      105372,
      105410,
      105412,
      105416,
      105424,
      105446,
      105518,
      105524,
      105550,
      105564,
      105570,
      105572,
      105576,
      105614,
      105628,
      105656,
      105666,
      105672,
      105680,
      105702,
      105722,
      105742,
      105756,
      105784,
      105840,
      105854,
      105858,
      105860,
      105864,
      105872,
      105888,
      105932,
      105970,
      105972,
      106006,
      106022,
      106028,
      106054,
      106060,
      106072,
      106100,
      106118,
      106124,
      106136,
      106160,
      106174,
      106190,
      106210,
      106212,
      106216,
      106250,
      106258,
      106260,
      106274,
      106276,
      106280,
      106306,
      106308,
      106312,
      106320,
      106334,
      106348,
      106394,
      106414,
      106418,
      106420,
      106566,
      106572,
      106610,
      106612,
      106630,
      106636,
      106648,
      106672,
      106686,
      106722,
      106724,
      106728,
      106742,
      106758,
      106764,
      106776,
      106800,
      106814,
      106848,
      106876,
      106894,
      106908,
      106936,
      106946,
      106948,
      106952,
      106960,
      106974,
      106982,
      106988,
      107032,
      107056,
      107070,
      107104,
      107132,
      107200,
      107256,
      107292,
      107320,
      107376,
      107390,
      107394,
      107396,
      107400,
      107408,
      107422,
      107424,
      107452,
      107462,
      107468,
      107480,
      107502,
      107506,
      107508,
      107544,
      107568,
      107582,
      107616,
      107644,
      107712,
      107768,
      108016,
      108060,
      108088,
      108144,
      108158,
      108256,
      108284,
      108290,
      108292,
      108296,
      108304,
      108318,
      108320,
      108348,
      108352,
      108408,
      108422,
      108428,
      108440,
      108464,
      108478,
      108494,
      108508,
      108514,
      108516,
      108520,
      108592,
      108640,
      108668,
      108736,
      108792,
      109040,
      109536,
      109680,
      109694,
      109792,
      109820,
      110016,
      110072,
      110084,
      110088,
      110096,
      110112,
      110140,
      110144,
      110200,
      110320,
      110342,
      110348,
      110360,
      110384,
      110398,
      110432,
      110460,
      110478,
      110492,
      110520,
      110532,
      110536,
      110544,
      110558,
      110658,
      110686,
      110714,
      110722,
      110724,
      110728,
      110736,
      110750,
      110752,
      110780,
      110796,
      110834,
      110836,
      110850,
      110852,
      110856,
      110864,
      110878,
      110880,
      110908,
      110912,
      110968,
      110982,
      111e3,
      111054,
      111074,
      111076,
      111080,
      111108,
      111112,
      111120,
      111134,
      111136,
      111164,
      111168,
      111224,
      111344,
      111372,
      111422,
      111456,
      111516,
      111554,
      111556,
      111560,
      111568,
      111590,
      111632,
      111646,
      111648,
      111676,
      111680,
      111736,
      111856,
      112096,
      112152,
      112224,
      112252,
      112320,
      112440,
      112514,
      112516,
      112520,
      112528,
      112542,
      112544,
      112588,
      112686,
      112718,
      112732,
      112782,
      112796,
      112824,
      112834,
      112836,
      112840,
      112848,
      112870,
      112890,
      112910,
      112924,
      112952,
      113008,
      113022,
      113026,
      113028,
      113032,
      113040,
      113054,
      113056,
      113100,
      113138,
      113140,
      113166,
      113180,
      113208,
      113264,
      113278,
      113376,
      113404,
      113416,
      113424,
      113440,
      113468,
      113472,
      113560,
      113614,
      113634,
      113636,
      113640,
      113686,
      113702,
      113708,
      113734,
      113740,
      113752,
      113778,
      113780,
      113798,
      113804,
      113816,
      113840,
      113854,
      113870,
      113890,
      113892,
      113896,
      113926,
      113932,
      113944,
      113968,
      113982,
      114016,
      114044,
      114076,
      114114,
      114116,
      114120,
      114128,
      114150,
      114170,
      114194,
      114196,
      114210,
      114212,
      114216,
      114242,
      114244,
      114248,
      114256,
      114270,
      114278,
      114306,
      114308,
      114312,
      114320,
      114334,
      114336,
      114364,
      114380,
      114420,
      114458,
      114478,
      114482,
      114484,
      114510,
      114524,
      114530,
      114532,
      114536,
      114842,
      114866,
      114868,
      114970,
      114994,
      114996,
      115042,
      115044,
      115048,
      115062,
      115130,
      115226,
      115250,
      115252,
      115278,
      115292,
      115298,
      115300,
      115304,
      115318,
      115342,
      115394,
      115396,
      115400,
      115408,
      115422,
      115430,
      115436,
      115450,
      115478,
      115494,
      115514,
      115526,
      115532,
      115570,
      115572,
      115738,
      115758,
      115762,
      115764,
      115790,
      115804,
      115810,
      115812,
      115816,
      115830,
      115854,
      115868,
      115896,
      115906,
      115912,
      115920,
      115934,
      115942,
      115948,
      115962,
      115996,
      116024,
      116080,
      116094,
      116098,
      116100,
      116104,
      116112,
      116126,
      116128,
      116156,
      116166,
      116172,
      116184,
      116206,
      116210,
      116212,
      116246,
      116262,
      116268,
      116282,
      116294,
      116300,
      116312,
      116334,
      116338,
      116340,
      116358,
      116364,
      116376,
      116400,
      116414,
      116430,
      116444,
      116450,
      116452,
      116456,
      116498,
      116500,
      116514,
      116520,
      116534,
      116546,
      116548,
      116552,
      116560,
      116574,
      116582,
      116588,
      116602,
      116654,
      116694,
      116714,
      116762,
      116782,
      116786,
      116788,
      116814,
      116828,
      116834,
      116836,
      116840,
      116854,
      116878,
      116892,
      116920,
      116930,
      116936,
      116944,
      116958,
      116966,
      116972,
      116986,
      117006,
      117048,
      117104,
      117118,
      117122,
      117124,
      117136,
      117150,
      117152,
      117180,
      117190,
      117196,
      117208,
      117230,
      117234,
      117236,
      117304,
      117360,
      117374,
      117472,
      117500,
      117506,
      117508,
      117512,
      117520,
      117536,
      117564,
      117568,
      117624,
      117638,
      117644,
      117656,
      117680,
      117694,
      117710,
      117724,
      117730,
      117732,
      117736,
      117750,
      117782,
      117798,
      117804,
      117818,
      117830,
      117848,
      117874,
      117876,
      117894,
      117936,
      117950,
      117966,
      117986,
      117988,
      117992,
      118022,
      118028,
      118040,
      118064,
      118078,
      118112,
      118140,
      118172,
      118210,
      118212,
      118216,
      118224,
      118238,
      118246,
      118266,
      118306,
      118312,
      118338,
      118352,
      118366,
      118374,
      118394,
      118402,
      118404,
      118408,
      118416,
      118430,
      118432,
      118460,
      118476,
      118514,
      118516,
      118574,
      118578,
      118580,
      118606,
      118620,
      118626,
      118628,
      118632,
      118678,
      118694,
      118700,
      118730,
      118738,
      118740,
      118830,
      118834,
      118836,
      118862,
      118876,
      118882,
      118884,
      118888,
      118902,
      118926,
      118940,
      118968,
      118978,
      118980,
      118984,
      118992,
      119006,
      119014,
      119020,
      119034,
      119068,
      119096,
      119152,
      119166,
      119170,
      119172,
      119176,
      119184,
      119198,
      119200,
      119228,
      119238,
      119244,
      119256,
      119278,
      119282,
      119284,
      119324,
      119352,
      119408,
      119422,
      119520,
      119548,
      119554,
      119556,
      119560,
      119568,
      119582,
      119584,
      119612,
      119616,
      119672,
      119686,
      119692,
      119704,
      119728,
      119742,
      119758,
      119772,
      119778,
      119780,
      119784,
      119798,
      119920,
      119934,
      120032,
      120060,
      120256,
      120312,
      120324,
      120328,
      120336,
      120352,
      120384,
      120440,
      120560,
      120582,
      120588,
      120600,
      120624,
      120638,
      120672,
      120700,
      120718,
      120732,
      120760,
      120770,
      120772,
      120776,
      120784,
      120798,
      120806,
      120812,
      120870,
      120876,
      120890,
      120902,
      120908,
      120920,
      120946,
      120948,
      120966,
      120972,
      120984,
      121008,
      121022,
      121038,
      121058,
      121060,
      121064,
      121078,
      121100,
      121112,
      121136,
      121150,
      121184,
      121212,
      121244,
      121282,
      121284,
      121288,
      121296,
      121318,
      121338,
      121356,
      121368,
      121392,
      121406,
      121440,
      121468,
      121536,
      121592,
      121656,
      121730,
      121732,
      121736,
      121744,
      121758,
      121760,
      121804,
      121842,
      121844,
      121890,
      121922,
      121924,
      121928,
      121936,
      121950,
      121958,
      121978,
      121986,
      121988,
      121992,
      122e3,
      122014,
      122016,
      122044,
      122060,
      122098,
      122100,
      122116,
      122120,
      122128,
      122142,
      122144,
      122172,
      122176,
      122232,
      122246,
      122264,
      122318,
      122338,
      122340,
      122344,
      122414,
      122418,
      122420,
      122446,
      122460,
      122466,
      122468,
      122472,
      122510,
      122524,
      122552,
      122562,
      122564,
      122568,
      122576,
      122598,
      122618,
      122646,
      122662,
      122668,
      122694,
      122700,
      122712,
      122738,
      122740,
      122762,
      122770,
      122772,
      122786,
      122788,
      122792,
      123018,
      123026,
      123028,
      123042,
      123044,
      123048,
      123062,
      123098,
      123146,
      123154,
      123156,
      123170,
      123172,
      123176,
      123190,
      123202,
      123204,
      123208,
      123216,
      123238,
      123244,
      123258,
      123290,
      123314,
      123316,
      123402,
      123410,
      123412,
      123426,
      123428,
      123432,
      123446,
      123458,
      123464,
      123472,
      123486,
      123494,
      123500,
      123514,
      123522,
      123524,
      123528,
      123536,
      123552,
      123580,
      123590,
      123596,
      123608,
      123630,
      123634,
      123636,
      123674,
      123698,
      123700,
      123740,
      123746,
      123748,
      123752,
      123834,
      123914,
      123922,
      123924,
      123938,
      123944,
      123958,
      123970,
      123976,
      123984,
      123998,
      124006,
      124012,
      124026,
      124034,
      124036,
      124048,
      124062,
      124064,
      124092,
      124102,
      124108,
      124120,
      124142,
      124146,
      124148,
      124162,
      124164,
      124168,
      124176,
      124190,
      124192,
      124220,
      124224,
      124280,
      124294,
      124300,
      124312,
      124336,
      124350,
      124366,
      124380,
      124386,
      124388,
      124392,
      124406,
      124442,
      124462,
      124466,
      124468,
      124494,
      124508,
      124514,
      124520,
      124558,
      124572,
      124600,
      124610,
      124612,
      124616,
      124624,
      124646,
      124666,
      124694,
      124710,
      124716,
      124730,
      124742,
      124748,
      124760,
      124786,
      124788,
      124818,
      124820,
      124834,
      124836,
      124840,
      124854,
      124946,
      124948,
      124962,
      124964,
      124968,
      124982,
      124994,
      124996,
      125e3,
      125008,
      125022,
      125030,
      125036,
      125050,
      125058,
      125060,
      125064,
      125072,
      125086,
      125088,
      125116,
      125126,
      125132,
      125144,
      125166,
      125170,
      125172,
      125186,
      125188,
      125192,
      125200,
      125216,
      125244,
      125248,
      125304,
      125318,
      125324,
      125336,
      125360,
      125374,
      125390,
      125404,
      125410,
      125412,
      125416,
      125430,
      125444,
      125448,
      125456,
      125472,
      125504,
      125560,
      125680,
      125702,
      125708,
      125720,
      125744,
      125758,
      125792,
      125820,
      125838,
      125852,
      125880,
      125890,
      125892,
      125896,
      125904,
      125918,
      125926,
      125932,
      125978,
      125998,
      126002,
      126004,
      126030,
      126044,
      126050,
      126052,
      126056,
      126094,
      126108,
      126136,
      126146,
      126148,
      126152,
      126160,
      126182,
      126202,
      126222,
      126236,
      126264,
      126320,
      126334,
      126338,
      126340,
      126344,
      126352,
      126366,
      126368,
      126412,
      126450,
      126452,
      126486,
      126502,
      126508,
      126522,
      126534,
      126540,
      126552,
      126574,
      126578,
      126580,
      126598,
      126604,
      126616,
      126640,
      126654,
      126670,
      126684,
      126690,
      126692,
      126696,
      126738,
      126754,
      126756,
      126760,
      126774,
      126786,
      126788,
      126792,
      126800,
      126814,
      126822,
      126828,
      126842,
      126894,
      126898,
      126900,
      126934,
      127126,
      127142,
      127148,
      127162,
      127178,
      127186,
      127188,
      127254,
      127270,
      127276,
      127290,
      127302,
      127308,
      127320,
      127342,
      127346,
      127348,
      127370,
      127378,
      127380,
      127394,
      127396,
      127400,
      127450,
      127510,
      127526,
      127532,
      127546,
      127558,
      127576,
      127598,
      127602,
      127604,
      127622,
      127628,
      127640,
      127664,
      127678,
      127694,
      127708,
      127714,
      127716,
      127720,
      127734,
      127754,
      127762,
      127764,
      127778,
      127784,
      127810,
      127812,
      127816,
      127824,
      127838,
      127846,
      127866,
      127898,
      127918,
      127922,
      127924,
      128022,
      128038,
      128044,
      128058,
      128070,
      128076,
      128088,
      128110,
      128114,
      128116,
      128134,
      128140,
      128152,
      128176,
      128190,
      128206,
      128220,
      128226,
      128228,
      128232,
      128246,
      128262,
      128268,
      128280,
      128304,
      128318,
      128352,
      128380,
      128398,
      128412,
      128440,
      128450,
      128452,
      128456,
      128464,
      128478,
      128486,
      128492,
      128506,
      128522,
      128530,
      128532,
      128546,
      128548,
      128552,
      128566,
      128578,
      128580,
      128584,
      128592,
      128606,
      128614,
      128634,
      128642,
      128644,
      128648,
      128656,
      128670,
      128672,
      128700,
      128716,
      128754,
      128756,
      128794,
      128814,
      128818,
      128820,
      128846,
      128860,
      128866,
      128868,
      128872,
      128886,
      128918,
      128934,
      128940,
      128954,
      128978,
      128980,
      129178,
      129198,
      129202,
      129204,
      129238,
      129258,
      129306,
      129326,
      129330,
      129332,
      129358,
      129372,
      129378,
      129380,
      129384,
      129398,
      129430,
      129446,
      129452,
      129466,
      129482,
      129490,
      129492,
      129562,
      129582,
      129586,
      129588,
      129614,
      129628,
      129634,
      129636,
      129640,
      129654,
      129678,
      129692,
      129720,
      129730,
      129732,
      129736,
      129744,
      129758,
      129766,
      129772,
      129814,
      129830,
      129836,
      129850,
      129862,
      129868,
      129880,
      129902,
      129906,
      129908,
      129930,
      129938,
      129940,
      129954,
      129956,
      129960,
      129974,
      130010
    ]), r.CODEWORD_TABLE = Int32Array.from([
      2627,
      1819,
      2622,
      2621,
      1813,
      1812,
      2729,
      2724,
      2723,
      2779,
      2774,
      2773,
      902,
      896,
      908,
      868,
      865,
      861,
      859,
      2511,
      873,
      871,
      1780,
      835,
      2493,
      825,
      2491,
      842,
      837,
      844,
      1764,
      1762,
      811,
      810,
      809,
      2483,
      807,
      2482,
      806,
      2480,
      815,
      814,
      813,
      812,
      2484,
      817,
      816,
      1745,
      1744,
      1742,
      1746,
      2655,
      2637,
      2635,
      2626,
      2625,
      2623,
      2628,
      1820,
      2752,
      2739,
      2737,
      2728,
      2727,
      2725,
      2730,
      2785,
      2783,
      2778,
      2777,
      2775,
      2780,
      787,
      781,
      747,
      739,
      736,
      2413,
      754,
      752,
      1719,
      692,
      689,
      681,
      2371,
      678,
      2369,
      700,
      697,
      694,
      703,
      1688,
      1686,
      642,
      638,
      2343,
      631,
      2341,
      627,
      2338,
      651,
      646,
      643,
      2345,
      654,
      652,
      1652,
      1650,
      1647,
      1654,
      601,
      599,
      2322,
      596,
      2321,
      594,
      2319,
      2317,
      611,
      610,
      608,
      606,
      2324,
      603,
      2323,
      615,
      614,
      612,
      1617,
      1616,
      1614,
      1612,
      616,
      1619,
      1618,
      2575,
      2538,
      2536,
      905,
      901,
      898,
      909,
      2509,
      2507,
      2504,
      870,
      867,
      864,
      860,
      2512,
      875,
      872,
      1781,
      2490,
      2489,
      2487,
      2485,
      1748,
      836,
      834,
      832,
      830,
      2494,
      827,
      2492,
      843,
      841,
      839,
      845,
      1765,
      1763,
      2701,
      2676,
      2674,
      2653,
      2648,
      2656,
      2634,
      2633,
      2631,
      2629,
      1821,
      2638,
      2636,
      2770,
      2763,
      2761,
      2750,
      2745,
      2753,
      2736,
      2735,
      2733,
      2731,
      1848,
      2740,
      2738,
      2786,
      2784,
      591,
      588,
      576,
      569,
      566,
      2296,
      1590,
      537,
      534,
      526,
      2276,
      522,
      2274,
      545,
      542,
      539,
      548,
      1572,
      1570,
      481,
      2245,
      466,
      2242,
      462,
      2239,
      492,
      485,
      482,
      2249,
      496,
      494,
      1534,
      1531,
      1528,
      1538,
      413,
      2196,
      406,
      2191,
      2188,
      425,
      419,
      2202,
      415,
      2199,
      432,
      430,
      427,
      1472,
      1467,
      1464,
      433,
      1476,
      1474,
      368,
      367,
      2160,
      365,
      2159,
      362,
      2157,
      2155,
      2152,
      378,
      377,
      375,
      2166,
      372,
      2165,
      369,
      2162,
      383,
      381,
      379,
      2168,
      1419,
      1418,
      1416,
      1414,
      385,
      1411,
      384,
      1423,
      1422,
      1420,
      1424,
      2461,
      802,
      2441,
      2439,
      790,
      786,
      783,
      794,
      2409,
      2406,
      2403,
      750,
      742,
      738,
      2414,
      756,
      753,
      1720,
      2367,
      2365,
      2362,
      2359,
      1663,
      693,
      691,
      684,
      2373,
      680,
      2370,
      702,
      699,
      696,
      704,
      1690,
      1687,
      2337,
      2336,
      2334,
      2332,
      1624,
      2329,
      1622,
      640,
      637,
      2344,
      634,
      2342,
      630,
      2340,
      650,
      648,
      645,
      2346,
      655,
      653,
      1653,
      1651,
      1649,
      1655,
      2612,
      2597,
      2595,
      2571,
      2568,
      2565,
      2576,
      2534,
      2529,
      2526,
      1787,
      2540,
      2537,
      907,
      904,
      900,
      910,
      2503,
      2502,
      2500,
      2498,
      1768,
      2495,
      1767,
      2510,
      2508,
      2506,
      869,
      866,
      863,
      2513,
      876,
      874,
      1782,
      2720,
      2713,
      2711,
      2697,
      2694,
      2691,
      2702,
      2672,
      2670,
      2664,
      1828,
      2678,
      2675,
      2647,
      2646,
      2644,
      2642,
      1823,
      2639,
      1822,
      2654,
      2652,
      2650,
      2657,
      2771,
      1855,
      2765,
      2762,
      1850,
      1849,
      2751,
      2749,
      2747,
      2754,
      353,
      2148,
      344,
      342,
      336,
      2142,
      332,
      2140,
      345,
      1375,
      1373,
      306,
      2130,
      299,
      2128,
      295,
      2125,
      319,
      314,
      311,
      2132,
      1354,
      1352,
      1349,
      1356,
      262,
      257,
      2101,
      253,
      2096,
      2093,
      274,
      273,
      267,
      2107,
      263,
      2104,
      280,
      278,
      275,
      1316,
      1311,
      1308,
      1320,
      1318,
      2052,
      202,
      2050,
      2044,
      2040,
      219,
      2063,
      212,
      2060,
      208,
      2055,
      224,
      221,
      2066,
      1260,
      1258,
      1252,
      231,
      1248,
      229,
      1266,
      1264,
      1261,
      1268,
      155,
      1998,
      153,
      1996,
      1994,
      1991,
      1988,
      165,
      164,
      2007,
      162,
      2006,
      159,
      2003,
      2e3,
      172,
      171,
      169,
      2012,
      166,
      2010,
      1186,
      1184,
      1182,
      1179,
      175,
      1176,
      173,
      1192,
      1191,
      1189,
      1187,
      176,
      1194,
      1193,
      2313,
      2307,
      2305,
      592,
      589,
      2294,
      2292,
      2289,
      578,
      572,
      568,
      2297,
      580,
      1591,
      2272,
      2267,
      2264,
      1547,
      538,
      536,
      529,
      2278,
      525,
      2275,
      547,
      544,
      541,
      1574,
      1571,
      2237,
      2235,
      2229,
      1493,
      2225,
      1489,
      478,
      2247,
      470,
      2244,
      465,
      2241,
      493,
      488,
      484,
      2250,
      498,
      495,
      1536,
      1533,
      1530,
      1539,
      2187,
      2186,
      2184,
      2182,
      1432,
      2179,
      1430,
      2176,
      1427,
      414,
      412,
      2197,
      409,
      2195,
      405,
      2193,
      2190,
      426,
      424,
      421,
      2203,
      418,
      2201,
      431,
      429,
      1473,
      1471,
      1469,
      1466,
      434,
      1477,
      1475,
      2478,
      2472,
      2470,
      2459,
      2457,
      2454,
      2462,
      803,
      2437,
      2432,
      2429,
      1726,
      2443,
      2440,
      792,
      789,
      785,
      2401,
      2399,
      2393,
      1702,
      2389,
      1699,
      2411,
      2408,
      2405,
      745,
      741,
      2415,
      758,
      755,
      1721,
      2358,
      2357,
      2355,
      2353,
      1661,
      2350,
      1660,
      2347,
      1657,
      2368,
      2366,
      2364,
      2361,
      1666,
      690,
      687,
      2374,
      683,
      2372,
      701,
      698,
      705,
      1691,
      1689,
      2619,
      2617,
      2610,
      2608,
      2605,
      2613,
      2593,
      2588,
      2585,
      1803,
      2599,
      2596,
      2563,
      2561,
      2555,
      1797,
      2551,
      1795,
      2573,
      2570,
      2567,
      2577,
      2525,
      2524,
      2522,
      2520,
      1786,
      2517,
      1785,
      2514,
      1783,
      2535,
      2533,
      2531,
      2528,
      1788,
      2541,
      2539,
      906,
      903,
      911,
      2721,
      1844,
      2715,
      2712,
      1838,
      1836,
      2699,
      2696,
      2693,
      2703,
      1827,
      1826,
      1824,
      2673,
      2671,
      2669,
      2666,
      1829,
      2679,
      2677,
      1858,
      1857,
      2772,
      1854,
      1853,
      1851,
      1856,
      2766,
      2764,
      143,
      1987,
      139,
      1986,
      135,
      133,
      131,
      1984,
      128,
      1983,
      125,
      1981,
      138,
      137,
      136,
      1985,
      1133,
      1132,
      1130,
      112,
      110,
      1974,
      107,
      1973,
      104,
      1971,
      1969,
      122,
      121,
      119,
      117,
      1977,
      114,
      1976,
      124,
      1115,
      1114,
      1112,
      1110,
      1117,
      1116,
      84,
      83,
      1953,
      81,
      1952,
      78,
      1950,
      1948,
      1945,
      94,
      93,
      91,
      1959,
      88,
      1958,
      85,
      1955,
      99,
      97,
      95,
      1961,
      1086,
      1085,
      1083,
      1081,
      1078,
      100,
      1090,
      1089,
      1087,
      1091,
      49,
      47,
      1917,
      44,
      1915,
      1913,
      1910,
      1907,
      59,
      1926,
      56,
      1925,
      53,
      1922,
      1919,
      66,
      64,
      1931,
      61,
      1929,
      1042,
      1040,
      1038,
      71,
      1035,
      70,
      1032,
      68,
      1048,
      1047,
      1045,
      1043,
      1050,
      1049,
      12,
      10,
      1869,
      1867,
      1864,
      1861,
      21,
      1880,
      19,
      1877,
      1874,
      1871,
      28,
      1888,
      25,
      1886,
      22,
      1883,
      982,
      980,
      977,
      974,
      32,
      30,
      991,
      989,
      987,
      984,
      34,
      995,
      994,
      992,
      2151,
      2150,
      2147,
      2146,
      2144,
      356,
      355,
      354,
      2149,
      2139,
      2138,
      2136,
      2134,
      1359,
      343,
      341,
      338,
      2143,
      335,
      2141,
      348,
      347,
      346,
      1376,
      1374,
      2124,
      2123,
      2121,
      2119,
      1326,
      2116,
      1324,
      310,
      308,
      305,
      2131,
      302,
      2129,
      298,
      2127,
      320,
      318,
      316,
      313,
      2133,
      322,
      321,
      1355,
      1353,
      1351,
      1357,
      2092,
      2091,
      2089,
      2087,
      1276,
      2084,
      1274,
      2081,
      1271,
      259,
      2102,
      256,
      2100,
      252,
      2098,
      2095,
      272,
      269,
      2108,
      266,
      2106,
      281,
      279,
      277,
      1317,
      1315,
      1313,
      1310,
      282,
      1321,
      1319,
      2039,
      2037,
      2035,
      2032,
      1203,
      2029,
      1200,
      1197,
      207,
      2053,
      205,
      2051,
      201,
      2049,
      2046,
      2043,
      220,
      218,
      2064,
      215,
      2062,
      211,
      2059,
      228,
      226,
      223,
      2069,
      1259,
      1257,
      1254,
      232,
      1251,
      230,
      1267,
      1265,
      1263,
      2316,
      2315,
      2312,
      2311,
      2309,
      2314,
      2304,
      2303,
      2301,
      2299,
      1593,
      2308,
      2306,
      590,
      2288,
      2287,
      2285,
      2283,
      1578,
      2280,
      1577,
      2295,
      2293,
      2291,
      579,
      577,
      574,
      571,
      2298,
      582,
      581,
      1592,
      2263,
      2262,
      2260,
      2258,
      1545,
      2255,
      1544,
      2252,
      1541,
      2273,
      2271,
      2269,
      2266,
      1550,
      535,
      532,
      2279,
      528,
      2277,
      546,
      543,
      549,
      1575,
      1573,
      2224,
      2222,
      2220,
      1486,
      2217,
      1485,
      2214,
      1482,
      1479,
      2238,
      2236,
      2234,
      2231,
      1496,
      2228,
      1492,
      480,
      477,
      2248,
      473,
      2246,
      469,
      2243,
      490,
      487,
      2251,
      497,
      1537,
      1535,
      1532,
      2477,
      2476,
      2474,
      2479,
      2469,
      2468,
      2466,
      2464,
      1730,
      2473,
      2471,
      2453,
      2452,
      2450,
      2448,
      1729,
      2445,
      1728,
      2460,
      2458,
      2456,
      2463,
      805,
      804,
      2428,
      2427,
      2425,
      2423,
      1725,
      2420,
      1724,
      2417,
      1722,
      2438,
      2436,
      2434,
      2431,
      1727,
      2444,
      2442,
      793,
      791,
      788,
      795,
      2388,
      2386,
      2384,
      1697,
      2381,
      1696,
      2378,
      1694,
      1692,
      2402,
      2400,
      2398,
      2395,
      1703,
      2392,
      1701,
      2412,
      2410,
      2407,
      751,
      748,
      744,
      2416,
      759,
      757,
      1807,
      2620,
      2618,
      1806,
      1805,
      2611,
      2609,
      2607,
      2614,
      1802,
      1801,
      1799,
      2594,
      2592,
      2590,
      2587,
      1804,
      2600,
      2598,
      1794,
      1793,
      1791,
      1789,
      2564,
      2562,
      2560,
      2557,
      1798,
      2554,
      1796,
      2574,
      2572,
      2569,
      2578,
      1847,
      1846,
      2722,
      1843,
      1842,
      1840,
      1845,
      2716,
      2714,
      1835,
      1834,
      1832,
      1830,
      1839,
      1837,
      2700,
      2698,
      2695,
      2704,
      1817,
      1811,
      1810,
      897,
      862,
      1777,
      829,
      826,
      838,
      1760,
      1758,
      808,
      2481,
      1741,
      1740,
      1738,
      1743,
      2624,
      1818,
      2726,
      2776,
      782,
      740,
      737,
      1715,
      686,
      679,
      695,
      1682,
      1680,
      639,
      628,
      2339,
      647,
      644,
      1645,
      1643,
      1640,
      1648,
      602,
      600,
      597,
      595,
      2320,
      593,
      2318,
      609,
      607,
      604,
      1611,
      1610,
      1608,
      1606,
      613,
      1615,
      1613,
      2328,
      926,
      924,
      892,
      886,
      899,
      857,
      850,
      2505,
      1778,
      824,
      823,
      821,
      819,
      2488,
      818,
      2486,
      833,
      831,
      828,
      840,
      1761,
      1759,
      2649,
      2632,
      2630,
      2746,
      2734,
      2732,
      2782,
      2781,
      570,
      567,
      1587,
      531,
      527,
      523,
      540,
      1566,
      1564,
      476,
      467,
      463,
      2240,
      486,
      483,
      1524,
      1521,
      1518,
      1529,
      411,
      403,
      2192,
      399,
      2189,
      423,
      416,
      1462,
      1457,
      1454,
      428,
      1468,
      1465,
      2210,
      366,
      363,
      2158,
      360,
      2156,
      357,
      2153,
      376,
      373,
      370,
      2163,
      1410,
      1409,
      1407,
      1405,
      382,
      1402,
      380,
      1417,
      1415,
      1412,
      1421,
      2175,
      2174,
      777,
      774,
      771,
      784,
      732,
      725,
      722,
      2404,
      743,
      1716,
      676,
      674,
      668,
      2363,
      665,
      2360,
      685,
      1684,
      1681,
      626,
      624,
      622,
      2335,
      620,
      2333,
      617,
      2330,
      641,
      635,
      649,
      1646,
      1644,
      1642,
      2566,
      928,
      925,
      2530,
      2527,
      894,
      891,
      888,
      2501,
      2499,
      2496,
      858,
      856,
      854,
      851,
      1779,
      2692,
      2668,
      2665,
      2645,
      2643,
      2640,
      2651,
      2768,
      2759,
      2757,
      2744,
      2743,
      2741,
      2748,
      352,
      1382,
      340,
      337,
      333,
      1371,
      1369,
      307,
      300,
      296,
      2126,
      315,
      312,
      1347,
      1342,
      1350,
      261,
      258,
      250,
      2097,
      246,
      2094,
      271,
      268,
      264,
      1306,
      1301,
      1298,
      276,
      1312,
      1309,
      2115,
      203,
      2048,
      195,
      2045,
      191,
      2041,
      213,
      209,
      2056,
      1246,
      1244,
      1238,
      225,
      1234,
      222,
      1256,
      1253,
      1249,
      1262,
      2080,
      2079,
      154,
      1997,
      150,
      1995,
      147,
      1992,
      1989,
      163,
      160,
      2004,
      156,
      2001,
      1175,
      1174,
      1172,
      1170,
      1167,
      170,
      1164,
      167,
      1185,
      1183,
      1180,
      1177,
      174,
      1190,
      1188,
      2025,
      2024,
      2022,
      587,
      586,
      564,
      559,
      556,
      2290,
      573,
      1588,
      520,
      518,
      512,
      2268,
      508,
      2265,
      530,
      1568,
      1565,
      461,
      457,
      2233,
      450,
      2230,
      446,
      2226,
      479,
      471,
      489,
      1526,
      1523,
      1520,
      397,
      395,
      2185,
      392,
      2183,
      389,
      2180,
      2177,
      410,
      2194,
      402,
      422,
      1463,
      1461,
      1459,
      1456,
      1470,
      2455,
      799,
      2433,
      2430,
      779,
      776,
      773,
      2397,
      2394,
      2390,
      734,
      728,
      724,
      746,
      1717,
      2356,
      2354,
      2351,
      2348,
      1658,
      677,
      675,
      673,
      670,
      667,
      688,
      1685,
      1683,
      2606,
      2589,
      2586,
      2559,
      2556,
      2552,
      927,
      2523,
      2521,
      2518,
      2515,
      1784,
      2532,
      895,
      893,
      890,
      2718,
      2709,
      2707,
      2689,
      2687,
      2684,
      2663,
      2662,
      2660,
      2658,
      1825,
      2667,
      2769,
      1852,
      2760,
      2758,
      142,
      141,
      1139,
      1138,
      134,
      132,
      129,
      126,
      1982,
      1129,
      1128,
      1126,
      1131,
      113,
      111,
      108,
      105,
      1972,
      101,
      1970,
      120,
      118,
      115,
      1109,
      1108,
      1106,
      1104,
      123,
      1113,
      1111,
      82,
      79,
      1951,
      75,
      1949,
      72,
      1946,
      92,
      89,
      86,
      1956,
      1077,
      1076,
      1074,
      1072,
      98,
      1069,
      96,
      1084,
      1082,
      1079,
      1088,
      1968,
      1967,
      48,
      45,
      1916,
      42,
      1914,
      39,
      1911,
      1908,
      60,
      57,
      54,
      1923,
      50,
      1920,
      1031,
      1030,
      1028,
      1026,
      67,
      1023,
      65,
      1020,
      62,
      1041,
      1039,
      1036,
      1033,
      69,
      1046,
      1044,
      1944,
      1943,
      1941,
      11,
      9,
      1868,
      7,
      1865,
      1862,
      1859,
      20,
      1878,
      16,
      1875,
      13,
      1872,
      970,
      968,
      966,
      963,
      29,
      960,
      26,
      23,
      983,
      981,
      978,
      975,
      33,
      971,
      31,
      990,
      988,
      985,
      1906,
      1904,
      1902,
      993,
      351,
      2145,
      1383,
      331,
      330,
      328,
      326,
      2137,
      323,
      2135,
      339,
      1372,
      1370,
      294,
      293,
      291,
      289,
      2122,
      286,
      2120,
      283,
      2117,
      309,
      303,
      317,
      1348,
      1346,
      1344,
      245,
      244,
      242,
      2090,
      239,
      2088,
      236,
      2085,
      2082,
      260,
      2099,
      249,
      270,
      1307,
      1305,
      1303,
      1300,
      1314,
      189,
      2038,
      186,
      2036,
      183,
      2033,
      2030,
      2026,
      206,
      198,
      2047,
      194,
      216,
      1247,
      1245,
      1243,
      1240,
      227,
      1237,
      1255,
      2310,
      2302,
      2300,
      2286,
      2284,
      2281,
      565,
      563,
      561,
      558,
      575,
      1589,
      2261,
      2259,
      2256,
      2253,
      1542,
      521,
      519,
      517,
      514,
      2270,
      511,
      533,
      1569,
      1567,
      2223,
      2221,
      2218,
      2215,
      1483,
      2211,
      1480,
      459,
      456,
      453,
      2232,
      449,
      474,
      491,
      1527,
      1525,
      1522,
      2475,
      2467,
      2465,
      2451,
      2449,
      2446,
      801,
      800,
      2426,
      2424,
      2421,
      2418,
      1723,
      2435,
      780,
      778,
      775,
      2387,
      2385,
      2382,
      2379,
      1695,
      2375,
      1693,
      2396,
      735,
      733,
      730,
      727,
      749,
      1718,
      2616,
      2615,
      2604,
      2603,
      2601,
      2584,
      2583,
      2581,
      2579,
      1800,
      2591,
      2550,
      2549,
      2547,
      2545,
      1792,
      2542,
      1790,
      2558,
      929,
      2719,
      1841,
      2710,
      2708,
      1833,
      1831,
      2690,
      2688,
      2686,
      1815,
      1809,
      1808,
      1774,
      1756,
      1754,
      1737,
      1736,
      1734,
      1739,
      1816,
      1711,
      1676,
      1674,
      633,
      629,
      1638,
      1636,
      1633,
      1641,
      598,
      1605,
      1604,
      1602,
      1600,
      605,
      1609,
      1607,
      2327,
      887,
      853,
      1775,
      822,
      820,
      1757,
      1755,
      1584,
      524,
      1560,
      1558,
      468,
      464,
      1514,
      1511,
      1508,
      1519,
      408,
      404,
      400,
      1452,
      1447,
      1444,
      417,
      1458,
      1455,
      2208,
      364,
      361,
      358,
      2154,
      1401,
      1400,
      1398,
      1396,
      374,
      1393,
      371,
      1408,
      1406,
      1403,
      1413,
      2173,
      2172,
      772,
      726,
      723,
      1712,
      672,
      669,
      666,
      682,
      1678,
      1675,
      625,
      623,
      621,
      618,
      2331,
      636,
      632,
      1639,
      1637,
      1635,
      920,
      918,
      884,
      880,
      889,
      849,
      848,
      847,
      846,
      2497,
      855,
      852,
      1776,
      2641,
      2742,
      2787,
      1380,
      334,
      1367,
      1365,
      301,
      297,
      1340,
      1338,
      1335,
      1343,
      255,
      251,
      247,
      1296,
      1291,
      1288,
      265,
      1302,
      1299,
      2113,
      204,
      196,
      192,
      2042,
      1232,
      1230,
      1224,
      214,
      1220,
      210,
      1242,
      1239,
      1235,
      1250,
      2077,
      2075,
      151,
      148,
      1993,
      144,
      1990,
      1163,
      1162,
      1160,
      1158,
      1155,
      161,
      1152,
      157,
      1173,
      1171,
      1168,
      1165,
      168,
      1181,
      1178,
      2021,
      2020,
      2018,
      2023,
      585,
      560,
      557,
      1585,
      516,
      509,
      1562,
      1559,
      458,
      447,
      2227,
      472,
      1516,
      1513,
      1510,
      398,
      396,
      393,
      390,
      2181,
      386,
      2178,
      407,
      1453,
      1451,
      1449,
      1446,
      420,
      1460,
      2209,
      769,
      764,
      720,
      712,
      2391,
      729,
      1713,
      664,
      663,
      661,
      659,
      2352,
      656,
      2349,
      671,
      1679,
      1677,
      2553,
      922,
      919,
      2519,
      2516,
      885,
      883,
      881,
      2685,
      2661,
      2659,
      2767,
      2756,
      2755,
      140,
      1137,
      1136,
      130,
      127,
      1125,
      1124,
      1122,
      1127,
      109,
      106,
      102,
      1103,
      1102,
      1100,
      1098,
      116,
      1107,
      1105,
      1980,
      80,
      76,
      73,
      1947,
      1068,
      1067,
      1065,
      1063,
      90,
      1060,
      87,
      1075,
      1073,
      1070,
      1080,
      1966,
      1965,
      46,
      43,
      40,
      1912,
      36,
      1909,
      1019,
      1018,
      1016,
      1014,
      58,
      1011,
      55,
      1008,
      51,
      1029,
      1027,
      1024,
      1021,
      63,
      1037,
      1034,
      1940,
      1939,
      1937,
      1942,
      8,
      1866,
      4,
      1863,
      1,
      1860,
      956,
      954,
      952,
      949,
      946,
      17,
      14,
      969,
      967,
      964,
      961,
      27,
      957,
      24,
      979,
      976,
      972,
      1901,
      1900,
      1898,
      1896,
      986,
      1905,
      1903,
      350,
      349,
      1381,
      329,
      327,
      324,
      1368,
      1366,
      292,
      290,
      287,
      284,
      2118,
      304,
      1341,
      1339,
      1337,
      1345,
      243,
      240,
      237,
      2086,
      233,
      2083,
      254,
      1297,
      1295,
      1293,
      1290,
      1304,
      2114,
      190,
      187,
      184,
      2034,
      180,
      2031,
      177,
      2027,
      199,
      1233,
      1231,
      1229,
      1226,
      217,
      1223,
      1241,
      2078,
      2076,
      584,
      555,
      554,
      552,
      550,
      2282,
      562,
      1586,
      507,
      506,
      504,
      502,
      2257,
      499,
      2254,
      515,
      1563,
      1561,
      445,
      443,
      441,
      2219,
      438,
      2216,
      435,
      2212,
      460,
      454,
      475,
      1517,
      1515,
      1512,
      2447,
      798,
      797,
      2422,
      2419,
      770,
      768,
      766,
      2383,
      2380,
      2376,
      721,
      719,
      717,
      714,
      731,
      1714,
      2602,
      2582,
      2580,
      2548,
      2546,
      2543,
      923,
      921,
      2717,
      2706,
      2705,
      2683,
      2682,
      2680,
      1771,
      1752,
      1750,
      1733,
      1732,
      1731,
      1735,
      1814,
      1707,
      1670,
      1668,
      1631,
      1629,
      1626,
      1634,
      1599,
      1598,
      1596,
      1594,
      1603,
      1601,
      2326,
      1772,
      1753,
      1751,
      1581,
      1554,
      1552,
      1504,
      1501,
      1498,
      1509,
      1442,
      1437,
      1434,
      401,
      1448,
      1445,
      2206,
      1392,
      1391,
      1389,
      1387,
      1384,
      359,
      1399,
      1397,
      1394,
      1404,
      2171,
      2170,
      1708,
      1672,
      1669,
      619,
      1632,
      1630,
      1628,
      1773,
      1378,
      1363,
      1361,
      1333,
      1328,
      1336,
      1286,
      1281,
      1278,
      248,
      1292,
      1289,
      2111,
      1218,
      1216,
      1210,
      197,
      1206,
      193,
      1228,
      1225,
      1221,
      1236,
      2073,
      2071,
      1151,
      1150,
      1148,
      1146,
      152,
      1143,
      149,
      1140,
      145,
      1161,
      1159,
      1156,
      1153,
      158,
      1169,
      1166,
      2017,
      2016,
      2014,
      2019,
      1582,
      510,
      1556,
      1553,
      452,
      448,
      1506,
      1500,
      394,
      391,
      387,
      1443,
      1441,
      1439,
      1436,
      1450,
      2207,
      765,
      716,
      713,
      1709,
      662,
      660,
      657,
      1673,
      1671,
      916,
      914,
      879,
      878,
      877,
      882,
      1135,
      1134,
      1121,
      1120,
      1118,
      1123,
      1097,
      1096,
      1094,
      1092,
      103,
      1101,
      1099,
      1979,
      1059,
      1058,
      1056,
      1054,
      77,
      1051,
      74,
      1066,
      1064,
      1061,
      1071,
      1964,
      1963,
      1007,
      1006,
      1004,
      1002,
      999,
      41,
      996,
      37,
      1017,
      1015,
      1012,
      1009,
      52,
      1025,
      1022,
      1936,
      1935,
      1933,
      1938,
      942,
      940,
      938,
      935,
      932,
      5,
      2,
      955,
      953,
      950,
      947,
      18,
      943,
      15,
      965,
      962,
      958,
      1895,
      1894,
      1892,
      1890,
      973,
      1899,
      1897,
      1379,
      325,
      1364,
      1362,
      288,
      285,
      1334,
      1332,
      1330,
      241,
      238,
      234,
      1287,
      1285,
      1283,
      1280,
      1294,
      2112,
      188,
      185,
      181,
      178,
      2028,
      1219,
      1217,
      1215,
      1212,
      200,
      1209,
      1227,
      2074,
      2072,
      583,
      553,
      551,
      1583,
      505,
      503,
      500,
      513,
      1557,
      1555,
      444,
      442,
      439,
      436,
      2213,
      455,
      451,
      1507,
      1505,
      1502,
      796,
      763,
      762,
      760,
      767,
      711,
      710,
      708,
      706,
      2377,
      718,
      715,
      1710,
      2544,
      917,
      915,
      2681,
      1627,
      1597,
      1595,
      2325,
      1769,
      1749,
      1747,
      1499,
      1438,
      1435,
      2204,
      1390,
      1388,
      1385,
      1395,
      2169,
      2167,
      1704,
      1665,
      1662,
      1625,
      1623,
      1620,
      1770,
      1329,
      1282,
      1279,
      2109,
      1214,
      1207,
      1222,
      2068,
      2065,
      1149,
      1147,
      1144,
      1141,
      146,
      1157,
      1154,
      2013,
      2011,
      2008,
      2015,
      1579,
      1549,
      1546,
      1495,
      1487,
      1433,
      1431,
      1428,
      1425,
      388,
      1440,
      2205,
      1705,
      658,
      1667,
      1664,
      1119,
      1095,
      1093,
      1978,
      1057,
      1055,
      1052,
      1062,
      1962,
      1960,
      1005,
      1003,
      1e3,
      997,
      38,
      1013,
      1010,
      1932,
      1930,
      1927,
      1934,
      941,
      939,
      936,
      933,
      6,
      930,
      3,
      951,
      948,
      944,
      1889,
      1887,
      1884,
      1881,
      959,
      1893,
      1891,
      35,
      1377,
      1360,
      1358,
      1327,
      1325,
      1322,
      1331,
      1277,
      1275,
      1272,
      1269,
      235,
      1284,
      2110,
      1205,
      1204,
      1201,
      1198,
      182,
      1195,
      179,
      1213,
      2070,
      2067,
      1580,
      501,
      1551,
      1548,
      440,
      437,
      1497,
      1494,
      1490,
      1503,
      761,
      709,
      707,
      1706,
      913,
      912,
      2198,
      1386,
      2164,
      2161,
      1621,
      1766,
      2103,
      1208,
      2058,
      2054,
      1145,
      1142,
      2005,
      2002,
      1999,
      2009,
      1488,
      1429,
      1426,
      2200,
      1698,
      1659,
      1656,
      1975,
      1053,
      1957,
      1954,
      1001,
      998,
      1924,
      1921,
      1918,
      1928,
      937,
      934,
      931,
      1879,
      1876,
      1873,
      1870,
      945,
      1885,
      1882,
      1323,
      1273,
      1270,
      2105,
      1202,
      1199,
      1196,
      1211,
      2061,
      2057,
      1576,
      1543,
      1540,
      1484,
      1481,
      1478,
      1491,
      1700
    ]), r;
  }()
), of = (
  /** @class */
  function() {
    function r(e, t) {
      this.bits = e, this.points = t;
    }
    return r.prototype.getBits = function() {
      return this.bits;
    }, r.prototype.getPoints = function() {
      return this.points;
    }, r;
  }()
), af = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, sf = (
  /** @class */
  function() {
    function r() {
    }
    return r.detectMultiple = function(e, t, n) {
      var i = e.getBlackMatrix(), o = r.detect(n, i);
      return o.length || (i = i.clone(), i.rotate180(), o = r.detect(n, i)), new of(i, o);
    }, r.detect = function(e, t) {
      for (var n, i, o = new Array(), a = 0, s = 0, f = !1; a < t.getHeight(); ) {
        var u = r.findVertices(t, a, s);
        if (u[0] == null && u[3] == null) {
          if (!f)
            break;
          f = !1, s = 0;
          try {
            for (var c = (n = void 0, af(o)), l = c.next(); !l.done; l = c.next()) {
              var d = l.value;
              d[1] != null && (a = Math.trunc(Math.max(a, d[1].getY()))), d[3] != null && (a = Math.max(a, Math.trunc(d[3].getY())));
            }
          } catch (h) {
            n = { error: h };
          } finally {
            try {
              l && !l.done && (i = c.return) && i.call(c);
            } finally {
              if (n)
                throw n.error;
            }
          }
          a += r.ROW_STEP;
          continue;
        }
        if (f = !0, o.push(u), !e)
          break;
        u[2] != null ? (s = Math.trunc(u[2].getX()), a = Math.trunc(u[2].getY())) : (s = Math.trunc(u[4].getX()), a = Math.trunc(u[4].getY()));
      }
      return o;
    }, r.findVertices = function(e, t, n) {
      var i = e.getHeight(), o = e.getWidth(), a = new Array(8);
      return r.copyToResult(a, r.findRowsWithPattern(e, i, o, t, n, r.START_PATTERN), r.INDEXES_START_PATTERN), a[4] != null && (n = Math.trunc(a[4].getX()), t = Math.trunc(a[4].getY())), r.copyToResult(a, r.findRowsWithPattern(e, i, o, t, n, r.STOP_PATTERN), r.INDEXES_STOP_PATTERN), a;
    }, r.copyToResult = function(e, t, n) {
      for (var i = 0; i < n.length; i++)
        e[n[i]] = t[i];
    }, r.findRowsWithPattern = function(e, t, n, i, o, a) {
      for (var s = new Array(4), f = !1, u = new Int32Array(a.length); i < t; i += r.ROW_STEP) {
        var c = r.findGuardPattern(e, o, i, n, !1, a, u);
        if (c != null) {
          for (; i > 0; ) {
            var l = r.findGuardPattern(e, o, --i, n, !1, a, u);
            if (l != null)
              c = l;
            else {
              i++;
              break;
            }
          }
          s[0] = new P(c[0], i), s[1] = new P(c[1], i), f = !0;
          break;
        }
      }
      var d = i + 1;
      if (f) {
        for (var h = 0, l = Int32Array.from([Math.trunc(s[0].getX()), Math.trunc(s[1].getX())]); d < t; d++) {
          var c = r.findGuardPattern(e, l[0], d, n, !1, a, u);
          if (c != null && Math.abs(l[0] - c[0]) < r.MAX_PATTERN_DRIFT && Math.abs(l[1] - c[1]) < r.MAX_PATTERN_DRIFT)
            l = c, h = 0;
          else {
            if (h > r.SKIPPED_ROW_COUNT_MAX)
              break;
            h++;
          }
        }
        d -= h + 1, s[2] = new P(l[0], d), s[3] = new P(l[1], d);
      }
      return d - i < r.BARCODE_MIN_HEIGHT && me.fill(s, null), s;
    }, r.findGuardPattern = function(e, t, n, i, o, a, s) {
      me.fillWithin(s, 0, s.length, 0);
      for (var f = t, u = 0; e.get(f, n) && f > 0 && u++ < r.MAX_PIXEL_DRIFT; )
        f--;
      for (var c = f, l = 0, d = a.length, h = o; c < i; c++) {
        var p = e.get(c, n);
        if (p !== h)
          s[l]++;
        else {
          if (l === d - 1) {
            if (r.patternMatchVariance(s, a, r.MAX_INDIVIDUAL_VARIANCE) < r.MAX_AVG_VARIANCE)
              return new Int32Array([f, c]);
            f += s[0] + s[1], ne.arraycopy(s, 2, s, 0, l - 1), s[l - 1] = 0, s[l] = 0, l--;
          } else
            l++;
          s[l] = 1, h = !h;
        }
      }
      return l === d - 1 && r.patternMatchVariance(s, a, r.MAX_INDIVIDUAL_VARIANCE) < r.MAX_AVG_VARIANCE ? new Int32Array([f, c - 1]) : null;
    }, r.patternMatchVariance = function(e, t, n) {
      for (var i = e.length, o = 0, a = 0, s = 0; s < i; s++)
        o += e[s], a += t[s];
      if (o < a)
        return (
          /*Float.POSITIVE_INFINITY*/
          1 / 0
        );
      var f = o / a;
      n *= f;
      for (var u = 0, c = 0; c < i; c++) {
        var l = e[c], d = t[c] * f, h = l > d ? l - d : d - l;
        if (h > n)
          return (
            /*Float.POSITIVE_INFINITY*/
            1 / 0
          );
        u += h;
      }
      return u / o;
    }, r.INDEXES_START_PATTERN = Int32Array.from([0, 4, 1, 5]), r.INDEXES_STOP_PATTERN = Int32Array.from([6, 2, 7, 3]), r.MAX_AVG_VARIANCE = 0.42, r.MAX_INDIVIDUAL_VARIANCE = 0.8, r.START_PATTERN = Int32Array.from([8, 1, 1, 1, 1, 1, 1, 3]), r.STOP_PATTERN = Int32Array.from([7, 1, 1, 3, 1, 1, 1, 2, 1]), r.MAX_PIXEL_DRIFT = 3, r.MAX_PATTERN_DRIFT = 5, r.SKIPPED_ROW_COUNT_MAX = 25, r.ROW_STEP = 5, r.BARCODE_MIN_HEIGHT = 10, r;
  }()
), ff = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lt = (
  /** @class */
  function() {
    function r(e, t) {
      if (t.length === 0)
        throw new F();
      this.field = e;
      var n = (
        /*int*/
        t.length
      );
      if (n > 1 && t[0] === 0) {
        for (var i = (
          /*int*/
          1
        ); i < n && t[i] === 0; )
          i++;
        i === n ? this.coefficients = new Int32Array([0]) : (this.coefficients = new Int32Array(n - i), ne.arraycopy(t, i, this.coefficients, 0, this.coefficients.length));
      } else
        this.coefficients = t;
    }
    return r.prototype.getCoefficients = function() {
      return this.coefficients;
    }, r.prototype.getDegree = function() {
      return this.coefficients.length - 1;
    }, r.prototype.isZero = function() {
      return this.coefficients[0] === 0;
    }, r.prototype.getCoefficient = function(e) {
      return this.coefficients[this.coefficients.length - 1 - e];
    }, r.prototype.evaluateAt = function(e) {
      var t, n;
      if (e === 0)
        return this.getCoefficient(0);
      if (e === 1) {
        var i = (
          /*int*/
          0
        );
        try {
          for (var o = ff(this.coefficients), a = o.next(); !a.done; a = o.next()) {
            var s = a.value;
            i = this.field.add(i, s);
          }
        } catch (l) {
          t = { error: l };
        } finally {
          try {
            a && !a.done && (n = o.return) && n.call(o);
          } finally {
            if (t)
              throw t.error;
          }
        }
        return i;
      }
      for (var f = (
        /*int*/
        this.coefficients[0]
      ), u = (
        /*int*/
        this.coefficients.length
      ), c = 1; c < u; c++)
        f = this.field.add(this.field.multiply(e, f), this.coefficients[c]);
      return f;
    }, r.prototype.add = function(e) {
      if (!this.field.equals(e.field))
        throw new F("ModulusPolys do not have same ModulusGF field");
      if (this.isZero())
        return e;
      if (e.isZero())
        return this;
      var t = this.coefficients, n = e.coefficients;
      if (t.length > n.length) {
        var i = t;
        t = n, n = i;
      }
      var o = new Int32Array(n.length), a = (
        /*int*/
        n.length - t.length
      );
      ne.arraycopy(n, 0, o, 0, a);
      for (var s = a; s < n.length; s++)
        o[s] = this.field.add(t[s - a], n[s]);
      return new r(this.field, o);
    }, r.prototype.subtract = function(e) {
      if (!this.field.equals(e.field))
        throw new F("ModulusPolys do not have same ModulusGF field");
      return e.isZero() ? this : this.add(e.negative());
    }, r.prototype.multiply = function(e) {
      return e instanceof r ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, r.prototype.multiplyOther = function(e) {
      if (!this.field.equals(e.field))
        throw new F("ModulusPolys do not have same ModulusGF field");
      if (this.isZero() || e.isZero())
        return new r(this.field, new Int32Array([0]));
      for (var t = this.coefficients, n = (
        /*int*/
        t.length
      ), i = e.coefficients, o = (
        /*int*/
        i.length
      ), a = new Int32Array(n + o - 1), s = 0; s < n; s++)
        for (var f = (
          /*int*/
          t[s]
        ), u = 0; u < o; u++)
          a[s + u] = this.field.add(a[s + u], this.field.multiply(f, i[u]));
      return new r(this.field, a);
    }, r.prototype.negative = function() {
      for (var e = (
        /*int*/
        this.coefficients.length
      ), t = new Int32Array(e), n = 0; n < e; n++)
        t[n] = this.field.subtract(0, this.coefficients[n]);
      return new r(this.field, t);
    }, r.prototype.multiplyScalar = function(e) {
      if (e === 0)
        return new r(this.field, new Int32Array([0]));
      if (e === 1)
        return this;
      for (var t = (
        /*int*/
        this.coefficients.length
      ), n = new Int32Array(t), i = 0; i < t; i++)
        n[i] = this.field.multiply(this.coefficients[i], e);
      return new r(this.field, n);
    }, r.prototype.multiplyByMonomial = function(e, t) {
      if (e < 0)
        throw new F();
      if (t === 0)
        return new r(this.field, new Int32Array([0]));
      for (var n = (
        /*int*/
        this.coefficients.length
      ), i = new Int32Array(n + e), o = 0; o < n; o++)
        i[o] = this.field.multiply(this.coefficients[o], t);
      return new r(this.field, i);
    }, r.prototype.toString = function() {
      for (var e = new V(
        /*8 * this.getDegree()*/
      ), t = this.getDegree(); t >= 0; t--) {
        var n = (
          /*int*/
          this.getCoefficient(t)
        );
        n !== 0 && (n < 0 ? (e.append(" - "), n = -n) : e.length() > 0 && e.append(" + "), (t === 0 || n !== 1) && e.append(n), t !== 0 && (t === 1 ? e.append("x") : (e.append("x^"), e.append(t))));
      }
      return e.toString();
    }, r;
  }()
), uf = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.add = function(e, t) {
      return (e + t) % this.modulus;
    }, r.prototype.subtract = function(e, t) {
      return (this.modulus + e - t) % this.modulus;
    }, r.prototype.exp = function(e) {
      return this.expTable[e];
    }, r.prototype.log = function(e) {
      if (e === 0)
        throw new F();
      return this.logTable[e];
    }, r.prototype.inverse = function(e) {
      if (e === 0)
        throw new yi();
      return this.expTable[this.modulus - this.logTable[e] - 1];
    }, r.prototype.multiply = function(e, t) {
      return e === 0 || t === 0 ? 0 : this.expTable[(this.logTable[e] + this.logTable[t]) % (this.modulus - 1)];
    }, r.prototype.getSize = function() {
      return this.modulus;
    }, r.prototype.equals = function(e) {
      return e === this;
    }, r;
  }()
), cf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), lf = (
  /** @class */
  function(r) {
    cf(e, r);
    function e(t, n) {
      var i = r.call(this) || this;
      i.modulus = t, i.expTable = new Int32Array(t), i.logTable = new Int32Array(t);
      for (var o = (
        /*int*/
        1
      ), a = 0; a < t; a++)
        i.expTable[a] = o, o = o * n % t;
      for (var a = 0; a < t - 1; a++)
        i.logTable[i.expTable[a]] = a;
      return i.zero = new lt(i, new Int32Array([0])), i.one = new lt(i, new Int32Array([1])), i;
    }
    return e.prototype.getZero = function() {
      return this.zero;
    }, e.prototype.getOne = function() {
      return this.one;
    }, e.prototype.buildMonomial = function(t, n) {
      if (t < 0)
        throw new F();
      if (n === 0)
        return this.zero;
      var i = new Int32Array(t + 1);
      return i[0] = n, new lt(this, i);
    }, e.PDF417_GF = new e(z.NUMBER_OF_CODEWORDS, 3), e;
  }(uf)
), df = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hf = (
  /** @class */
  function() {
    function r() {
      this.field = lf.PDF417_GF;
    }
    return r.prototype.decode = function(e, t, n) {
      for (var i, o, a = new lt(this.field, e), s = new Int32Array(t), f = !1, u = t; u > 0; u--) {
        var c = a.evaluateAt(this.field.exp(u));
        s[t - u] = c, c !== 0 && (f = !0);
      }
      if (!f)
        return 0;
      var l = this.field.getOne();
      if (n != null)
        try {
          for (var d = df(n), h = d.next(); !h.done; h = d.next()) {
            var p = h.value, v = this.field.exp(e.length - 1 - p), y = new lt(this.field, new Int32Array([this.field.subtract(0, v), 1]));
            l = l.multiply(y);
          }
        } catch (R) {
          i = { error: R };
        } finally {
          try {
            h && !h.done && (o = d.return) && o.call(d);
          } finally {
            if (i)
              throw i.error;
          }
        }
      for (var _ = new lt(this.field, s), x = this.runEuclideanAlgorithm(this.field.buildMonomial(t, 1), _, t), C = x[0], E = x[1], S = this.findErrorLocations(C), I = this.findErrorMagnitudes(E, C, S), u = 0; u < S.length; u++) {
        var T = e.length - 1 - this.field.log(S[u]);
        if (T < 0)
          throw pe.getChecksumInstance();
        e[T] = this.field.subtract(e[T], I[u]);
      }
      return S.length;
    }, r.prototype.runEuclideanAlgorithm = function(e, t, n) {
      if (e.getDegree() < t.getDegree()) {
        var i = e;
        e = t, t = i;
      }
      for (var o = e, a = t, s = this.field.getZero(), f = this.field.getOne(); a.getDegree() >= Math.round(n / 2); ) {
        var u = o, c = s;
        if (o = a, s = f, o.isZero())
          throw pe.getChecksumInstance();
        a = u;
        for (var l = this.field.getZero(), d = o.getCoefficient(o.getDegree()), h = this.field.inverse(d); a.getDegree() >= o.getDegree() && !a.isZero(); ) {
          var p = a.getDegree() - o.getDegree(), v = this.field.multiply(a.getCoefficient(a.getDegree()), h);
          l = l.add(this.field.buildMonomial(p, v)), a = a.subtract(o.multiplyByMonomial(p, v));
        }
        f = l.multiply(s).subtract(c).negative();
      }
      var y = f.getCoefficient(0);
      if (y === 0)
        throw pe.getChecksumInstance();
      var _ = this.field.inverse(y), x = f.multiply(_), C = a.multiply(_);
      return [x, C];
    }, r.prototype.findErrorLocations = function(e) {
      for (var t = e.getDegree(), n = new Int32Array(t), i = 0, o = 1; o < this.field.getSize() && i < t; o++)
        e.evaluateAt(o) === 0 && (n[i] = this.field.inverse(o), i++);
      if (i !== t)
        throw pe.getChecksumInstance();
      return n;
    }, r.prototype.findErrorMagnitudes = function(e, t, n) {
      for (var i = t.getDegree(), o = new Int32Array(i), a = 1; a <= i; a++)
        o[i - a] = this.field.multiply(a, t.getCoefficient(a));
      for (var s = new lt(this.field, o), f = n.length, u = new Int32Array(f), a = 0; a < f; a++) {
        var c = this.field.inverse(n[a]), l = this.field.subtract(0, e.evaluateAt(c)), d = this.field.inverse(s.evaluateAt(c));
        u[a] = this.field.multiply(l, d);
      }
      return u;
    }, r;
  }()
), Gr = (
  /** @class */
  function() {
    function r(e, t, n, i, o) {
      e instanceof r ? this.constructor_2(e) : this.constructor_1(e, t, n, i, o);
    }
    return r.prototype.constructor_1 = function(e, t, n, i, o) {
      var a = t == null || n == null, s = i == null || o == null;
      if (a && s)
        throw new w();
      a ? (t = new P(0, i.getY()), n = new P(0, o.getY())) : s && (i = new P(e.getWidth() - 1, t.getY()), o = new P(e.getWidth() - 1, n.getY())), this.image = e, this.topLeft = t, this.bottomLeft = n, this.topRight = i, this.bottomRight = o, this.minX = Math.trunc(Math.min(t.getX(), n.getX())), this.maxX = Math.trunc(Math.max(i.getX(), o.getX())), this.minY = Math.trunc(Math.min(t.getY(), i.getY())), this.maxY = Math.trunc(Math.max(n.getY(), o.getY()));
    }, r.prototype.constructor_2 = function(e) {
      this.image = e.image, this.topLeft = e.getTopLeft(), this.bottomLeft = e.getBottomLeft(), this.topRight = e.getTopRight(), this.bottomRight = e.getBottomRight(), this.minX = e.getMinX(), this.maxX = e.getMaxX(), this.minY = e.getMinY(), this.maxY = e.getMaxY();
    }, r.merge = function(e, t) {
      return e == null ? t : t == null ? e : new r(e.image, e.topLeft, e.bottomLeft, t.topRight, t.bottomRight);
    }, r.prototype.addMissingRows = function(e, t, n) {
      var i = this.topLeft, o = this.bottomLeft, a = this.topRight, s = this.bottomRight;
      if (e > 0) {
        var f = n ? this.topLeft : this.topRight, u = Math.trunc(f.getY() - e);
        u < 0 && (u = 0);
        var c = new P(f.getX(), u);
        n ? i = c : a = c;
      }
      if (t > 0) {
        var l = n ? this.bottomLeft : this.bottomRight, d = Math.trunc(l.getY() + t);
        d >= this.image.getHeight() && (d = this.image.getHeight() - 1);
        var h = new P(l.getX(), d);
        n ? o = h : s = h;
      }
      return new r(this.image, i, o, a, s);
    }, r.prototype.getMinX = function() {
      return this.minX;
    }, r.prototype.getMaxX = function() {
      return this.maxX;
    }, r.prototype.getMinY = function() {
      return this.minY;
    }, r.prototype.getMaxY = function() {
      return this.maxY;
    }, r.prototype.getTopLeft = function() {
      return this.topLeft;
    }, r.prototype.getTopRight = function() {
      return this.topRight;
    }, r.prototype.getBottomLeft = function() {
      return this.bottomLeft;
    }, r.prototype.getBottomRight = function() {
      return this.bottomRight;
    }, r;
  }()
), pf = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.columnCount = e, this.errorCorrectionLevel = i, this.rowCountUpperPart = t, this.rowCountLowerPart = n, this.rowCount = t + n;
    }
    return r.prototype.getColumnCount = function() {
      return this.columnCount;
    }, r.prototype.getErrorCorrectionLevel = function() {
      return this.errorCorrectionLevel;
    }, r.prototype.getRowCount = function() {
      return this.rowCount;
    }, r.prototype.getRowCountUpperPart = function() {
      return this.rowCountUpperPart;
    }, r.prototype.getRowCountLowerPart = function() {
      return this.rowCountLowerPart;
    }, r;
  }()
), rn = (
  /** @class */
  function() {
    function r() {
      this.buffer = "";
    }
    return r.form = function(e, t) {
      var n = -1;
      function i(a, s, f, u, c, l) {
        if (a === "%%")
          return "%";
        if (t[++n] !== void 0) {
          a = u ? parseInt(u.substr(1)) : void 0;
          var d = c ? parseInt(c.substr(1)) : void 0, h;
          switch (l) {
            case "s":
              h = t[n];
              break;
            case "c":
              h = t[n][0];
              break;
            case "f":
              h = parseFloat(t[n]).toFixed(a);
              break;
            case "p":
              h = parseFloat(t[n]).toPrecision(a);
              break;
            case "e":
              h = parseFloat(t[n]).toExponential(a);
              break;
            case "x":
              h = parseInt(t[n]).toString(d || 16);
              break;
            case "d":
              h = parseFloat(parseInt(t[n], d || 10).toPrecision(a)).toFixed(0);
              break;
          }
          h = typeof h == "object" ? JSON.stringify(h) : (+h).toString(d);
          for (var p = parseInt(f), v = f && f[0] + "" == "0" ? "0" : " "; h.length < p; )
            h = s !== void 0 ? h + v : v + h;
          return h;
        }
      }
      var o = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
      return e.replace(o, i);
    }, r.prototype.format = function(e) {
      for (var t = [], n = 1; n < arguments.length; n++)
        t[n - 1] = arguments[n];
      this.buffer += r.form(e, t);
    }, r.prototype.toString = function() {
      return this.buffer;
    }, r;
  }()
), vf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ii = (
  /** @class */
  function() {
    function r(e) {
      this.boundingBox = new Gr(e), this.codewords = new Array(e.getMaxY() - e.getMinY() + 1);
    }
    return r.prototype.getCodewordNearby = function(e) {
      var t = this.getCodeword(e);
      if (t != null)
        return t;
      for (var n = 1; n < r.MAX_NEARBY_DISTANCE; n++) {
        var i = this.imageRowToCodewordIndex(e) - n;
        if (i >= 0 && (t = this.codewords[i], t != null) || (i = this.imageRowToCodewordIndex(e) + n, i < this.codewords.length && (t = this.codewords[i], t != null)))
          return t;
      }
      return null;
    }, r.prototype.imageRowToCodewordIndex = function(e) {
      return e - this.boundingBox.getMinY();
    }, r.prototype.setCodeword = function(e, t) {
      this.codewords[this.imageRowToCodewordIndex(e)] = t;
    }, r.prototype.getCodeword = function(e) {
      return this.codewords[this.imageRowToCodewordIndex(e)];
    }, r.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, r.prototype.getCodewords = function() {
      return this.codewords;
    }, r.prototype.toString = function() {
      var e, t, n = new rn(), i = 0;
      try {
        for (var o = vf(this.codewords), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          if (s == null) {
            n.format("%3d:    |   %n", i++);
            continue;
          }
          n.format("%3d: %3d|%3d%n", i++, s.getRowNumber(), s.getValue());
        }
      } catch (f) {
        e = { error: f };
      } finally {
        try {
          a && !a.done && (t = o.return) && t.call(o);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return n.toString();
    }, r.MAX_NEARBY_DISTANCE = 5, r;
  }()
), gf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, xf = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t)
    return r;
  var n = t.call(r), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}, Ft = (
  /** @class */
  function() {
    function r() {
      this.values = /* @__PURE__ */ new Map();
    }
    return r.prototype.setValue = function(e) {
      e = Math.trunc(e);
      var t = this.values.get(e);
      t == null && (t = 0), t++, this.values.set(e, t);
    }, r.prototype.getValue = function() {
      var e, t, n = -1, i = new Array(), o = function(l, d) {
        var h = {
          getKey: function() {
            return l;
          },
          getValue: function() {
            return d;
          }
        };
        h.getValue() > n ? (n = h.getValue(), i = [], i.push(h.getKey())) : h.getValue() === n && i.push(h.getKey());
      };
      try {
        for (var a = gf(this.values.entries()), s = a.next(); !s.done; s = a.next()) {
          var f = xf(s.value, 2), u = f[0], c = f[1];
          o(u, c);
        }
      } catch (l) {
        e = { error: l };
      } finally {
        try {
          s && !s.done && (t = a.return) && t.call(a);
        } finally {
          if (e)
            throw e.error;
        }
      }
      return z.toIntArray(i);
    }, r.prototype.getConfidence = function(e) {
      return this.values.get(e);
    }, r;
  }()
), yf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Tr = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zn = (
  /** @class */
  function(r) {
    yf(e, r);
    function e(t, n) {
      var i = r.call(this, t) || this;
      return i._isLeft = n, i;
    }
    return e.prototype.setRowNumbers = function() {
      var t, n;
      try {
        for (var i = Tr(this.getCodewords()), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a != null && a.setRowNumberAsRowIndicatorColumn();
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
      var n = this.getCodewords();
      this.setRowNumbers(), this.removeIncorrectCodewords(n, t);
      for (var i = this.getBoundingBox(), o = this._isLeft ? i.getTopLeft() : i.getTopRight(), a = this._isLeft ? i.getBottomLeft() : i.getBottomRight(), s = this.imageRowToCodewordIndex(Math.trunc(o.getY())), f = this.imageRowToCodewordIndex(Math.trunc(a.getY())), u = -1, c = 1, l = 0, d = s; d < f; d++)
        if (n[d] != null) {
          var h = n[d], p = h.getRowNumber() - u;
          if (p === 0)
            l++;
          else if (p === 1)
            c = Math.max(c, l), l = 1, u = h.getRowNumber();
          else if (p < 0 || h.getRowNumber() >= t.getRowCount() || p > d)
            n[d] = null;
          else {
            var v = void 0;
            c > 2 ? v = (c - 2) * p : v = p;
            for (var y = v >= d, _ = 1; _ <= v && !y; _++)
              y = n[d - _] != null;
            y ? n[d] = null : (u = h.getRowNumber(), l = 1);
          }
        }
    }, e.prototype.getRowHeights = function() {
      var t, n, i = this.getBarcodeMetadata();
      if (i == null)
        return null;
      this.adjustIncompleteIndicatorColumnRowNumbers(i);
      var o = new Int32Array(i.getRowCount());
      try {
        for (var a = Tr(this.getCodewords()), s = a.next(); !s.done; s = a.next()) {
          var f = s.value;
          if (f != null) {
            var u = f.getRowNumber();
            if (u >= o.length)
              continue;
            o[u]++;
          }
        }
      } catch (c) {
        t = { error: c };
      } finally {
        try {
          s && !s.done && (n = a.return) && n.call(a);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return o;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
      for (var n = this.getBoundingBox(), i = this._isLeft ? n.getTopLeft() : n.getTopRight(), o = this._isLeft ? n.getBottomLeft() : n.getBottomRight(), a = this.imageRowToCodewordIndex(Math.trunc(i.getY())), s = this.imageRowToCodewordIndex(Math.trunc(o.getY())), f = this.getCodewords(), u = -1, c = a; c < s; c++)
        if (f[c] != null) {
          var l = f[c];
          l.setRowNumberAsRowIndicatorColumn();
          var d = l.getRowNumber() - u;
          d === 0 || (d === 1 ? u = l.getRowNumber() : l.getRowNumber() >= t.getRowCount() ? f[c] = null : u = l.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
      var t, n, i = this.getCodewords(), o = new Ft(), a = new Ft(), s = new Ft(), f = new Ft();
      try {
        for (var u = Tr(i), c = u.next(); !c.done; c = u.next()) {
          var l = c.value;
          if (l != null) {
            l.setRowNumberAsRowIndicatorColumn();
            var d = l.getValue() % 30, h = l.getRowNumber();
            switch (this._isLeft || (h += 2), h % 3) {
              case 0:
                a.setValue(d * 3 + 1);
                break;
              case 1:
                f.setValue(d / 3), s.setValue(d % 3);
                break;
              case 2:
                o.setValue(d + 1);
                break;
            }
          }
        }
      } catch (v) {
        t = { error: v };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (t)
            throw t.error;
        }
      }
      if (o.getValue().length === 0 || a.getValue().length === 0 || s.getValue().length === 0 || f.getValue().length === 0 || o.getValue()[0] < 1 || a.getValue()[0] + s.getValue()[0] < z.MIN_ROWS_IN_BARCODE || a.getValue()[0] + s.getValue()[0] > z.MAX_ROWS_IN_BARCODE)
        return null;
      var p = new pf(o.getValue()[0], a.getValue()[0], s.getValue()[0], f.getValue()[0]);
      return this.removeIncorrectCodewords(i, p), p;
    }, e.prototype.removeIncorrectCodewords = function(t, n) {
      for (var i = 0; i < t.length; i++) {
        var o = t[i];
        if (t[i] != null) {
          var a = o.getValue() % 30, s = o.getRowNumber();
          if (s > n.getRowCount()) {
            t[i] = null;
            continue;
          }
          switch (this._isLeft || (s += 2), s % 3) {
            case 0:
              a * 3 + 1 !== n.getRowCountUpperPart() && (t[i] = null);
              break;
            case 1:
              (Math.trunc(a / 3) !== n.getErrorCorrectionLevel() || a % 3 !== n.getRowCountLowerPart()) && (t[i] = null);
              break;
            case 2:
              a + 1 !== n.getColumnCount() && (t[i] = null);
              break;
          }
        }
      }
    }, e.prototype.isLeft = function() {
      return this._isLeft;
    }, e.prototype.toString = function() {
      return "IsLeft: " + this._isLeft + `
` + r.prototype.toString.call(this);
    }, e;
  }(Ii)
), mf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _f = (
  /** @class */
  function() {
    function r(e, t) {
      this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = e, this.barcodeColumnCount = e.getColumnCount(), this.boundingBox = t, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return r.prototype.getDetectionResultColumns = function() {
      this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
      var e = z.MAX_CODEWORDS_IN_BARCODE, t;
      do
        t = e, e = this.adjustRowNumbersAndGetCount();
      while (e > 0 && e < t);
      return this.detectionResultColumns;
    }, r.prototype.adjustIndicatorColumnRowNumbers = function(e) {
      e != null && e.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, r.prototype.adjustRowNumbersAndGetCount = function() {
      var e = this.adjustRowNumbersByRow();
      if (e === 0)
        return 0;
      for (var t = 1; t < this.barcodeColumnCount + 1; t++)
        for (var n = this.detectionResultColumns[t].getCodewords(), i = 0; i < n.length; i++)
          n[i] != null && (n[i].hasValidRowNumber() || this.adjustRowNumbers(t, i, n));
      return e;
    }, r.prototype.adjustRowNumbersByRow = function() {
      this.adjustRowNumbersFromBothRI();
      var e = this.adjustRowNumbersFromLRI();
      return e + this.adjustRowNumbersFromRRI();
    }, r.prototype.adjustRowNumbersFromBothRI = function() {
      if (!(this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null)) {
        for (var e = this.detectionResultColumns[0].getCodewords(), t = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < e.length; n++)
          if (e[n] != null && t[n] != null && e[n].getRowNumber() === t[n].getRowNumber())
            for (var i = 1; i <= this.barcodeColumnCount; i++) {
              var o = this.detectionResultColumns[i].getCodewords()[n];
              o != null && (o.setRowNumber(e[n].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[i].getCodewords()[n] = null));
            }
      }
    }, r.prototype.adjustRowNumbersFromRRI = function() {
      if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null)
        return 0;
      for (var e = 0, t = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < t.length; n++)
        if (t[n] != null)
          for (var i = t[n].getRowNumber(), o = 0, a = this.barcodeColumnCount + 1; a > 0 && o < this.ADJUST_ROW_NUMBER_SKIP; a--) {
            var s = this.detectionResultColumns[a].getCodewords()[n];
            s != null && (o = r.adjustRowNumberIfValid(i, o, s), s.hasValidRowNumber() || e++);
          }
      return e;
    }, r.prototype.adjustRowNumbersFromLRI = function() {
      if (this.detectionResultColumns[0] == null)
        return 0;
      for (var e = 0, t = this.detectionResultColumns[0].getCodewords(), n = 0; n < t.length; n++)
        if (t[n] != null)
          for (var i = t[n].getRowNumber(), o = 0, a = 1; a < this.barcodeColumnCount + 1 && o < this.ADJUST_ROW_NUMBER_SKIP; a++) {
            var s = this.detectionResultColumns[a].getCodewords()[n];
            s != null && (o = r.adjustRowNumberIfValid(i, o, s), s.hasValidRowNumber() || e++);
          }
      return e;
    }, r.adjustRowNumberIfValid = function(e, t, n) {
      return n == null || n.hasValidRowNumber() || (n.isValidRowNumber(e) ? (n.setRowNumber(e), t = 0) : ++t), t;
    }, r.prototype.adjustRowNumbers = function(e, t, n) {
      var i, o;
      if (this.detectionResultColumns[e - 1] != null) {
        var a = n[t], s = this.detectionResultColumns[e - 1].getCodewords(), f = s;
        this.detectionResultColumns[e + 1] != null && (f = this.detectionResultColumns[e + 1].getCodewords());
        var u = new Array(14);
        u[2] = s[t], u[3] = f[t], t > 0 && (u[0] = n[t - 1], u[4] = s[t - 1], u[5] = f[t - 1]), t > 1 && (u[8] = n[t - 2], u[10] = s[t - 2], u[11] = f[t - 2]), t < n.length - 1 && (u[1] = n[t + 1], u[6] = s[t + 1], u[7] = f[t + 1]), t < n.length - 2 && (u[9] = n[t + 2], u[12] = s[t + 2], u[13] = f[t + 2]);
        try {
          for (var c = mf(u), l = c.next(); !l.done; l = c.next()) {
            var d = l.value;
            if (r.adjustRowNumber(a, d))
              return;
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            l && !l.done && (o = c.return) && o.call(c);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    }, r.adjustRowNumber = function(e, t) {
      return t == null ? !1 : t.hasValidRowNumber() && t.getBucket() === e.getBucket() ? (e.setRowNumber(t.getRowNumber()), !0) : !1;
    }, r.prototype.getBarcodeColumnCount = function() {
      return this.barcodeColumnCount;
    }, r.prototype.getBarcodeRowCount = function() {
      return this.barcodeMetadata.getRowCount();
    }, r.prototype.getBarcodeECLevel = function() {
      return this.barcodeMetadata.getErrorCorrectionLevel();
    }, r.prototype.setBoundingBox = function(e) {
      this.boundingBox = e;
    }, r.prototype.getBoundingBox = function() {
      return this.boundingBox;
    }, r.prototype.setDetectionResultColumn = function(e, t) {
      this.detectionResultColumns[e] = t;
    }, r.prototype.getDetectionResultColumn = function(e) {
      return this.detectionResultColumns[e];
    }, r.prototype.toString = function() {
      var e = this.detectionResultColumns[0];
      e == null && (e = this.detectionResultColumns[this.barcodeColumnCount + 1]);
      for (var t = new rn(), n = 0; n < e.getCodewords().length; n++) {
        t.format("CW %3d:", n);
        for (var i = 0; i < this.barcodeColumnCount + 2; i++) {
          if (this.detectionResultColumns[i] == null) {
            t.format("    |   ");
            continue;
          }
          var o = this.detectionResultColumns[i].getCodewords()[n];
          if (o == null) {
            t.format("    |   ");
            continue;
          }
          t.format(" %3d|%3d", o.getRowNumber(), o.getValue());
        }
        t.format("%n");
      }
      return t.toString();
    }, r;
  }()
), Cf = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.rowNumber = r.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(t), this.bucket = Math.trunc(n), this.value = Math.trunc(i);
    }
    return r.prototype.hasValidRowNumber = function() {
      return this.isValidRowNumber(this.rowNumber);
    }, r.prototype.isValidRowNumber = function(e) {
      return e !== r.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, r.prototype.setRowNumberAsRowIndicatorColumn = function() {
      this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
    }, r.prototype.getWidth = function() {
      return this.endX - this.startX;
    }, r.prototype.getStartX = function() {
      return this.startX;
    }, r.prototype.getEndX = function() {
      return this.endX;
    }, r.prototype.getBucket = function() {
      return this.bucket;
    }, r.prototype.getValue = function() {
      return this.value;
    }, r.prototype.getRowNumber = function() {
      return this.rowNumber;
    }, r.prototype.setRowNumber = function(e) {
      this.rowNumber = e;
    }, r.prototype.toString = function() {
      return this.rowNumber + "|" + this.value;
    }, r.BARCODE_ROW_UNKNOWN = -1, r;
  }()
), Af = (
  /** @class */
  function() {
    function r() {
    }
    return r.initialize = function() {
      for (var e = 0; e < z.SYMBOL_TABLE.length; e++)
        for (var t = z.SYMBOL_TABLE[e], n = t & 1, i = 0; i < z.BARS_IN_MODULE; i++) {
          for (var o = 0; (t & 1) === n; )
            o += 1, t >>= 1;
          n = t & 1, r.RATIOS_TABLE[e] || (r.RATIOS_TABLE[e] = new Array(z.BARS_IN_MODULE)), r.RATIOS_TABLE[e][z.BARS_IN_MODULE - i - 1] = Math.fround(o / z.MODULES_IN_CODEWORD);
        }
      this.bSymbolTableReady = !0;
    }, r.getDecodedValue = function(e) {
      var t = r.getDecodedCodewordValue(r.sampleBitCounts(e));
      return t !== -1 ? t : r.getClosestDecodedValue(e);
    }, r.sampleBitCounts = function(e) {
      for (var t = Y.sum(e), n = new Int32Array(z.BARS_IN_MODULE), i = 0, o = 0, a = 0; a < z.MODULES_IN_CODEWORD; a++) {
        var s = t / (2 * z.MODULES_IN_CODEWORD) + a * t / z.MODULES_IN_CODEWORD;
        o + e[i] <= s && (o += e[i], i++), n[i]++;
      }
      return n;
    }, r.getDecodedCodewordValue = function(e) {
      var t = r.getBitValue(e);
      return z.getCodeword(t) === -1 ? -1 : t;
    }, r.getBitValue = function(e) {
      for (var t = (
        /*long*/
        0
      ), n = 0; n < e.length; n++)
        for (var i = 0; i < e[n]; i++)
          t = t << 1 | (n % 2 === 0 ? 1 : 0);
      return Math.trunc(t);
    }, r.getClosestDecodedValue = function(e) {
      var t = Y.sum(e), n = new Array(z.BARS_IN_MODULE);
      if (t > 1)
        for (var i = 0; i < n.length; i++)
          n[i] = Math.fround(e[i] / t);
      var o = kr.MAX_VALUE, a = -1;
      this.bSymbolTableReady || r.initialize();
      for (var s = 0; s < r.RATIOS_TABLE.length; s++) {
        for (var f = 0, u = r.RATIOS_TABLE[s], c = 0; c < z.BARS_IN_MODULE; c++) {
          var l = Math.fround(u[c] - n[c]);
          if (f += Math.fround(l * l), f >= o)
            break;
        }
        f < o && (o = f, a = z.SYMBOL_TABLE[s]);
      }
      return a;
    }, r.bSymbolTableReady = !1, r.RATIOS_TABLE = new Array(z.SYMBOL_TABLE.length).map(function(e) {
      return new Array(z.BARS_IN_MODULE);
    }), r;
  }()
), Ef = (
  /** @class */
  function() {
    function r() {
      this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return r.prototype.getSegmentIndex = function() {
      return this.segmentIndex;
    }, r.prototype.setSegmentIndex = function(e) {
      this.segmentIndex = e;
    }, r.prototype.getFileId = function() {
      return this.fileId;
    }, r.prototype.setFileId = function(e) {
      this.fileId = e;
    }, r.prototype.getOptionalData = function() {
      return this.optionalData;
    }, r.prototype.setOptionalData = function(e) {
      this.optionalData = e;
    }, r.prototype.isLastSegment = function() {
      return this.lastSegment;
    }, r.prototype.setLastSegment = function(e) {
      this.lastSegment = e;
    }, r.prototype.getSegmentCount = function() {
      return this.segmentCount;
    }, r.prototype.setSegmentCount = function(e) {
      this.segmentCount = e;
    }, r.prototype.getSender = function() {
      return this.sender || null;
    }, r.prototype.setSender = function(e) {
      this.sender = e;
    }, r.prototype.getAddressee = function() {
      return this.addressee || null;
    }, r.prototype.setAddressee = function(e) {
      this.addressee = e;
    }, r.prototype.getFileName = function() {
      return this.fileName;
    }, r.prototype.setFileName = function(e) {
      this.fileName = e;
    }, r.prototype.getFileSize = function() {
      return this.fileSize;
    }, r.prototype.setFileSize = function(e) {
      this.fileSize = e;
    }, r.prototype.getChecksum = function() {
      return this.checksum;
    }, r.prototype.setChecksum = function(e) {
      this.checksum = e;
    }, r.prototype.getTimestamp = function() {
      return this.timestamp;
    }, r.prototype.setTimestamp = function(e) {
      this.timestamp = e;
    }, r;
  }()
), Yn = (
  /** @class */
  function() {
    function r() {
    }
    return r.parseLong = function(e, t) {
      return t === void 0 && (t = void 0), parseInt(e, t);
    }, r;
  }()
), wf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Sf = (
  /** @class */
  function(r) {
    wf(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "NullPointerException", e;
  }(Le)
), If = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.writeBytes = function(e) {
      this.writeBytesOffset(e, 0, e.length);
    }, r.prototype.writeBytesOffset = function(e, t, n) {
      if (e == null)
        throw new Sf();
      if (t < 0 || t > e.length || n < 0 || t + n > e.length || t + n < 0)
        throw new Qr();
      if (n === 0)
        return;
      for (var i = 0; i < n; i++)
        this.write(e[t + i]);
    }, r.prototype.flush = function() {
    }, r.prototype.close = function() {
    }, r;
  }()
), bf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Tf = (
  /** @class */
  function(r) {
    bf(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Le)
), Of = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Rf = (
  /** @class */
  function(r) {
    Of(e, r);
    function e(t) {
      t === void 0 && (t = 32);
      var n = r.call(this) || this;
      if (n.count = 0, t < 0)
        throw new F("Negative initial size: " + t);
      return n.buf = new Uint8Array(t), n;
    }
    return e.prototype.ensureCapacity = function(t) {
      t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
      var n = this.buf.length, i = n << 1;
      if (i - t < 0 && (i = t), i < 0) {
        if (t < 0)
          throw new Tf();
        i = G.MAX_VALUE;
      }
      this.buf = me.copyOfUint8Array(this.buf, i);
    }, e.prototype.write = function(t) {
      this.ensureCapacity(this.count + 1), this.buf[this.count] = /*(byte)*/
      t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, n, i) {
      if (n < 0 || n > t.length || i < 0 || n + i - t.length > 0)
        throw new Qr();
      this.ensureCapacity(this.count + i), ne.arraycopy(t, n, this.buf, this.count, i), this.count += i;
    }, e.prototype.writeTo = function(t) {
      t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
      this.count = 0;
    }, e.prototype.toByteArray = function() {
      return me.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
      return this.count;
    }, e.prototype.toString = function(t) {
      return t ? typeof t == "string" ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
      return new String(
        this.buf
        /*, 0, this.count*/
      ).toString();
    }, e.prototype.toString_string = function(t) {
      return new String(
        this.buf
        /*, 0, this.count, charsetName*/
      ).toString();
    }, e.prototype.toString_number = function(t) {
      return new String(
        this.buf
        /*, hibyte, 0, this.count*/
      ).toString();
    }, e.prototype.close = function() {
    }, e;
  }(If)
), ee;
(function(r) {
  r[r.ALPHA = 0] = "ALPHA", r[r.LOWER = 1] = "LOWER", r[r.MIXED = 2] = "MIXED", r[r.PUNCT = 3] = "PUNCT", r[r.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", r[r.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
})(ee || (ee = {}));
function bi() {
  if (typeof window < "u")
    return window.BigInt || null;
  if (typeof global < "u")
    return global.BigInt || null;
  if (typeof self < "u")
    return self.BigInt || null;
  throw new Error("Can't search globals for BigInt!");
}
var $t;
function nt(r) {
  if (typeof $t > "u" && ($t = bi()), $t === null)
    throw new Error("BigInt is not supported!");
  return $t(r);
}
function Df() {
  var r = [];
  r[0] = nt(1);
  var e = nt(900);
  r[1] = e;
  for (var t = 2; t < 16; t++)
    r[t] = r[t - 1] * e;
  return r;
}
var Pf = (
  /** @class */
  function() {
    function r() {
    }
    return r.decode = function(e, t) {
      var n = new V(""), i = ye.ISO8859_1;
      n.enableDecoding(i);
      for (var o = 1, a = e[o++], s = new Ef(); o < e[0]; ) {
        switch (a) {
          case r.TEXT_COMPACTION_MODE_LATCH:
            o = r.textCompaction(e, o, n);
            break;
          case r.BYTE_COMPACTION_MODE_LATCH:
          case r.BYTE_COMPACTION_MODE_LATCH_6:
            o = r.byteCompaction(a, e, i, o, n);
            break;
          case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
            n.append(
              /*(char)*/
              e[o++]
            );
            break;
          case r.NUMERIC_COMPACTION_MODE_LATCH:
            o = r.numericCompaction(e, o, n);
            break;
          case r.ECI_CHARSET:
            ye.getCharacterSetECIByValue(e[o++]);
            break;
          case r.ECI_GENERAL_PURPOSE:
            o += 2;
            break;
          case r.ECI_USER_DEFINED:
            o++;
            break;
          case r.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            o = r.decodeMacroBlock(e, o, s);
            break;
          case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
          case r.MACRO_PDF417_TERMINATOR:
            throw new O();
          default:
            o--, o = r.textCompaction(e, o, n);
            break;
        }
        if (o < e.length)
          a = e[o++];
        else
          throw O.getFormatInstance();
      }
      if (n.length() === 0)
        throw O.getFormatInstance();
      var f = new pr(null, n.toString(), null, t);
      return f.setOther(s), f;
    }, r.decodeMacroBlock = function(e, t, n) {
      if (t + r.NUMBER_OF_SEQUENCE_CODEWORDS > e[0])
        throw O.getFormatInstance();
      for (var i = new Int32Array(r.NUMBER_OF_SEQUENCE_CODEWORDS), o = 0; o < r.NUMBER_OF_SEQUENCE_CODEWORDS; o++, t++)
        i[o] = e[t];
      n.setSegmentIndex(G.parseInt(r.decodeBase900toBase10(i, r.NUMBER_OF_SEQUENCE_CODEWORDS)));
      var a = new V();
      t = r.textCompaction(e, t, a), n.setFileId(a.toString());
      var s = -1;
      for (e[t] === r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (s = t + 1); t < e[0]; )
        switch (e[t]) {
          case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            switch (t++, e[t]) {
              case r.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                var f = new V();
                t = r.textCompaction(e, t + 1, f), n.setFileName(f.toString());
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                var u = new V();
                t = r.textCompaction(e, t + 1, u), n.setSender(u.toString());
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                var c = new V();
                t = r.textCompaction(e, t + 1, c), n.setAddressee(c.toString());
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                var l = new V();
                t = r.numericCompaction(e, t + 1, l), n.setSegmentCount(G.parseInt(l.toString()));
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                var d = new V();
                t = r.numericCompaction(e, t + 1, d), n.setTimestamp(Yn.parseLong(d.toString()));
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                var h = new V();
                t = r.numericCompaction(e, t + 1, h), n.setChecksum(G.parseInt(h.toString()));
                break;
              case r.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                var p = new V();
                t = r.numericCompaction(e, t + 1, p), n.setFileSize(Yn.parseLong(p.toString()));
                break;
              default:
                throw O.getFormatInstance();
            }
            break;
          case r.MACRO_PDF417_TERMINATOR:
            t++, n.setLastSegment(!0);
            break;
          default:
            throw O.getFormatInstance();
        }
      if (s !== -1) {
        var v = t - s;
        n.isLastSegment() && v--, n.setOptionalData(me.copyOfRange(e, s, s + v));
      }
      return t;
    }, r.textCompaction = function(e, t, n) {
      for (var i = new Int32Array((e[0] - t) * 2), o = new Int32Array((e[0] - t) * 2), a = 0, s = !1; t < e[0] && !s; ) {
        var f = e[t++];
        if (f < r.TEXT_COMPACTION_MODE_LATCH)
          i[a] = f / 30, i[a + 1] = f % 30, a += 2;
        else
          switch (f) {
            case r.TEXT_COMPACTION_MODE_LATCH:
              i[a++] = r.TEXT_COMPACTION_MODE_LATCH;
              break;
            case r.BYTE_COMPACTION_MODE_LATCH:
            case r.BYTE_COMPACTION_MODE_LATCH_6:
            case r.NUMERIC_COMPACTION_MODE_LATCH:
            case r.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case r.MACRO_PDF417_TERMINATOR:
              t--, s = !0;
              break;
            case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
              i[a] = r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, f = e[t++], o[a] = f, a++;
              break;
          }
      }
      return r.decodeTextCompaction(i, o, a, n), t;
    }, r.decodeTextCompaction = function(e, t, n, i) {
      for (var o = ee.ALPHA, a = ee.ALPHA, s = 0; s < n; ) {
        var f = e[s], u = (
          /*char*/
          ""
        );
        switch (o) {
          case ee.ALPHA:
            if (f < 26)
              u = /*(char)('A' + subModeCh) */
              String.fromCharCode(65 + f);
            else
              switch (f) {
                case 26:
                  u = " ";
                  break;
                case r.LL:
                  o = ee.LOWER;
                  break;
                case r.ML:
                  o = ee.MIXED;
                  break;
                case r.PS:
                  a = o, o = ee.PUNCT_SHIFT;
                  break;
                case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    t[s]
                  );
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
          case ee.LOWER:
            if (f < 26)
              u = /*(char)('a' + subModeCh)*/
              String.fromCharCode(97 + f);
            else
              switch (f) {
                case 26:
                  u = " ";
                  break;
                case r.AS:
                  a = o, o = ee.ALPHA_SHIFT;
                  break;
                case r.ML:
                  o = ee.MIXED;
                  break;
                case r.PS:
                  a = o, o = ee.PUNCT_SHIFT;
                  break;
                case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    t[s]
                  );
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
          case ee.MIXED:
            if (f < r.PL)
              u = r.MIXED_CHARS[f];
            else
              switch (f) {
                case r.PL:
                  o = ee.PUNCT;
                  break;
                case 26:
                  u = " ";
                  break;
                case r.LL:
                  o = ee.LOWER;
                  break;
                case r.AL:
                  o = ee.ALPHA;
                  break;
                case r.PS:
                  a = o, o = ee.PUNCT_SHIFT;
                  break;
                case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    t[s]
                  );
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
          case ee.PUNCT:
            if (f < r.PAL)
              u = r.PUNCT_CHARS[f];
            else
              switch (f) {
                case r.PAL:
                  o = ee.ALPHA;
                  break;
                case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    t[s]
                  );
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
          case ee.ALPHA_SHIFT:
            if (o = a, f < 26)
              u = /*(char)('A' + subModeCh)*/
              String.fromCharCode(65 + f);
            else
              switch (f) {
                case 26:
                  u = " ";
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
          case ee.PUNCT_SHIFT:
            if (o = a, f < r.PAL)
              u = r.PUNCT_CHARS[f];
            else
              switch (f) {
                case r.PAL:
                  o = ee.ALPHA;
                  break;
                case r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                  i.append(
                    /*(char)*/
                    t[s]
                  );
                  break;
                case r.TEXT_COMPACTION_MODE_LATCH:
                  o = ee.ALPHA;
                  break;
              }
            break;
        }
        u !== "" && i.append(u), s++;
      }
    }, r.byteCompaction = function(e, t, n, i, o) {
      var a = new Rf(), s = 0, f = (
        /*long*/
        0
      ), u = !1;
      switch (e) {
        case r.BYTE_COMPACTION_MODE_LATCH:
          for (var c = new Int32Array(6), l = t[i++]; i < t[0] && !u; )
            switch (c[s++] = l, f = 900 * f + l, l = t[i++], l) {
              case r.TEXT_COMPACTION_MODE_LATCH:
              case r.BYTE_COMPACTION_MODE_LATCH:
              case r.NUMERIC_COMPACTION_MODE_LATCH:
              case r.BYTE_COMPACTION_MODE_LATCH_6:
              case r.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
              case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
              case r.MACRO_PDF417_TERMINATOR:
                i--, u = !0;
                break;
              default:
                if (s % 5 === 0 && s > 0) {
                  for (var d = 0; d < 6; ++d)
                    a.write(
                      /*(byte)*/
                      Number(nt(f) >> nt(8 * (5 - d)))
                    );
                  f = 0, s = 0;
                }
                break;
            }
          i === t[0] && l < r.TEXT_COMPACTION_MODE_LATCH && (c[s++] = l);
          for (var h = 0; h < s; h++)
            a.write(
              /*(byte)*/
              c[h]
            );
          break;
        case r.BYTE_COMPACTION_MODE_LATCH_6:
          for (; i < t[0] && !u; ) {
            var p = t[i++];
            if (p < r.TEXT_COMPACTION_MODE_LATCH)
              s++, f = 900 * f + p;
            else
              switch (p) {
                case r.TEXT_COMPACTION_MODE_LATCH:
                case r.BYTE_COMPACTION_MODE_LATCH:
                case r.NUMERIC_COMPACTION_MODE_LATCH:
                case r.BYTE_COMPACTION_MODE_LATCH_6:
                case r.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case r.MACRO_PDF417_TERMINATOR:
                  i--, u = !0;
                  break;
              }
            if (s % 5 === 0 && s > 0) {
              for (var d = 0; d < 6; ++d)
                a.write(
                  /*(byte)*/
                  Number(nt(f) >> nt(8 * (5 - d)))
                );
              f = 0, s = 0;
            }
          }
          break;
      }
      return o.append(Ve.decode(a.toByteArray(), n)), i;
    }, r.numericCompaction = function(e, t, n) {
      for (var i = 0, o = !1, a = new Int32Array(r.MAX_NUMERIC_CODEWORDS); t < e[0] && !o; ) {
        var s = e[t++];
        if (t === e[0] && (o = !0), s < r.TEXT_COMPACTION_MODE_LATCH)
          a[i] = s, i++;
        else
          switch (s) {
            case r.TEXT_COMPACTION_MODE_LATCH:
            case r.BYTE_COMPACTION_MODE_LATCH:
            case r.BYTE_COMPACTION_MODE_LATCH_6:
            case r.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
            case r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
            case r.MACRO_PDF417_TERMINATOR:
              t--, o = !0;
              break;
          }
        (i % r.MAX_NUMERIC_CODEWORDS === 0 || s === r.NUMERIC_COMPACTION_MODE_LATCH || o) && i > 0 && (n.append(r.decodeBase900toBase10(a, i)), i = 0);
      }
      return t;
    }, r.decodeBase900toBase10 = function(e, t) {
      for (var n = nt(0), i = 0; i < t; i++)
        n += r.EXP900[t - i - 1] * nt(e[i]);
      var o = n.toString();
      if (o.charAt(0) !== "1")
        throw new O();
      return o.substring(1);
    }, r.TEXT_COMPACTION_MODE_LATCH = 900, r.BYTE_COMPACTION_MODE_LATCH = 901, r.NUMERIC_COMPACTION_MODE_LATCH = 902, r.BYTE_COMPACTION_MODE_LATCH_6 = 924, r.ECI_USER_DEFINED = 925, r.ECI_GENERAL_PURPOSE = 926, r.ECI_CHARSET = 927, r.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, r.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, r.MACRO_PDF417_TERMINATOR = 922, r.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, r.MAX_NUMERIC_CODEWORDS = 15, r.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, r.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, r.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, r.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, r.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, r.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, r.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, r.PL = 25, r.LL = 27, r.AS = 27, r.ML = 28, r.AL = 28, r.PS = 29, r.PAL = 29, r.PUNCT_CHARS = `;<>@[\\]_\`~!\r	,:
-.$/"|*()?{}'`, r.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", r.EXP900 = bi() ? Df() : [], r.NUMBER_OF_SEQUENCE_CODEWORDS = 2, r;
  }()
), Pt = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Nf = (
  /** @class */
  function() {
    function r() {
    }
    return r.decode = function(e, t, n, i, o, a, s) {
      for (var f = new Gr(e, t, n, i, o), u = null, c = null, l, d = !0; ; d = !1) {
        if (t != null && (u = r.getRowIndicatorColumn(e, f, t, !0, a, s)), i != null && (c = r.getRowIndicatorColumn(e, f, i, !1, a, s)), l = r.merge(u, c), l == null)
          throw w.getNotFoundInstance();
        var h = l.getBoundingBox();
        if (d && h != null && (h.getMinY() < f.getMinY() || h.getMaxY() > f.getMaxY()))
          f = h;
        else
          break;
      }
      l.setBoundingBox(f);
      var p = l.getBarcodeColumnCount() + 1;
      l.setDetectionResultColumn(0, u), l.setDetectionResultColumn(p, c);
      for (var v = u != null, y = 1; y <= p; y++) {
        var _ = v ? y : p - y;
        if (l.getDetectionResultColumn(_) === /* null */
        void 0) {
          var x = void 0;
          _ === 0 || _ === p ? x = new zn(f, _ === 0) : x = new Ii(f), l.setDetectionResultColumn(_, x);
          for (var C = -1, E = C, S = f.getMinY(); S <= f.getMaxY(); S++) {
            if (C = r.getStartColumn(l, _, S, v), C < 0 || C > f.getMaxX()) {
              if (E === -1)
                continue;
              C = E;
            }
            var I = r.detectCodeword(e, f.getMinX(), f.getMaxX(), v, C, S, a, s);
            I != null && (x.setCodeword(S, I), E = C, a = Math.min(a, I.getWidth()), s = Math.max(s, I.getWidth()));
          }
        }
      }
      return r.createDecoderResult(l);
    }, r.merge = function(e, t) {
      if (e == null && t == null)
        return null;
      var n = r.getBarcodeMetadata(e, t);
      if (n == null)
        return null;
      var i = Gr.merge(r.adjustBoundingBox(e), r.adjustBoundingBox(t));
      return new _f(n, i);
    }, r.adjustBoundingBox = function(e) {
      var t, n;
      if (e == null)
        return null;
      var i = e.getRowHeights();
      if (i == null)
        return null;
      var o = r.getMax(i), a = 0;
      try {
        for (var s = Pt(i), f = s.next(); !f.done; f = s.next()) {
          var u = f.value;
          if (a += o - u, u > 0)
            break;
        }
      } catch (h) {
        t = { error: h };
      } finally {
        try {
          f && !f.done && (n = s.return) && n.call(s);
        } finally {
          if (t)
            throw t.error;
        }
      }
      for (var c = e.getCodewords(), l = 0; a > 0 && c[l] == null; l++)
        a--;
      for (var d = 0, l = i.length - 1; l >= 0 && (d += o - i[l], !(i[l] > 0)); l--)
        ;
      for (var l = c.length - 1; d > 0 && c[l] == null; l--)
        d--;
      return e.getBoundingBox().addMissingRows(a, d, e.isLeft());
    }, r.getMax = function(e) {
      var t, n, i = -1;
      try {
        for (var o = Pt(e), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          i = Math.max(i, s);
        }
      } catch (f) {
        t = { error: f };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return i;
    }, r.getBarcodeMetadata = function(e, t) {
      var n;
      if (e == null || (n = e.getBarcodeMetadata()) == null)
        return t == null ? null : t.getBarcodeMetadata();
      var i;
      return t == null || (i = t.getBarcodeMetadata()) == null ? n : n.getColumnCount() !== i.getColumnCount() && n.getErrorCorrectionLevel() !== i.getErrorCorrectionLevel() && n.getRowCount() !== i.getRowCount() ? null : n;
    }, r.getRowIndicatorColumn = function(e, t, n, i, o, a) {
      for (var s = new zn(t, i), f = 0; f < 2; f++)
        for (var u = f === 0 ? 1 : -1, c = Math.trunc(Math.trunc(n.getX())), l = Math.trunc(Math.trunc(n.getY())); l <= t.getMaxY() && l >= t.getMinY(); l += u) {
          var d = r.detectCodeword(e, 0, e.getWidth(), i, c, l, o, a);
          d != null && (s.setCodeword(l, d), i ? c = d.getStartX() : c = d.getEndX());
        }
      return s;
    }, r.adjustCodewordCount = function(e, t) {
      var n = t[0][1], i = n.getValue(), o = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - r.getNumberOfECCodeWords(e.getBarcodeECLevel());
      if (i.length === 0) {
        if (o < 1 || o > z.MAX_CODEWORDS_IN_BARCODE)
          throw w.getNotFoundInstance();
        n.setValue(o);
      } else
        i[0] !== o && n.setValue(o);
    }, r.createDecoderResult = function(e) {
      var t = r.createBarcodeMatrix(e);
      r.adjustCodewordCount(e, t);
      for (var n = new Array(), i = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), o = (
        /*List<int[]>*/
        []
      ), a = (
        /*Collection<Integer>*/
        new Array()
      ), s = 0; s < e.getBarcodeRowCount(); s++)
        for (var f = 0; f < e.getBarcodeColumnCount(); f++) {
          var u = t[s][f + 1].getValue(), c = s * e.getBarcodeColumnCount() + f;
          u.length === 0 ? n.push(c) : u.length === 1 ? i[c] = u[0] : (a.push(c), o.push(u));
        }
      for (var l = new Array(o.length), d = 0; d < l.length; d++)
        l[d] = o[d];
      return r.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), i, z.toIntArray(n), z.toIntArray(a), l);
    }, r.createDecoderResultFromAmbiguousValues = function(e, t, n, i, o) {
      for (var a = new Int32Array(i.length), s = 100; s-- > 0; ) {
        for (var f = 0; f < a.length; f++)
          t[i[f]] = o[f][a[f]];
        try {
          return r.decodeCodewords(t, e, n);
        } catch (c) {
          var u = c instanceof pe;
          if (!u)
            throw c;
        }
        if (a.length === 0)
          throw pe.getChecksumInstance();
        for (var f = 0; f < a.length; f++)
          if (a[f] < o[f].length - 1) {
            a[f]++;
            break;
          } else if (a[f] = 0, f === a.length - 1)
            throw pe.getChecksumInstance();
      }
      throw pe.getChecksumInstance();
    }, r.createBarcodeMatrix = function(e) {
      for (var t, n, i, o, a = Array.from({ length: e.getBarcodeRowCount() }, function() {
        return new Array(e.getBarcodeColumnCount() + 2);
      }), s = 0; s < a.length; s++)
        for (var f = 0; f < a[s].length; f++)
          a[s][f] = new Ft();
      var u = 0;
      try {
        for (var c = Pt(e.getDetectionResultColumns()), l = c.next(); !l.done; l = c.next()) {
          var d = l.value;
          if (d != null)
            try {
              for (var h = (i = void 0, Pt(d.getCodewords())), p = h.next(); !p.done; p = h.next()) {
                var v = p.value;
                if (v != null) {
                  var y = v.getRowNumber();
                  if (y >= 0) {
                    if (y >= a.length)
                      continue;
                    a[y][u].setValue(v.getValue());
                  }
                }
              }
            } catch (_) {
              i = { error: _ };
            } finally {
              try {
                p && !p.done && (o = h.return) && o.call(h);
              } finally {
                if (i)
                  throw i.error;
              }
            }
          u++;
        }
      } catch (_) {
        t = { error: _ };
      } finally {
        try {
          l && !l.done && (n = c.return) && n.call(c);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return a;
    }, r.isValidBarcodeColumn = function(e, t) {
      return t >= 0 && t <= e.getBarcodeColumnCount() + 1;
    }, r.getStartColumn = function(e, t, n, i) {
      var o, a, s = i ? 1 : -1, f = null;
      if (r.isValidBarcodeColumn(e, t - s) && (f = e.getDetectionResultColumn(t - s).getCodeword(n)), f != null)
        return i ? f.getEndX() : f.getStartX();
      if (f = e.getDetectionResultColumn(t).getCodewordNearby(n), f != null)
        return i ? f.getStartX() : f.getEndX();
      if (r.isValidBarcodeColumn(e, t - s) && (f = e.getDetectionResultColumn(t - s).getCodewordNearby(n)), f != null)
        return i ? f.getEndX() : f.getStartX();
      for (var u = 0; r.isValidBarcodeColumn(e, t - s); ) {
        t -= s;
        try {
          for (var c = (o = void 0, Pt(e.getDetectionResultColumn(t).getCodewords())), l = c.next(); !l.done; l = c.next()) {
            var d = l.value;
            if (d != null)
              return (i ? d.getEndX() : d.getStartX()) + s * u * (d.getEndX() - d.getStartX());
          }
        } catch (h) {
          o = { error: h };
        } finally {
          try {
            l && !l.done && (a = c.return) && a.call(c);
          } finally {
            if (o)
              throw o.error;
          }
        }
        u++;
      }
      return i ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, r.detectCodeword = function(e, t, n, i, o, a, s, f) {
      o = r.adjustCodewordStartColumn(e, t, n, i, o, a);
      var u = r.getModuleBitCount(e, t, n, i, o, a);
      if (u == null)
        return null;
      var c, l = Y.sum(u);
      if (i)
        c = o + l;
      else {
        for (var d = 0; d < u.length / 2; d++) {
          var h = u[d];
          u[d] = u[u.length - 1 - d], u[u.length - 1 - d] = h;
        }
        c = o, o = c - l;
      }
      if (!r.checkCodewordSkew(l, s, f))
        return null;
      var p = Af.getDecodedValue(u), v = z.getCodeword(p);
      return v === -1 ? null : new Cf(o, c, r.getCodewordBucketNumber(p), v);
    }, r.getModuleBitCount = function(e, t, n, i, o, a) {
      for (var s = o, f = new Int32Array(8), u = 0, c = i ? 1 : -1, l = i; (i ? s < n : s >= t) && u < f.length; )
        e.get(s, a) === l ? (f[u]++, s += c) : (u++, l = !l);
      return u === f.length || s === (i ? n : t) && u === f.length - 1 ? f : null;
    }, r.getNumberOfECCodeWords = function(e) {
      return 2 << e;
    }, r.adjustCodewordStartColumn = function(e, t, n, i, o, a) {
      for (var s = o, f = i ? -1 : 1, u = 0; u < 2; u++) {
        for (; (i ? s >= t : s < n) && i === e.get(s, a); ) {
          if (Math.abs(o - s) > r.CODEWORD_SKEW_SIZE)
            return o;
          s += f;
        }
        f = -f, i = !i;
      }
      return s;
    }, r.checkCodewordSkew = function(e, t, n) {
      return t - r.CODEWORD_SKEW_SIZE <= e && e <= n + r.CODEWORD_SKEW_SIZE;
    }, r.decodeCodewords = function(e, t, n) {
      if (e.length === 0)
        throw O.getFormatInstance();
      var i = 1 << t + 1, o = r.correctErrors(e, n, i);
      r.verifyCodewordCount(e, i);
      var a = Pf.decode(e, "" + t);
      return a.setErrorsCorrected(o), a.setErasures(n.length), a;
    }, r.correctErrors = function(e, t, n) {
      if (t != null && t.length > n / 2 + r.MAX_ERRORS || n < 0 || n > r.MAX_EC_CODEWORDS)
        throw pe.getChecksumInstance();
      return r.errorCorrection.decode(e, n, t);
    }, r.verifyCodewordCount = function(e, t) {
      if (e.length < 4)
        throw O.getFormatInstance();
      var n = e[0];
      if (n > e.length)
        throw O.getFormatInstance();
      if (n === 0)
        if (t < e.length)
          e[0] = e.length - t;
        else
          throw O.getFormatInstance();
    }, r.getBitCountForCodeword = function(e) {
      for (var t = new Int32Array(8), n = 0, i = t.length - 1; !((e & 1) !== n && (n = e & 1, i--, i < 0)); )
        t[i]++, e >>= 1;
      return t;
    }, r.getCodewordBucketNumber = function(e) {
      return e instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(e) : this.getCodewordBucketNumber_number(e);
    }, r.getCodewordBucketNumber_number = function(e) {
      return r.getCodewordBucketNumber(r.getBitCountForCodeword(e));
    }, r.getCodewordBucketNumber_Int32Array = function(e) {
      return (e[0] - e[2] + e[4] - e[6] + 9) % 9;
    }, r.toString = function(e) {
      for (var t = new rn(), n = 0; n < e.length; n++) {
        t.format("Row %2d: ", n);
        for (var i = 0; i < e[n].length; i++) {
          var o = e[n][i];
          o.getValue().length === 0 ? t.format("        ", null) : t.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
        }
        t.format("%n");
      }
      return t.toString();
    }, r.CODEWORD_SKEW_SIZE = 2, r.MAX_ERRORS = 3, r.MAX_EC_CODEWORDS = 512, r.errorCorrection = new hf(), r;
  }()
), Mf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, lr = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.decode = function(e, t) {
      t === void 0 && (t = null);
      var n = r.decode(e, t, !1);
      if (n == null || n.length === 0 || n[0] == null)
        throw w.getNotFoundInstance();
      return n[0];
    }, r.prototype.decodeMultiple = function(e, t) {
      t === void 0 && (t = null);
      try {
        return r.decode(e, t, !0);
      } catch (n) {
        throw n instanceof O || n instanceof pe ? w.getNotFoundInstance() : n;
      }
    }, r.decode = function(e, t, n) {
      var i, o, a = new Array(), s = sf.detectMultiple(e, t, n);
      try {
        for (var f = Mf(s.getPoints()), u = f.next(); !u.done; u = f.next()) {
          var c = u.value, l = Nf.decode(s.getBits(), c[4], c[5], c[6], c[7], r.getMinCodewordWidth(c), r.getMaxCodewordWidth(c)), d = new Oe(l.getText(), l.getRawBytes(), void 0, c, L.PDF_417);
          d.putMetadata(be.ERROR_CORRECTION_LEVEL, l.getECLevel());
          var h = l.getOther();
          h != null && d.putMetadata(be.PDF417_EXTRA_METADATA, h), a.push(d);
        }
      } catch (p) {
        i = { error: p };
      } finally {
        try {
          u && !u.done && (o = f.return) && o.call(f);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return a.map(function(p) {
        return p;
      });
    }, r.getMaxWidth = function(e, t) {
      return e == null || t == null ? 0 : Math.trunc(Math.abs(e.getX() - t.getX()));
    }, r.getMinWidth = function(e, t) {
      return e == null || t == null ? G.MAX_VALUE : Math.trunc(Math.abs(e.getX() - t.getX()));
    }, r.getMaxCodewordWidth = function(e) {
      return Math.floor(Math.max(Math.max(r.getMaxWidth(e[0], e[4]), r.getMaxWidth(e[6], e[2]) * z.MODULES_IN_CODEWORD / z.MODULES_IN_STOP_PATTERN), Math.max(r.getMaxWidth(e[1], e[5]), r.getMaxWidth(e[7], e[3]) * z.MODULES_IN_CODEWORD / z.MODULES_IN_STOP_PATTERN)));
    }, r.getMinCodewordWidth = function(e) {
      return Math.floor(Math.min(Math.min(r.getMinWidth(e[0], e[4]), r.getMinWidth(e[6], e[2]) * z.MODULES_IN_CODEWORD / z.MODULES_IN_STOP_PATTERN), Math.min(r.getMinWidth(e[1], e[5]), r.getMinWidth(e[7], e[3]) * z.MODULES_IN_CODEWORD / z.MODULES_IN_STOP_PATTERN)));
    }, r.prototype.reset = function() {
    }, r;
  }()
), Bf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), $n = (
  /** @class */
  function(r) {
    Bf(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "ReaderException", e;
  }(Le)
), Zn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Ti = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.decode = function(e, t) {
      return this.setHints(t), this.decodeInternal(e);
    }, r.prototype.decodeWithState = function(e) {
      return (this.readers === null || this.readers === void 0) && this.setHints(null), this.decodeInternal(e);
    }, r.prototype.setHints = function(e) {
      this.hints = e;
      var t = e != null && e.get(fe.TRY_HARDER) !== void 0, n = e == null ? null : e.get(fe.POSSIBLE_FORMATS), i = new Array();
      if (n != null) {
        var o = n.some(function(a) {
          return a === L.UPC_A || a === L.UPC_E || a === L.EAN_13 || a === L.EAN_8 || a === L.CODABAR || a === L.CODE_39 || a === L.CODE_93 || a === L.CODE_128 || a === L.ITF || a === L.RSS_14 || a === L.RSS_EXPANDED;
        });
        o && !t && i.push(new mt(e)), n.includes(L.QR_CODE) && i.push(new cr()), n.includes(L.DATA_MATRIX) && i.push(new ur()), n.includes(L.AZTEC) && i.push(new sr()), n.includes(L.PDF_417) && i.push(new lr()), o && t && i.push(new mt(e));
      }
      i.length === 0 && (t || i.push(new mt(e)), i.push(new cr()), i.push(new ur()), i.push(new sr()), i.push(new lr()), t && i.push(new mt(e))), this.readers = i;
    }, r.prototype.reset = function() {
      var e, t;
      if (this.readers !== null)
        try {
          for (var n = Zn(this.readers), i = n.next(); !i.done; i = n.next()) {
            var o = i.value;
            o.reset();
          }
        } catch (a) {
          e = { error: a };
        } finally {
          try {
            i && !i.done && (t = n.return) && t.call(n);
          } finally {
            if (e)
              throw e.error;
          }
        }
    }, r.prototype.decodeInternal = function(e) {
      var t, n;
      if (this.readers === null)
        throw new $n("No readers where selected, nothing can be read.");
      try {
        for (var i = Zn(this.readers), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          try {
            return a.decode(e, this.hints);
          } catch (s) {
            if (s instanceof $n)
              continue;
          }
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
      throw new w("No MultiFormat Readers were able to detect the code.");
    }, r;
  }()
), Lf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Lf(e, r);
  function e(t, n) {
    t === void 0 && (t = null), n === void 0 && (n = 500);
    var i = this, o = new Ti();
    return o.setHints(t), i = r.call(this, o, n) || this, i;
  }
  return e.prototype.decodeBitmap = function(t) {
    return this.reader.decodeWithState(t);
  }, e;
})(wt);
var Ff = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Ff(e, r);
  function e(t) {
    return t === void 0 && (t = 500), r.call(this, new lr(), t) || this;
  }
  return e;
})(wt);
var kf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  kf(e, r);
  function e(t) {
    return t === void 0 && (t = 500), r.call(this, new cr(), t) || this;
  }
  return e;
})(wt);
var Hr;
(function(r) {
  r[r.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", r[r.CHARACTER_SET = 1] = "CHARACTER_SET", r[r.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", r[r.DATA_MATRIX_COMPACT = 3] = "DATA_MATRIX_COMPACT", r[r.MIN_SIZE = 4] = "MIN_SIZE", r[r.MAX_SIZE = 5] = "MAX_SIZE", r[r.MARGIN = 6] = "MARGIN", r[r.PDF417_COMPACT = 7] = "PDF417_COMPACT", r[r.PDF417_COMPACTION = 8] = "PDF417_COMPACTION", r[r.PDF417_DIMENSIONS = 9] = "PDF417_DIMENSIONS", r[r.AZTEC_LAYERS = 10] = "AZTEC_LAYERS", r[r.QR_VERSION = 11] = "QR_VERSION", r[r.GS1_FORMAT = 12] = "GS1_FORMAT", r[r.FORCE_C40 = 13] = "FORCE_C40";
})(Hr || (Hr = {}));
const Zt = Hr;
var Oi = (
  /** @class */
  function() {
    function r(e) {
      this.field = e, this.cachedGenerators = [], this.cachedGenerators.push(new it(e, Int32Array.from([1])));
    }
    return r.prototype.buildGenerator = function(e) {
      var t = this.cachedGenerators;
      if (e >= t.length)
        for (var n = t[t.length - 1], i = this.field, o = t.length; o <= e; o++) {
          var a = n.multiply(new it(i, Int32Array.from([1, i.exp(o - 1 + i.getGeneratorBase())])));
          t.push(a), n = a;
        }
      return t[e];
    }, r.prototype.encode = function(e, t) {
      if (t === 0)
        throw new F("No error correction bytes");
      var n = e.length - t;
      if (n <= 0)
        throw new F("No data bytes provided");
      var i = this.buildGenerator(t), o = new Int32Array(n);
      ne.arraycopy(e, 0, o, 0, n);
      var a = new it(this.field, o);
      a = a.multiplyByMonomial(t, 1);
      for (var s = a.divide(i)[1], f = s.getCoefficients(), u = t - f.length, c = 0; c < u; c++)
        e[n + c] = 0;
      ne.arraycopy(f, 0, e, n + u, f.length);
    }, r;
  }()
), kt = (
  /** @class */
  function() {
    function r() {
    }
    return r.applyMaskPenaltyRule1 = function(e) {
      return r.applyMaskPenaltyRule1Internal(e, !0) + r.applyMaskPenaltyRule1Internal(e, !1);
    }, r.applyMaskPenaltyRule2 = function(e) {
      for (var t = 0, n = e.getArray(), i = e.getWidth(), o = e.getHeight(), a = 0; a < o - 1; a++)
        for (var s = n[a], f = 0; f < i - 1; f++) {
          var u = s[f];
          u === s[f + 1] && u === n[a + 1][f] && u === n[a + 1][f + 1] && t++;
        }
      return r.N2 * t;
    }, r.applyMaskPenaltyRule3 = function(e) {
      for (var t = 0, n = e.getArray(), i = e.getWidth(), o = e.getHeight(), a = 0; a < o; a++)
        for (var s = 0; s < i; s++) {
          var f = n[a];
          s + 6 < i && f[s] === 1 && f[s + 1] === 0 && f[s + 2] === 1 && f[s + 3] === 1 && f[s + 4] === 1 && f[s + 5] === 0 && f[s + 6] === 1 && (r.isWhiteHorizontal(f, s - 4, s) || r.isWhiteHorizontal(f, s + 7, s + 11)) && t++, a + 6 < o && n[a][s] === 1 && n[a + 1][s] === 0 && n[a + 2][s] === 1 && n[a + 3][s] === 1 && n[a + 4][s] === 1 && n[a + 5][s] === 0 && n[a + 6][s] === 1 && (r.isWhiteVertical(n, s, a - 4, a) || r.isWhiteVertical(n, s, a + 7, a + 11)) && t++;
        }
      return t * r.N3;
    }, r.isWhiteHorizontal = function(e, t, n) {
      t = Math.max(t, 0), n = Math.min(n, e.length);
      for (var i = t; i < n; i++)
        if (e[i] === 1)
          return !1;
      return !0;
    }, r.isWhiteVertical = function(e, t, n, i) {
      n = Math.max(n, 0), i = Math.min(i, e.length);
      for (var o = n; o < i; o++)
        if (e[o][t] === 1)
          return !1;
      return !0;
    }, r.applyMaskPenaltyRule4 = function(e) {
      for (var t = 0, n = e.getArray(), i = e.getWidth(), o = e.getHeight(), a = 0; a < o; a++)
        for (var s = n[a], f = 0; f < i; f++)
          s[f] === 1 && t++;
      var u = e.getHeight() * e.getWidth(), c = Math.floor(Math.abs(t * 2 - u) * 10 / u);
      return c * r.N4;
    }, r.getDataMaskBit = function(e, t, n) {
      var i, o;
      switch (e) {
        case 0:
          i = n + t & 1;
          break;
        case 1:
          i = n & 1;
          break;
        case 2:
          i = t % 3;
          break;
        case 3:
          i = (n + t) % 3;
          break;
        case 4:
          i = Math.floor(n / 2) + Math.floor(t / 3) & 1;
          break;
        case 5:
          o = n * t, i = (o & 1) + o % 3;
          break;
        case 6:
          o = n * t, i = (o & 1) + o % 3 & 1;
          break;
        case 7:
          o = n * t, i = o % 3 + (n + t & 1) & 1;
          break;
        default:
          throw new F("Invalid mask pattern: " + e);
      }
      return i === 0;
    }, r.applyMaskPenaltyRule1Internal = function(e, t) {
      for (var n = 0, i = t ? e.getHeight() : e.getWidth(), o = t ? e.getWidth() : e.getHeight(), a = e.getArray(), s = 0; s < i; s++) {
        for (var f = 0, u = -1, c = 0; c < o; c++) {
          var l = t ? a[s][c] : a[c][s];
          l === u ? f++ : (f >= 5 && (n += r.N1 + (f - 5)), f = 1, u = l);
        }
        f >= 5 && (n += r.N1 + (f - 5));
      }
      return n;
    }, r.N1 = 3, r.N2 = 3, r.N3 = 40, r.N4 = 10, r;
  }()
), Uf = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vf = (
  /** @class */
  function() {
    function r(e, t) {
      this.width = e, this.height = t;
      for (var n = new Array(t), i = 0; i !== t; i++)
        n[i] = new Uint8Array(e);
      this.bytes = n;
    }
    return r.prototype.getHeight = function() {
      return this.height;
    }, r.prototype.getWidth = function() {
      return this.width;
    }, r.prototype.get = function(e, t) {
      return this.bytes[t][e];
    }, r.prototype.getArray = function() {
      return this.bytes;
    }, r.prototype.setNumber = function(e, t, n) {
      this.bytes[t][e] = n;
    }, r.prototype.setBoolean = function(e, t, n) {
      this.bytes[t][e] = /*(byte) */
      n ? 1 : 0;
    }, r.prototype.clear = function(e) {
      var t, n;
      try {
        for (var i = Uf(this.bytes), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          me.fill(a, e);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (t)
            throw t.error;
        }
      }
    }, r.prototype.equals = function(e) {
      if (!(e instanceof r))
        return !1;
      var t = e;
      if (this.width !== t.width || this.height !== t.height)
        return !1;
      for (var n = 0, i = this.height; n < i; ++n)
        for (var o = this.bytes[n], a = t.bytes[n], s = 0, f = this.width; s < f; ++s)
          if (o[s] !== a[s])
            return !1;
      return !0;
    }, r.prototype.toString = function() {
      for (var e = new V(), t = 0, n = this.height; t < n; ++t) {
        for (var i = this.bytes[t], o = 0, a = this.width; o < a; ++o)
          switch (i[o]) {
            case 0:
              e.append(" 0");
              break;
            case 1:
              e.append(" 1");
              break;
            default:
              e.append("  ");
              break;
          }
        e.append(`
`);
      }
      return e.toString();
    }, r;
  }()
), jr = (
  /** @class */
  function() {
    function r() {
      this.maskPattern = -1;
    }
    return r.prototype.getMode = function() {
      return this.mode;
    }, r.prototype.getECLevel = function() {
      return this.ecLevel;
    }, r.prototype.getVersion = function() {
      return this.version;
    }, r.prototype.getMaskPattern = function() {
      return this.maskPattern;
    }, r.prototype.getMatrix = function() {
      return this.matrix;
    }, r.prototype.toString = function() {
      var e = new V();
      return e.append(`<<
`), e.append(" mode: "), e.append(this.mode ? this.mode.toString() : "null"), e.append(`
 ecLevel: `), e.append(this.ecLevel ? this.ecLevel.toString() : "null"), e.append(`
 version: `), e.append(this.version ? this.version.toString() : "null"), e.append(`
 maskPattern: `), e.append(this.maskPattern.toString()), this.matrix ? (e.append(`
 matrix:
`), e.append(this.matrix.toString())) : e.append(`
 matrix: null
`), e.append(`>>
`), e.toString();
    }, r.prototype.setMode = function(e) {
      this.mode = e;
    }, r.prototype.setECLevel = function(e) {
      this.ecLevel = e;
    }, r.prototype.setVersion = function(e) {
      this.version = e;
    }, r.prototype.setMaskPattern = function(e) {
      this.maskPattern = e;
    }, r.prototype.setMatrix = function(e) {
      this.matrix = e;
    }, r.isValidMaskPattern = function(e) {
      return e >= 0 && e < r.NUM_MASK_PATTERNS;
    }, r.NUM_MASK_PATTERNS = 8, r;
  }()
), Gf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ae = (
  /** @class */
  function(r) {
    Gf(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.kind = "WriterException", e;
  }(Le)
), Kn = (
  /** @class */
  function() {
    function r() {
    }
    return r.clearMatrix = function(e) {
      e.clear(
        /*(byte) */
        /*-1*/
        255
      );
    }, r.buildMatrix = function(e, t, n, i, o) {
      r.clearMatrix(o), r.embedBasicPatterns(n, o), r.embedTypeInfo(t, i, o), r.maybeEmbedVersionInfo(n, o), r.embedDataBits(e, i, o);
    }, r.embedBasicPatterns = function(e, t) {
      r.embedPositionDetectionPatternsAndSeparators(t), r.embedDarkDotAtLeftBottomCorner(t), r.maybeEmbedPositionAdjustmentPatterns(e, t), r.embedTimingPatterns(t);
    }, r.embedTypeInfo = function(e, t, n) {
      var i = new Ee();
      r.makeTypeInfoBits(e, t, i);
      for (var o = 0, a = i.getSize(); o < a; ++o) {
        var s = i.get(i.getSize() - 1 - o), f = r.TYPE_INFO_COORDINATES[o], u = f[0], c = f[1];
        if (n.setBoolean(u, c, s), o < 8) {
          var l = n.getWidth() - o - 1, d = 8;
          n.setBoolean(l, d, s);
        } else {
          var l = 8, d = n.getHeight() - 7 + (o - 8);
          n.setBoolean(l, d, s);
        }
      }
    }, r.maybeEmbedVersionInfo = function(e, t) {
      if (!(e.getVersionNumber() < 7)) {
        var n = new Ee();
        r.makeVersionInfoBits(e, n);
        for (var i = 6 * 3 - 1, o = 0; o < 6; ++o)
          for (var a = 0; a < 3; ++a) {
            var s = n.get(i);
            i--, t.setBoolean(o, t.getHeight() - 11 + a, s), t.setBoolean(t.getHeight() - 11 + a, o, s);
          }
      }
    }, r.embedDataBits = function(e, t, n) {
      for (var i = 0, o = -1, a = n.getWidth() - 1, s = n.getHeight() - 1; a > 0; ) {
        for (a === 6 && (a -= 1); s >= 0 && s < n.getHeight(); ) {
          for (var f = 0; f < 2; ++f) {
            var u = a - f;
            if (r.isEmpty(n.get(u, s))) {
              var c = void 0;
              i < e.getSize() ? (c = e.get(i), ++i) : c = !1, t !== 255 && kt.getDataMaskBit(t, u, s) && (c = !c), n.setBoolean(u, s, c);
            }
          }
          s += o;
        }
        o = -o, s += o, a -= 2;
      }
      if (i !== e.getSize())
        throw new ae("Not all bits consumed: " + i + "/" + e.getSize());
    }, r.findMSBSet = function(e) {
      return 32 - G.numberOfLeadingZeros(e);
    }, r.calculateBCHCode = function(e, t) {
      if (t === 0)
        throw new F("0 polynomial");
      var n = r.findMSBSet(t);
      for (e <<= n - 1; r.findMSBSet(e) >= n; )
        e ^= t << r.findMSBSet(e) - n;
      return e;
    }, r.makeTypeInfoBits = function(e, t, n) {
      if (!jr.isValidMaskPattern(t))
        throw new ae("Invalid mask pattern");
      var i = e.getBits() << 3 | t;
      n.appendBits(i, 5);
      var o = r.calculateBCHCode(i, r.TYPE_INFO_POLY);
      n.appendBits(o, 10);
      var a = new Ee();
      if (a.appendBits(r.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), n.getSize() !== 15)
        throw new ae("should not happen but we got: " + n.getSize());
    }, r.makeVersionInfoBits = function(e, t) {
      t.appendBits(e.getVersionNumber(), 6);
      var n = r.calculateBCHCode(e.getVersionNumber(), r.VERSION_INFO_POLY);
      if (t.appendBits(n, 12), t.getSize() !== 18)
        throw new ae("should not happen but we got: " + t.getSize());
    }, r.isEmpty = function(e) {
      return e === 255;
    }, r.embedTimingPatterns = function(e) {
      for (var t = 8; t < e.getWidth() - 8; ++t) {
        var n = (t + 1) % 2;
        r.isEmpty(e.get(t, 6)) && e.setNumber(t, 6, n), r.isEmpty(e.get(6, t)) && e.setNumber(6, t, n);
      }
    }, r.embedDarkDotAtLeftBottomCorner = function(e) {
      if (e.get(8, e.getHeight() - 8) === 0)
        throw new ae();
      e.setNumber(8, e.getHeight() - 8, 1);
    }, r.embedHorizontalSeparationPattern = function(e, t, n) {
      for (var i = 0; i < 8; ++i) {
        if (!r.isEmpty(n.get(e + i, t)))
          throw new ae();
        n.setNumber(e + i, t, 0);
      }
    }, r.embedVerticalSeparationPattern = function(e, t, n) {
      for (var i = 0; i < 7; ++i) {
        if (!r.isEmpty(n.get(e, t + i)))
          throw new ae();
        n.setNumber(e, t + i, 0);
      }
    }, r.embedPositionAdjustmentPattern = function(e, t, n) {
      for (var i = 0; i < 5; ++i)
        for (var o = r.POSITION_ADJUSTMENT_PATTERN[i], a = 0; a < 5; ++a)
          n.setNumber(e + a, t + i, o[a]);
    }, r.embedPositionDetectionPattern = function(e, t, n) {
      for (var i = 0; i < 7; ++i)
        for (var o = r.POSITION_DETECTION_PATTERN[i], a = 0; a < 7; ++a)
          n.setNumber(e + a, t + i, o[a]);
    }, r.embedPositionDetectionPatternsAndSeparators = function(e) {
      var t = r.POSITION_DETECTION_PATTERN[0].length;
      r.embedPositionDetectionPattern(0, 0, e), r.embedPositionDetectionPattern(e.getWidth() - t, 0, e), r.embedPositionDetectionPattern(0, e.getWidth() - t, e);
      var n = 8;
      r.embedHorizontalSeparationPattern(0, n - 1, e), r.embedHorizontalSeparationPattern(e.getWidth() - n, n - 1, e), r.embedHorizontalSeparationPattern(0, e.getWidth() - n, e);
      var i = 7;
      r.embedVerticalSeparationPattern(i, 0, e), r.embedVerticalSeparationPattern(e.getHeight() - i - 1, 0, e), r.embedVerticalSeparationPattern(i, e.getHeight() - i, e);
    }, r.maybeEmbedPositionAdjustmentPatterns = function(e, t) {
      if (!(e.getVersionNumber() < 2))
        for (var n = e.getVersionNumber() - 1, i = r.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], o = 0, a = i.length; o !== a; o++) {
          var s = i[o];
          if (s >= 0)
            for (var f = 0; f !== a; f++) {
              var u = i[f];
              u >= 0 && r.isEmpty(t.get(u, s)) && r.embedPositionAdjustmentPattern(u - 2, s - 2, t);
            }
        }
    }, r.POSITION_DETECTION_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 1, 1, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1, 1, 1])
    ]), r.POSITION_ADJUSTMENT_PATTERN = Array.from([
      Int32Array.from([1, 1, 1, 1, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 0, 1, 0, 1]),
      Int32Array.from([1, 0, 0, 0, 1]),
      Int32Array.from([1, 1, 1, 1, 1])
    ]), r.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
      Int32Array.from([-1, -1, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 18, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 26, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 30, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 34, -1, -1, -1, -1, -1]),
      Int32Array.from([6, 22, 38, -1, -1, -1, -1]),
      Int32Array.from([6, 24, 42, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, -1, -1, -1, -1]),
      Int32Array.from([6, 28, 50, -1, -1, -1, -1]),
      Int32Array.from([6, 30, 54, -1, -1, -1, -1]),
      Int32Array.from([6, 32, 58, -1, -1, -1, -1]),
      Int32Array.from([6, 34, 62, -1, -1, -1, -1]),
      Int32Array.from([6, 26, 46, 66, -1, -1, -1]),
      Int32Array.from([6, 26, 48, 70, -1, -1, -1]),
      Int32Array.from([6, 26, 50, 74, -1, -1, -1]),
      Int32Array.from([6, 30, 54, 78, -1, -1, -1]),
      Int32Array.from([6, 30, 56, 82, -1, -1, -1]),
      Int32Array.from([6, 30, 58, 86, -1, -1, -1]),
      Int32Array.from([6, 34, 62, 90, -1, -1, -1]),
      Int32Array.from([6, 28, 50, 72, 94, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, -1, -1]),
      Int32Array.from([6, 30, 54, 78, 102, -1, -1]),
      Int32Array.from([6, 28, 54, 80, 106, -1, -1]),
      Int32Array.from([6, 32, 58, 84, 110, -1, -1]),
      Int32Array.from([6, 30, 58, 86, 114, -1, -1]),
      Int32Array.from([6, 34, 62, 90, 118, -1, -1]),
      Int32Array.from([6, 26, 50, 74, 98, 122, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, -1]),
      Int32Array.from([6, 26, 52, 78, 104, 130, -1]),
      Int32Array.from([6, 30, 56, 82, 108, 134, -1]),
      Int32Array.from([6, 34, 60, 86, 112, 138, -1]),
      Int32Array.from([6, 30, 58, 86, 114, 142, -1]),
      Int32Array.from([6, 34, 62, 90, 118, 146, -1]),
      Int32Array.from([6, 30, 54, 78, 102, 126, 150]),
      Int32Array.from([6, 24, 50, 76, 102, 128, 154]),
      Int32Array.from([6, 28, 54, 80, 106, 132, 158]),
      Int32Array.from([6, 32, 58, 84, 110, 136, 162]),
      Int32Array.from([6, 26, 54, 82, 110, 138, 166]),
      Int32Array.from([6, 30, 58, 86, 114, 142, 170])
    ]), r.TYPE_INFO_COORDINATES = Array.from([
      Int32Array.from([8, 0]),
      Int32Array.from([8, 1]),
      Int32Array.from([8, 2]),
      Int32Array.from([8, 3]),
      Int32Array.from([8, 4]),
      Int32Array.from([8, 5]),
      Int32Array.from([8, 7]),
      Int32Array.from([8, 8]),
      Int32Array.from([7, 8]),
      Int32Array.from([5, 8]),
      Int32Array.from([4, 8]),
      Int32Array.from([3, 8]),
      Int32Array.from([2, 8]),
      Int32Array.from([1, 8]),
      Int32Array.from([0, 8])
    ]), r.VERSION_INFO_POLY = 7973, r.TYPE_INFO_POLY = 1335, r.TYPE_INFO_MASK_PATTERN = 21522, r;
  }()
), Hf = (
  /** @class */
  function() {
    function r(e, t) {
      this.dataBytes = e, this.errorCorrectionBytes = t;
    }
    return r.prototype.getDataBytes = function() {
      return this.dataBytes;
    }, r.prototype.getErrorCorrectionBytes = function() {
      return this.errorCorrectionBytes;
    }, r;
  }()
), qn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function r() {
  }
  return r.calculateMaskPenalty = function(e) {
    return kt.applyMaskPenaltyRule1(e) + kt.applyMaskPenaltyRule2(e) + kt.applyMaskPenaltyRule3(e) + kt.applyMaskPenaltyRule4(e);
  }, r.encode = function(e, t, n) {
    n === void 0 && (n = null);
    var i = r.DEFAULT_BYTE_MODE_ENCODING, o = n !== null && n.get(Zt.CHARACTER_SET) !== void 0;
    o && (i = n.get(Zt.CHARACTER_SET).toString());
    var a = this.chooseMode(e, i), s = new Ee();
    if (a === se.BYTE && (o || r.DEFAULT_BYTE_MODE_ENCODING !== i)) {
      var f = ye.getCharacterSetECIByName(i);
      f !== void 0 && this.appendECI(f, s);
    }
    this.appendModeInfo(a, s);
    var u = new Ee();
    this.appendBytes(e, a, u, i);
    var c;
    if (n !== null && n.get(Zt.QR_VERSION) !== void 0) {
      var l = Number.parseInt(n.get(Zt.QR_VERSION).toString(), 10);
      c = ht.getVersionForNumber(l);
      var d = this.calculateBitsNeeded(a, s, u, c);
      if (!this.willFit(d, c, t))
        throw new ae("Data too big for requested version");
    } else
      c = this.recommendVersion(t, a, s, u);
    var h = new Ee();
    h.appendBitArray(s);
    var p = a === se.BYTE ? u.getSizeInBytes() : e.length;
    this.appendLengthInfo(p, c, a, h), h.appendBitArray(u);
    var v = c.getECBlocksForLevel(t), y = c.getTotalCodewords() - v.getTotalECCodewords();
    this.terminateBits(y, h);
    var _ = this.interleaveWithECBytes(h, c.getTotalCodewords(), y, v.getNumBlocks()), x = new jr();
    x.setECLevel(t), x.setMode(a), x.setVersion(c);
    var C = c.getDimensionForVersion(), E = new Vf(C, C), S = this.chooseMaskPattern(_, t, c, E);
    return x.setMaskPattern(S), Kn.buildMatrix(_, t, c, S, E), x.setMatrix(E), x;
  }, r.recommendVersion = function(e, t, n, i) {
    var o = this.calculateBitsNeeded(t, n, i, ht.getVersionForNumber(1)), a = this.chooseVersion(o, e), s = this.calculateBitsNeeded(t, n, i, a);
    return this.chooseVersion(s, e);
  }, r.calculateBitsNeeded = function(e, t, n, i) {
    return t.getSize() + e.getCharacterCountBits(i) + n.getSize();
  }, r.getAlphanumericCode = function(e) {
    return e < r.ALPHANUMERIC_TABLE.length ? r.ALPHANUMERIC_TABLE[e] : -1;
  }, r.chooseMode = function(e, t) {
    if (t === void 0 && (t = null), ye.SJIS.getName() === t && this.isOnlyDoubleByteKanji(e))
      return se.KANJI;
    for (var n = !1, i = !1, o = 0, a = e.length; o < a; ++o) {
      var s = e.charAt(o);
      if (r.isDigit(s))
        n = !0;
      else if (this.getAlphanumericCode(s.charCodeAt(0)) !== -1)
        i = !0;
      else
        return se.BYTE;
    }
    return i ? se.ALPHANUMERIC : n ? se.NUMERIC : se.BYTE;
  }, r.isOnlyDoubleByteKanji = function(e) {
    var t;
    try {
      t = Ve.encode(e, ye.SJIS);
    } catch {
      return !1;
    }
    var n = t.length;
    if (n % 2 !== 0)
      return !1;
    for (var i = 0; i < n; i += 2) {
      var o = t[i] & 255;
      if ((o < 129 || o > 159) && (o < 224 || o > 235))
        return !1;
    }
    return !0;
  }, r.chooseMaskPattern = function(e, t, n, i) {
    for (var o = Number.MAX_SAFE_INTEGER, a = -1, s = 0; s < jr.NUM_MASK_PATTERNS; s++) {
      Kn.buildMatrix(e, t, n, s, i);
      var f = this.calculateMaskPenalty(i);
      f < o && (o = f, a = s);
    }
    return a;
  }, r.chooseVersion = function(e, t) {
    for (var n = 1; n <= 40; n++) {
      var i = ht.getVersionForNumber(n);
      if (r.willFit(e, i, t))
        return i;
    }
    throw new ae("Data too big");
  }, r.willFit = function(e, t, n) {
    var i = t.getTotalCodewords(), o = t.getECBlocksForLevel(n), a = o.getTotalECCodewords(), s = i - a, f = (e + 7) / 8;
    return s >= f;
  }, r.terminateBits = function(e, t) {
    var n = e * 8;
    if (t.getSize() > n)
      throw new ae("data bits cannot fit in the QR Code" + t.getSize() + " > " + n);
    for (var i = 0; i < 4 && t.getSize() < n; ++i)
      t.appendBit(!1);
    var o = t.getSize() & 7;
    if (o > 0)
      for (var i = o; i < 8; i++)
        t.appendBit(!1);
    for (var a = e - t.getSizeInBytes(), i = 0; i < a; ++i)
      t.appendBits(i & 1 ? 17 : 236, 8);
    if (t.getSize() !== n)
      throw new ae("Bits size does not equal capacity");
  }, r.getNumDataBytesAndNumECBytesForBlockID = function(e, t, n, i, o, a) {
    if (i >= n)
      throw new ae("Block ID too large");
    var s = e % n, f = n - s, u = Math.floor(e / n), c = u + 1, l = Math.floor(t / n), d = l + 1, h = u - l, p = c - d;
    if (h !== p)
      throw new ae("EC bytes mismatch");
    if (n !== f + s)
      throw new ae("RS blocks mismatch");
    if (e !== (l + h) * f + (d + p) * s)
      throw new ae("Total bytes mismatch");
    i < f ? (o[0] = l, a[0] = h) : (o[0] = d, a[0] = p);
  }, r.interleaveWithECBytes = function(e, t, n, i) {
    var o, a, s, f;
    if (e.getSizeInBytes() !== n)
      throw new ae("Number of bits and data bytes does not match");
    for (var u = 0, c = 0, l = 0, d = new Array(), h = 0; h < i; ++h) {
      var p = new Int32Array(1), v = new Int32Array(1);
      r.getNumDataBytesAndNumECBytesForBlockID(t, n, i, h, p, v);
      var y = p[0], _ = new Uint8Array(y);
      e.toBytes(8 * u, _, 0, y);
      var x = r.generateECBytes(_, v[0]);
      d.push(new Hf(_, x)), c = Math.max(c, y), l = Math.max(l, x.length), u += p[0];
    }
    if (n !== u)
      throw new ae("Data bytes does not match offset");
    for (var C = new Ee(), h = 0; h < c; ++h)
      try {
        for (var E = (o = void 0, qn(d)), S = E.next(); !S.done; S = E.next()) {
          var I = S.value, _ = I.getDataBytes();
          h < _.length && C.appendBits(_[h], 8);
        }
      } catch (M) {
        o = { error: M };
      } finally {
        try {
          S && !S.done && (a = E.return) && a.call(E);
        } finally {
          if (o)
            throw o.error;
        }
      }
    for (var h = 0; h < l; ++h)
      try {
        for (var T = (s = void 0, qn(d)), R = T.next(); !R.done; R = T.next()) {
          var I = R.value, x = I.getErrorCorrectionBytes();
          h < x.length && C.appendBits(x[h], 8);
        }
      } catch (M) {
        s = { error: M };
      } finally {
        try {
          R && !R.done && (f = T.return) && f.call(T);
        } finally {
          if (s)
            throw s.error;
        }
      }
    if (t !== C.getSizeInBytes())
      throw new ae("Interleaving error: " + t + " and " + C.getSizeInBytes() + " differ.");
    return C;
  }, r.generateECBytes = function(e, t) {
    for (var n = e.length, i = new Int32Array(n + t), o = 0; o < n; o++)
      i[o] = e[o] & 255;
    new Oi(Be.QR_CODE_FIELD_256).encode(i, t);
    for (var a = new Uint8Array(t), o = 0; o < t; o++)
      a[o] = /*(byte) */
      i[n + o];
    return a;
  }, r.appendModeInfo = function(e, t) {
    t.appendBits(e.getBits(), 4);
  }, r.appendLengthInfo = function(e, t, n, i) {
    var o = n.getCharacterCountBits(t);
    if (e >= 1 << o)
      throw new ae(e + " is bigger than " + ((1 << o) - 1));
    i.appendBits(e, o);
  }, r.appendBytes = function(e, t, n, i) {
    switch (t) {
      case se.NUMERIC:
        r.appendNumericBytes(e, n);
        break;
      case se.ALPHANUMERIC:
        r.appendAlphanumericBytes(e, n);
        break;
      case se.BYTE:
        r.append8BitBytes(e, n, i);
        break;
      case se.KANJI:
        r.appendKanjiBytes(e, n);
        break;
      default:
        throw new ae("Invalid mode: " + t);
    }
  }, r.getDigit = function(e) {
    return e.charCodeAt(0) - 48;
  }, r.isDigit = function(e) {
    var t = r.getDigit(e);
    return t >= 0 && t <= 9;
  }, r.appendNumericBytes = function(e, t) {
    for (var n = e.length, i = 0; i < n; ) {
      var o = r.getDigit(e.charAt(i));
      if (i + 2 < n) {
        var a = r.getDigit(e.charAt(i + 1)), s = r.getDigit(e.charAt(i + 2));
        t.appendBits(o * 100 + a * 10 + s, 10), i += 3;
      } else if (i + 1 < n) {
        var a = r.getDigit(e.charAt(i + 1));
        t.appendBits(o * 10 + a, 7), i += 2;
      } else
        t.appendBits(o, 4), i++;
    }
  }, r.appendAlphanumericBytes = function(e, t) {
    for (var n = e.length, i = 0; i < n; ) {
      var o = r.getAlphanumericCode(e.charCodeAt(i));
      if (o === -1)
        throw new ae();
      if (i + 1 < n) {
        var a = r.getAlphanumericCode(e.charCodeAt(i + 1));
        if (a === -1)
          throw new ae();
        t.appendBits(o * 45 + a, 11), i += 2;
      } else
        t.appendBits(o, 6), i++;
    }
  }, r.append8BitBytes = function(e, t, n) {
    var i;
    try {
      i = Ve.encode(e, n);
    } catch (f) {
      throw new ae(f);
    }
    for (var o = 0, a = i.length; o !== a; o++) {
      var s = i[o];
      t.appendBits(s, 8);
    }
  }, r.appendKanjiBytes = function(e, t) {
    var n;
    try {
      n = Ve.encode(e, ye.SJIS);
    } catch (l) {
      throw new ae(l);
    }
    for (var i = n.length, o = 0; o < i; o += 2) {
      var a = n[o] & 255, s = n[o + 1] & 255, f = a << 8 & 4294967295 | s, u = -1;
      if (f >= 33088 && f <= 40956 ? u = f - 33088 : f >= 57408 && f <= 60351 && (u = f - 49472), u === -1)
        throw new ae("Invalid byte sequence");
      var c = (u >> 8) * 192 + (u & 255);
      t.appendBits(c, 13);
    }
  }, r.appendECI = function(e, t) {
    t.appendBits(se.ECI.getBits(), 4), t.appendBits(e.getValue(), 8);
  }, r.ALPHANUMERIC_TABLE = Int32Array.from([
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    36,
    -1,
    -1,
    -1,
    37,
    38,
    -1,
    -1,
    -1,
    -1,
    39,
    40,
    -1,
    41,
    42,
    43,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    44,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    -1,
    -1,
    -1,
    -1,
    -1
  ]), r.DEFAULT_BYTE_MODE_ENCODING = ye.UTF8.getName(), r;
})();
var jf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  jf(e, r);
  function e(t, n, i, o, a, s, f, u) {
    var c = r.call(this, s, f) || this;
    if (c.yuvData = t, c.dataWidth = n, c.dataHeight = i, c.left = o, c.top = a, o + s > n || a + f > i)
      throw new F("Crop rectangle does not fit within image data.");
    return u && c.reverseHorizontal(s, f), c;
  }
  return e.prototype.getRow = function(t, n) {
    if (t < 0 || t >= this.getHeight())
      throw new F("Requested row is outside the image: " + t);
    var i = this.getWidth();
    (n == null || n.length < i) && (n = new Uint8ClampedArray(i));
    var o = (t + this.top) * this.dataWidth + this.left;
    return ne.arraycopy(this.yuvData, o, n, 0, i), n;
  }, e.prototype.getMatrix = function() {
    var t = this.getWidth(), n = this.getHeight();
    if (t === this.dataWidth && n === this.dataHeight)
      return this.yuvData;
    var i = t * n, o = new Uint8ClampedArray(i), a = this.top * this.dataWidth + this.left;
    if (t === this.dataWidth)
      return ne.arraycopy(this.yuvData, a, o, 0, i), o;
    for (var s = 0; s < n; s++) {
      var f = s * t;
      ne.arraycopy(this.yuvData, a, o, f, t), a += this.dataWidth;
    }
    return o;
  }, e.prototype.isCropSupported = function() {
    return !0;
  }, e.prototype.crop = function(t, n, i, o) {
    return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + n, i, o, !1);
  }, e.prototype.renderThumbnail = function() {
    for (var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, n = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, i = new Int32Array(t * n), o = this.yuvData, a = this.top * this.dataWidth + this.left, s = 0; s < n; s++) {
      for (var f = s * t, u = 0; u < t; u++) {
        var c = o[a + u * e.THUMBNAIL_SCALE_FACTOR] & 255;
        i[f + u] = 4278190080 | c * 65793;
      }
      a += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
    }
    return i;
  }, e.prototype.getThumbnailWidth = function() {
    return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
  }, e.prototype.getThumbnailHeight = function() {
    return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
  }, e.prototype.reverseHorizontal = function(t, n) {
    for (var i = this.yuvData, o = 0, a = this.top * this.dataWidth + this.left; o < n; o++, a += this.dataWidth)
      for (var s = a + t / 2, f = a, u = a + t - 1; f < s; f++, u--) {
        var c = i[f];
        i[f] = i[u], i[u] = c;
      }
  }, e.prototype.invert = function() {
    return new hr(this);
  }, e.THUMBNAIL_SCALE_FACTOR = 2, e;
})(Ut);
var Wf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Wf(e, r);
  function e(t, n, i, o, a, s, f) {
    var u = r.call(this, n, i) || this;
    if (u.dataWidth = o, u.dataHeight = a, u.left = s, u.top = f, t.BYTES_PER_ELEMENT === 4) {
      for (var c = n * i, l = new Uint8ClampedArray(c), d = 0; d < c; d++) {
        var h = t[d], p = h >> 16 & 255, v = h >> 7 & 510, y = h & 255;
        l[d] = /*(byte) */
        (p + v + y) / 4 & 255;
      }
      u.luminances = l;
    } else
      u.luminances = t;
    if (o === void 0 && (u.dataWidth = n), a === void 0 && (u.dataHeight = i), s === void 0 && (u.left = 0), f === void 0 && (u.top = 0), u.left + n > u.dataWidth || u.top + i > u.dataHeight)
      throw new F("Crop rectangle does not fit within image data.");
    return u;
  }
  return e.prototype.getRow = function(t, n) {
    if (t < 0 || t >= this.getHeight())
      throw new F("Requested row is outside the image: " + t);
    var i = this.getWidth();
    (n == null || n.length < i) && (n = new Uint8ClampedArray(i));
    var o = (t + this.top) * this.dataWidth + this.left;
    return ne.arraycopy(this.luminances, o, n, 0, i), n;
  }, e.prototype.getMatrix = function() {
    var t = this.getWidth(), n = this.getHeight();
    if (t === this.dataWidth && n === this.dataHeight)
      return this.luminances;
    var i = t * n, o = new Uint8ClampedArray(i), a = this.top * this.dataWidth + this.left;
    if (t === this.dataWidth)
      return ne.arraycopy(this.luminances, a, o, 0, i), o;
    for (var s = 0; s < n; s++) {
      var f = s * t;
      ne.arraycopy(this.luminances, a, o, f, t), a += this.dataWidth;
    }
    return o;
  }, e.prototype.isCropSupported = function() {
    return !0;
  }, e.prototype.crop = function(t, n, i, o) {
    return new e(this.luminances, i, o, this.dataWidth, this.dataHeight, this.left + t, this.top + n);
  }, e.prototype.invert = function() {
    return new hr(this);
  }, e;
})(Ut);
var Xf = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), zf = (
  /** @class */
  function(r) {
    Xf(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.forName = function(t) {
      return this.getCharacterSetECIByName(t);
    }, e;
  }(ye)
), Yf = (
  /** @class */
  function() {
    function r() {
    }
    return r.ISO_8859_1 = ye.ISO8859_1, r;
  }()
), Wr, $f = 301, Zf = function(r, e) {
  for (var t = 1, n = 0; n < 255; n++)
    e[n] = t, r[t] = n, t *= 2, t >= 256 && (t ^= $f);
  return {
    LOG: r,
    ALOG: e
  };
};
Wr = Zf([], []), Wr.LOG;
Wr.ALOG;
var Qn;
(function(r) {
  r[r.FORCE_NONE = 0] = "FORCE_NONE", r[r.FORCE_SQUARE = 1] = "FORCE_SQUARE", r[r.FORCE_RECTANGLE = 2] = "FORCE_RECTANGLE";
})(Qn || (Qn = {}));
var Jn = 129, Ri = 230, Kf = 231, qf = 235, Qf = 236, Jf = 237, eu = 238, tu = 239, ru = 240, Or = 254, nu = 254, ei = "[)>05", ti = "[)>06", ri = "", J = 0, Ie = 1, Ne = 2, ge = 3, Ae = 4, Te = 5, iu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getEncodingMode = function() {
      return J;
    }, r.prototype.encode = function(e) {
      var t = We.determineConsecutiveDigitCount(e.getMessage(), e.pos);
      if (t >= 2)
        e.writeCodeword(this.encodeASCIIDigits(e.getMessage().charCodeAt(e.pos), e.getMessage().charCodeAt(e.pos + 1))), e.pos += 2;
      else {
        var n = e.getCurrentChar(), i = We.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
        if (i !== this.getEncodingMode())
          switch (i) {
            case Te:
              e.writeCodeword(Kf), e.signalEncoderChange(Te);
              return;
            case Ie:
              e.writeCodeword(Ri), e.signalEncoderChange(Ie);
              return;
            case ge:
              e.writeCodeword(eu), e.signalEncoderChange(ge);
              break;
            case Ne:
              e.writeCodeword(tu), e.signalEncoderChange(Ne);
              break;
            case Ae:
              e.writeCodeword(ru), e.signalEncoderChange(Ae);
              break;
            default:
              throw new Error("Illegal mode: " + i);
          }
        else
          We.isExtendedASCII(n) ? (e.writeCodeword(qf), e.writeCodeword(n - 128 + 1), e.pos++) : (e.writeCodeword(n + 1), e.pos++);
      }
    }, r.prototype.encodeASCIIDigits = function(e, t) {
      if (We.isDigit(e) && We.isDigit(t)) {
        var n = (e - 48) * 10 + (t - 48);
        return n + 130;
      }
      throw new Error("not digits: " + e + t);
    }, r;
  }()
), ou = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getEncodingMode = function() {
      return Te;
    }, r.prototype.encode = function(e) {
      var t = new V();
      for (t.append(0); e.hasMoreCharacters(); ) {
        var n = e.getCurrentChar();
        t.append(n), e.pos++;
        var i = We.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
        if (i !== this.getEncodingMode()) {
          e.signalEncoderChange(J);
          break;
        }
      }
      var o = t.length() - 1, a = 1, s = e.getCodewordCount() + o + a;
      e.updateSymbolInfo(s);
      var f = e.getSymbolInfo().getDataCapacity() - s > 0;
      if (e.hasMoreCharacters() || f)
        if (o <= 249)
          t.setCharAt(0, X.getCharAt(o));
        else if (o <= 1555)
          t.setCharAt(0, X.getCharAt(Math.floor(o / 250) + 249)), t.insert(1, X.getCharAt(o % 250));
        else
          throw new Error("Message length not in valid ranges: " + o);
      for (var u = 0, n = t.length(); u < n; u++)
        e.writeCodeword(this.randomize255State(t.charAt(u).charCodeAt(0), e.getCodewordCount() + 1));
    }, r.prototype.randomize255State = function(e, t) {
      var n = 149 * t % 255 + 1, i = e + n;
      return i <= 255 ? i : i - 256;
    }, r;
  }()
), nn = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getEncodingMode = function() {
      return Ie;
    }, r.prototype.encodeMaximal = function(e) {
      for (var t = new V(), n = 0, i = e.pos, o = 0; e.hasMoreCharacters(); ) {
        var a = e.getCurrentChar();
        e.pos++, n = this.encodeChar(a, t), t.length() % 3 === 0 && (i = e.pos, o = t.length());
      }
      if (o !== t.length()) {
        var s = Math.floor(t.length() / 3 * 2), f = Math.floor(e.getCodewordCount() + s + 1);
        e.updateSymbolInfo(f);
        var u = e.getSymbolInfo().getDataCapacity() - f, c = Math.floor(t.length() % 3);
        (c === 2 && u !== 2 || c === 1 && (n > 3 || u !== 1)) && (e.pos = i);
      }
      t.length() > 0 && e.writeCodeword(Ri), this.handleEOD(e, t);
    }, r.prototype.encode = function(e) {
      for (var t = new V(); e.hasMoreCharacters(); ) {
        var n = e.getCurrentChar();
        e.pos++;
        var i = this.encodeChar(n, t), o = Math.floor(t.length() / 3) * 2, a = e.getCodewordCount() + o;
        e.updateSymbolInfo(a);
        var s = e.getSymbolInfo().getDataCapacity() - a;
        if (!e.hasMoreCharacters()) {
          var f = new V();
          for (t.length() % 3 === 2 && s !== 2 && (i = this.backtrackOneCharacter(e, t, f, i)); t.length() % 3 === 1 && (i > 3 || s !== 1); )
            i = this.backtrackOneCharacter(e, t, f, i);
          break;
        }
        var u = t.length();
        if (u % 3 === 0) {
          var c = We.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
          if (c !== this.getEncodingMode()) {
            e.signalEncoderChange(J);
            break;
          }
        }
      }
      this.handleEOD(e, t);
    }, r.prototype.backtrackOneCharacter = function(e, t, n, i) {
      var o = t.length(), a = t.toString().substring(0, o - i);
      t.setLengthToZero(), t.append(a), e.pos--;
      var s = e.getCurrentChar();
      return i = this.encodeChar(s, n), e.resetSymbolInfo(), i;
    }, r.prototype.writeNextTriplet = function(e, t) {
      e.writeCodewords(this.encodeToCodewords(t.toString()));
      var n = t.toString().substring(3);
      t.setLengthToZero(), t.append(n);
    }, r.prototype.handleEOD = function(e, t) {
      var n = Math.floor(t.length() / 3 * 2), i = t.length() % 3, o = e.getCodewordCount() + n;
      e.updateSymbolInfo(o);
      var a = e.getSymbolInfo().getDataCapacity() - o;
      if (i === 2) {
        for (t.append("\0"); t.length() >= 3; )
          this.writeNextTriplet(e, t);
        e.hasMoreCharacters() && e.writeCodeword(Or);
      } else if (a === 1 && i === 1) {
        for (; t.length() >= 3; )
          this.writeNextTriplet(e, t);
        e.hasMoreCharacters() && e.writeCodeword(Or), e.pos--;
      } else if (i === 0) {
        for (; t.length() >= 3; )
          this.writeNextTriplet(e, t);
        (a > 0 || e.hasMoreCharacters()) && e.writeCodeword(Or);
      } else
        throw new Error("Unexpected case. Please report!");
      e.signalEncoderChange(J);
    }, r.prototype.encodeChar = function(e, t) {
      if (e === 32)
        return t.append(3), 1;
      if (e >= 48 && e <= 57)
        return t.append(e - 48 + 4), 1;
      if (e >= 65 && e <= 90)
        return t.append(e - 65 + 14), 1;
      if (e < 32)
        return t.append(0), t.append(e), 2;
      if (e <= 47)
        return t.append(1), t.append(e - 33), 2;
      if (e <= 64)
        return t.append(1), t.append(e - 58 + 15), 2;
      if (e <= 95)
        return t.append(1), t.append(e - 91 + 22), 2;
      if (e <= 127)
        return t.append(2), t.append(e - 96), 2;
      t.append("1");
      var n = 2;
      return n += this.encodeChar(e - 128, t), n;
    }, r.prototype.encodeToCodewords = function(e) {
      var t = 1600 * e.charCodeAt(0) + 40 * e.charCodeAt(1) + e.charCodeAt(2) + 1, n = t / 256, i = t % 256, o = new V();
      return o.append(n), o.append(i), o.toString();
    }, r;
  }()
), au = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.getEncodingMode = function() {
      return Ae;
    }, r.prototype.encode = function(e) {
      for (var t = new V(); e.hasMoreCharacters(); ) {
        var n = e.getCurrentChar();
        this.encodeChar(n, t), e.pos++;
        var i = t.length();
        if (i >= 4) {
          e.writeCodewords(this.encodeToCodewords(t.toString()));
          var o = t.toString().substring(4);
          t.setLengthToZero(), t.append(o);
          var a = We.lookAheadTest(e.getMessage(), e.pos, this.getEncodingMode());
          if (a !== this.getEncodingMode()) {
            e.signalEncoderChange(J);
            break;
          }
        }
      }
      t.append(X.getCharAt(31)), this.handleEOD(e, t);
    }, r.prototype.handleEOD = function(e, t) {
      try {
        var n = t.length();
        if (n === 0)
          return;
        if (n === 1) {
          e.updateSymbolInfo();
          var i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount(), o = e.getRemainingCharacters();
          if (o > i && (e.updateSymbolInfo(e.getCodewordCount() + 1), i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount()), o <= i && i <= 2)
            return;
        }
        if (n > 4)
          throw new Error("Count must not exceed 4");
        var a = n - 1, s = this.encodeToCodewords(t.toString()), f = !e.hasMoreCharacters(), u = f && a <= 2;
        if (a <= 2) {
          e.updateSymbolInfo(e.getCodewordCount() + a);
          var i = e.getSymbolInfo().getDataCapacity() - e.getCodewordCount();
          i >= 3 && (u = !1, e.updateSymbolInfo(e.getCodewordCount() + s.length));
        }
        u ? (e.resetSymbolInfo(), e.pos -= a) : e.writeCodewords(s);
      } finally {
        e.signalEncoderChange(J);
      }
    }, r.prototype.encodeChar = function(e, t) {
      e >= 32 && e <= 63 ? t.append(e) : e >= 64 && e <= 94 ? t.append(X.getCharAt(e - 64)) : We.illegalCharacter(X.getCharAt(e));
    }, r.prototype.encodeToCodewords = function(e) {
      var t = e.length;
      if (t === 0)
        throw new Error("StringBuilder must not be empty");
      var n = e.charAt(0).charCodeAt(0), i = t >= 2 ? e.charAt(1).charCodeAt(0) : 0, o = t >= 3 ? e.charAt(2).charCodeAt(0) : 0, a = t >= 4 ? e.charAt(3).charCodeAt(0) : 0, s = (n << 18) + (i << 12) + (o << 6) + a, f = s >> 16 & 255, u = s >> 8 & 255, c = s & 255, l = new V();
      return l.append(f), t >= 2 && l.append(u), t >= 3 && l.append(c), l.toString();
    }, r;
  }()
), su = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), fu = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, K = (
  /** @class */
  function() {
    function r(e, t, n, i, o, a, s, f) {
      s === void 0 && (s = 0), f === void 0 && (f = 0), this.rectangular = e, this.dataCapacity = t, this.errorCodewords = n, this.matrixWidth = i, this.matrixHeight = o, this.dataRegions = a, this.rsBlockData = s, this.rsBlockError = f;
    }
    return r.lookup = function(e, t, n, i, o) {
      var a, s;
      t === void 0 && (t = 0), n === void 0 && (n = null), i === void 0 && (i = null), o === void 0 && (o = !0);
      try {
        for (var f = fu(cu), u = f.next(); !u.done; u = f.next()) {
          var c = u.value;
          if (!(t === 1 && c.rectangular) && !(t === 2 && !c.rectangular) && !(n != null && (c.getSymbolWidth() < n.getWidth() || c.getSymbolHeight() < n.getHeight())) && !(i != null && (c.getSymbolWidth() > i.getWidth() || c.getSymbolHeight() > i.getHeight())) && e <= c.dataCapacity)
            return c;
        }
      } catch (l) {
        a = { error: l };
      } finally {
        try {
          u && !u.done && (s = f.return) && s.call(f);
        } finally {
          if (a)
            throw a.error;
        }
      }
      if (o)
        throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + e);
      return null;
    }, r.prototype.getHorizontalDataRegions = function() {
      switch (this.dataRegions) {
        case 1:
          return 1;
        case 2:
        case 4:
          return 2;
        case 16:
          return 4;
        case 36:
          return 6;
        default:
          throw new Error("Cannot handle this number of data regions");
      }
    }, r.prototype.getVerticalDataRegions = function() {
      switch (this.dataRegions) {
        case 1:
        case 2:
          return 1;
        case 4:
          return 2;
        case 16:
          return 4;
        case 36:
          return 6;
        default:
          throw new Error("Cannot handle this number of data regions");
      }
    }, r.prototype.getSymbolDataWidth = function() {
      return this.getHorizontalDataRegions() * this.matrixWidth;
    }, r.prototype.getSymbolDataHeight = function() {
      return this.getVerticalDataRegions() * this.matrixHeight;
    }, r.prototype.getSymbolWidth = function() {
      return this.getSymbolDataWidth() + this.getHorizontalDataRegions() * 2;
    }, r.prototype.getSymbolHeight = function() {
      return this.getSymbolDataHeight() + this.getVerticalDataRegions() * 2;
    }, r.prototype.getCodewordCount = function() {
      return this.dataCapacity + this.errorCodewords;
    }, r.prototype.getInterleavedBlockCount = function() {
      return this.rsBlockData ? this.dataCapacity / this.rsBlockData : 1;
    }, r.prototype.getDataCapacity = function() {
      return this.dataCapacity;
    }, r.prototype.getErrorCodewords = function() {
      return this.errorCodewords;
    }, r.prototype.getDataLengthForInterleavedBlock = function(e) {
      return this.rsBlockData;
    }, r.prototype.getErrorLengthForInterleavedBlock = function(e) {
      return this.rsBlockError;
    }, r;
  }()
), uu = (
  /** @class */
  function(r) {
    su(e, r);
    function e() {
      return r.call(this, !1, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    return e.prototype.getInterleavedBlockCount = function() {
      return 10;
    }, e.prototype.getDataLengthForInterleavedBlock = function(t) {
      return t <= 8 ? 156 : 155;
    }, e;
  }(K)
), cu = [
  new K(!1, 3, 5, 8, 8, 1),
  new K(!1, 5, 7, 10, 10, 1),
  /*rect*/
  new K(!0, 5, 7, 16, 6, 1),
  new K(!1, 8, 10, 12, 12, 1),
  /*rect*/
  new K(!0, 10, 11, 14, 6, 2),
  new K(!1, 12, 12, 14, 14, 1),
  /*rect*/
  new K(!0, 16, 14, 24, 10, 1),
  new K(!1, 18, 14, 16, 16, 1),
  new K(!1, 22, 18, 18, 18, 1),
  /*rect*/
  new K(!0, 22, 18, 16, 10, 2),
  new K(!1, 30, 20, 20, 20, 1),
  /*rect*/
  new K(!0, 32, 24, 16, 14, 2),
  new K(!1, 36, 24, 22, 22, 1),
  new K(!1, 44, 28, 24, 24, 1),
  /*rect*/
  new K(!0, 49, 28, 22, 14, 2),
  new K(!1, 62, 36, 14, 14, 4),
  new K(!1, 86, 42, 16, 16, 4),
  new K(!1, 114, 48, 18, 18, 4),
  new K(!1, 144, 56, 20, 20, 4),
  new K(!1, 174, 68, 22, 22, 4),
  new K(!1, 204, 84, 24, 24, 4, 102, 42),
  new K(!1, 280, 112, 14, 14, 16, 140, 56),
  new K(!1, 368, 144, 16, 16, 16, 92, 36),
  new K(!1, 456, 192, 18, 18, 16, 114, 48),
  new K(!1, 576, 224, 20, 20, 16, 144, 56),
  new K(!1, 696, 272, 22, 22, 16, 174, 68),
  new K(!1, 816, 336, 24, 24, 16, 136, 56),
  new K(!1, 1050, 408, 18, 18, 36, 175, 68),
  new K(!1, 1304, 496, 20, 20, 36, 163, 62),
  new uu()
], lu = (
  /** @class */
  function() {
    function r(e) {
      this.msg = e, this.pos = 0, this.skipAtEnd = 0;
      for (var t = e.split("").map(function(s) {
        return s.charCodeAt(0);
      }), n = new V(), i = 0, o = t.length; i < o; i++) {
        var a = String.fromCharCode(t[i] & 255);
        if (a === "?" && e.charAt(i) !== "?")
          throw new Error("Message contains characters outside ISO-8859-1 encoding.");
        n.append(a);
      }
      this.msg = n.toString(), this.shape = 0, this.codewords = new V(), this.newEncoding = -1;
    }
    return r.prototype.setSymbolShape = function(e) {
      this.shape = e;
    }, r.prototype.setSizeConstraints = function(e, t) {
      this.minSize = e, this.maxSize = t;
    }, r.prototype.getMessage = function() {
      return this.msg;
    }, r.prototype.setSkipAtEnd = function(e) {
      this.skipAtEnd = e;
    }, r.prototype.getCurrentChar = function() {
      return this.msg.charCodeAt(this.pos);
    }, r.prototype.getCurrent = function() {
      return this.msg.charCodeAt(this.pos);
    }, r.prototype.getCodewords = function() {
      return this.codewords;
    }, r.prototype.writeCodewords = function(e) {
      this.codewords.append(e);
    }, r.prototype.writeCodeword = function(e) {
      this.codewords.append(e);
    }, r.prototype.getCodewordCount = function() {
      return this.codewords.length();
    }, r.prototype.getNewEncoding = function() {
      return this.newEncoding;
    }, r.prototype.signalEncoderChange = function(e) {
      this.newEncoding = e;
    }, r.prototype.resetEncoderSignal = function() {
      this.newEncoding = -1;
    }, r.prototype.hasMoreCharacters = function() {
      return this.pos < this.getTotalMessageCharCount();
    }, r.prototype.getTotalMessageCharCount = function() {
      return this.msg.length - this.skipAtEnd;
    }, r.prototype.getRemainingCharacters = function() {
      return this.getTotalMessageCharCount() - this.pos;
    }, r.prototype.getSymbolInfo = function() {
      return this.symbolInfo;
    }, r.prototype.updateSymbolInfo = function(e) {
      e === void 0 && (e = this.getCodewordCount()), (this.symbolInfo == null || e > this.symbolInfo.getDataCapacity()) && (this.symbolInfo = K.lookup(e, this.shape, this.minSize, this.maxSize, !0));
    }, r.prototype.resetSymbolInfo = function() {
      this.symbolInfo = null;
    }, r;
  }()
), du = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), hu = (
  /** @class */
  function(r) {
    du(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.getEncodingMode = function() {
      return ge;
    }, e.prototype.encode = function(t) {
      for (var n = new V(); t.hasMoreCharacters(); ) {
        var i = t.getCurrentChar();
        t.pos++, this.encodeChar(i, n);
        var o = n.length();
        if (o % 3 === 0) {
          this.writeNextTriplet(t, n);
          var a = We.lookAheadTest(t.getMessage(), t.pos, this.getEncodingMode());
          if (a !== this.getEncodingMode()) {
            t.signalEncoderChange(J);
            break;
          }
        }
      }
      this.handleEOD(t, n);
    }, e.prototype.encodeChar = function(t, n) {
      switch (t) {
        case 13:
          n.append(0);
          break;
        case 42:
          n.append(1);
          break;
        case 62:
          n.append(2);
          break;
        case 32:
          n.append(3);
          break;
        default:
          t >= 48 && t <= 57 ? n.append(t - 48 + 4) : t >= 65 && t <= 90 ? n.append(t - 65 + 14) : We.illegalCharacter(X.getCharAt(t));
          break;
      }
      return 1;
    }, e.prototype.handleEOD = function(t, n) {
      t.updateSymbolInfo();
      var i = t.getSymbolInfo().getDataCapacity() - t.getCodewordCount(), o = n.length();
      t.pos -= o, (t.getRemainingCharacters() > 1 || i > 1 || t.getRemainingCharacters() !== i) && t.writeCodeword(nu), t.getNewEncoding() < 0 && t.signalEncoderChange(J);
    }, e;
  }(nn)
), pu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), vu = (
  /** @class */
  function(r) {
    pu(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.getEncodingMode = function() {
      return Ne;
    }, e.prototype.encodeChar = function(t, n) {
      if (t === 32)
        return n.append(3), 1;
      if (t >= 48 && t <= 57)
        return n.append(t - 48 + 4), 1;
      if (t >= 97 && t <= 122)
        return n.append(t - 97 + 14), 1;
      if (t < 32)
        return n.append(0), n.append(t), 2;
      if (t <= 47)
        return n.append(1), n.append(t - 33), 2;
      if (t <= 64)
        return n.append(1), n.append(t - 58 + 15), 2;
      if (t >= 91 && t <= 95)
        return n.append(1), n.append(t - 91 + 22), 2;
      if (t === 96)
        return n.append(2), n.append(0), 2;
      if (t <= 90)
        return n.append(2), n.append(t - 65 + 1), 2;
      if (t <= 127)
        return n.append(2), n.append(t - 123 + 27), 2;
      n.append("1");
      var i = 2;
      return i += this.encodeChar(t - 128, n), i;
    }, e;
  }(nn)
), gu = (
  /** @class */
  function() {
    function r() {
    }
    return r.randomize253State = function(e) {
      var t = 149 * e % 253 + 1, n = Jn + t;
      return n <= 254 ? n : n - 254;
    }, r.encodeHighLevel = function(e, t, n, i, o) {
      t === void 0 && (t = 0), n === void 0 && (n = null), i === void 0 && (i = null), o === void 0 && (o = !1);
      var a = new nn(), s = [
        new iu(),
        a,
        new vu(),
        new hu(),
        new au(),
        new ou()
      ], f = new lu(e);
      f.setSymbolShape(t), f.setSizeConstraints(n, i), e.startsWith(ei) && e.endsWith(ri) ? (f.writeCodeword(Qf), f.setSkipAtEnd(2), f.pos += ei.length) : e.startsWith(ti) && e.endsWith(ri) && (f.writeCodeword(Jf), f.setSkipAtEnd(2), f.pos += ti.length);
      var u = J;
      for (o && (a.encodeMaximal(f), u = f.getNewEncoding(), f.resetEncoderSignal()); f.hasMoreCharacters(); )
        s[u].encode(f), f.getNewEncoding() >= 0 && (u = f.getNewEncoding(), f.resetEncoderSignal());
      var c = f.getCodewordCount();
      f.updateSymbolInfo();
      var l = f.getSymbolInfo().getDataCapacity();
      c < l && u !== J && u !== Te && u !== Ae && f.writeCodeword("þ");
      var d = f.getCodewords();
      for (d.length() < l && d.append(Jn); d.length() < l; )
        d.append(this.randomize253State(d.length() + 1));
      return f.getCodewords().toString();
    }, r.lookAheadTest = function(e, t, n) {
      var i = this.lookAheadTestIntern(e, t, n);
      if (n === ge && i === ge) {
        for (var o = Math.min(t + 3, e.length), a = t; a < o; a++)
          if (!this.isNativeX12(e.charCodeAt(a)))
            return J;
      } else if (n === Ae && i === Ae) {
        for (var o = Math.min(t + 4, e.length), a = t; a < o; a++)
          if (!this.isNativeEDIFACT(e.charCodeAt(a)))
            return J;
      }
      return i;
    }, r.lookAheadTestIntern = function(e, t, n) {
      if (t >= e.length)
        return n;
      var i;
      n === J ? i = [0, 1, 1, 1, 1, 1.25] : (i = [1, 2, 2, 2, 2, 2.25], i[n] = 0);
      for (var o = 0, a = new Uint8Array(6), s = []; ; ) {
        if (t + o === e.length) {
          me.fill(a, 0), me.fill(s, 0);
          var f = this.findMinimums(i, s, G.MAX_VALUE, a), u = this.getMinimumCount(a);
          if (s[J] === f)
            return J;
          if (u === 1) {
            if (a[Te] > 0)
              return Te;
            if (a[Ae] > 0)
              return Ae;
            if (a[Ne] > 0)
              return Ne;
            if (a[ge] > 0)
              return ge;
          }
          return Ie;
        }
        var c = e.charCodeAt(t + o);
        if (o++, this.isDigit(c) ? i[J] += 0.5 : this.isExtendedASCII(c) ? (i[J] = Math.ceil(i[J]), i[J] += 2) : (i[J] = Math.ceil(i[J]), i[J]++), this.isNativeC40(c) ? i[Ie] += 2 / 3 : this.isExtendedASCII(c) ? i[Ie] += 8 / 3 : i[Ie] += 4 / 3, this.isNativeText(c) ? i[Ne] += 2 / 3 : this.isExtendedASCII(c) ? i[Ne] += 8 / 3 : i[Ne] += 4 / 3, this.isNativeX12(c) ? i[ge] += 2 / 3 : this.isExtendedASCII(c) ? i[ge] += 13 / 3 : i[ge] += 10 / 3, this.isNativeEDIFACT(c) ? i[Ae] += 3 / 4 : this.isExtendedASCII(c) ? i[Ae] += 17 / 4 : i[Ae] += 13 / 4, this.isSpecialB256(c) ? i[Te] += 4 : i[Te]++, o >= 4) {
          if (me.fill(a, 0), me.fill(s, 0), this.findMinimums(i, s, G.MAX_VALUE, a), s[J] < this.min(s[Te], s[Ie], s[Ne], s[ge], s[Ae]))
            return J;
          if (s[Te] < s[J] || s[Te] + 1 < this.min(s[Ie], s[Ne], s[ge], s[Ae]))
            return Te;
          if (s[Ae] + 1 < this.min(s[Te], s[Ie], s[Ne], s[ge], s[J]))
            return Ae;
          if (s[Ne] + 1 < this.min(s[Te], s[Ie], s[Ae], s[ge], s[J]))
            return Ne;
          if (s[ge] + 1 < this.min(s[Te], s[Ie], s[Ae], s[Ne], s[J]))
            return ge;
          if (s[Ie] + 1 < this.min(s[J], s[Te], s[Ae], s[Ne])) {
            if (s[Ie] < s[ge])
              return Ie;
            if (s[Ie] === s[ge]) {
              for (var l = t + o + 1; l < e.length; ) {
                var d = e.charCodeAt(l);
                if (this.isX12TermSep(d))
                  return ge;
                if (!this.isNativeX12(d))
                  break;
                l++;
              }
              return Ie;
            }
          }
        }
      }
    }, r.min = function(e, t, n, i, o) {
      var a = Math.min(e, Math.min(t, Math.min(n, i)));
      return o === void 0 ? a : Math.min(a, o);
    }, r.findMinimums = function(e, t, n, i) {
      for (var o = 0; o < 6; o++) {
        var a = t[o] = Math.ceil(e[o]);
        n > a && (n = a, me.fill(i, 0)), n === a && (i[o] = i[o] + 1);
      }
      return n;
    }, r.getMinimumCount = function(e) {
      for (var t = 0, n = 0; n < 6; n++)
        t += e[n];
      return t || 0;
    }, r.isDigit = function(e) {
      return e >= 48 && e <= 57;
    }, r.isExtendedASCII = function(e) {
      return e >= 128 && e <= 255;
    }, r.isNativeC40 = function(e) {
      return e === 32 || e >= 48 && e <= 57 || e >= 65 && e <= 90;
    }, r.isNativeText = function(e) {
      return e === 32 || e >= 48 && e <= 57 || e >= 97 && e <= 122;
    }, r.isNativeX12 = function(e) {
      return this.isX12TermSep(e) || e === 32 || e >= 48 && e <= 57 || e >= 65 && e <= 90;
    }, r.isX12TermSep = function(e) {
      return e === 13 || // CR
      e === 42 || e === 62;
    }, r.isNativeEDIFACT = function(e) {
      return e >= 32 && e <= 94;
    }, r.isSpecialB256 = function(e) {
      return !1;
    }, r.determineConsecutiveDigitCount = function(e, t) {
      t === void 0 && (t = 0);
      for (var n = e.length, i = t; i < n && this.isDigit(e.charCodeAt(i)); )
        i++;
      return i - t;
    }, r.illegalCharacter = function(e) {
      var t = G.toHexString(e.charCodeAt(0));
      throw t = "0000".substring(0, 4 - t.length) + t, new Error("Illegal character: " + e + " (0x" + t + ")");
    }, r;
  }()
);
const We = gu;
var Rr = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ni = (
  /** @class */
  function() {
    function r(e) {
      this.charset = e, this.name = e.name;
    }
    return r.prototype.canEncode = function(e) {
      try {
        return Ve.encode(e, this.charset) != null;
      } catch {
        return !1;
      }
    }, r;
  }()
), xu = (
  /** @class */
  function() {
    function r(e, t, n) {
      var i, o, a, s, f, u;
      this.ENCODERS = [
        "IBM437",
        "ISO-8859-2",
        "ISO-8859-3",
        "ISO-8859-4",
        "ISO-8859-5",
        "ISO-8859-6",
        "ISO-8859-7",
        "ISO-8859-8",
        "ISO-8859-9",
        "ISO-8859-10",
        "ISO-8859-11",
        "ISO-8859-13",
        "ISO-8859-14",
        "ISO-8859-15",
        "ISO-8859-16",
        "windows-1250",
        "windows-1251",
        "windows-1252",
        "windows-1256",
        "Shift_JIS"
      ].map(function(B) {
        return new ni(zf.forName(B));
      }), this.encoders = [];
      var c = [];
      c.push(new ni(Yf.ISO_8859_1));
      for (var l = t != null && t.name.startsWith("UTF"), d = 0; d < e.length; d++) {
        var h = !1;
        try {
          for (var p = (i = void 0, Rr(c)), v = p.next(); !v.done; v = p.next()) {
            var y = v.value, _ = e.charAt(d), x = _.charCodeAt(0);
            if (x === n || y.canEncode(_)) {
              h = !0;
              break;
            }
          }
        } catch (B) {
          i = { error: B };
        } finally {
          try {
            v && !v.done && (o = p.return) && o.call(p);
          } finally {
            if (i)
              throw i.error;
          }
        }
        if (!h)
          try {
            for (var C = (a = void 0, Rr(this.ENCODERS)), E = C.next(); !E.done; E = C.next()) {
              var y = E.value;
              if (y.canEncode(e.charAt(d))) {
                c.push(y), h = !0;
                break;
              }
            }
          } catch (B) {
            a = { error: B };
          } finally {
            try {
              E && !E.done && (s = C.return) && s.call(C);
            } finally {
              if (a)
                throw a.error;
            }
          }
        h || (l = !0);
      }
      if (c.length === 1 && !l)
        this.encoders = [c[0]];
      else {
        this.encoders = [];
        var S = 0;
        try {
          for (var I = Rr(c), T = I.next(); !T.done; T = I.next()) {
            var y = T.value;
            this.encoders[S++] = y;
          }
        } catch (B) {
          f = { error: B };
        } finally {
          try {
            T && !T.done && (u = I.return) && u.call(I);
          } finally {
            if (f)
              throw f.error;
          }
        }
      }
      var R = -1;
      if (t != null) {
        for (var d = 0; d < this.encoders.length; d++)
          if (this.encoders[d] != null && t.name === this.encoders[d].name) {
            R = d;
            break;
          }
      }
      this.priorityEncoderIndex = R;
    }
    return r.prototype.length = function() {
      return this.encoders.length;
    }, r.prototype.getCharsetName = function(e) {
      if (!(e < this.length()))
        throw new Error("index must be less than length");
      return this.encoders[e].name;
    }, r.prototype.getCharset = function(e) {
      if (!(e < this.length()))
        throw new Error("index must be less than length");
      return this.encoders[e].charset;
    }, r.prototype.getECIValue = function(e) {
      return this.encoders[e].charset.getValueIdentifier();
    }, r.prototype.getPriorityEncoderIndex = function() {
      return this.priorityEncoderIndex;
    }, r.prototype.canEncode = function(e, t) {
      if (!(t < this.length()))
        throw new Error("index must be less than length");
      return !0;
    }, r.prototype.encode = function(e, t) {
      if (!(t < this.length()))
        throw new Error("index must be less than length");
      return Ve.encode(X.getCharAt(e), this.encoders[t].name);
    }, r;
  }()
), yu = 3, mu = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.fnc1 = n;
      var i = new xu(e, t, n);
      if (i.length() === 1)
        for (var o = 0; o < this.bytes.length; o++) {
          var a = e.charAt(o).charCodeAt(0);
          this.bytes[o] = a === n ? 1e3 : a;
        }
      else
        this.bytes = this.encodeMinimally(e, i, n);
    }
    return r.prototype.getFNC1Character = function() {
      return this.fnc1;
    }, r.prototype.length = function() {
      return this.bytes.length;
    }, r.prototype.haveNCharacters = function(e, t) {
      if (e + t - 1 >= this.bytes.length)
        return !1;
      for (var n = 0; n < t; n++)
        if (this.isECI(e + n))
          return !1;
      return !0;
    }, r.prototype.charAt = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      if (this.isECI(e))
        throw new Error("value at " + e + " is not a character but an ECI");
      return this.isFNC1(e) ? this.fnc1 : this.bytes[e];
    }, r.prototype.subSequence = function(e, t) {
      if (e < 0 || e > t || t > this.length())
        throw new Error("" + e);
      for (var n = new V(), i = e; i < t; i++) {
        if (this.isECI(i))
          throw new Error("value at " + i + " is not a character but an ECI");
        n.append(this.charAt(i));
      }
      return n.toString();
    }, r.prototype.isECI = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      return this.bytes[e] > 255 && this.bytes[e] <= 999;
    }, r.prototype.isFNC1 = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      return this.bytes[e] === 1e3;
    }, r.prototype.getECIValue = function(e) {
      if (e < 0 || e >= this.length())
        throw new Error("" + e);
      if (!this.isECI(e))
        throw new Error("value at " + e + " is not an ECI but a character");
      return this.bytes[e] - 256;
    }, r.prototype.addEdge = function(e, t, n) {
      (e[t][n.encoderIndex] == null || e[t][n.encoderIndex].cachedTotalSize > n.cachedTotalSize) && (e[t][n.encoderIndex] = n);
    }, r.prototype.addEdges = function(e, t, n, i, o, a) {
      var s = e.charAt(i).charCodeAt(0), f = 0, u = t.length();
      t.getPriorityEncoderIndex() >= 0 && (s === a || t.canEncode(s, t.getPriorityEncoderIndex())) && (f = t.getPriorityEncoderIndex(), u = f + 1);
      for (var c = f; c < u; c++)
        (s === a || t.canEncode(s, c)) && this.addEdge(n, i + 1, new ii(s, t, c, o, a));
    }, r.prototype.encodeMinimally = function(e, t, n) {
      var i = e.length, o = new ii[i + 1][t.length()]();
      this.addEdges(e, t, o, 0, null, n);
      for (var a = 1; a <= i; a++) {
        for (var s = 0; s < t.length(); s++)
          o[a][s] != null && a < i && this.addEdges(e, t, o, a, o[a][s], n);
        for (var s = 0; s < t.length(); s++)
          o[a - 1][s] = null;
      }
      for (var f = -1, u = G.MAX_VALUE, s = 0; s < t.length(); s++)
        if (o[i][s] != null) {
          var c = o[i][s];
          c.cachedTotalSize < u && (u = c.cachedTotalSize, f = s);
        }
      if (f < 0)
        throw new Error('Failed to encode "' + e + '"');
      for (var l = [], d = o[i][f]; d != null; ) {
        if (d.isFNC1())
          l.unshift(1e3);
        else
          for (var h = t.encode(d.c, d.encoderIndex), a = h.length - 1; a >= 0; a--)
            l.unshift(h[a] & 255);
        var p = d.previous === null ? 0 : d.previous.encoderIndex;
        p !== d.encoderIndex && l.unshift(256 + t.getECIValue(d.encoderIndex)), d = d.previous;
      }
      for (var v = [], a = 0; a < v.length; a++)
        v[a] = l[a];
      return v;
    }, r;
  }()
), ii = (
  /** @class */
  function() {
    function r(e, t, n, i, o) {
      this.c = e, this.encoderSet = t, this.encoderIndex = n, this.previous = i, this.fnc1 = o, this.c = e === o ? 1e3 : e;
      var a = this.isFNC1() ? 1 : t.encode(e, n).length, s = i === null ? 0 : i.encoderIndex;
      s !== n && (a += yu), i != null && (a += i.cachedTotalSize), this.cachedTotalSize = a;
    }
    return r.prototype.isFNC1 = function() {
      return this.c === 1e3;
    }, r;
  }()
), _u = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
var oi;
(function(r) {
  r[r.ASCII = 0] = "ASCII", r[r.C40 = 1] = "C40", r[r.TEXT = 2] = "TEXT", r[r.X12 = 3] = "X12", r[r.EDF = 4] = "EDF", r[r.B256 = 5] = "B256";
})(oi || (oi = {}));
(function(r) {
  _u(e, r);
  function e(t, n, i, o, a) {
    var s = r.call(this, t, n, i) || this;
    return s.shape = o, s.macroId = a, s;
  }
  return e.prototype.getMacroId = function() {
    return this.macroId;
  }, e.prototype.getShapeHint = function() {
    return this.shape;
  }, e;
})(mu);
var Cu = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.isCompact = function() {
      return this.compact;
    }, r.prototype.setCompact = function(e) {
      this.compact = e;
    }, r.prototype.getSize = function() {
      return this.size;
    }, r.prototype.setSize = function(e) {
      this.size = e;
    }, r.prototype.getLayers = function() {
      return this.layers;
    }, r.prototype.setLayers = function(e) {
      this.layers = e;
    }, r.prototype.getCodeWords = function() {
      return this.codeWords;
    }, r.prototype.setCodeWords = function(e) {
      this.codeWords = e;
    }, r.prototype.getMatrix = function() {
      return this.matrix;
    }, r.prototype.setMatrix = function(e) {
      this.matrix = e;
    }, r;
  }()
), ai = (
  /** @class */
  function() {
    function r() {
    }
    return r.singletonList = function(e) {
      return [e];
    }, r.min = function(e, t) {
      return e.sort(t)[0];
    }, r;
  }()
), Au = (
  /** @class */
  function() {
    function r(e) {
      this.previous = e;
    }
    return r.prototype.getPrevious = function() {
      return this.previous;
    }, r;
  }()
), Eu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), on = (
  /** @class */
  function(r) {
    Eu(e, r);
    function e(t, n, i) {
      var o = r.call(this, t) || this;
      return o.value = n, o.bitCount = i, o;
    }
    return e.prototype.appendTo = function(t, n) {
      t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, n) {
      return new e(this, t, n);
    }, e.prototype.addBinaryShift = function(t, n) {
      return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, n);
    }, e.prototype.toString = function() {
      var t = this.value & (1 << this.bitCount) - 1;
      return t |= 1 << this.bitCount, "<" + G.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
  }(Au)
), wu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        i.hasOwnProperty(o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Su = (
  /** @class */
  function(r) {
    wu(e, r);
    function e(t, n, i) {
      var o = r.call(this, t, 0, 0) || this;
      return o.binaryShiftStart = n, o.binaryShiftByteCount = i, o;
    }
    return e.prototype.appendTo = function(t, n) {
      for (var i = 0; i < this.binaryShiftByteCount; i++)
        (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : i === 0 ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(n[this.binaryShiftStart + i], 8);
    }, e.prototype.addBinaryShift = function(t, n) {
      return new e(this, t, n);
    }, e.prototype.toString = function() {
      return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    }, e;
  }(on)
);
function Iu(r, e, t) {
  return new Su(r, e, t);
}
function Nt(r, e, t) {
  return new on(r, e, t);
}
var bu = [
  "UPPER",
  "LOWER",
  "DIGIT",
  "MIXED",
  "PUNCT"
], ot = 0, dr = 1, Ue = 2, Di = 3, ze = 4, Tu = new on(null, 0, 0), Dr = [
  Int32Array.from([
    0,
    (5 << 16) + 28,
    (5 << 16) + 30,
    (5 << 16) + 29,
    656318
    // UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (9 << 16) + 480 + 14,
    0,
    (5 << 16) + 30,
    (5 << 16) + 29,
    656318
    // LOWER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (4 << 16) + 14,
    (9 << 16) + 448 + 28,
    0,
    (9 << 16) + 448 + 29,
    932798
    // DIGIT -> UPPER -> MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 29,
    (5 << 16) + 28,
    656318,
    0,
    (5 << 16) + 30
    // MIXED -> PUNCT
  ]),
  Int32Array.from([
    (5 << 16) + 31,
    656380,
    656382,
    656381,
    0
  ])
], Ou = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Ru(r) {
  var e, t;
  try {
    for (var n = Ou(r), i = n.next(); !i.done; i = n.next()) {
      var o = i.value;
      me.fill(o, -1);
    }
  } catch (a) {
    e = { error: a };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return r[ot][ze] = 0, r[dr][ze] = 0, r[dr][ot] = 28, r[Di][ze] = 0, r[Ue][ze] = 0, r[Ue][ot] = 15, r;
}
var Pi = Ru(me.createInt32Array(6, 6)), Du = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pu = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.token = e, this.mode = t, this.binaryShiftByteCount = n, this.bitCount = i;
    }
    return r.prototype.getMode = function() {
      return this.mode;
    }, r.prototype.getToken = function() {
      return this.token;
    }, r.prototype.getBinaryShiftByteCount = function() {
      return this.binaryShiftByteCount;
    }, r.prototype.getBitCount = function() {
      return this.bitCount;
    }, r.prototype.latchAndAppend = function(e, t) {
      var n = this.bitCount, i = this.token;
      if (e !== this.mode) {
        var o = Dr[this.mode][e];
        i = Nt(i, o & 65535, o >> 16), n += o >> 16;
      }
      var a = e === Ue ? 4 : 5;
      return i = Nt(i, t, a), new r(i, e, 0, n + a);
    }, r.prototype.shiftAndAppend = function(e, t) {
      var n = this.token, i = this.mode === Ue ? 4 : 5;
      return n = Nt(n, Pi[this.mode][e], i), n = Nt(n, t, 5), new r(n, this.mode, 0, this.bitCount + i + 5);
    }, r.prototype.addBinaryShiftChar = function(e) {
      var t = this.token, n = this.mode, i = this.bitCount;
      if (this.mode === ze || this.mode === Ue) {
        var o = Dr[n][ot];
        t = Nt(t, o & 65535, o >> 16), i += o >> 16, n = ot;
      }
      var a = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8, s = new r(t, n, this.binaryShiftByteCount + 1, i + a);
      return s.binaryShiftByteCount === 2078 && (s = s.endBinaryShift(e + 1)), s;
    }, r.prototype.endBinaryShift = function(e) {
      if (this.binaryShiftByteCount === 0)
        return this;
      var t = this.token;
      return t = Iu(t, e - this.binaryShiftByteCount, this.binaryShiftByteCount), new r(t, this.mode, 0, this.bitCount);
    }, r.prototype.isBetterThanOrEqualTo = function(e) {
      var t = this.bitCount + (Dr[this.mode][e.mode] >> 16);
      return this.binaryShiftByteCount < e.binaryShiftByteCount ? t += r.calculateBinaryShiftCost(e) - r.calculateBinaryShiftCost(this) : this.binaryShiftByteCount > e.binaryShiftByteCount && e.binaryShiftByteCount > 0 && (t += 10), t <= e.bitCount;
    }, r.prototype.toBitArray = function(e) {
      for (var t, n, i = [], o = this.endBinaryShift(e.length).token; o !== null; o = o.getPrevious())
        i.unshift(o);
      var a = new Ee();
      try {
        for (var s = Du(i), f = s.next(); !f.done; f = s.next()) {
          var u = f.value;
          u.appendTo(a, e);
        }
      } catch (c) {
        t = { error: c };
      } finally {
        try {
          f && !f.done && (n = s.return) && n.call(s);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return a;
    }, r.prototype.toString = function() {
      return X.format("%s bits=%d bytes=%d", bu[this.mode], this.bitCount, this.binaryShiftByteCount);
    }, r.calculateBinaryShiftCost = function(e) {
      return e.binaryShiftByteCount > 62 ? 21 : e.binaryShiftByteCount > 31 ? 20 : e.binaryShiftByteCount > 0 ? 10 : 0;
    }, r.INITIAL_STATE = new r(Tu, ot, 0, 0), r;
  }()
);
function Nu(r) {
  var e = X.getCharCode(" "), t = X.getCharCode("."), n = X.getCharCode(",");
  r[ot][e] = 1;
  for (var i = X.getCharCode("Z"), o = X.getCharCode("A"), a = o; a <= i; a++)
    r[ot][a] = a - o + 2;
  r[dr][e] = 1;
  for (var s = X.getCharCode("z"), f = X.getCharCode("a"), a = f; a <= s; a++)
    r[dr][a] = a - f + 2;
  r[Ue][e] = 1;
  for (var u = X.getCharCode("9"), c = X.getCharCode("0"), a = c; a <= u; a++)
    r[Ue][a] = a - c + 2;
  r[Ue][n] = 12, r[Ue][t] = 13;
  for (var l = [
    "\0",
    " ",
    "",
    "",
    "",
    "",
    "",
    "",
    "\x07",
    "\b",
    "	",
    `
`,
    "\v",
    "\f",
    "\r",
    "\x1B",
    "",
    "",
    "",
    "",
    "@",
    "\\",
    "^",
    "_",
    "`",
    "|",
    "~",
    ""
  ], d = 0; d < l.length; d++)
    r[Di][X.getCharCode(l[d])] = d;
  for (var h = [
    "\0",
    "\r",
    "\0",
    "\0",
    "\0",
    "\0",
    "!",
    "'",
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "[",
    "]",
    "{",
    "}"
  ], d = 0; d < h.length; d++)
    X.getCharCode(h[d]) > 0 && (r[ze][X.getCharCode(h[d])] = d);
  return r;
}
var Pr = Nu(me.createInt32Array(5, 256)), Kt = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Mu = (
  /** @class */
  function() {
    function r(e) {
      this.text = e;
    }
    return r.prototype.encode = function() {
      for (var e = X.getCharCode(" "), t = X.getCharCode(`
`), n = ai.singletonList(Pu.INITIAL_STATE), i = 0; i < this.text.length; i++) {
        var o = void 0, a = i + 1 < this.text.length ? this.text[i + 1] : 0;
        switch (this.text[i]) {
          case X.getCharCode("\r"):
            o = a === t ? 2 : 0;
            break;
          case X.getCharCode("."):
            o = a === e ? 3 : 0;
            break;
          case X.getCharCode(","):
            o = a === e ? 4 : 0;
            break;
          case X.getCharCode(":"):
            o = a === e ? 5 : 0;
            break;
          default:
            o = 0;
        }
        o > 0 ? (n = r.updateStateListForPair(n, i, o), i++) : n = this.updateStateListForChar(n, i);
      }
      var s = ai.min(n, function(f, u) {
        return f.getBitCount() - u.getBitCount();
      });
      return s.toBitArray(this.text);
    }, r.prototype.updateStateListForChar = function(e, t) {
      var n, i, o = [];
      try {
        for (var a = Kt(e), s = a.next(); !s.done; s = a.next()) {
          var f = s.value;
          this.updateStateForChar(f, t, o);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          s && !s.done && (i = a.return) && i.call(a);
        } finally {
          if (n)
            throw n.error;
        }
      }
      return r.simplifyStates(o);
    }, r.prototype.updateStateForChar = function(e, t, n) {
      for (var i = this.text[t] & 255, o = Pr[e.getMode()][i] > 0, a = null, s = 0; s <= ze; s++) {
        var f = Pr[s][i];
        if (f > 0) {
          if (a == null && (a = e.endBinaryShift(t)), !o || s === e.getMode() || s === Ue) {
            var u = a.latchAndAppend(s, f);
            n.push(u);
          }
          if (!o && Pi[e.getMode()][s] >= 0) {
            var c = a.shiftAndAppend(s, f);
            n.push(c);
          }
        }
      }
      if (e.getBinaryShiftByteCount() > 0 || Pr[e.getMode()][i] === 0) {
        var l = e.addBinaryShiftChar(t);
        n.push(l);
      }
    }, r.updateStateListForPair = function(e, t, n) {
      var i, o, a = [];
      try {
        for (var s = Kt(e), f = s.next(); !f.done; f = s.next()) {
          var u = f.value;
          this.updateStateForPair(u, t, n, a);
        }
      } catch (c) {
        i = { error: c };
      } finally {
        try {
          f && !f.done && (o = s.return) && o.call(s);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return this.simplifyStates(a);
    }, r.updateStateForPair = function(e, t, n, i) {
      var o = e.endBinaryShift(t);
      if (i.push(o.latchAndAppend(ze, n)), e.getMode() !== ze && i.push(o.shiftAndAppend(ze, n)), n === 3 || n === 4) {
        var a = o.latchAndAppend(Ue, 16 - n).latchAndAppend(Ue, 1);
        i.push(a);
      }
      if (e.getBinaryShiftByteCount() > 0) {
        var s = e.addBinaryShiftChar(t).addBinaryShiftChar(t + 1);
        i.push(s);
      }
    }, r.simplifyStates = function(e) {
      var t, n, i, o, a = [];
      try {
        for (var s = Kt(e), f = s.next(); !f.done; f = s.next()) {
          var u = f.value, c = !0, l = function(y) {
            if (y.isBetterThanOrEqualTo(u))
              return c = !1, "break";
            u.isBetterThanOrEqualTo(y) && (a = a.filter(function(_) {
              return _ !== y;
            }));
          };
          try {
            for (var d = (i = void 0, Kt(a)), h = d.next(); !h.done; h = d.next()) {
              var p = h.value, v = l(p);
              if (v === "break")
                break;
            }
          } catch (y) {
            i = { error: y };
          } finally {
            try {
              h && !h.done && (o = d.return) && o.call(d);
            } finally {
              if (i)
                throw i.error;
            }
          }
          c && a.push(u);
        }
      } catch (y) {
        t = { error: y };
      } finally {
        try {
          f && !f.done && (n = s.return) && n.call(s);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return a;
    }, r;
  }()
), Bu = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function() {
  function r() {
  }
  return r.encodeBytes = function(e) {
    return r.encode(e, r.DEFAULT_EC_PERCENT, r.DEFAULT_AZTEC_LAYERS);
  }, r.encode = function(e, t, n) {
    var i = new Mu(e).encode(), o = G.truncDivision(i.getSize() * t, 100) + 11, a = i.getSize() + o, s, f, u, c, l;
    if (n !== r.DEFAULT_AZTEC_LAYERS) {
      if (s = n < 0, f = Math.abs(n), f > (s ? r.MAX_NB_BITS_COMPACT : r.MAX_NB_BITS))
        throw new F(X.format("Illegal value %s for layers", n));
      u = r.totalBitsInLayer(f, s), c = r.WORD_SIZE[f];
      var d = u - u % c;
      if (l = r.stuffBits(i, c), l.getSize() + o > d)
        throw new F("Data to large for user specified layer");
      if (s && l.getSize() > c * 64)
        throw new F("Data to large for user specified layer");
    } else {
      c = 0, l = null;
      for (var h = 0; ; h++) {
        if (h > r.MAX_NB_BITS)
          throw new F("Data too large for an Aztec code");
        if (s = h <= 3, f = s ? h + 1 : h, u = r.totalBitsInLayer(f, s), !(a > u)) {
          (l == null || c !== r.WORD_SIZE[f]) && (c = r.WORD_SIZE[f], l = r.stuffBits(i, c));
          var d = u - u % c;
          if (!(s && l.getSize() > c * 64) && l.getSize() + o <= d)
            break;
        }
      }
    }
    var p = r.generateCheckWords(l, u, c), v = l.getSize() / c, y = r.generateModeMessage(s, f, v), _ = (s ? 11 : 14) + f * 4, x = new Int32Array(_), C;
    if (s) {
      C = _;
      for (var h = 0; h < x.length; h++)
        x[h] = h;
    } else {
      C = _ + 1 + 2 * G.truncDivision(G.truncDivision(_, 2) - 1, 15);
      for (var E = G.truncDivision(_, 2), S = G.truncDivision(C, 2), h = 0; h < E; h++) {
        var I = h + G.truncDivision(h, 15);
        x[E - h - 1] = S - I - 1, x[E + h] = S + I + 1;
      }
    }
    for (var T = new Ye(C), h = 0, R = 0; h < f; h++) {
      for (var B = (f - h) * 4 + (s ? 9 : 12), M = 0; M < B; M++)
        for (var te = M * 2, N = 0; N < 2; N++)
          p.get(R + te + N) && T.set(x[h * 2 + N], x[h * 2 + M]), p.get(R + B * 2 + te + N) && T.set(x[h * 2 + M], x[_ - 1 - h * 2 - N]), p.get(R + B * 4 + te + N) && T.set(x[_ - 1 - h * 2 - N], x[_ - 1 - h * 2 - M]), p.get(R + B * 6 + te + N) && T.set(x[_ - 1 - h * 2 - M], x[h * 2 + N]);
      R += B * 8;
    }
    if (r.drawModeMessage(T, s, C, y), s)
      r.drawBullsEye(T, G.truncDivision(C, 2), 5);
    else {
      r.drawBullsEye(T, G.truncDivision(C, 2), 7);
      for (var h = 0, M = 0; h < G.truncDivision(_, 2) - 1; h += 15, M += 16)
        for (var N = G.truncDivision(C, 2) & 1; N < C; N += 2)
          T.set(G.truncDivision(C, 2) - M, N), T.set(G.truncDivision(C, 2) + M, N), T.set(N, G.truncDivision(C, 2) - M), T.set(N, G.truncDivision(C, 2) + M);
    }
    var H = new Cu();
    return H.setCompact(s), H.setSize(C), H.setLayers(f), H.setCodeWords(v), H.setMatrix(T), H;
  }, r.drawBullsEye = function(e, t, n) {
    for (var i = 0; i < n; i += 2)
      for (var o = t - i; o <= t + i; o++)
        e.set(o, t - i), e.set(o, t + i), e.set(t - i, o), e.set(t + i, o);
    e.set(t - n, t - n), e.set(t - n + 1, t - n), e.set(t - n, t - n + 1), e.set(t + n, t - n), e.set(t + n, t - n + 1), e.set(t + n, t + n - 1);
  }, r.generateModeMessage = function(e, t, n) {
    var i = new Ee();
    return e ? (i.appendBits(t - 1, 2), i.appendBits(n - 1, 6), i = r.generateCheckWords(i, 28, 4)) : (i.appendBits(t - 1, 5), i.appendBits(n - 1, 11), i = r.generateCheckWords(i, 40, 4)), i;
  }, r.drawModeMessage = function(e, t, n, i) {
    var o = G.truncDivision(n, 2);
    if (t)
      for (var a = 0; a < 7; a++) {
        var s = o - 3 + a;
        i.get(a) && e.set(s, o - 5), i.get(a + 7) && e.set(o + 5, s), i.get(20 - a) && e.set(s, o + 5), i.get(27 - a) && e.set(o - 5, s);
      }
    else
      for (var a = 0; a < 10; a++) {
        var s = o - 5 + a + G.truncDivision(a, 5);
        i.get(a) && e.set(s, o - 7), i.get(a + 10) && e.set(o + 7, s), i.get(29 - a) && e.set(s, o + 7), i.get(39 - a) && e.set(o - 7, s);
      }
  }, r.generateCheckWords = function(e, t, n) {
    var i, o, a = e.getSize() / n, s = new Oi(r.getGF(n)), f = G.truncDivision(t, n), u = r.bitsToWords(e, n, f);
    s.encode(u, f - a);
    var c = t % n, l = new Ee();
    l.appendBits(0, c);
    try {
      for (var d = Bu(Array.from(u)), h = d.next(); !h.done; h = d.next()) {
        var p = h.value;
        l.appendBits(p, n);
      }
    } catch (v) {
      i = { error: v };
    } finally {
      try {
        h && !h.done && (o = d.return) && o.call(d);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return l;
  }, r.bitsToWords = function(e, t, n) {
    var i = new Int32Array(n), o, a;
    for (o = 0, a = e.getSize() / t; o < a; o++) {
      for (var s = 0, f = 0; f < t; f++)
        s |= e.get(o * t + f) ? 1 << t - f - 1 : 0;
      i[o] = s;
    }
    return i;
  }, r.getGF = function(e) {
    switch (e) {
      case 4:
        return Be.AZTEC_PARAM;
      case 6:
        return Be.AZTEC_DATA_6;
      case 8:
        return Be.AZTEC_DATA_8;
      case 10:
        return Be.AZTEC_DATA_10;
      case 12:
        return Be.AZTEC_DATA_12;
      default:
        throw new F("Unsupported word size " + e);
    }
  }, r.stuffBits = function(e, t) {
    for (var n = new Ee(), i = e.getSize(), o = (1 << t) - 2, a = 0; a < i; a += t) {
      for (var s = 0, f = 0; f < t; f++)
        (a + f >= i || e.get(a + f)) && (s |= 1 << t - 1 - f);
      (s & o) === o ? (n.appendBits(s & o, t), a--) : s & o ? n.appendBits(s, t) : (n.appendBits(s | 1, t), a--);
    }
    return n;
  }, r.totalBitsInLayer = function(e, t) {
    return ((t ? 88 : 112) + 16 * e) * e;
  }, r.DEFAULT_EC_PERCENT = 33, r.DEFAULT_AZTEC_LAYERS = 0, r.MAX_NB_BITS = 32, r.MAX_NB_BITS_COMPACT = 4, r.WORD_SIZE = Int32Array.from([
    4,
    6,
    6,
    8,
    8,
    8,
    8,
    8,
    8,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    10,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12
  ]), r;
})();
var Lu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Fu = (
  /** @class */
  function(r) {
    Lu(e, r);
    function e(t) {
      var n = r.call(this, t.width, t.height) || this;
      return n.canvas = t, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(t), n;
    }
    return e.makeBufferFromCanvasImageData = function(t) {
      var n = t.getContext("2d");
      if (!n)
        throw new Error("Couldn't get canvas context.");
      var i = n.getImageData(0, 0, t.width, t.height);
      return e.toGrayscaleBuffer(i.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, n, i) {
      for (var o = new Uint8ClampedArray(n * i), a = 0, s = 0, f = t.length; a < f; a += 4, s++) {
        var u = void 0, c = t[a + 3];
        if (c === 0)
          u = 255;
        else {
          var l = t[a], d = t[a + 1], h = t[a + 2];
          u = 306 * l + 601 * d + 117 * h + 512 >> 10;
        }
        o[s] = u;
      }
      return o;
    }, e.prototype.getRow = function(t, n) {
      if (t < 0 || t >= this.getHeight())
        throw new F("Requested row is outside the image: " + t);
      var i = this.getWidth(), o = t * i;
      return n === null ? n = this.buffer.slice(o, o + i) : (n.length < i && (n = new Uint8ClampedArray(i)), n.set(this.buffer.slice(o, o + i))), n;
    }, e.prototype.getMatrix = function() {
      return this.buffer;
    }, e.prototype.isCropSupported = function() {
      return !0;
    }, e.prototype.crop = function(t, n, i, o) {
      return r.prototype.crop.call(this, t, n, i, o), this;
    }, e.prototype.isRotateSupported = function() {
      return !0;
    }, e.prototype.rotateCounterClockwise = function() {
      return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
      return this.rotate(-45), this;
    }, e.prototype.invert = function() {
      return new hr(this);
    }, e.prototype.getTempCanvasElement = function() {
      if (this.tempCanvasElement === null) {
        var t = this.canvas.ownerDocument.createElement("canvas");
        t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
      }
      return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
      var n = this.getTempCanvasElement();
      if (!n)
        throw new Error("Could not create a Canvas element.");
      var i = t * e.DEGREE_TO_RADIANS, o = this.canvas.width, a = this.canvas.height, s = Math.ceil(Math.abs(Math.cos(i)) * o + Math.abs(Math.sin(i)) * a), f = Math.ceil(Math.abs(Math.sin(i)) * o + Math.abs(Math.cos(i)) * a);
      n.width = s, n.height = f;
      var u = n.getContext("2d");
      if (!u)
        throw new Error("Could not create a Canvas Context element.");
      return u.translate(s / 2, f / 2), u.rotate(i), u.drawImage(this.canvas, o / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(n), this;
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
  }(Ut)
);
function Ni() {
  return typeof navigator < "u";
}
function ku() {
  return Ni() && !!navigator.mediaDevices;
}
function Uu() {
  return !!(ku() && navigator.mediaDevices.enumerateDevices);
}
var Ct = function() {
  return Ct = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Ct.apply(this, arguments);
}, ue = function(r, e, t, n) {
  function i(o) {
    return o instanceof t ? o : new t(function(a) {
      a(o);
    });
  }
  return new (t || (t = Promise))(function(o, a) {
    function s(c) {
      try {
        u(n.next(c));
      } catch (l) {
        a(l);
      }
    }
    function f(c) {
      try {
        u(n.throw(c));
      } catch (l) {
        a(l);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, f);
    }
    u((n = n.apply(r, e || [])).next());
  });
}, ce = function(r, e) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return f([u, c]);
    };
  }
  function f(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (n = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done)
          return o;
        switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
          case 0:
          case 1:
            o = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < o[1]) {
              t.label = o[1], o = u;
              break;
            }
            if (o && t.label < o[2]) {
              t.label = o[2], t.ops.push(u);
              break;
            }
            o[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (c) {
        u = [6, c], i = 0;
      } finally {
        n = o = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, Nr = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t)
    return t.call(r);
  if (r && typeof r.length == "number")
    return {
      next: function() {
        return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vu = {
  delayBetweenScanAttempts: 500,
  delayBetweenScanSuccess: 500,
  tryPlayVideoTimeout: 5e3
}, St = (
  /** @class */
  function() {
    function r(e, t, n) {
      t === void 0 && (t = /* @__PURE__ */ new Map()), n === void 0 && (n = {}), this.reader = e, this.hints = t, this.options = Ct(Ct({}, Vu), n);
    }
    return Object.defineProperty(r.prototype, "possibleFormats", {
      /**
       * Allows to change the possible formats the decoder should
       * search for while scanning some image. Useful for changing
       * the possible formats during BrowserCodeReader::scan.
       */
      set: function(e) {
        this.hints.set(fe.POSSIBLE_FORMATS, e);
      },
      enumerable: !1,
      configurable: !0
    }), r.addVideoSource = function(e, t) {
      try {
        e.srcObject = t;
      } catch {
        console.error("got interrupted by new loading request");
      }
    }, r.mediaStreamSetTorch = function(e, t) {
      return ue(this, void 0, void 0, function() {
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, e.applyConstraints({
                advanced: [{
                  fillLightMode: t ? "flash" : "off",
                  torch: !!t
                }]
              })];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.mediaStreamIsTorchCompatible = function(e) {
      var t, n, i = e.getVideoTracks();
      try {
        for (var o = Nr(i), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          if (r.mediaStreamIsTorchCompatibleTrack(s))
            return !0;
        }
      } catch (f) {
        t = { error: f };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (t)
            throw t.error;
        }
      }
      return !1;
    }, r.mediaStreamIsTorchCompatibleTrack = function(e) {
      try {
        var t = e.getCapabilities();
        return "torch" in t;
      } catch (n) {
        return console.error(n), console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."), !1;
      }
    }, r.isVideoPlaying = function(e) {
      return e.currentTime > 0 && !e.paused && e.readyState > 2;
    }, r.getMediaElement = function(e, t) {
      var n = document.getElementById(e);
      if (!n)
        throw new de("element with id '".concat(e, "' not found"));
      if (n.nodeName.toLowerCase() !== t.toLowerCase())
        throw new de("element with id '".concat(e, "' must be an ").concat(t, " element"));
      return n;
    }, r.createVideoElement = function(e) {
      if (e instanceof HTMLVideoElement)
        return e;
      if (typeof e == "string")
        return r.getMediaElement(e, "video");
      if (!e && typeof document < "u") {
        var t = document.createElement("video");
        return t.width = 200, t.height = 200, t;
      }
      throw new Error("Couldn't get videoElement from videoSource!");
    }, r.prepareImageElement = function(e) {
      if (e instanceof HTMLImageElement)
        return e;
      if (typeof e == "string")
        return r.getMediaElement(e, "img");
      if (typeof e > "u") {
        var t = document.createElement("img");
        return t.width = 200, t.height = 200, t;
      }
      throw new Error("Couldn't get imageElement from imageSource!");
    }, r.prepareVideoElement = function(e) {
      var t = r.createVideoElement(e);
      return t.setAttribute("autoplay", "true"), t.setAttribute("muted", "true"), t.setAttribute("playsinline", "true"), t;
    }, r.isImageLoaded = function(e) {
      return !(!e.complete || e.naturalWidth === 0);
    }, r.createBinaryBitmapFromCanvas = function(e) {
      var t = new Fu(e), n = new xi(t);
      return new gi(n);
    }, r.drawImageOnCanvas = function(e, t) {
      e.drawImage(t, 0, 0);
    }, r.getMediaElementDimensions = function(e) {
      if (e instanceof HTMLVideoElement)
        return {
          height: e.videoHeight,
          width: e.videoWidth
        };
      if (e instanceof HTMLImageElement)
        return {
          height: e.naturalHeight || e.height,
          width: e.naturalWidth || e.width
        };
      throw new Error("Couldn't find the Source's dimensions!");
    }, r.createCaptureCanvas = function(e) {
      if (!e)
        throw new de("Cannot create a capture canvas without a media element.");
      if (typeof document > "u")
        throw new Error(`The page "Document" is undefined, make sure you're running in a browser.`);
      var t = document.createElement("canvas"), n = r.getMediaElementDimensions(e), i = n.width, o = n.height;
      return t.style.width = i + "px", t.style.height = o + "px", t.width = i, t.height = o, t;
    }, r.tryPlayVideo = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              if (e != null && e.ended)
                return console.error("Trying to play video that has ended."), [2, !1];
              if (r.isVideoPlaying(e))
                return console.warn("Trying to play video that is already playing."), [2, !0];
              n.label = 1;
            case 1:
              return n.trys.push([1, 3, , 4]), [4, e.play()];
            case 2:
              return n.sent(), [2, !0];
            case 3:
              return t = n.sent(), console.warn("It was not possible to play the video.", t), [2, !1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.createCanvasFromMediaElement = function(e) {
      var t = r.createCaptureCanvas(e), n = t.getContext("2d");
      if (!n)
        throw new Error("Couldn't find Canvas 2D Context.");
      return r.drawImageOnCanvas(n, e), t;
    }, r.createBinaryBitmapFromMediaElem = function(e) {
      var t = r.createCanvasFromMediaElement(e);
      return r.createBinaryBitmapFromCanvas(t);
    }, r.destroyImageElement = function(e) {
      e.src = "", e.removeAttribute("src"), e = void 0;
    }, r.listVideoInputDevices = function() {
      return ue(this, void 0, void 0, function() {
        var e, t, n, i, o, a, s, f, u, c, l, d;
        return ce(this, function(h) {
          switch (h.label) {
            case 0:
              if (!Ni())
                throw new Error("Can't enumerate devices, navigator is not present.");
              if (!Uu())
                throw new Error("Can't enumerate devices, method not supported.");
              return [4, navigator.mediaDevices.enumerateDevices()];
            case 1:
              e = h.sent(), t = [];
              try {
                for (n = Nr(e), i = n.next(); !i.done; i = n.next())
                  o = i.value, a = o.kind === "video" ? "videoinput" : o.kind, a === "videoinput" && (s = o.deviceId || o.id, f = o.label || "Video device ".concat(t.length + 1), u = o.groupId, c = { deviceId: s, label: f, kind: a, groupId: u }, t.push(c));
              } catch (p) {
                l = { error: p };
              } finally {
                try {
                  i && !i.done && (d = n.return) && d.call(n);
                } finally {
                  if (l)
                    throw l.error;
                }
              }
              return [2, t];
          }
        });
      });
    }, r.findDeviceById = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, r.listVideoInputDevices()];
            case 1:
              return t = n.sent(), t ? [2, t.find(function(i) {
                return i.deviceId === e;
              })] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.cleanVideoSource = function(e) {
      if (e) {
        try {
          e.srcObject = null;
        } catch {
          e.src = "";
        }
        e && e.removeAttribute("src");
      }
    }, r.releaseAllStreams = function() {
      r.streamTracker.length !== 0 && r.streamTracker.forEach(function(e) {
        e.getTracks().forEach(function(t) {
          return t.stop();
        });
      }), r.streamTracker = [];
    }, r.playVideoOnLoadAsync = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n;
        return ce(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, r.tryPlayVideo(e)];
            case 1:
              return n = i.sent(), n ? [2, !0] : [2, new Promise(function(o, a) {
                var s = setTimeout(function() {
                  r.isVideoPlaying(e) || (a(!1), e.removeEventListener("canplay", f));
                }, t), f = function() {
                  r.tryPlayVideo(e).then(function(u) {
                    clearTimeout(s), e.removeEventListener("canplay", f), o(u);
                  });
                };
                e.addEventListener("canplay", f);
              })];
          }
        });
      });
    }, r.attachStreamToVideo = function(e, t, n) {
      return n === void 0 && (n = 5e3), ue(this, void 0, void 0, function() {
        var i;
        return ce(this, function(o) {
          switch (o.label) {
            case 0:
              return i = r.prepareVideoElement(t), r.addVideoSource(i, e), [4, r.playVideoOnLoadAsync(i, n)];
            case 1:
              return o.sent(), [2, i];
          }
        });
      });
    }, r._waitImageLoad = function(e) {
      return new Promise(function(t, n) {
        var i = 1e4, o = setTimeout(function() {
          r.isImageLoaded(e) || (e.removeEventListener("load", a), n());
        }, i), a = function() {
          clearTimeout(o), e.removeEventListener("load", a), t();
        };
        e.addEventListener("load", a);
      });
    }, r.checkCallbackFnOrThrow = function(e) {
      if (!e)
        throw new de("`callbackFn` is a required parameter, you cannot capture results without it.");
    }, r.disposeMediaStream = function(e) {
      e.getVideoTracks().forEach(function(t) {
        return t.stop();
      }), e = void 0;
    }, r.prototype.decode = function(e) {
      var t = r.createCanvasFromMediaElement(e);
      return this.decodeFromCanvas(t);
    }, r.prototype.decodeBitmap = function(e) {
      return this.reader.decode(e, this.hints);
    }, r.prototype.decodeFromCanvas = function(e) {
      var t = r.createBinaryBitmapFromCanvas(e);
      return this.decodeBitmap(t);
    }, r.prototype.decodeFromImageElement = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              if (!e)
                throw new de("An image element must be provided.");
              return t = r.prepareImageElement(e), [4, this._decodeOnLoadImage(t)];
            case 1:
              return [2, n.sent()];
          }
        });
      });
    }, r.prototype.decodeFromImageUrl = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              if (!e)
                throw new de("An URL must be provided.");
              t = r.prepareImageElement(), t.src = e, n.label = 1;
            case 1:
              return n.trys.push([1, , 3, 4]), [4, this.decodeFromImageElement(t)];
            case 2:
              return [2, n.sent()];
            case 3:
              return r.destroyImageElement(t), [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.decodeFromConstraints = function(e, t, n) {
      return ue(this, void 0, void 0, function() {
        var i, o;
        return ce(this, function(a) {
          switch (a.label) {
            case 0:
              return r.checkCallbackFnOrThrow(n), [4, this.getUserMedia(e)];
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return a.trys.push([2, 4, , 5]), [4, this.decodeFromStream(i, t, n)];
            case 3:
              return [2, a.sent()];
            case 4:
              throw o = a.sent(), r.disposeMediaStream(i), o;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.decodeFromStream = function(e, t, n) {
      return ue(this, void 0, void 0, function() {
        var i, o, a, s, f, u, c, l, d, h = this;
        return ce(this, function(p) {
          switch (p.label) {
            case 0:
              return r.checkCallbackFnOrThrow(n), i = this.options.tryPlayVideoTimeout, [4, r.attachStreamToVideo(e, t, i)];
            case 1:
              return o = p.sent(), a = function() {
                r.disposeMediaStream(e), r.cleanVideoSource(o);
              }, s = this.scan(o, n, a), f = e.getVideoTracks(), u = Ct(Ct({}, s), { stop: function() {
                s.stop();
              }, streamVideoConstraintsApply: function(v, y) {
                return ue(this, void 0, void 0, function() {
                  var _, x, C, E, S, I, T;
                  return ce(this, function(R) {
                    switch (R.label) {
                      case 0:
                        _ = y ? f.filter(y) : f, R.label = 1;
                      case 1:
                        R.trys.push([1, 6, 7, 8]), x = Nr(_), C = x.next(), R.label = 2;
                      case 2:
                        return C.done ? [3, 5] : (E = C.value, [4, E.applyConstraints(v)]);
                      case 3:
                        R.sent(), R.label = 4;
                      case 4:
                        return C = x.next(), [3, 2];
                      case 5:
                        return [3, 8];
                      case 6:
                        return S = R.sent(), I = { error: S }, [3, 8];
                      case 7:
                        try {
                          C && !C.done && (T = x.return) && T.call(x);
                        } finally {
                          if (I)
                            throw I.error;
                        }
                        return [
                          7
                          /*endfinally*/
                        ];
                      case 8:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, streamVideoConstraintsGet: function(v) {
                return f.find(v).getConstraints();
              }, streamVideoSettingsGet: function(v) {
                return f.find(v).getSettings();
              }, streamVideoCapabilitiesGet: function(v) {
                return f.find(v).getCapabilities();
              } }), c = r.mediaStreamIsTorchCompatible(e), c && (l = f == null ? void 0 : f.find(function(v) {
                return r.mediaStreamIsTorchCompatibleTrack(v);
              }), d = function(v) {
                return ue(h, void 0, void 0, function() {
                  return ce(this, function(y) {
                    switch (y.label) {
                      case 0:
                        return [4, r.mediaStreamSetTorch(l, v)];
                      case 1:
                        return y.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }, u.switchTorch = d, u.stop = function() {
                return ue(h, void 0, void 0, function() {
                  return ce(this, function(v) {
                    switch (v.label) {
                      case 0:
                        return s.stop(), [4, d(!1)];
                      case 1:
                        return v.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [2, u];
          }
        });
      });
    }, r.prototype.decodeFromVideoDevice = function(e, t, n) {
      return ue(this, void 0, void 0, function() {
        var i, o;
        return ce(this, function(a) {
          switch (a.label) {
            case 0:
              return r.checkCallbackFnOrThrow(n), e ? i = { deviceId: { exact: e } } : i = { facingMode: "environment" }, o = { video: i }, [4, this.decodeFromConstraints(o, t, n)];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, r.prototype.decodeFromVideoElement = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n, i;
        return ce(this, function(o) {
          switch (o.label) {
            case 0:
              if (r.checkCallbackFnOrThrow(t), !e)
                throw new de("A video element must be provided.");
              return n = r.prepareVideoElement(e), i = this.options.tryPlayVideoTimeout, [4, r.playVideoOnLoadAsync(n, i)];
            case 1:
              return o.sent(), [2, this.scan(n, t)];
          }
        });
      });
    }, r.prototype.decodeFromVideoUrl = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n, i, o, a;
        return ce(this, function(s) {
          switch (s.label) {
            case 0:
              if (r.checkCallbackFnOrThrow(t), !e)
                throw new de("An URL must be provided.");
              return n = r.prepareVideoElement(), n.src = e, i = function() {
                r.cleanVideoSource(n);
              }, o = this.options.tryPlayVideoTimeout, [4, r.playVideoOnLoadAsync(n, o)];
            case 1:
              return s.sent(), a = this.scan(n, t, i), [2, a];
          }
        });
      });
    }, r.prototype.decodeOnceFromConstraints = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n;
        return ce(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.getUserMedia(e)];
            case 1:
              return n = i.sent(), [4, this.decodeOnceFromStream(n, t)];
            case 2:
              return [2, i.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromStream = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n, i, o;
        return ce(this, function(a) {
          switch (a.label) {
            case 0:
              return n = !!t, [4, r.attachStreamToVideo(e, t)];
            case 1:
              i = a.sent(), a.label = 2;
            case 2:
              return a.trys.push([2, , 4, 5]), [4, this.scanOneResult(i)];
            case 3:
              return o = a.sent(), [2, o];
            case 4:
              return n || r.cleanVideoSource(i), [
                7
                /*endfinally*/
              ];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.decodeOnceFromVideoDevice = function(e, t) {
      return ue(this, void 0, void 0, function() {
        var n, i;
        return ce(this, function(o) {
          switch (o.label) {
            case 0:
              return e ? n = { deviceId: { exact: e } } : n = { facingMode: "environment" }, i = { video: n }, [4, this.decodeOnceFromConstraints(i, t)];
            case 1:
              return [2, o.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromVideoElement = function(e) {
      return ue(this, void 0, void 0, function() {
        var t, n;
        return ce(this, function(i) {
          switch (i.label) {
            case 0:
              if (!e)
                throw new de("A video element must be provided.");
              return t = r.prepareVideoElement(e), n = this.options.tryPlayVideoTimeout, [4, r.playVideoOnLoadAsync(t, n)];
            case 1:
              return i.sent(), [4, this.scanOneResult(t)];
            case 2:
              return [2, i.sent()];
          }
        });
      });
    }, r.prototype.decodeOnceFromVideoUrl = function(e) {
      return ue(this, void 0, void 0, function() {
        var t, n;
        return ce(this, function(i) {
          switch (i.label) {
            case 0:
              if (!e)
                throw new de("An URL must be provided.");
              t = r.prepareVideoElement(), t.src = e, n = this.decodeOnceFromVideoElement(t), i.label = 1;
            case 1:
              return i.trys.push([1, , 3, 4]), [4, n];
            case 2:
              return [2, i.sent()];
            case 3:
              return r.cleanVideoSource(t), [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.scanOneResult = function(e, t, n, i) {
      var o = this;
      return t === void 0 && (t = !0), n === void 0 && (n = !0), i === void 0 && (i = !0), new Promise(function(a, s) {
        o.scan(e, function(f, u, c) {
          if (f) {
            a(f), c.stop();
            return;
          }
          if (u) {
            if (u instanceof w && t || u instanceof pe && n || u instanceof O && i)
              return;
            c.stop(), s(u);
          }
        });
      });
    }, r.prototype.scan = function(e, t, n) {
      var i = this;
      r.checkCallbackFnOrThrow(t);
      var o = r.createCaptureCanvas(e), a = o.getContext("2d");
      if (!a)
        throw new Error("Couldn't create canvas for visual element scan.");
      var s = function() {
        a = void 0, o = void 0;
      }, f = !1, u, c = function() {
        f = !0, clearTimeout(u), s(), n && n();
      }, l = { stop: c }, d = function() {
        if (!f)
          try {
            r.drawImageOnCanvas(a, e);
            var h = i.decodeFromCanvas(o);
            t(h, void 0, l), u = setTimeout(d, i.options.delayBetweenScanSuccess);
          } catch (_) {
            t(void 0, _, l);
            var p = _ instanceof pe, v = _ instanceof O, y = _ instanceof w;
            if (p || v || y) {
              u = setTimeout(d, i.options.delayBetweenScanAttempts);
              return;
            }
            s(), n && n(_);
          }
      };
      return d(), l;
    }, r.prototype._decodeOnLoadImage = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              return t = r.isImageLoaded(e), t ? [3, 2] : [4, r._waitImageLoad(e)];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [2, this.decode(e)];
          }
        });
      });
    }, r.prototype.getUserMedia = function(e) {
      return ue(this, void 0, void 0, function() {
        var t;
        return ce(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, navigator.mediaDevices.getUserMedia(e)];
            case 1:
              return t = n.sent(), r.streamTracker.push(t), [2, t];
          }
        });
      });
    }, r.streamTracker = [], r;
  }()
), Gu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Gu(e, r);
  function e(t, n) {
    return r.call(this, new sr(), t, n) || this;
  }
  return e;
})(St);
var Hu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Hu(e, r);
  function e(t, n) {
    return r.call(this, new mt(t), t, n) || this;
  }
  return e;
})(St);
var ju = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  ju(e, r);
  function e(t, n) {
    return r.call(this, new ur(), t, n) || this;
  }
  return e;
})(St);
var Wu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Wu(e, r);
  function e(t, n) {
    var i = this, o = new Ti();
    return o.setHints(t), i = r.call(this, o, t, n) || this, i.reader = o, i;
  }
  return Object.defineProperty(e.prototype, "possibleFormats", {
    set: function(t) {
      this.hints.set(fe.POSSIBLE_FORMATS, t), this.reader.setHints(this.hints);
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.decodeBitmap = function(t) {
    return this.reader.decodeWithState(t);
  }, e.prototype.setHints = function(t) {
    this.hints = t, this.reader.setHints(this.hints);
  }, e;
})(St);
var Xu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}();
(function(r) {
  Xu(e, r);
  function e(t, n) {
    return r.call(this, new lr(), t, n) || this;
  }
  return e;
})(St);
var zu = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Yu = (
  /** @class */
  function(r) {
    zu(e, r);
    function e(t, n) {
      return r.call(this, new cr(), t, n) || this;
    }
    return e;
  }(St)
);
const an = "-";
function $u(r) {
  const e = Ku(r), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: n
  } = r;
  function i(a) {
    const s = a.split(an);
    return s[0] === "" && s.length !== 1 && s.shift(), Mi(s, e) || Zu(a);
  }
  function o(a, s) {
    const f = t[a] || [];
    return s && n[a] ? [...f, ...n[a]] : f;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: o
  };
}
function Mi(r, e) {
  var a;
  if (r.length === 0)
    return e.classGroupId;
  const t = r[0], n = e.nextPart.get(t), i = n ? Mi(r.slice(1), n) : void 0;
  if (i)
    return i;
  if (e.validators.length === 0)
    return;
  const o = r.join(an);
  return (a = e.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : a.classGroupId;
}
const si = /^\[(.+)\]$/;
function Zu(r) {
  if (si.test(r)) {
    const e = si.exec(r)[1], t = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function Ku(r) {
  const {
    theme: e,
    prefix: t
  } = r, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Qu(Object.entries(r.classGroups), t).forEach(([o, a]) => {
    Xr(a, n, o, e);
  }), n;
}
function Xr(r, e, t, n) {
  r.forEach((i) => {
    if (typeof i == "string") {
      const o = i === "" ? e : fi(e, i);
      o.classGroupId = t;
      return;
    }
    if (typeof i == "function") {
      if (qu(i)) {
        Xr(i(n), e, t, n);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: t
      });
      return;
    }
    Object.entries(i).forEach(([o, a]) => {
      Xr(a, fi(e, o), t, n);
    });
  });
}
function fi(r, e) {
  let t = r;
  return e.split(an).forEach((n) => {
    t.nextPart.has(n) || t.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(n);
  }), t;
}
function qu(r) {
  return r.isThemeGetter;
}
function Qu(r, e) {
  return e ? r.map(([t, n]) => {
    const i = n.map((o) => typeof o == "string" ? e + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([a, s]) => [e + a, s])) : o);
    return [t, i];
  }) : r;
}
function Ju(r) {
  if (r < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function i(o, a) {
    t.set(o, a), e++, e > r && (e = 0, n = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(o) {
      let a = t.get(o);
      if (a !== void 0)
        return a;
      if ((a = n.get(o)) !== void 0)
        return i(o, a), a;
    },
    set(o, a) {
      t.has(o) ? t.set(o, a) : i(o, a);
    }
  };
}
const Bi = "!";
function ec(r) {
  const e = r.separator, t = e.length === 1, n = e[0], i = e.length;
  return function(a) {
    const s = [];
    let f = 0, u = 0, c;
    for (let v = 0; v < a.length; v++) {
      let y = a[v];
      if (f === 0) {
        if (y === n && (t || a.slice(v, v + i) === e)) {
          s.push(a.slice(u, v)), u = v + i;
          continue;
        }
        if (y === "/") {
          c = v;
          continue;
        }
      }
      y === "[" ? f++ : y === "]" && f--;
    }
    const l = s.length === 0 ? a : a.substring(u), d = l.startsWith(Bi), h = d ? l.substring(1) : l, p = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: d,
      baseClassName: h,
      maybePostfixModifierPosition: p
    };
  };
}
function tc(r) {
  if (r.length <= 1)
    return r;
  const e = [];
  let t = [];
  return r.forEach((n) => {
    n[0] === "[" ? (e.push(...t.sort(), n), t = []) : t.push(n);
  }), e.push(...t.sort()), e;
}
function rc(r) {
  return {
    cache: Ju(r.cacheSize),
    splitModifiers: ec(r),
    ...$u(r)
  };
}
const nc = /\s+/;
function ic(r, e) {
  const {
    splitModifiers: t,
    getClassGroupId: n,
    getConflictingClassGroupIds: i
  } = e, o = /* @__PURE__ */ new Set();
  return r.trim().split(nc).map((a) => {
    const {
      modifiers: s,
      hasImportantModifier: f,
      baseClassName: u,
      maybePostfixModifierPosition: c
    } = t(a);
    let l = n(c ? u.substring(0, c) : u), d = !!c;
    if (!l) {
      if (!c)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (l = n(u), !l)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      d = !1;
    }
    const h = tc(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: f ? h + Bi : h,
      classGroupId: l,
      originalClassName: a,
      hasPostfixModifier: d
    };
  }).reverse().filter((a) => {
    if (!a.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: f,
      hasPostfixModifier: u
    } = a, c = s + f;
    return o.has(c) ? !1 : (o.add(c), i(f, u).forEach((l) => o.add(s + l)), !0);
  }).reverse().map((a) => a.originalClassName).join(" ");
}
function oc() {
  let r = 0, e, t, n = "";
  for (; r < arguments.length; )
    (e = arguments[r++]) && (t = Li(e)) && (n && (n += " "), n += t);
  return n;
}
function Li(r) {
  if (typeof r == "string")
    return r;
  let e, t = "";
  for (let n = 0; n < r.length; n++)
    r[n] && (e = Li(r[n])) && (t && (t += " "), t += e);
  return t;
}
function ac(r, ...e) {
  let t, n, i, o = a;
  function a(f) {
    const u = e.reduce((c, l) => l(c), r());
    return t = rc(u), n = t.cache.get, i = t.cache.set, o = s, s(f);
  }
  function s(f) {
    const u = n(f);
    if (u)
      return u;
    const c = ic(f, t);
    return i(f, c), c;
  }
  return function() {
    return o(oc.apply(null, arguments));
  };
}
function oe(r) {
  const e = (t) => t[r] || [];
  return e.isThemeGetter = !0, e;
}
const Fi = /^\[(?:([a-z-]+):)?(.+)\]$/i, sc = /^\d+\/\d+$/, fc = /* @__PURE__ */ new Set(["px", "full", "screen"]), uc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, cc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, lc = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, dc = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, hc = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function Ke(r) {
  return dt(r) || fc.has(r) || sc.test(r);
}
function tt(r) {
  return It(r, "length", Cc);
}
function dt(r) {
  return !!r && !Number.isNaN(Number(r));
}
function qt(r) {
  return It(r, "number", dt);
}
function Mt(r) {
  return !!r && Number.isInteger(Number(r));
}
function pc(r) {
  return r.endsWith("%") && dt(r.slice(0, -1));
}
function U(r) {
  return Fi.test(r);
}
function rt(r) {
  return uc.test(r);
}
const vc = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function gc(r) {
  return It(r, vc, ki);
}
function xc(r) {
  return It(r, "position", ki);
}
const yc = /* @__PURE__ */ new Set(["image", "url"]);
function mc(r) {
  return It(r, yc, Ec);
}
function _c(r) {
  return It(r, "", Ac);
}
function Bt() {
  return !0;
}
function It(r, e, t) {
  const n = Fi.exec(r);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : t(n[2]) : !1;
}
function Cc(r) {
  return cc.test(r) && !lc.test(r);
}
function ki() {
  return !1;
}
function Ac(r) {
  return dc.test(r);
}
function Ec(r) {
  return hc.test(r);
}
function wc() {
  const r = oe("colors"), e = oe("spacing"), t = oe("blur"), n = oe("brightness"), i = oe("borderColor"), o = oe("borderRadius"), a = oe("borderSpacing"), s = oe("borderWidth"), f = oe("contrast"), u = oe("grayscale"), c = oe("hueRotate"), l = oe("invert"), d = oe("gap"), h = oe("gradientColorStops"), p = oe("gradientColorStopPositions"), v = oe("inset"), y = oe("margin"), _ = oe("opacity"), x = oe("padding"), C = oe("saturate"), E = oe("scale"), S = oe("sepia"), I = oe("skew"), T = oe("space"), R = oe("translate"), B = () => ["auto", "contain", "none"], M = () => ["auto", "hidden", "clip", "visible", "scroll"], te = () => ["auto", U, e], N = () => [U, e], H = () => ["", Ke, tt], ie = () => ["auto", dt, U], we = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Ge = () => ["solid", "dashed", "dotted", "double", "none"], $e = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], Xe = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], qe = () => ["", "0", U], bt = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Qe = () => [dt, qt], at = () => [dt, U];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Bt],
      spacing: [Ke, tt],
      blur: ["none", "", rt, U],
      brightness: Qe(),
      borderColor: [r],
      borderRadius: ["none", "", "full", rt, U],
      borderSpacing: N(),
      borderWidth: H(),
      contrast: Qe(),
      grayscale: qe(),
      hueRotate: at(),
      invert: qe(),
      gap: N(),
      gradientColorStops: [r],
      gradientColorStopPositions: [pc, tt],
      inset: te(),
      margin: te(),
      opacity: Qe(),
      padding: N(),
      saturate: Qe(),
      scale: Qe(),
      sepia: qe(),
      skew: at(),
      space: N(),
      translate: N()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", U]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [rt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": bt()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": bt()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...we(), U]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Mt, U]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: te()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", U]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: qe()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: qe()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Mt, U]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Bt]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Mt, U]
        }, U]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ie()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ie()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Bt]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Mt, U]
        }, U]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ie()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ie()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", U]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", U]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...Xe()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Xe(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...Xe(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", U, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [U, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [U, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [rt]
        }, rt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [U, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [U, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [U, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [U, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", rt, tt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", qt]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Bt]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", U]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", dt, qt]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ke, U]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", U]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", U]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [r]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [r]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Ge(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ke, tt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ke, U]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [r]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: N()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", U]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", U]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...we(), xc]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", gc]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, mc]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [r]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Ge(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Ge()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Ge()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ke, U]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ke, tt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [r]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: H()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [r]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ke, tt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [r]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", rt, _c]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Bt]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $e()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $e()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [f]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", rt, U]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [l]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [f]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [l]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", U]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: at()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", U]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: at()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", U]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [E]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [E]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [E]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Mt, U]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [I]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [I]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", U]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", r]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", U]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [r]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": N()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": N()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": N()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": N()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": N()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": N()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": N()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": N()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": N()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": N()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": N()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": N()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": N()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": N()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": N()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": N()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": N()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": N()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", U]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [r, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ke, tt, qt]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [r, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const Ui = /* @__PURE__ */ ac(wc);
let Vi = !0, Gi = !0;
function tr(r, e, t) {
  const n = r.match(e);
  return n && n.length >= t && parseInt(n[t], 10);
}
function pt(r, e, t) {
  if (!r.RTCPeerConnection)
    return;
  const n = r.RTCPeerConnection.prototype, i = n.addEventListener;
  n.addEventListener = function(a, s) {
    if (a !== e)
      return i.apply(this, arguments);
    const f = (u) => {
      const c = t(u);
      c && (s.handleEvent ? s.handleEvent(c) : s(c));
    };
    return this._eventMap = this._eventMap || {}, this._eventMap[e] || (this._eventMap[e] = /* @__PURE__ */ new Map()), this._eventMap[e].set(s, f), i.apply(this, [
      a,
      f
    ]);
  };
  const o = n.removeEventListener;
  n.removeEventListener = function(a, s) {
    if (a !== e || !this._eventMap || !this._eventMap[e])
      return o.apply(this, arguments);
    if (!this._eventMap[e].has(s))
      return o.apply(this, arguments);
    const f = this._eventMap[e].get(s);
    return this._eventMap[e].delete(s), this._eventMap[e].size === 0 && delete this._eventMap[e], Object.keys(this._eventMap).length === 0 && delete this._eventMap, o.apply(this, [
      a,
      f
    ]);
  }, Object.defineProperty(n, "on" + e, {
    get() {
      return this["_on" + e];
    },
    set(a) {
      this["_on" + e] && (this.removeEventListener(
        e,
        this["_on" + e]
      ), delete this["_on" + e]), a && this.addEventListener(
        e,
        this["_on" + e] = a
      );
    },
    enumerable: !0,
    configurable: !0
  });
}
function Sc(r) {
  return typeof r != "boolean" ? new Error("Argument type: " + typeof r + ". Please use a boolean.") : (Vi = r, r ? "adapter.js logging disabled" : "adapter.js logging enabled");
}
function Ic(r) {
  return typeof r != "boolean" ? new Error("Argument type: " + typeof r + ". Please use a boolean.") : (Gi = !r, "adapter.js deprecation warnings " + (r ? "disabled" : "enabled"));
}
function Hi() {
  if (typeof window == "object") {
    if (Vi)
      return;
    typeof console < "u" && typeof console.log == "function" && console.log.apply(console, arguments);
  }
}
function sn(r, e) {
  Gi && console.warn(r + " is deprecated, please use " + e + " instead.");
}
function bc(r) {
  const e = { browser: null, version: null };
  if (typeof r > "u" || !r.navigator || !r.navigator.userAgent)
    return e.browser = "Not a browser.", e;
  const { navigator: t } = r;
  if (t.mozGetUserMedia)
    e.browser = "firefox", e.version = tr(
      t.userAgent,
      /Firefox\/(\d+)\./,
      1
    );
  else if (t.webkitGetUserMedia || r.isSecureContext === !1 && r.webkitRTCPeerConnection)
    e.browser = "chrome", e.version = tr(
      t.userAgent,
      /Chrom(e|ium)\/(\d+)\./,
      2
    );
  else if (r.RTCPeerConnection && t.userAgent.match(/AppleWebKit\/(\d+)\./))
    e.browser = "safari", e.version = tr(
      t.userAgent,
      /AppleWebKit\/(\d+)\./,
      1
    ), e.supportsUnifiedPlan = r.RTCRtpTransceiver && "currentDirection" in r.RTCRtpTransceiver.prototype;
  else
    return e.browser = "Not a supported browser.", e;
  return e;
}
function ui(r) {
  return Object.prototype.toString.call(r) === "[object Object]";
}
function ji(r) {
  return ui(r) ? Object.keys(r).reduce(function(e, t) {
    const n = ui(r[t]), i = n ? ji(r[t]) : r[t], o = n && !Object.keys(i).length;
    return i === void 0 || o ? e : Object.assign(e, { [t]: i });
  }, {}) : r;
}
function zr(r, e, t) {
  !e || t.has(e.id) || (t.set(e.id, e), Object.keys(e).forEach((n) => {
    n.endsWith("Id") ? zr(r, r.get(e[n]), t) : n.endsWith("Ids") && e[n].forEach((i) => {
      zr(r, r.get(i), t);
    });
  }));
}
function ci(r, e, t) {
  const n = t ? "outbound-rtp" : "inbound-rtp", i = /* @__PURE__ */ new Map();
  if (e === null)
    return i;
  const o = [];
  return r.forEach((a) => {
    a.type === "track" && a.trackIdentifier === e.id && o.push(a);
  }), o.forEach((a) => {
    r.forEach((s) => {
      s.type === n && s.trackId === a.id && zr(r, s, i);
    });
  }), i;
}
const li = Hi;
function Wi(r, e) {
  const t = r && r.navigator;
  if (!t.mediaDevices)
    return;
  const n = function(s) {
    if (typeof s != "object" || s.mandatory || s.optional)
      return s;
    const f = {};
    return Object.keys(s).forEach((u) => {
      if (u === "require" || u === "advanced" || u === "mediaSource")
        return;
      const c = typeof s[u] == "object" ? s[u] : { ideal: s[u] };
      c.exact !== void 0 && typeof c.exact == "number" && (c.min = c.max = c.exact);
      const l = function(d, h) {
        return d ? d + h.charAt(0).toUpperCase() + h.slice(1) : h === "deviceId" ? "sourceId" : h;
      };
      if (c.ideal !== void 0) {
        f.optional = f.optional || [];
        let d = {};
        typeof c.ideal == "number" ? (d[l("min", u)] = c.ideal, f.optional.push(d), d = {}, d[l("max", u)] = c.ideal, f.optional.push(d)) : (d[l("", u)] = c.ideal, f.optional.push(d));
      }
      c.exact !== void 0 && typeof c.exact != "number" ? (f.mandatory = f.mandatory || {}, f.mandatory[l("", u)] = c.exact) : ["min", "max"].forEach((d) => {
        c[d] !== void 0 && (f.mandatory = f.mandatory || {}, f.mandatory[l(d, u)] = c[d]);
      });
    }), s.advanced && (f.optional = (f.optional || []).concat(s.advanced)), f;
  }, i = function(s, f) {
    if (e.version >= 61)
      return f(s);
    if (s = JSON.parse(JSON.stringify(s)), s && typeof s.audio == "object") {
      const u = function(c, l, d) {
        l in c && !(d in c) && (c[d] = c[l], delete c[l]);
      };
      s = JSON.parse(JSON.stringify(s)), u(s.audio, "autoGainControl", "googAutoGainControl"), u(s.audio, "noiseSuppression", "googNoiseSuppression"), s.audio = n(s.audio);
    }
    if (s && typeof s.video == "object") {
      let u = s.video.facingMode;
      u = u && (typeof u == "object" ? u : { ideal: u });
      const c = e.version < 66;
      if (u && (u.exact === "user" || u.exact === "environment" || u.ideal === "user" || u.ideal === "environment") && !(t.mediaDevices.getSupportedConstraints && t.mediaDevices.getSupportedConstraints().facingMode && !c)) {
        delete s.video.facingMode;
        let l;
        if (u.exact === "environment" || u.ideal === "environment" ? l = ["back", "rear"] : (u.exact === "user" || u.ideal === "user") && (l = ["front"]), l)
          return t.mediaDevices.enumerateDevices().then((d) => {
            d = d.filter((p) => p.kind === "videoinput");
            let h = d.find((p) => l.some((v) => p.label.toLowerCase().includes(v)));
            return !h && d.length && l.includes("back") && (h = d[d.length - 1]), h && (s.video.deviceId = u.exact ? { exact: h.deviceId } : { ideal: h.deviceId }), s.video = n(s.video), li("chrome: " + JSON.stringify(s)), f(s);
          });
      }
      s.video = n(s.video);
    }
    return li("chrome: " + JSON.stringify(s)), f(s);
  }, o = function(s) {
    return e.version >= 64 ? s : {
      name: {
        PermissionDeniedError: "NotAllowedError",
        PermissionDismissedError: "NotAllowedError",
        InvalidStateError: "NotAllowedError",
        DevicesNotFoundError: "NotFoundError",
        ConstraintNotSatisfiedError: "OverconstrainedError",
        TrackStartError: "NotReadableError",
        MediaDeviceFailedDueToShutdown: "NotAllowedError",
        MediaDeviceKillSwitchOn: "NotAllowedError",
        TabCaptureError: "AbortError",
        ScreenCaptureError: "AbortError",
        DeviceCaptureError: "AbortError"
      }[s.name] || s.name,
      message: s.message,
      constraint: s.constraint || s.constraintName,
      toString() {
        return this.name + (this.message && ": ") + this.message;
      }
    };
  }, a = function(s, f, u) {
    i(s, (c) => {
      t.webkitGetUserMedia(c, f, (l) => {
        u && u(o(l));
      });
    });
  };
  if (t.getUserMedia = a.bind(t), t.mediaDevices.getUserMedia) {
    const s = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    t.mediaDevices.getUserMedia = function(f) {
      return i(f, (u) => s(u).then((c) => {
        if (u.audio && !c.getAudioTracks().length || u.video && !c.getVideoTracks().length)
          throw c.getTracks().forEach((l) => {
            l.stop();
          }), new DOMException("", "NotFoundError");
        return c;
      }, (c) => Promise.reject(o(c))));
    };
  }
}
function Tc(r, e) {
  if (!(r.navigator.mediaDevices && "getDisplayMedia" in r.navigator.mediaDevices) && r.navigator.mediaDevices) {
    if (typeof e != "function") {
      console.error("shimGetDisplayMedia: getSourceId argument is not a function");
      return;
    }
    r.navigator.mediaDevices.getDisplayMedia = function(n) {
      return e(n).then((i) => {
        const o = n.video && n.video.width, a = n.video && n.video.height, s = n.video && n.video.frameRate;
        return n.video = {
          mandatory: {
            chromeMediaSource: "desktop",
            chromeMediaSourceId: i,
            maxFrameRate: s || 3
          }
        }, o && (n.video.mandatory.maxWidth = o), a && (n.video.mandatory.maxHeight = a), r.navigator.mediaDevices.getUserMedia(n);
      });
    };
  }
}
function Xi(r) {
  r.MediaStream = r.MediaStream || r.webkitMediaStream;
}
function zi(r) {
  if (typeof r == "object" && r.RTCPeerConnection && !("ontrack" in r.RTCPeerConnection.prototype)) {
    Object.defineProperty(r.RTCPeerConnection.prototype, "ontrack", {
      get() {
        return this._ontrack;
      },
      set(t) {
        this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = t);
      },
      enumerable: !0,
      configurable: !0
    });
    const e = r.RTCPeerConnection.prototype.setRemoteDescription;
    r.RTCPeerConnection.prototype.setRemoteDescription = function() {
      return this._ontrackpoly || (this._ontrackpoly = (n) => {
        n.stream.addEventListener("addtrack", (i) => {
          let o;
          r.RTCPeerConnection.prototype.getReceivers ? o = this.getReceivers().find((s) => s.track && s.track.id === i.track.id) : o = { track: i.track };
          const a = new Event("track");
          a.track = i.track, a.receiver = o, a.transceiver = { receiver: o }, a.streams = [n.stream], this.dispatchEvent(a);
        }), n.stream.getTracks().forEach((i) => {
          let o;
          r.RTCPeerConnection.prototype.getReceivers ? o = this.getReceivers().find((s) => s.track && s.track.id === i.id) : o = { track: i };
          const a = new Event("track");
          a.track = i, a.receiver = o, a.transceiver = { receiver: o }, a.streams = [n.stream], this.dispatchEvent(a);
        });
      }, this.addEventListener("addstream", this._ontrackpoly)), e.apply(this, arguments);
    };
  } else
    pt(r, "track", (e) => (e.transceiver || Object.defineProperty(
      e,
      "transceiver",
      { value: { receiver: e.receiver } }
    ), e));
}
function Yi(r) {
  if (typeof r == "object" && r.RTCPeerConnection && !("getSenders" in r.RTCPeerConnection.prototype) && "createDTMFSender" in r.RTCPeerConnection.prototype) {
    const e = function(i, o) {
      return {
        track: o,
        get dtmf() {
          return this._dtmf === void 0 && (o.kind === "audio" ? this._dtmf = i.createDTMFSender(o) : this._dtmf = null), this._dtmf;
        },
        _pc: i
      };
    };
    if (!r.RTCPeerConnection.prototype.getSenders) {
      r.RTCPeerConnection.prototype.getSenders = function() {
        return this._senders = this._senders || [], this._senders.slice();
      };
      const i = r.RTCPeerConnection.prototype.addTrack;
      r.RTCPeerConnection.prototype.addTrack = function(s, f) {
        let u = i.apply(this, arguments);
        return u || (u = e(this, s), this._senders.push(u)), u;
      };
      const o = r.RTCPeerConnection.prototype.removeTrack;
      r.RTCPeerConnection.prototype.removeTrack = function(s) {
        o.apply(this, arguments);
        const f = this._senders.indexOf(s);
        f !== -1 && this._senders.splice(f, 1);
      };
    }
    const t = r.RTCPeerConnection.prototype.addStream;
    r.RTCPeerConnection.prototype.addStream = function(o) {
      this._senders = this._senders || [], t.apply(this, [o]), o.getTracks().forEach((a) => {
        this._senders.push(e(this, a));
      });
    };
    const n = r.RTCPeerConnection.prototype.removeStream;
    r.RTCPeerConnection.prototype.removeStream = function(o) {
      this._senders = this._senders || [], n.apply(this, [o]), o.getTracks().forEach((a) => {
        const s = this._senders.find((f) => f.track === a);
        s && this._senders.splice(this._senders.indexOf(s), 1);
      });
    };
  } else if (typeof r == "object" && r.RTCPeerConnection && "getSenders" in r.RTCPeerConnection.prototype && "createDTMFSender" in r.RTCPeerConnection.prototype && r.RTCRtpSender && !("dtmf" in r.RTCRtpSender.prototype)) {
    const e = r.RTCPeerConnection.prototype.getSenders;
    r.RTCPeerConnection.prototype.getSenders = function() {
      const n = e.apply(this, []);
      return n.forEach((i) => i._pc = this), n;
    }, Object.defineProperty(r.RTCRtpSender.prototype, "dtmf", {
      get() {
        return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
      }
    });
  }
}
function $i(r) {
  if (!r.RTCPeerConnection)
    return;
  const e = r.RTCPeerConnection.prototype.getStats;
  r.RTCPeerConnection.prototype.getStats = function() {
    const [n, i, o] = arguments;
    if (arguments.length > 0 && typeof n == "function")
      return e.apply(this, arguments);
    if (e.length === 0 && (arguments.length === 0 || typeof n != "function"))
      return e.apply(this, []);
    const a = function(f) {
      const u = {};
      return f.result().forEach((l) => {
        const d = {
          id: l.id,
          timestamp: l.timestamp,
          type: {
            localcandidate: "local-candidate",
            remotecandidate: "remote-candidate"
          }[l.type] || l.type
        };
        l.names().forEach((h) => {
          d[h] = l.stat(h);
        }), u[d.id] = d;
      }), u;
    }, s = function(f) {
      return new Map(Object.keys(f).map((u) => [u, f[u]]));
    };
    if (arguments.length >= 2) {
      const f = function(u) {
        i(s(a(u)));
      };
      return e.apply(this, [
        f,
        n
      ]);
    }
    return new Promise((f, u) => {
      e.apply(this, [
        function(c) {
          f(s(a(c)));
        },
        u
      ]);
    }).then(i, o);
  };
}
function Zi(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection && r.RTCRtpSender && r.RTCRtpReceiver))
    return;
  if (!("getStats" in r.RTCRtpSender.prototype)) {
    const t = r.RTCPeerConnection.prototype.getSenders;
    t && (r.RTCPeerConnection.prototype.getSenders = function() {
      const o = t.apply(this, []);
      return o.forEach((a) => a._pc = this), o;
    });
    const n = r.RTCPeerConnection.prototype.addTrack;
    n && (r.RTCPeerConnection.prototype.addTrack = function() {
      const o = n.apply(this, arguments);
      return o._pc = this, o;
    }), r.RTCRtpSender.prototype.getStats = function() {
      const o = this;
      return this._pc.getStats().then((a) => (
        /* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */
        ci(a, o.track, !0)
      ));
    };
  }
  if (!("getStats" in r.RTCRtpReceiver.prototype)) {
    const t = r.RTCPeerConnection.prototype.getReceivers;
    t && (r.RTCPeerConnection.prototype.getReceivers = function() {
      const i = t.apply(this, []);
      return i.forEach((o) => o._pc = this), i;
    }), pt(r, "track", (n) => (n.receiver._pc = n.srcElement, n)), r.RTCRtpReceiver.prototype.getStats = function() {
      const i = this;
      return this._pc.getStats().then((o) => ci(o, i.track, !1));
    };
  }
  if (!("getStats" in r.RTCRtpSender.prototype && "getStats" in r.RTCRtpReceiver.prototype))
    return;
  const e = r.RTCPeerConnection.prototype.getStats;
  r.RTCPeerConnection.prototype.getStats = function() {
    if (arguments.length > 0 && arguments[0] instanceof r.MediaStreamTrack) {
      const n = arguments[0];
      let i, o, a;
      return this.getSenders().forEach((s) => {
        s.track === n && (i ? a = !0 : i = s);
      }), this.getReceivers().forEach((s) => (s.track === n && (o ? a = !0 : o = s), s.track === n)), a || i && o ? Promise.reject(new DOMException(
        "There are more than one sender or receiver for the track.",
        "InvalidAccessError"
      )) : i ? i.getStats() : o ? o.getStats() : Promise.reject(new DOMException(
        "There is no sender or receiver for the track.",
        "InvalidAccessError"
      ));
    }
    return e.apply(this, arguments);
  };
}
function Ki(r) {
  r.RTCPeerConnection.prototype.getLocalStreams = function() {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map((a) => this._shimmedLocalStreams[a][0]);
  };
  const e = r.RTCPeerConnection.prototype.addTrack;
  r.RTCPeerConnection.prototype.addTrack = function(a, s) {
    if (!s)
      return e.apply(this, arguments);
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    const f = e.apply(this, arguments);
    return this._shimmedLocalStreams[s.id] ? this._shimmedLocalStreams[s.id].indexOf(f) === -1 && this._shimmedLocalStreams[s.id].push(f) : this._shimmedLocalStreams[s.id] = [s, f], f;
  };
  const t = r.RTCPeerConnection.prototype.addStream;
  r.RTCPeerConnection.prototype.addStream = function(a) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {}, a.getTracks().forEach((u) => {
      if (this.getSenders().find((l) => l.track === u))
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
    });
    const s = this.getSenders();
    t.apply(this, arguments);
    const f = this.getSenders().filter((u) => s.indexOf(u) === -1);
    this._shimmedLocalStreams[a.id] = [a].concat(f);
  };
  const n = r.RTCPeerConnection.prototype.removeStream;
  r.RTCPeerConnection.prototype.removeStream = function(a) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[a.id], n.apply(this, arguments);
  };
  const i = r.RTCPeerConnection.prototype.removeTrack;
  r.RTCPeerConnection.prototype.removeTrack = function(a) {
    return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, a && Object.keys(this._shimmedLocalStreams).forEach((s) => {
      const f = this._shimmedLocalStreams[s].indexOf(a);
      f !== -1 && this._shimmedLocalStreams[s].splice(f, 1), this._shimmedLocalStreams[s].length === 1 && delete this._shimmedLocalStreams[s];
    }), i.apply(this, arguments);
  };
}
function qi(r, e) {
  if (!r.RTCPeerConnection)
    return;
  if (r.RTCPeerConnection.prototype.addTrack && e.version >= 65)
    return Ki(r);
  const t = r.RTCPeerConnection.prototype.getLocalStreams;
  r.RTCPeerConnection.prototype.getLocalStreams = function() {
    const c = t.apply(this);
    return this._reverseStreams = this._reverseStreams || {}, c.map((l) => this._reverseStreams[l.id]);
  };
  const n = r.RTCPeerConnection.prototype.addStream;
  r.RTCPeerConnection.prototype.addStream = function(c) {
    if (this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, c.getTracks().forEach((l) => {
      if (this.getSenders().find((h) => h.track === l))
        throw new DOMException(
          "Track already exists.",
          "InvalidAccessError"
        );
    }), !this._reverseStreams[c.id]) {
      const l = new r.MediaStream(c.getTracks());
      this._streams[c.id] = l, this._reverseStreams[l.id] = c, c = l;
    }
    n.apply(this, [c]);
  };
  const i = r.RTCPeerConnection.prototype.removeStream;
  r.RTCPeerConnection.prototype.removeStream = function(c) {
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, i.apply(this, [this._streams[c.id] || c]), delete this._reverseStreams[this._streams[c.id] ? this._streams[c.id].id : c.id], delete this._streams[c.id];
  }, r.RTCPeerConnection.prototype.addTrack = function(c, l) {
    if (this.signalingState === "closed")
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    const d = [].slice.call(arguments, 1);
    if (d.length !== 1 || !d[0].getTracks().find((v) => v === c))
      throw new DOMException(
        "The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.",
        "NotSupportedError"
      );
    if (this.getSenders().find((v) => v.track === c))
      throw new DOMException(
        "Track already exists.",
        "InvalidAccessError"
      );
    this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {};
    const p = this._streams[l.id];
    if (p)
      p.addTrack(c), Promise.resolve().then(() => {
        this.dispatchEvent(new Event("negotiationneeded"));
      });
    else {
      const v = new r.MediaStream([c]);
      this._streams[l.id] = v, this._reverseStreams[v.id] = l, this.addStream(v);
    }
    return this.getSenders().find((v) => v.track === c);
  };
  function o(u, c) {
    let l = c.sdp;
    return Object.keys(u._reverseStreams || []).forEach((d) => {
      const h = u._reverseStreams[d], p = u._streams[h.id];
      l = l.replace(
        new RegExp(p.id, "g"),
        h.id
      );
    }), new RTCSessionDescription({
      type: c.type,
      sdp: l
    });
  }
  function a(u, c) {
    let l = c.sdp;
    return Object.keys(u._reverseStreams || []).forEach((d) => {
      const h = u._reverseStreams[d], p = u._streams[h.id];
      l = l.replace(
        new RegExp(h.id, "g"),
        p.id
      );
    }), new RTCSessionDescription({
      type: c.type,
      sdp: l
    });
  }
  ["createOffer", "createAnswer"].forEach(function(u) {
    const c = r.RTCPeerConnection.prototype[u], l = { [u]() {
      const d = arguments;
      return arguments.length && typeof arguments[0] == "function" ? c.apply(this, [
        (p) => {
          const v = o(this, p);
          d[0].apply(null, [v]);
        },
        (p) => {
          d[1] && d[1].apply(null, p);
        },
        arguments[2]
      ]) : c.apply(this, arguments).then((p) => o(this, p));
    } };
    r.RTCPeerConnection.prototype[u] = l[u];
  });
  const s = r.RTCPeerConnection.prototype.setLocalDescription;
  r.RTCPeerConnection.prototype.setLocalDescription = function() {
    return !arguments.length || !arguments[0].type ? s.apply(this, arguments) : (arguments[0] = a(this, arguments[0]), s.apply(this, arguments));
  };
  const f = Object.getOwnPropertyDescriptor(
    r.RTCPeerConnection.prototype,
    "localDescription"
  );
  Object.defineProperty(
    r.RTCPeerConnection.prototype,
    "localDescription",
    {
      get() {
        const u = f.get.apply(this);
        return u.type === "" ? u : o(this, u);
      }
    }
  ), r.RTCPeerConnection.prototype.removeTrack = function(c) {
    if (this.signalingState === "closed")
      throw new DOMException(
        "The RTCPeerConnection's signalingState is 'closed'.",
        "InvalidStateError"
      );
    if (!c._pc)
      throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
    if (!(c._pc === this))
      throw new DOMException(
        "Sender was not created by this connection.",
        "InvalidAccessError"
      );
    this._streams = this._streams || {};
    let d;
    Object.keys(this._streams).forEach((h) => {
      this._streams[h].getTracks().find((v) => c.track === v) && (d = this._streams[h]);
    }), d && (d.getTracks().length === 1 ? this.removeStream(this._reverseStreams[d.id]) : d.removeTrack(c.track), this.dispatchEvent(new Event("negotiationneeded")));
  };
}
function Yr(r, e) {
  !r.RTCPeerConnection && r.webkitRTCPeerConnection && (r.RTCPeerConnection = r.webkitRTCPeerConnection), r.RTCPeerConnection && e.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(t) {
    const n = r.RTCPeerConnection.prototype[t], i = { [t]() {
      return arguments[0] = new (t === "addIceCandidate" ? r.RTCIceCandidate : r.RTCSessionDescription)(arguments[0]), n.apply(this, arguments);
    } };
    r.RTCPeerConnection.prototype[t] = i[t];
  });
}
function Qi(r, e) {
  pt(r, "negotiationneeded", (t) => {
    const n = t.target;
    if (!((e.version < 72 || n.getConfiguration && n.getConfiguration().sdpSemantics === "plan-b") && n.signalingState !== "stable"))
      return t;
  });
}
const di = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fixNegotiationNeeded: Qi,
  shimAddTrackRemoveTrack: qi,
  shimAddTrackRemoveTrackWithNative: Ki,
  shimGetDisplayMedia: Tc,
  shimGetSendersWithDtmf: Yi,
  shimGetStats: $i,
  shimGetUserMedia: Wi,
  shimMediaStream: Xi,
  shimOnTrack: zi,
  shimPeerConnection: Yr,
  shimSenderReceiverGetStats: Zi
}, Symbol.toStringTag, { value: "Module" }));
function Ji(r, e) {
  const t = r && r.navigator, n = r && r.MediaStreamTrack;
  if (t.getUserMedia = function(i, o, a) {
    sn(
      "navigator.getUserMedia",
      "navigator.mediaDevices.getUserMedia"
    ), t.mediaDevices.getUserMedia(i).then(o, a);
  }, !(e.version > 55 && "autoGainControl" in t.mediaDevices.getSupportedConstraints())) {
    const i = function(a, s, f) {
      s in a && !(f in a) && (a[f] = a[s], delete a[s]);
    }, o = t.mediaDevices.getUserMedia.bind(t.mediaDevices);
    if (t.mediaDevices.getUserMedia = function(a) {
      return typeof a == "object" && typeof a.audio == "object" && (a = JSON.parse(JSON.stringify(a)), i(a.audio, "autoGainControl", "mozAutoGainControl"), i(a.audio, "noiseSuppression", "mozNoiseSuppression")), o(a);
    }, n && n.prototype.getSettings) {
      const a = n.prototype.getSettings;
      n.prototype.getSettings = function() {
        const s = a.apply(this, arguments);
        return i(s, "mozAutoGainControl", "autoGainControl"), i(s, "mozNoiseSuppression", "noiseSuppression"), s;
      };
    }
    if (n && n.prototype.applyConstraints) {
      const a = n.prototype.applyConstraints;
      n.prototype.applyConstraints = function(s) {
        return this.kind === "audio" && typeof s == "object" && (s = JSON.parse(JSON.stringify(s)), i(s, "autoGainControl", "mozAutoGainControl"), i(s, "noiseSuppression", "mozNoiseSuppression")), a.apply(this, [s]);
      };
    }
  }
}
function Oc(r, e) {
  r.navigator.mediaDevices && "getDisplayMedia" in r.navigator.mediaDevices || r.navigator.mediaDevices && (r.navigator.mediaDevices.getDisplayMedia = function(n) {
    if (!(n && n.video)) {
      const i = new DOMException("getDisplayMedia without video constraints is undefined");
      return i.name = "NotFoundError", i.code = 8, Promise.reject(i);
    }
    return n.video === !0 ? n.video = { mediaSource: e } : n.video.mediaSource = e, r.navigator.mediaDevices.getUserMedia(n);
  });
}
function eo(r) {
  typeof r == "object" && r.RTCTrackEvent && "receiver" in r.RTCTrackEvent.prototype && !("transceiver" in r.RTCTrackEvent.prototype) && Object.defineProperty(r.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return { receiver: this.receiver };
    }
  });
}
function $r(r, e) {
  if (typeof r != "object" || !(r.RTCPeerConnection || r.mozRTCPeerConnection))
    return;
  !r.RTCPeerConnection && r.mozRTCPeerConnection && (r.RTCPeerConnection = r.mozRTCPeerConnection), e.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(i) {
    const o = r.RTCPeerConnection.prototype[i], a = { [i]() {
      return arguments[0] = new (i === "addIceCandidate" ? r.RTCIceCandidate : r.RTCSessionDescription)(arguments[0]), o.apply(this, arguments);
    } };
    r.RTCPeerConnection.prototype[i] = a[i];
  });
  const t = {
    inboundrtp: "inbound-rtp",
    outboundrtp: "outbound-rtp",
    candidatepair: "candidate-pair",
    localcandidate: "local-candidate",
    remotecandidate: "remote-candidate"
  }, n = r.RTCPeerConnection.prototype.getStats;
  r.RTCPeerConnection.prototype.getStats = function() {
    const [o, a, s] = arguments;
    return n.apply(this, [o || null]).then((f) => {
      if (e.version < 53 && !a)
        try {
          f.forEach((u) => {
            u.type = t[u.type] || u.type;
          });
        } catch (u) {
          if (u.name !== "TypeError")
            throw u;
          f.forEach((c, l) => {
            f.set(l, Object.assign({}, c, {
              type: t[c.type] || c.type
            }));
          });
        }
      return f;
    }).then(a, s);
  };
}
function to(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection && r.RTCRtpSender) || r.RTCRtpSender && "getStats" in r.RTCRtpSender.prototype)
    return;
  const e = r.RTCPeerConnection.prototype.getSenders;
  e && (r.RTCPeerConnection.prototype.getSenders = function() {
    const i = e.apply(this, []);
    return i.forEach((o) => o._pc = this), i;
  });
  const t = r.RTCPeerConnection.prototype.addTrack;
  t && (r.RTCPeerConnection.prototype.addTrack = function() {
    const i = t.apply(this, arguments);
    return i._pc = this, i;
  }), r.RTCRtpSender.prototype.getStats = function() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(/* @__PURE__ */ new Map());
  };
}
function ro(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection && r.RTCRtpSender) || r.RTCRtpSender && "getStats" in r.RTCRtpReceiver.prototype)
    return;
  const e = r.RTCPeerConnection.prototype.getReceivers;
  e && (r.RTCPeerConnection.prototype.getReceivers = function() {
    const n = e.apply(this, []);
    return n.forEach((i) => i._pc = this), n;
  }), pt(r, "track", (t) => (t.receiver._pc = t.srcElement, t)), r.RTCRtpReceiver.prototype.getStats = function() {
    return this._pc.getStats(this.track);
  };
}
function no(r) {
  !r.RTCPeerConnection || "removeStream" in r.RTCPeerConnection.prototype || (r.RTCPeerConnection.prototype.removeStream = function(t) {
    sn("removeStream", "removeTrack"), this.getSenders().forEach((n) => {
      n.track && t.getTracks().includes(n.track) && this.removeTrack(n);
    });
  });
}
function io(r) {
  r.DataChannel && !r.RTCDataChannel && (r.RTCDataChannel = r.DataChannel);
}
function oo(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection))
    return;
  const e = r.RTCPeerConnection.prototype.addTransceiver;
  e && (r.RTCPeerConnection.prototype.addTransceiver = function() {
    this.setParametersPromises = [];
    let n = arguments[1] && arguments[1].sendEncodings;
    n === void 0 && (n = []), n = [...n];
    const i = n.length > 0;
    i && n.forEach((a) => {
      if ("rid" in a && !/^[a-z0-9]{0,16}$/i.test(a.rid))
        throw new TypeError("Invalid RID value provided.");
      if ("scaleResolutionDownBy" in a && !(parseFloat(a.scaleResolutionDownBy) >= 1))
        throw new RangeError("scale_resolution_down_by must be >= 1.0");
      if ("maxFramerate" in a && !(parseFloat(a.maxFramerate) >= 0))
        throw new RangeError("max_framerate must be >= 0.0");
    });
    const o = e.apply(this, arguments);
    if (i) {
      const { sender: a } = o, s = a.getParameters();
      (!("encodings" in s) || // Avoid being fooled by patched getParameters() below.
      s.encodings.length === 1 && Object.keys(s.encodings[0]).length === 0) && (s.encodings = n, a.sendEncodings = n, this.setParametersPromises.push(
        a.setParameters(s).then(() => {
          delete a.sendEncodings;
        }).catch(() => {
          delete a.sendEncodings;
        })
      ));
    }
    return o;
  });
}
function ao(r) {
  if (!(typeof r == "object" && r.RTCRtpSender))
    return;
  const e = r.RTCRtpSender.prototype.getParameters;
  e && (r.RTCRtpSender.prototype.getParameters = function() {
    const n = e.apply(this, arguments);
    return "encodings" in n || (n.encodings = [].concat(this.sendEncodings || [{}])), n;
  });
}
function so(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection))
    return;
  const e = r.RTCPeerConnection.prototype.createOffer;
  r.RTCPeerConnection.prototype.createOffer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => e.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : e.apply(this, arguments);
  };
}
function fo(r) {
  if (!(typeof r == "object" && r.RTCPeerConnection))
    return;
  const e = r.RTCPeerConnection.prototype.createAnswer;
  r.RTCPeerConnection.prototype.createAnswer = function() {
    return this.setParametersPromises && this.setParametersPromises.length ? Promise.all(this.setParametersPromises).then(() => e.apply(this, arguments)).finally(() => {
      this.setParametersPromises = [];
    }) : e.apply(this, arguments);
  };
}
const hi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimAddTransceiver: oo,
  shimCreateAnswer: fo,
  shimCreateOffer: so,
  shimGetDisplayMedia: Oc,
  shimGetParameters: ao,
  shimGetUserMedia: Ji,
  shimOnTrack: eo,
  shimPeerConnection: $r,
  shimRTCDataChannel: io,
  shimReceiverGetStats: ro,
  shimRemoveStream: no,
  shimSenderGetStats: to
}, Symbol.toStringTag, { value: "Module" }));
function uo(r) {
  if (!(typeof r != "object" || !r.RTCPeerConnection)) {
    if ("getLocalStreams" in r.RTCPeerConnection.prototype || (r.RTCPeerConnection.prototype.getLocalStreams = function() {
      return this._localStreams || (this._localStreams = []), this._localStreams;
    }), !("addStream" in r.RTCPeerConnection.prototype)) {
      const e = r.RTCPeerConnection.prototype.addTrack;
      r.RTCPeerConnection.prototype.addStream = function(n) {
        this._localStreams || (this._localStreams = []), this._localStreams.includes(n) || this._localStreams.push(n), n.getAudioTracks().forEach((i) => e.call(
          this,
          i,
          n
        )), n.getVideoTracks().forEach((i) => e.call(
          this,
          i,
          n
        ));
      }, r.RTCPeerConnection.prototype.addTrack = function(n, ...i) {
        return i && i.forEach((o) => {
          this._localStreams ? this._localStreams.includes(o) || this._localStreams.push(o) : this._localStreams = [o];
        }), e.apply(this, arguments);
      };
    }
    "removeStream" in r.RTCPeerConnection.prototype || (r.RTCPeerConnection.prototype.removeStream = function(t) {
      this._localStreams || (this._localStreams = []);
      const n = this._localStreams.indexOf(t);
      if (n === -1)
        return;
      this._localStreams.splice(n, 1);
      const i = t.getTracks();
      this.getSenders().forEach((o) => {
        i.includes(o.track) && this.removeTrack(o);
      });
    });
  }
}
function co(r) {
  if (!(typeof r != "object" || !r.RTCPeerConnection) && ("getRemoteStreams" in r.RTCPeerConnection.prototype || (r.RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this._remoteStreams ? this._remoteStreams : [];
  }), !("onaddstream" in r.RTCPeerConnection.prototype))) {
    Object.defineProperty(r.RTCPeerConnection.prototype, "onaddstream", {
      get() {
        return this._onaddstream;
      },
      set(t) {
        this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = t), this.addEventListener("track", this._onaddstreampoly = (n) => {
          n.streams.forEach((i) => {
            if (this._remoteStreams || (this._remoteStreams = []), this._remoteStreams.includes(i))
              return;
            this._remoteStreams.push(i);
            const o = new Event("addstream");
            o.stream = i, this.dispatchEvent(o);
          });
        });
      }
    });
    const e = r.RTCPeerConnection.prototype.setRemoteDescription;
    r.RTCPeerConnection.prototype.setRemoteDescription = function() {
      const n = this;
      return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(i) {
        i.streams.forEach((o) => {
          if (n._remoteStreams || (n._remoteStreams = []), n._remoteStreams.indexOf(o) >= 0)
            return;
          n._remoteStreams.push(o);
          const a = new Event("addstream");
          a.stream = o, n.dispatchEvent(a);
        });
      }), e.apply(n, arguments);
    };
  }
}
function lo(r) {
  if (typeof r != "object" || !r.RTCPeerConnection)
    return;
  const e = r.RTCPeerConnection.prototype, t = e.createOffer, n = e.createAnswer, i = e.setLocalDescription, o = e.setRemoteDescription, a = e.addIceCandidate;
  e.createOffer = function(u, c) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], d = t.apply(this, [l]);
    return c ? (d.then(u, c), Promise.resolve()) : d;
  }, e.createAnswer = function(u, c) {
    const l = arguments.length >= 2 ? arguments[2] : arguments[0], d = n.apply(this, [l]);
    return c ? (d.then(u, c), Promise.resolve()) : d;
  };
  let s = function(f, u, c) {
    const l = i.apply(this, [f]);
    return c ? (l.then(u, c), Promise.resolve()) : l;
  };
  e.setLocalDescription = s, s = function(f, u, c) {
    const l = o.apply(this, [f]);
    return c ? (l.then(u, c), Promise.resolve()) : l;
  }, e.setRemoteDescription = s, s = function(f, u, c) {
    const l = a.apply(this, [f]);
    return c ? (l.then(u, c), Promise.resolve()) : l;
  }, e.addIceCandidate = s;
}
function ho(r) {
  const e = r && r.navigator;
  if (e.mediaDevices && e.mediaDevices.getUserMedia) {
    const t = e.mediaDevices, n = t.getUserMedia.bind(t);
    e.mediaDevices.getUserMedia = (i) => n(po(i));
  }
  !e.getUserMedia && e.mediaDevices && e.mediaDevices.getUserMedia && (e.getUserMedia = (function(n, i, o) {
    e.mediaDevices.getUserMedia(n).then(i, o);
  }).bind(e));
}
function po(r) {
  return r && r.video !== void 0 ? Object.assign(
    {},
    r,
    { video: ji(r.video) }
  ) : r;
}
function vo(r) {
  if (!r.RTCPeerConnection)
    return;
  const e = r.RTCPeerConnection;
  r.RTCPeerConnection = function(n, i) {
    if (n && n.iceServers) {
      const o = [];
      for (let a = 0; a < n.iceServers.length; a++) {
        let s = n.iceServers[a];
        s.urls === void 0 && s.url ? (sn("RTCIceServer.url", "RTCIceServer.urls"), s = JSON.parse(JSON.stringify(s)), s.urls = s.url, delete s.url, o.push(s)) : o.push(n.iceServers[a]);
      }
      n.iceServers = o;
    }
    return new e(n, i);
  }, r.RTCPeerConnection.prototype = e.prototype, "generateCertificate" in e && Object.defineProperty(r.RTCPeerConnection, "generateCertificate", {
    get() {
      return e.generateCertificate;
    }
  });
}
function go(r) {
  typeof r == "object" && r.RTCTrackEvent && "receiver" in r.RTCTrackEvent.prototype && !("transceiver" in r.RTCTrackEvent.prototype) && Object.defineProperty(r.RTCTrackEvent.prototype, "transceiver", {
    get() {
      return { receiver: this.receiver };
    }
  });
}
function xo(r) {
  const e = r.RTCPeerConnection.prototype.createOffer;
  r.RTCPeerConnection.prototype.createOffer = function(n) {
    if (n) {
      typeof n.offerToReceiveAudio < "u" && (n.offerToReceiveAudio = !!n.offerToReceiveAudio);
      const i = this.getTransceivers().find((a) => a.receiver.track.kind === "audio");
      n.offerToReceiveAudio === !1 && i ? i.direction === "sendrecv" ? i.setDirection ? i.setDirection("sendonly") : i.direction = "sendonly" : i.direction === "recvonly" && (i.setDirection ? i.setDirection("inactive") : i.direction = "inactive") : n.offerToReceiveAudio === !0 && !i && this.addTransceiver("audio", { direction: "recvonly" }), typeof n.offerToReceiveVideo < "u" && (n.offerToReceiveVideo = !!n.offerToReceiveVideo);
      const o = this.getTransceivers().find((a) => a.receiver.track.kind === "video");
      n.offerToReceiveVideo === !1 && o ? o.direction === "sendrecv" ? o.setDirection ? o.setDirection("sendonly") : o.direction = "sendonly" : o.direction === "recvonly" && (o.setDirection ? o.setDirection("inactive") : o.direction = "inactive") : n.offerToReceiveVideo === !0 && !o && this.addTransceiver("video", { direction: "recvonly" });
    }
    return e.apply(this, arguments);
  };
}
function yo(r) {
  typeof r != "object" || r.AudioContext || (r.AudioContext = r.webkitAudioContext);
}
const pi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  shimAudioContext: yo,
  shimCallbacksAPI: lo,
  shimConstraints: po,
  shimCreateOfferLegacy: xo,
  shimGetUserMedia: ho,
  shimLocalStreamsAPI: uo,
  shimRTCIceServerUrls: vo,
  shimRemoteStreamsAPI: co,
  shimTrackEventTransceiver: go
}, Symbol.toStringTag, { value: "Module" }));
var mo = { exports: {} };
(function(r) {
  const e = {};
  e.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
  }, e.localCName = e.generateIdentifier(), e.splitLines = function(t) {
    return t.trim().split(`
`).map((n) => n.trim());
  }, e.splitSections = function(t) {
    return t.split(`
m=`).map((i, o) => (o > 0 ? "m=" + i : i).trim() + `\r
`);
  }, e.getDescription = function(t) {
    const n = e.splitSections(t);
    return n && n[0];
  }, e.getMediaSections = function(t) {
    const n = e.splitSections(t);
    return n.shift(), n;
  }, e.matchPrefix = function(t, n) {
    return e.splitLines(t).filter((i) => i.indexOf(n) === 0);
  }, e.parseCandidate = function(t) {
    let n;
    t.indexOf("a=candidate:") === 0 ? n = t.substring(12).split(" ") : n = t.substring(10).split(" ");
    const i = {
      foundation: n[0],
      component: { 1: "rtp", 2: "rtcp" }[n[1]] || n[1],
      protocol: n[2].toLowerCase(),
      priority: parseInt(n[3], 10),
      ip: n[4],
      address: n[4],
      // address is an alias for ip.
      port: parseInt(n[5], 10),
      // skip parts[6] == 'typ'
      type: n[7]
    };
    for (let o = 8; o < n.length; o += 2)
      switch (n[o]) {
        case "raddr":
          i.relatedAddress = n[o + 1];
          break;
        case "rport":
          i.relatedPort = parseInt(n[o + 1], 10);
          break;
        case "tcptype":
          i.tcpType = n[o + 1];
          break;
        case "ufrag":
          i.ufrag = n[o + 1], i.usernameFragment = n[o + 1];
          break;
        default:
          i[n[o]] === void 0 && (i[n[o]] = n[o + 1]);
          break;
      }
    return i;
  }, e.writeCandidate = function(t) {
    const n = [];
    n.push(t.foundation);
    const i = t.component;
    i === "rtp" ? n.push(1) : i === "rtcp" ? n.push(2) : n.push(i), n.push(t.protocol.toUpperCase()), n.push(t.priority), n.push(t.address || t.ip), n.push(t.port);
    const o = t.type;
    return n.push("typ"), n.push(o), o !== "host" && t.relatedAddress && t.relatedPort && (n.push("raddr"), n.push(t.relatedAddress), n.push("rport"), n.push(t.relatedPort)), t.tcpType && t.protocol.toLowerCase() === "tcp" && (n.push("tcptype"), n.push(t.tcpType)), (t.usernameFragment || t.ufrag) && (n.push("ufrag"), n.push(t.usernameFragment || t.ufrag)), "candidate:" + n.join(" ");
  }, e.parseIceOptions = function(t) {
    return t.substring(14).split(" ");
  }, e.parseRtpMap = function(t) {
    let n = t.substring(9).split(" ");
    const i = {
      payloadType: parseInt(n.shift(), 10)
      // was: id
    };
    return n = n[0].split("/"), i.name = n[0], i.clockRate = parseInt(n[1], 10), i.channels = n.length === 3 ? parseInt(n[2], 10) : 1, i.numChannels = i.channels, i;
  }, e.writeRtpMap = function(t) {
    let n = t.payloadType;
    t.preferredPayloadType !== void 0 && (n = t.preferredPayloadType);
    const i = t.channels || t.numChannels || 1;
    return "a=rtpmap:" + n + " " + t.name + "/" + t.clockRate + (i !== 1 ? "/" + i : "") + `\r
`;
  }, e.parseExtmap = function(t) {
    const n = t.substring(9).split(" ");
    return {
      id: parseInt(n[0], 10),
      direction: n[0].indexOf("/") > 0 ? n[0].split("/")[1] : "sendrecv",
      uri: n[1],
      attributes: n.slice(2).join(" ")
    };
  }, e.writeExtmap = function(t) {
    return "a=extmap:" + (t.id || t.preferredId) + (t.direction && t.direction !== "sendrecv" ? "/" + t.direction : "") + " " + t.uri + (t.attributes ? " " + t.attributes : "") + `\r
`;
  }, e.parseFmtp = function(t) {
    const n = {};
    let i;
    const o = t.substring(t.indexOf(" ") + 1).split(";");
    for (let a = 0; a < o.length; a++)
      i = o[a].trim().split("="), n[i[0].trim()] = i[1];
    return n;
  }, e.writeFmtp = function(t) {
    let n = "", i = t.payloadType;
    if (t.preferredPayloadType !== void 0 && (i = t.preferredPayloadType), t.parameters && Object.keys(t.parameters).length) {
      const o = [];
      Object.keys(t.parameters).forEach((a) => {
        t.parameters[a] !== void 0 ? o.push(a + "=" + t.parameters[a]) : o.push(a);
      }), n += "a=fmtp:" + i + " " + o.join(";") + `\r
`;
    }
    return n;
  }, e.parseRtcpFb = function(t) {
    const n = t.substring(t.indexOf(" ") + 1).split(" ");
    return {
      type: n.shift(),
      parameter: n.join(" ")
    };
  }, e.writeRtcpFb = function(t) {
    let n = "", i = t.payloadType;
    return t.preferredPayloadType !== void 0 && (i = t.preferredPayloadType), t.rtcpFeedback && t.rtcpFeedback.length && t.rtcpFeedback.forEach((o) => {
      n += "a=rtcp-fb:" + i + " " + o.type + (o.parameter && o.parameter.length ? " " + o.parameter : "") + `\r
`;
    }), n;
  }, e.parseSsrcMedia = function(t) {
    const n = t.indexOf(" "), i = {
      ssrc: parseInt(t.substring(7, n), 10)
    }, o = t.indexOf(":", n);
    return o > -1 ? (i.attribute = t.substring(n + 1, o), i.value = t.substring(o + 1)) : i.attribute = t.substring(n + 1), i;
  }, e.parseSsrcGroup = function(t) {
    const n = t.substring(13).split(" ");
    return {
      semantics: n.shift(),
      ssrcs: n.map((i) => parseInt(i, 10))
    };
  }, e.getMid = function(t) {
    const n = e.matchPrefix(t, "a=mid:")[0];
    if (n)
      return n.substring(6);
  }, e.parseFingerprint = function(t) {
    const n = t.substring(14).split(" ");
    return {
      algorithm: n[0].toLowerCase(),
      // algorithm is case-sensitive in Edge.
      value: n[1].toUpperCase()
      // the definition is upper-case in RFC 4572.
    };
  }, e.getDtlsParameters = function(t, n) {
    return {
      role: "auto",
      fingerprints: e.matchPrefix(
        t + n,
        "a=fingerprint:"
      ).map(e.parseFingerprint)
    };
  }, e.writeDtlsParameters = function(t, n) {
    let i = "a=setup:" + n + `\r
`;
    return t.fingerprints.forEach((o) => {
      i += "a=fingerprint:" + o.algorithm + " " + o.value + `\r
`;
    }), i;
  }, e.parseCryptoLine = function(t) {
    const n = t.substring(9).split(" ");
    return {
      tag: parseInt(n[0], 10),
      cryptoSuite: n[1],
      keyParams: n[2],
      sessionParams: n.slice(3)
    };
  }, e.writeCryptoLine = function(t) {
    return "a=crypto:" + t.tag + " " + t.cryptoSuite + " " + (typeof t.keyParams == "object" ? e.writeCryptoKeyParams(t.keyParams) : t.keyParams) + (t.sessionParams ? " " + t.sessionParams.join(" ") : "") + `\r
`;
  }, e.parseCryptoKeyParams = function(t) {
    if (t.indexOf("inline:") !== 0)
      return null;
    const n = t.substring(7).split("|");
    return {
      keyMethod: "inline",
      keySalt: n[0],
      lifeTime: n[1],
      mkiValue: n[2] ? n[2].split(":")[0] : void 0,
      mkiLength: n[2] ? n[2].split(":")[1] : void 0
    };
  }, e.writeCryptoKeyParams = function(t) {
    return t.keyMethod + ":" + t.keySalt + (t.lifeTime ? "|" + t.lifeTime : "") + (t.mkiValue && t.mkiLength ? "|" + t.mkiValue + ":" + t.mkiLength : "");
  }, e.getCryptoParameters = function(t, n) {
    return e.matchPrefix(
      t + n,
      "a=crypto:"
    ).map(e.parseCryptoLine);
  }, e.getIceParameters = function(t, n) {
    const i = e.matchPrefix(
      t + n,
      "a=ice-ufrag:"
    )[0], o = e.matchPrefix(
      t + n,
      "a=ice-pwd:"
    )[0];
    return i && o ? {
      usernameFragment: i.substring(12),
      password: o.substring(10)
    } : null;
  }, e.writeIceParameters = function(t) {
    let n = "a=ice-ufrag:" + t.usernameFragment + `\r
a=ice-pwd:` + t.password + `\r
`;
    return t.iceLite && (n += `a=ice-lite\r
`), n;
  }, e.parseRtpParameters = function(t) {
    const n = {
      codecs: [],
      headerExtensions: [],
      fecMechanisms: [],
      rtcp: []
    }, o = e.splitLines(t)[0].split(" ");
    n.profile = o[2];
    for (let s = 3; s < o.length; s++) {
      const f = o[s], u = e.matchPrefix(
        t,
        "a=rtpmap:" + f + " "
      )[0];
      if (u) {
        const c = e.parseRtpMap(u), l = e.matchPrefix(
          t,
          "a=fmtp:" + f + " "
        );
        switch (c.parameters = l.length ? e.parseFmtp(l[0]) : {}, c.rtcpFeedback = e.matchPrefix(
          t,
          "a=rtcp-fb:" + f + " "
        ).map(e.parseRtcpFb), n.codecs.push(c), c.name.toUpperCase()) {
          case "RED":
          case "ULPFEC":
            n.fecMechanisms.push(c.name.toUpperCase());
            break;
        }
      }
    }
    e.matchPrefix(t, "a=extmap:").forEach((s) => {
      n.headerExtensions.push(e.parseExtmap(s));
    });
    const a = e.matchPrefix(t, "a=rtcp-fb:* ").map(e.parseRtcpFb);
    return n.codecs.forEach((s) => {
      a.forEach((f) => {
        s.rtcpFeedback.find((c) => c.type === f.type && c.parameter === f.parameter) || s.rtcpFeedback.push(f);
      });
    }), n;
  }, e.writeRtpDescription = function(t, n) {
    let i = "";
    i += "m=" + t + " ", i += n.codecs.length > 0 ? "9" : "0", i += " " + (n.profile || "UDP/TLS/RTP/SAVPF") + " ", i += n.codecs.map((a) => a.preferredPayloadType !== void 0 ? a.preferredPayloadType : a.payloadType).join(" ") + `\r
`, i += `c=IN IP4 0.0.0.0\r
`, i += `a=rtcp:9 IN IP4 0.0.0.0\r
`, n.codecs.forEach((a) => {
      i += e.writeRtpMap(a), i += e.writeFmtp(a), i += e.writeRtcpFb(a);
    });
    let o = 0;
    return n.codecs.forEach((a) => {
      a.maxptime > o && (o = a.maxptime);
    }), o > 0 && (i += "a=maxptime:" + o + `\r
`), n.headerExtensions && n.headerExtensions.forEach((a) => {
      i += e.writeExtmap(a);
    }), i;
  }, e.parseRtpEncodingParameters = function(t) {
    const n = [], i = e.parseRtpParameters(t), o = i.fecMechanisms.indexOf("RED") !== -1, a = i.fecMechanisms.indexOf("ULPFEC") !== -1, s = e.matchPrefix(t, "a=ssrc:").map((d) => e.parseSsrcMedia(d)).filter((d) => d.attribute === "cname"), f = s.length > 0 && s[0].ssrc;
    let u;
    const c = e.matchPrefix(t, "a=ssrc-group:FID").map((d) => d.substring(17).split(" ").map((p) => parseInt(p, 10)));
    c.length > 0 && c[0].length > 1 && c[0][0] === f && (u = c[0][1]), i.codecs.forEach((d) => {
      if (d.name.toUpperCase() === "RTX" && d.parameters.apt) {
        let h = {
          ssrc: f,
          codecPayloadType: parseInt(d.parameters.apt, 10)
        };
        f && u && (h.rtx = { ssrc: u }), n.push(h), o && (h = JSON.parse(JSON.stringify(h)), h.fec = {
          ssrc: f,
          mechanism: a ? "red+ulpfec" : "red"
        }, n.push(h));
      }
    }), n.length === 0 && f && n.push({
      ssrc: f
    });
    let l = e.matchPrefix(t, "b=");
    return l.length && (l[0].indexOf("b=TIAS:") === 0 ? l = parseInt(l[0].substring(7), 10) : l[0].indexOf("b=AS:") === 0 ? l = parseInt(l[0].substring(5), 10) * 1e3 * 0.95 - 50 * 40 * 8 : l = void 0, n.forEach((d) => {
      d.maxBitrate = l;
    })), n;
  }, e.parseRtcpParameters = function(t) {
    const n = {}, i = e.matchPrefix(t, "a=ssrc:").map((s) => e.parseSsrcMedia(s)).filter((s) => s.attribute === "cname")[0];
    i && (n.cname = i.value, n.ssrc = i.ssrc);
    const o = e.matchPrefix(t, "a=rtcp-rsize");
    n.reducedSize = o.length > 0, n.compound = o.length === 0;
    const a = e.matchPrefix(t, "a=rtcp-mux");
    return n.mux = a.length > 0, n;
  }, e.writeRtcpParameters = function(t) {
    let n = "";
    return t.reducedSize && (n += `a=rtcp-rsize\r
`), t.mux && (n += `a=rtcp-mux\r
`), t.ssrc !== void 0 && t.cname && (n += "a=ssrc:" + t.ssrc + " cname:" + t.cname + `\r
`), n;
  }, e.parseMsid = function(t) {
    let n;
    const i = e.matchPrefix(t, "a=msid:");
    if (i.length === 1)
      return n = i[0].substring(7).split(" "), { stream: n[0], track: n[1] };
    const o = e.matchPrefix(t, "a=ssrc:").map((a) => e.parseSsrcMedia(a)).filter((a) => a.attribute === "msid");
    if (o.length > 0)
      return n = o[0].value.split(" "), { stream: n[0], track: n[1] };
  }, e.parseSctpDescription = function(t) {
    const n = e.parseMLine(t), i = e.matchPrefix(t, "a=max-message-size:");
    let o;
    i.length > 0 && (o = parseInt(i[0].substring(19), 10)), isNaN(o) && (o = 65536);
    const a = e.matchPrefix(t, "a=sctp-port:");
    if (a.length > 0)
      return {
        port: parseInt(a[0].substring(12), 10),
        protocol: n.fmt,
        maxMessageSize: o
      };
    const s = e.matchPrefix(t, "a=sctpmap:");
    if (s.length > 0) {
      const f = s[0].substring(10).split(" ");
      return {
        port: parseInt(f[0], 10),
        protocol: f[1],
        maxMessageSize: o
      };
    }
  }, e.writeSctpDescription = function(t, n) {
    let i = [];
    return t.protocol !== "DTLS/SCTP" ? i = [
      "m=" + t.kind + " 9 " + t.protocol + " " + n.protocol + `\r
`,
      `c=IN IP4 0.0.0.0\r
`,
      "a=sctp-port:" + n.port + `\r
`
    ] : i = [
      "m=" + t.kind + " 9 " + t.protocol + " " + n.port + `\r
`,
      `c=IN IP4 0.0.0.0\r
`,
      "a=sctpmap:" + n.port + " " + n.protocol + ` 65535\r
`
    ], n.maxMessageSize !== void 0 && i.push("a=max-message-size:" + n.maxMessageSize + `\r
`), i.join("");
  }, e.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
  }, e.writeSessionBoilerplate = function(t, n, i) {
    let o;
    const a = n !== void 0 ? n : 2;
    return t ? o = t : o = e.generateSessionId(), `v=0\r
o=` + (i || "thisisadapterortc") + " " + o + " " + a + ` IN IP4 127.0.0.1\r
s=-\r
t=0 0\r
`;
  }, e.getDirection = function(t, n) {
    const i = e.splitLines(t);
    for (let o = 0; o < i.length; o++)
      switch (i[o]) {
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
          return i[o].substring(2);
      }
    return n ? e.getDirection(n) : "sendrecv";
  }, e.getKind = function(t) {
    return e.splitLines(t)[0].split(" ")[0].substring(2);
  }, e.isRejected = function(t) {
    return t.split(" ", 2)[1] === "0";
  }, e.parseMLine = function(t) {
    const i = e.splitLines(t)[0].substring(2).split(" ");
    return {
      kind: i[0],
      port: parseInt(i[1], 10),
      protocol: i[2],
      fmt: i.slice(3).join(" ")
    };
  }, e.parseOLine = function(t) {
    const i = e.matchPrefix(t, "o=")[0].substring(2).split(" ");
    return {
      username: i[0],
      sessionId: i[1],
      sessionVersion: parseInt(i[2], 10),
      netType: i[3],
      addressType: i[4],
      address: i[5]
    };
  }, e.isValidSDP = function(t) {
    if (typeof t != "string" || t.length === 0)
      return !1;
    const n = e.splitLines(t);
    for (let i = 0; i < n.length; i++)
      if (n[i].length < 2 || n[i].charAt(1) !== "=")
        return !1;
    return !0;
  }, r.exports = e;
})(mo);
var _o = mo.exports;
const At = /* @__PURE__ */ Ko(_o), Rc = /* @__PURE__ */ Zo({
  __proto__: null,
  default: At
}, [_o]);
function rr(r) {
  if (!r.RTCIceCandidate || r.RTCIceCandidate && "foundation" in r.RTCIceCandidate.prototype)
    return;
  const e = r.RTCIceCandidate;
  r.RTCIceCandidate = function(n) {
    if (typeof n == "object" && n.candidate && n.candidate.indexOf("a=") === 0 && (n = JSON.parse(JSON.stringify(n)), n.candidate = n.candidate.substring(2)), n.candidate && n.candidate.length) {
      const i = new e(n), o = At.parseCandidate(n.candidate);
      for (const a in o)
        a in i || Object.defineProperty(
          i,
          a,
          { value: o[a] }
        );
      return i.toJSON = function() {
        return {
          candidate: i.candidate,
          sdpMid: i.sdpMid,
          sdpMLineIndex: i.sdpMLineIndex,
          usernameFragment: i.usernameFragment
        };
      }, i;
    }
    return new e(n);
  }, r.RTCIceCandidate.prototype = e.prototype, pt(r, "icecandidate", (t) => (t.candidate && Object.defineProperty(t, "candidate", {
    value: new r.RTCIceCandidate(t.candidate),
    writable: "false"
  }), t));
}
function Zr(r) {
  !r.RTCIceCandidate || r.RTCIceCandidate && "relayProtocol" in r.RTCIceCandidate.prototype || pt(r, "icecandidate", (e) => {
    if (e.candidate) {
      const t = At.parseCandidate(e.candidate.candidate);
      t.type === "relay" && (e.candidate.relayProtocol = {
        0: "tls",
        1: "tcp",
        2: "udp"
      }[t.priority >> 24]);
    }
    return e;
  });
}
function nr(r, e) {
  if (!r.RTCPeerConnection)
    return;
  "sctp" in r.RTCPeerConnection.prototype || Object.defineProperty(r.RTCPeerConnection.prototype, "sctp", {
    get() {
      return typeof this._sctp > "u" ? null : this._sctp;
    }
  });
  const t = function(s) {
    if (!s || !s.sdp)
      return !1;
    const f = At.splitSections(s.sdp);
    return f.shift(), f.some((u) => {
      const c = At.parseMLine(u);
      return c && c.kind === "application" && c.protocol.indexOf("SCTP") !== -1;
    });
  }, n = function(s) {
    const f = s.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
    if (f === null || f.length < 2)
      return -1;
    const u = parseInt(f[1], 10);
    return u !== u ? -1 : u;
  }, i = function(s) {
    let f = 65536;
    return e.browser === "firefox" && (e.version < 57 ? s === -1 ? f = 16384 : f = 2147483637 : e.version < 60 ? f = e.version === 57 ? 65535 : 65536 : f = 2147483637), f;
  }, o = function(s, f) {
    let u = 65536;
    e.browser === "firefox" && e.version === 57 && (u = 65535);
    const c = At.matchPrefix(
      s.sdp,
      "a=max-message-size:"
    );
    return c.length > 0 ? u = parseInt(c[0].substring(19), 10) : e.browser === "firefox" && f !== -1 && (u = 2147483637), u;
  }, a = r.RTCPeerConnection.prototype.setRemoteDescription;
  r.RTCPeerConnection.prototype.setRemoteDescription = function() {
    if (this._sctp = null, e.browser === "chrome" && e.version >= 76) {
      const { sdpSemantics: f } = this.getConfiguration();
      f === "plan-b" && Object.defineProperty(this, "sctp", {
        get() {
          return typeof this._sctp > "u" ? null : this._sctp;
        },
        enumerable: !0,
        configurable: !0
      });
    }
    if (t(arguments[0])) {
      const f = n(arguments[0]), u = i(f), c = o(arguments[0], f);
      let l;
      u === 0 && c === 0 ? l = Number.POSITIVE_INFINITY : u === 0 || c === 0 ? l = Math.max(u, c) : l = Math.min(u, c);
      const d = {};
      Object.defineProperty(d, "maxMessageSize", {
        get() {
          return l;
        }
      }), this._sctp = d;
    }
    return a.apply(this, arguments);
  };
}
function ir(r) {
  if (!(r.RTCPeerConnection && "createDataChannel" in r.RTCPeerConnection.prototype))
    return;
  function e(n, i) {
    const o = n.send;
    n.send = function() {
      const s = arguments[0], f = s.length || s.size || s.byteLength;
      if (n.readyState === "open" && i.sctp && f > i.sctp.maxMessageSize)
        throw new TypeError("Message too large (can send a maximum of " + i.sctp.maxMessageSize + " bytes)");
      return o.apply(n, arguments);
    };
  }
  const t = r.RTCPeerConnection.prototype.createDataChannel;
  r.RTCPeerConnection.prototype.createDataChannel = function() {
    const i = t.apply(this, arguments);
    return e(i, this), i;
  }, pt(r, "datachannel", (n) => (e(n.channel, n.target), n));
}
function Kr(r) {
  if (!r.RTCPeerConnection || "connectionState" in r.RTCPeerConnection.prototype)
    return;
  const e = r.RTCPeerConnection.prototype;
  Object.defineProperty(e, "connectionState", {
    get() {
      return {
        completed: "connected",
        checking: "connecting"
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "onconnectionstatechange", {
    get() {
      return this._onconnectionstatechange || null;
    },
    set(t) {
      this._onconnectionstatechange && (this.removeEventListener(
        "connectionstatechange",
        this._onconnectionstatechange
      ), delete this._onconnectionstatechange), t && this.addEventListener(
        "connectionstatechange",
        this._onconnectionstatechange = t
      );
    },
    enumerable: !0,
    configurable: !0
  }), ["setLocalDescription", "setRemoteDescription"].forEach((t) => {
    const n = e[t];
    e[t] = function() {
      return this._connectionstatechangepoly || (this._connectionstatechangepoly = (i) => {
        const o = i.target;
        if (o._lastConnectionState !== o.connectionState) {
          o._lastConnectionState = o.connectionState;
          const a = new Event("connectionstatechange", i);
          o.dispatchEvent(a);
        }
        return i;
      }, this.addEventListener(
        "iceconnectionstatechange",
        this._connectionstatechangepoly
      )), n.apply(this, arguments);
    };
  });
}
function qr(r, e) {
  if (!r.RTCPeerConnection || e.browser === "chrome" && e.version >= 71 || e.browser === "safari" && e.version >= 605)
    return;
  const t = r.RTCPeerConnection.prototype.setRemoteDescription;
  r.RTCPeerConnection.prototype.setRemoteDescription = function(i) {
    if (i && i.sdp && i.sdp.indexOf(`
a=extmap-allow-mixed`) !== -1) {
      const o = i.sdp.split(`
`).filter((a) => a.trim() !== "a=extmap-allow-mixed").join(`
`);
      r.RTCSessionDescription && i instanceof r.RTCSessionDescription ? arguments[0] = new r.RTCSessionDescription({
        type: i.type,
        sdp: o
      }) : i.sdp = o;
    }
    return t.apply(this, arguments);
  };
}
function or(r, e) {
  if (!(r.RTCPeerConnection && r.RTCPeerConnection.prototype))
    return;
  const t = r.RTCPeerConnection.prototype.addIceCandidate;
  !t || t.length === 0 || (r.RTCPeerConnection.prototype.addIceCandidate = function() {
    return arguments[0] ? (e.browser === "chrome" && e.version < 78 || e.browser === "firefox" && e.version < 68 || e.browser === "safari") && arguments[0] && arguments[0].candidate === "" ? Promise.resolve() : t.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), Promise.resolve());
  });
}
function ar(r, e) {
  if (!(r.RTCPeerConnection && r.RTCPeerConnection.prototype))
    return;
  const t = r.RTCPeerConnection.prototype.setLocalDescription;
  !t || t.length === 0 || (r.RTCPeerConnection.prototype.setLocalDescription = function() {
    let i = arguments[0] || {};
    if (typeof i != "object" || i.type && i.sdp)
      return t.apply(this, arguments);
    if (i = { type: i.type, sdp: i.sdp }, !i.type)
      switch (this.signalingState) {
        case "stable":
        case "have-local-offer":
        case "have-remote-pranswer":
          i.type = "offer";
          break;
        default:
          i.type = "answer";
          break;
      }
    return i.sdp || i.type !== "offer" && i.type !== "answer" ? t.apply(this, [i]) : (i.type === "offer" ? this.createOffer : this.createAnswer).apply(this).then((a) => t.apply(this, [a]));
  });
}
const Dc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  removeExtmapAllowMixed: qr,
  shimAddIceCandidateNullOrEmpty: or,
  shimConnectionState: Kr,
  shimMaxMessageSize: nr,
  shimParameterlessSetLocalDescription: ar,
  shimRTCIceCandidate: rr,
  shimRTCIceCandidateRelayProtocol: Zr,
  shimSendThrowTypeError: ir
}, Symbol.toStringTag, { value: "Module" }));
function Pc({ window: r } = {}, e = {
  shimChrome: !0,
  shimFirefox: !0,
  shimSafari: !0
}) {
  const t = Hi, n = bc(r), i = {
    browserDetails: n,
    commonShim: Dc,
    extractVersion: tr,
    disableLog: Sc,
    disableWarnings: Ic,
    // Expose sdp as a convenience. For production apps include directly.
    sdp: Rc
  };
  switch (n.browser) {
    case "chrome":
      if (!di || !Yr || !e.shimChrome)
        return t("Chrome shim is not included in this adapter release."), i;
      if (n.version === null)
        return t("Chrome shim can not determine version, not shimming."), i;
      t("adapter.js shimming chrome."), i.browserShim = di, or(r, n), ar(r), Wi(r, n), Xi(r), Yr(r, n), zi(r), qi(r, n), Yi(r), $i(r), Zi(r), Qi(r, n), rr(r), Zr(r), Kr(r), nr(r, n), ir(r), qr(r, n);
      break;
    case "firefox":
      if (!hi || !$r || !e.shimFirefox)
        return t("Firefox shim is not included in this adapter release."), i;
      t("adapter.js shimming firefox."), i.browserShim = hi, or(r, n), ar(r), Ji(r, n), $r(r, n), eo(r), no(r), to(r), ro(r), io(r), oo(r), ao(r), so(r), fo(r), rr(r), Kr(r), nr(r, n), ir(r);
      break;
    case "safari":
      if (!pi || !e.shimSafari)
        return t("Safari shim is not included in this adapter release."), i;
      t("adapter.js shimming safari."), i.browserShim = pi, or(r, n), ar(r), vo(r), xo(r), lo(r), uo(r), co(r), go(r), ho(r), yo(r), rr(r), Zr(r), nr(r, n), ir(r), qr(r, n);
      break;
    default:
      t("Unsupported browser!");
      break;
  }
  return i;
}
Pc({ window: typeof window > "u" ? void 0 : window });
const Nc = ({
  className: r,
  videoConstrains: e = { facingMode: "environment", frameRate: 30 },
  scanDelay: t = 300,
  scanSuccessDelay: n = 3500,
  onReadError: i,
  onRead: o,
  read: a,
  flipVideo: s,
  children: f,
  ...u
}) => {
  const c = zo(null), [l, d] = Yo(), h = $o(
    () => new Yu(void 0, {
      delayBetweenScanAttempts: t,
      delayBetweenScanSuccess: n
    }),
    [t, n]
  );
  return En(() => {
    !c.current || !a || l || h.decodeFromConstraints(
      { video: e },
      c.current,
      (p, v) => {
        p && o && o(p), v != null && v.message && i && i((v == null ? void 0 : v.message) || "");
      }
    ).then((p) => {
      d(p);
    }).catch((p) => {
      i && i(p.message);
    });
  }, [
    e,
    t,
    n,
    i,
    o,
    a,
    l,
    h
  ]), En(() => {
    a || (l == null || l.stop(), d(void 0));
  }, [l, a]), /* @__PURE__ */ ct.jsxs(
    "section",
    {
      className: Ui("relative h-full w-full overflow-hidden", r),
      ...u,
      children: [
        /* @__PURE__ */ ct.jsx(
          "video",
          {
            muted: !0,
            className: "h-full w-full object-cover object-center data-[flip='true']:-scale-x-100",
            "data-flip": !!s,
            ref: c
          }
        ),
        f
      ]
    }
  );
};
Nc.displayName = "QrReader";
const Mc = ({
  className: r,
  ...e
}) => /* @__PURE__ */ ct.jsxs(
  "svg",
  {
    className: Ui(
      "absolute left-0 top-0 z-10 h-full w-full border-[3rem] border-black/40",
      r
    ),
    viewBox: "0 0 100 100",
    color: "rgb(239 68 68)",
    ...e,
    children: [
      /* @__PURE__ */ ct.jsx(
        "path",
        {
          fill: "none",
          d: "M13,0 L0,0 L0,13",
          stroke: "currentColor",
          strokeWidth: "5"
        }
      ),
      /* @__PURE__ */ ct.jsx(
        "path",
        {
          fill: "none",
          d: "M0,87 L0,100 L13,100",
          stroke: "currentColor",
          strokeWidth: "5"
        }
      ),
      /* @__PURE__ */ ct.jsx(
        "path",
        {
          fill: "none",
          d: "M87,100 L100,100 L100,87",
          stroke: "currentColor",
          strokeWidth: "5"
        }
      ),
      /* @__PURE__ */ ct.jsx(
        "path",
        {
          fill: "none",
          d: "M100,13 L100,0 87,0",
          stroke: "currentColor",
          strokeWidth: "5"
        }
      )
    ]
  }
);
Mc.displayName = "QrReaderViewFinder";
export {
  Nc as QrReader,
  Mc as QrReaderViewFinder
};
